export const translations = {
  de: {
    Common: 'Common',
    'active_admin.menu.admin': 'Administration',
    'active_admin.menu.armies': 'Armies',
    'active_admin.menu.builder': 'Builder',
    'active_admin.menu.dashboard': 'Administration',
    'active_admin.menu.import': 'Import',
    'active_admin.menu.log': 'Log',
    'active_admin.menu.magic': 'magic',
    'active_admin.menu.map': 'Maps',
    'active_admin.menu.ninth_age': 'Ninth Age',
    'active_admin.menu.organisation': 'Organisation',
    'active_admin.menu.paint': 'Paint',
    'active_admin.menu.statistique': 'Statistiques',
    'active_admin.menu.tournament': 'Tournament',
    'active_admin.menu.unit': 'Unit',
    'active_admin.menu.user_annoncement': 'Annoncements',
    'active_admin.menu.users': 'Users',
    'active_admin.menu.versioning': 'Versioning',
    'active_admin.translate.ko': 'Korean',
    'active_admin.translate.pl': 'Polish',
    'active_admin.translate.ru': 'Russian',
    'active_admin.translate.zh': 'Chinese',
    'activerecord.attributes.data_analytics/report.deployments.CounterThrust':
      'Counter Thrust',
    'activerecord.attributes.data_analytics/report.deployments.DawnAssult':
      'Dawn Assult',
    'activerecord.attributes.data_analytics/report.deployments.Encircle':
      'Encircle',
    'activerecord.attributes.data_analytics/report.deployments.FrontlineClash':
      'Frontline Clash',
    'activerecord.attributes.data_analytics/report.deployments.MarchingColumns':
      'Marching Columns',
    'activerecord.attributes.data_analytics/report.deployments.RefusedFlank':
      'Refused Flank',
    'activerecord.attributes.data_analytics/report.maps.A1':
      'A1 - Shrouded Pool',
    'activerecord.attributes.data_analytics/report.maps.A2':
      'A2 - Foothill Outpost',
    'activerecord.attributes.data_analytics/report.maps.A3':
      'A3 - Dilapidated Manor',
    'activerecord.attributes.data_analytics/report.maps.A4':
      'A4 - Volcanic Lake',
    'activerecord.attributes.data_analytics/report.maps.A5':
      'A5 - Misty Marshes',
    'activerecord.attributes.data_analytics/report.maps.A6':
      'A6 - Ancient Walls',
    'activerecord.attributes.data_analytics/report.maps.A7': 'A7 - Beacon Hill',
    'activerecord.attributes.data_analytics/report.maps.A8':
      'A8 - Witch’s Cottage',
    'activerecord.attributes.data_analytics/report.maps.B1':
      'B1 - Mage’s Sanctum',
    'activerecord.attributes.data_analytics/report.maps.B2':
      'B2 - Villa Grounds',
    'activerecord.attributes.data_analytics/report.maps.B3':
      'B3 - Ancient Fortress',
    'activerecord.attributes.data_analytics/report.maps.B4':
      'B4 - Frontier Farm',
    'activerecord.attributes.data_analytics/report.maps.B5':
      'B5 - Ravaged Watchtower',
    'activerecord.attributes.data_analytics/report.maps.B6':
      'B6 - Creeping Forest',
    'activerecord.attributes.data_analytics/report.maps.B7':
      'B7 - Eerie Graveyard',
    'activerecord.attributes.data_analytics/report.maps.B8':
      'B8 - Shattered Bridge',
    'activerecord.attributes.data_analytics/report.objectives.Breakthrough':
      'Breakthrough',
    'activerecord.attributes.data_analytics/report.objectives.CaptureFlags':
      'Capture the Flags',
    'activerecord.attributes.data_analytics/report.objectives.HoldGround':
      'Hold the Ground',
    'activerecord.attributes.data_analytics/report.objectives.KingHill':
      'King of the Hill',
    'activerecord.attributes.data_analytics/report.objectives.SecureTarget':
      'Secure Target',
    'activerecord.attributes.data_analytics/report.objectives.SpoilsWar':
      'Spoils of War',
    'activerecord.attributes.data_analytics/report.opponent_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.opponent_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.opponent_objective':
      'Take the objective',
    'activerecord.attributes.data_analytics/report.your_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.your_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.your_objective':
      'Take the objective',
    'activerecord.attributes.ninth_age/magic_item.only_foot':
      'Prohibited mount',
    'activerecord.attributes.ninth_age/magic_item.only_wizard':
      'Only wizard can use it',
    'activerecord.attributes.ninth_age/magic_item.organisation_ids':
      'Organisations required from the model',
    'activerecord.attributes.ninth_age/magic_item.model_rule_ids':
      'Prohibited  model rules on model',
    'activerecord.attributes.ninth_age/magic_item.unit_ids':
      'For this units only',
    'activerecord.attributes.ninth_age/magic_item.unit_size':
      'Unit with this size can not use this item',
    'activerecord.attributes.ninth_age/magic_standard.organisation':
      'Add organisation to unit',
    'activerecord.attributes.ninth_age/magic_standard.organisation_ids':
      "Only organisation's units",
    'activerecord.attributes.ninth_age/troop.carac_agi': 'Agi',
    'activerecord.attributes.ninth_age/troop.carac_ap': 'Ap',
    'activerecord.attributes.ninth_age/troop.carac_att': 'Att',
    'activerecord.attributes.ninth_age/troop.carac_of': 'Off',
    'activerecord.attributes.ninth_age/troop.carac_str': 'Str',
    'activerecord.attributes.ninth_age/unit.carac_aeg': 'Aeg',
    'activerecord.attributes.ninth_age/unit.carac_arm': 'Arm',
    'activerecord.attributes.ninth_age/unit.carac_def': 'Def',
    'activerecord.attributes.ninth_age/unit.carac_dis': 'Dis',
    'activerecord.attributes.ninth_age/unit.carac_evoked': 'Rea',
    'activerecord.attributes.ninth_age/unit.carac_fly_adv': 'Fly adv',
    'activerecord.attributes.ninth_age/unit.carac_fly_mar': 'Fly mar',
    'activerecord.attributes.ninth_age/unit.carac_ground_adv': 'Adv',
    'activerecord.attributes.ninth_age/unit.carac_ground_mar': 'Mar',
    'activerecord.attributes.ninth_age/unit.carac_hp': 'HP',
    'activerecord.attributes.ninth_age/unit.carac_res': 'Res',
    'activerecord.attributes.ninth_age_army.source.FanMade': 'Fan Made',
    'activerecord.attributes.ninth_age_army.source.Official': 'Official',
    'activerecord.attributes.ninth_age_army.source.Supplement': 'Supplement',
    'activerecord.attributes.ninth_age_unit_option.category.BSB':
      'Battle Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.C': 'Champion',
    'activerecord.attributes.ninth_age_unit_option.category.ModelRule':
      'ModelRule',
    'activerecord.attributes.ninth_age_unit_option.category.ExtraSpells':
      'Spells',
    'activerecord.attributes.ninth_age_unit_option.category.General': 'General',
    'activerecord.attributes.ninth_age_unit_option.category.Generic': 'Generic',
    'activerecord.attributes.ninth_age_unit_option.category.M': 'Musician',
    'activerecord.attributes.ninth_age_unit_option.category.MagicBanner':
      'Banner Enchantment',
    'activerecord.attributes.ninth_age_unit_option.category.MagicEquipment':
      'Magic items',
    'activerecord.attributes.ninth_age_unit_option.category.MagicLvl':
      'Magic LVL',
    'activerecord.attributes.ninth_age_unit_option.category.MagicPath':
      'Magic Path',
    'activerecord.attributes.ninth_age_unit_option.category.MayTake':
      'May take',
    'activerecord.attributes.ninth_age_unit_option.category.Mount': 'Mount',
    'activerecord.attributes.ninth_age_unit_option.category.MustChoice':
      'Must choose',
    'activerecord.attributes.ninth_age_unit_option.category.OneChoice':
      'One choice only',
    'activerecord.attributes.ninth_age_unit_option.category.S':
      'Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.SpecialRule':
      'Special Rule',
    'activerecord.attributes.ninth_age_unit_option.category.WizardAdept':
      'Wizard Adept',
    'activerecord.attributes.ninth_age_unit_option.category.WizardApprentice':
      'Wizard Apprentice',
    'activerecord.attributes.ninth_age_unit_option.category.WizardMaster':
      'Wizard Master',
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ChangeUnitOrganisation':
      "Change unit's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ExcludeAddOrganisation':
      "Not affected with other unit option's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.Unit':
      'All the unit',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Add':
      'Add',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Replace':
      'Replace',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.A':
      'V1-A',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.BS':
      'V1-BS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.E':
      'V1-E',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.I':
      'V1-I',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.LD':
      'V1-Ld',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.M':
      'V1-M',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.S':
      'V1-S',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.T':
      'V1-T',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.W':
      'V1-W',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.WS':
      'V1-WS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_aeg':
      'V2-Aeg',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_agi':
      'V2-Agi',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ap':
      'V2-Ap',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_arm':
      'V2-Arm',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_att':
      'V2-Att',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_def':
      'V2-Def',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_dis':
      'V2-Dis',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_evoked':
      'V2-Evoked',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_adv':
      'V2-Fly-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_mar':
      'V2-Fly-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_adv':
      'V2-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_mar':
      'V2-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_hp':
      'V2-Hp',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_of':
      'V2-Of',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_res':
      'V2-Res',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_str':
      'V2-Str',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByArmy':
      'per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByModel':
      'item per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.MaxRatioByArmy':
      'Max Ratio per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Model':
      'Models per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ModelByUnit':
      'Models per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Units':
      'Units per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Quantity':
      'Quantity from the option',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Selection':
      'Option selected',
    'activerecord.attributes.ninth_age_version.game.EssenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.WarhammerBattle':
      'Warhammer Battle',
    'activerecord.attributes.ninth_age_version.game.essenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.ninthAge': 'Ninth Age',
    'activerecord.attributes.ninth_age_version.game.battle': 'Warhammer Battle',
    'activerecord.attributes.tournament/contest.participation': 'Participation',
    'activerecord.models.ninth_age/magic_standard.one': 'Magic banner',
    'activerecord.models.ninth_age/magic_standard.other': 'Magic banners',
    'activerecord.models.ninth_age/unit.one': 'Unit',
    'activerecord.models.ninth_age/unit.other': 'Units',
    'admin.dashboard': 'Administration',
    'admin.tournament': 'Tournament Org',
    and: ' and ',
    'army.armybook': 'Army book',
    'army.banner': 'Banner enchantement',
    'army.index.show': 'Show',
    'army.index.title': 'All armies',
    'army.show.back': 'Back',
    'army_list.clone.information': 'Are you sure to duplicate list:',
    'army_list.clone.submit': 'Duplicate',
    'army_list.clone.title': 'Duplicate list',
    'army_list.delete.information': 'Are you sure to destroy this list:',
    'army_list.delete.submit': '!!! Delete !!!',
    'army_list.delete.title': 'Delete\u003cbr /\u003elist',
    'army_list.edit.title': 'Update the list',
    'army_list.export.html_full': 'Full HTML',
    'army_list.export.html_lite': 'Lite HTML',
    'army_list.export.include_magics': 'Include magic paths?',
    'army_list.export.information': 'Choose format for list export:',
    'army_list.export.pdf_full': 'Full PDF',
    'army_list.export.pdf_lite': 'Lite PDF',
    'army_list.export.print': 'Print',
    'army_list.export.separator': 'Separator',
    'army_list.export.title': 'Export list',
    'army_list.export.txt.general': 'General',
    'army_list.export.verbosity': 'Verbosity',
    'army_list.form.army.error': 'You must select an army.',
    'army_list.form.army.placeholder': 'Select an army',
    'army_list.form.army.title': 'Army *',
    'army_list.form.folder.placeholder': 'Select a folder',
    'army_list.form.folder.title': 'Folder',
    'army_list.form.max.name': 'You must choose the max of your army',
    'army_list.form.max.placeholder': 'Enter a max',
    'army_list.form.max.title': 'Max *',
    'army_list.form.name.error': 'You must name your list',
    'army_list.form.name.placeholder': 'Enter a name',
    'army_list.form.name.title': 'Name *',
    'army_list.form.notes.placeholder': 'My notes',
    'army_list.form.notes.title': 'Notes',
    'army_list.form.private.title': 'is a private list',
    'army_list.form.rate.title': 'Rate with max',
    'army_list.form.version.error': 'You must select a version.',
    'army_list.form.version.placeholder': 'Select a version',
    'army_list.form.version.title': 'Version *',
    'army_list.format.title': 'Format \u0026 Import an army list',
    'army_list.index.add': 'Create new army list',
    'army_list.index.and': 'and',
    'army_list.index.contest': 'Create a contest',
    'army_list.index.filter': 'Filter by',
    'army_list.index.folder': 'Create new folder',
    'army_list.index.name_or_notes': 'Name or notes',
    'army_list.index.search': 'Submit',
    'army_list.index.title': 'My army lists',
    'army_list.new.title': 'Create new list',
    'army_list.show.add_unit': 'Add unit',
    'army_list.show.delete': 'Delete',
    'army_list.show.duplicate': 'Duplicate',
    'army_list.show.edit': 'Edit',
    'army_list.show.export': 'Export',
    'army_list.show.notes': 'Notes',
    'army_list.show.organisation.excess': 'Excess',
    'army_list.show.organisation.missing': 'Missing',
    'army_list.show.organisation.remaining': 'Remaining',
    'army_list.show.print': 'Print',
    'army_list.show.rearrange_units': 'Rearrange Units',
    'army_list.show.title': 'Army list • {name}',
    'army_list.unit.form.name.placeholder': 'Add a name',
    'army_list.unit.form.name.title': 'Name',
    'army_list.unit.form.title': 'Add an unit',
    'army_list.unit.form.unit.error': 'You must select an unit',
    'army_list.unit.form.unit.placeholder': 'Select an unit',
    'army_list.unit.form.unit.title': 'Unit *',
    'army_list_unit.delete.information':
      'Sind Sie sicher, diese Einheit zu zerstören:',
    'army_list_unit.delete.submit': '!!! Löschen !!!',
    'army_list_unit.delete.title': 'Löschen',
    'army_list_unit.duplicate.new_army_list': 'Neue% {Name} Liste',
    'army_list_unit.duplicate.target': 'Nach:',
    'army_list_unit.duplicate.title': 'Duplikat',
    'army_list_unit.edit.form.magic': 'Magie',
    'army_list_unit.edit.form.notes': 'Notizen',
    'army_list_unit.edit.magic_items': 'Magische Gegenstände',
    'army_list_unit.edit.magic_standards': 'Magische Standards',
    'army_list_unit.edit.options': 'Optionen',
    'army_list_unit.edit.title': 'Bearbeiten',
    'army_list_unit.form.name': 'Name',
    'army_list_unit.form.submit': 'Create Unit',
    'army_list_unit.new.title': 'Add new unit',
    'army_list_unit.show.command_group_unit_options': 'Command Group Options',
    'army_list_unit.show.delete': 'Löschen',
    'army_list_unit.show.duplicate': 'Duplikat',
    'army_list_unit.show.edit': 'Bearbeiten',
    'army_list_unit.show.model_rules': 'ModelRules',
    'army_list_unit.show.magic': 'Magic',
    'army_list_unit.show.magic_items': 'Magic items',
    'army_list_unit.show.magic_lvl_unit_options':
      'May become (one choice only)',
    'army_list_unit.show.magic_standards': 'Magic banners',
    'army_list_unit.show.magic_unit_options': 'Magic Options',
    'army_list_unit.show.mount_unit_options': 'Mount Options',
    'army_list_unit.show.notes': 'Notes',
    'army_list_unit.show.path_unit_options': 'Must generate spells from',
    'army_list_unit.show.path_unit_options_choose_one':
      'Must generate spells from (choose one)',
    'army_list_unit.show.troops.A': 'A',
    'army_list_unit.show.troops.BS': 'BS',
    'army_list_unit.show.troops.E': 'Evoked',
    'army_list_unit.show.troops.I': 'I',
    'army_list_unit.show.troops.LD': 'Ld',
    'army_list_unit.show.troops.M': 'M',
    'army_list_unit.show.troops.S': 'S',
    'army_list_unit.show.troops.T': 'T',
    'army_list_unit.show.troops.W': 'W',
    'army_list_unit.show.troops.WS': 'WS',
    'army_list_unit.show.troops.name': 'Troops',
    'army_list_unit.show.troops.profile': 'Profile',
    'army_list_unit.show.troops.type': "Troop's type",
    'army_list_unit.show.unit_options': 'Options',
    'army_magic_spell.name': 'Racial Trait Spell',
    'builder.searchs.index.and': 'and',
    'builder.searchs.index.between': 'between',
    'builder.searchs.index.points': 'points',
    'builder.searchs.index.search': 'Search',
    'builder.searchs.index.search_army_select_error':
      'You must select one army',
    'builder.searchs.index.select_army': 'Choise the army',
    'builder.searchs.index.select_points_range': 'Number of point',
    'builder.searchs.index.select_version': 'Choise the version of 9Th Age',
    'builder.searchs.index.title': 'Search an Army list',
    'builder.searchs.show.and': 'and',
    'builder.searchs.show.between': 'between',
    'builder.searchs.show.points': 'points',
    'builder.searchs.show.title': 'Army list found',
    close: 'Schließen',
    'confirmation.form.email': 'Email',
    'confirmation.form.submit': 'Save',
    'confirmation.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'confirmation.lost.password': 'I have lost my password!',
    'confirmation.title': 'Bestätigungsanweisungen erneut senden',
    'contest.back': 'back',
    'contest.delete.information': 'Are you sure to delete:',
    'contest.delete.submit': '!!! Delete !!!',
    'contest.delete.title': 'Delete contest',
    'contest.edit.title': 'Edit my contest',
    'contest.form.armyListMax.error': 'Your contest need a max points by army',
    'contest.form.armyListMax.placeholder': 'Enter a max points by army',
    'contest.form.armyListMax.title': 'Max points by army',
    'contest.form.endDate.error': 'Your contest need a end date',
    'contest.form.endDate.placeholder': 'Enter a end date',
    'contest.form.endDate.title': 'End date *',
    'contest.form.name.error': 'You must name your list',
    'contest.form.name.placeholder': 'Enter a name',
    'contest.form.name.title': 'Name *',
    'contest.form.participation.error':
      'Your contest need a participation mode',
    'contest.form.participation.placeholder': 'Enter a participation mode',
    'contest.form.participation.title': 'Individual or by Team',
    'contest.form.startDate.error': 'Your contest need a start date',
    'contest.form.startDate.placeholder': 'Enter a start date',
    'contest.form.startDate.title': 'Start date *',
    'contest.form.teamMax.error': 'Your contest need a number of team',
    'contest.form.teamMax.placeholder': 'Enter a number of team',
    'contest.form.teamMax.title': 'Number of team',
    'contest.form.userMax.error':
      'Your contest need a number of participant or team size',
    'contest.form.userMax.placeholder':
      'Enter a number of participant or team size',
    'contest.form.userMax.title': 'Number of participant or team size',
    'contest.form.versionid.error': 'Your contest need a game version',
    'contest.form.versionid.placeholder': 'Enter a game version',
    'contest.form.versionid.title': 'Game version *',
    'contest.name': 'Tournament',
    'contest.new.title': 'Create a contest',
    'contest.show.title': 'Contest: {name}',
    'data_analytics.analytics.title': 'Project: Better data for T9A',
    'data_analytics.report.new.title': 'Report a game',
    'model_rules.index.show': 'Show',
    'model_rules.index.title': 'Sonderregeln',
    'export.format': 'Format',
    'export.full': 'Full',
    'export.lite': 'Lite',
    'export.magics': 'Magics',
    'export.nomagics': 'No Magics',
    'export.print': 'print',
    'export.verbosity': 'Verbosity',
    'export.withmagics': 'With magics',
    'folder.add_army_list.form.select': 'Select an army list',
    'folder.add_army_list.title': 'Add a list into this folder',
    'folder.back': 'back',
    'folder.delete.information': 'Are you sure to delete:',
    'folder.delete.submit': '!!! Delete !!!',
    'folder.delete.title': 'Delete folder',
    'folder.edit.title': 'Edit my folder',
    'folder.form.is_share.title': 'Share this folder',
    'folder.form.name.error': 'You must name your list',
    'folder.form.name.placeholder': 'Enter a name',
    'folder.form.name.title': 'Name *',
    'folder.form.parent.placeholder': 'Select the parent',
    'folder.form.parent.title': 'Parent',
    'folder.name': 'Folder',
    'folder.new.title': 'Create a folder',
    'folder.share.title': 'Share folder',
    'folder.show.title': 'Folder: {name}',
    'folder.tournament.information':
      'You can convert this folder into a tournament!',
    'folder.tournament.submit': '!!! Create !!!',
    'folder.tournament.title': 'Create a tournament',
    'footerlink.privacy': 'Privacy Policy',
    'form.add': 'Add',
    'form.cancel': 'Cancel',
    'form.create': 'Create',
    'form.format': 'Format',
    'form.import': 'Import',
    'form.save': 'Save',
    'format.form.date.error': 'You must select a creation date for your list',
    'format.form.date.placeholder': '01/01/2022',
    'format.form.date.title': 'Creation date *',
    'format.form.formated.title': 'Your formated army list',
    'format.form.game.error':
      "You must select the game's name that you want to play",
    'format.form.game.placeholder': 'T9A, EoW, WHB,....',
    'format.form.game.title': 'Your game *',
    'format.form.source.error': 'You must add your list',
    'format.form.source.placeholder': 'Enter an army list',
    'format.form.source.title': 'Your army list *',
    'format.new.title': 'Format and Import an army list',
    help: 'Hilfe',
    'home.app.available.google': 'Bekomm es auf Google Play',
    'home.app.available.on_platform': 'Derzeit verfügbar auf:',
    'home.app.mobile': 'A mobile app',
    'home.locale.available': '9ThBuilder ist in mehreren Sprachen verfügbar.',
    'home.locale.default':
      'Wenn Inhalte in der von Ihnen gewählten Sprache nicht verfügbar sind, werden standardmäßig englische Inhalte automatisch angezeigt.',
    'home.no_account':
      'You can now use all the features of 9ThBuilder without having to create an account first. \nBe careful however, your lists are linked to your local session and therefore will not be available on another browser and may be lost if you delete your cache or your session."\n',
    'home.welcome': '9TH BUILDER',
    'home.whoarewe.compose': 'Compose and archive your favorite armies!',
    'home.whoarewe.description':
      'A passionate of Battle since many years. I took the 9Th Builder since several years, creates a mobile application and helps the 9Th Age administration.\nHelped by Kaos War who greatly contributed to enter army lists and for the new homePage.\n9Th Builder is an effective and easy-to-use tool for creating your army lists and sharing them. It does not generate any income :)\n',
    'home.whoarewe.discord': 'Discord',
    'home.whoarewe.draft': 'Make a team pairing',
    'home.whoarewe.format': 'Format or import your army',
    'home.whoarewe.list': 'Create an Army list',
    'home.whoarewe.newsfb': 'News Facebook',
    'home.whoarewe.paint': 'Create an Paint list',
    'home.whoarewe.readarmy': 'Read Army Books',
    'home.whoarewe.readmagic': 'Read Magic Paths',
    'home.whoarewe.title': 'Who are we?',
    'home.whoarewe.try': 'Do you want to try?',
    'home.whoarewe.whatdo': 'What can you do?',
    'lexicon.index.show': 'Army books \u0026 Tools',
    'magic.casting': 'Gießen',
    'magic.duration': 'Dauer',
    'magic.effect': 'Bewirken',
    'magic.index.show': 'Show',
    'magic.index.title': 'Magie',
    'magic.range': 'Angebot',
    'magic.show.back': 'Zurück',
    'magic.type': 'Art',
    'magic_item_categories.index.show': 'Show',
    'magic_item_categories.index.title': 'Magic item categories',
    'magic_items.Cbtbmw': 'Cannot be taken by models with',
    'magic_items.Enchantment': 'Enchantment',
    'magic_items.dominant': 'Dominant',
    'magic_items.footonly': 'foot only',
    'magic_items.index.show': 'Show',
    'magic_items.index.title': 'Magic items',
    'magic_items.only': 'only',
    'magic_items.perArmy': 'par Armée',
    'magic_items.type_figurine.All': 'All',
    'magic_items.type_figurine.AnimisteBestial': 'Animiste bestial',
    'magic_items.type_figurine.Character': 'Character',
    'magic_items.type_figurine.FeralOrc': 'Feral Orc',
    'magic_items.type_figurine.Goblins': 'Goblins',
    'magic_items.type_figurine.Infantry': 'Infantry',
    'magic_items.type_figurine.KnightCommanders': 'Knight Commanders',
    'magic_items.type_figurine.MageOnFoot': 'Mage On Foot',
    'magic_items.type_figurine.MarshalsMountedOnHorse':
      'Marshals mounted on Horse',
    'magic_items.type_figurine.ModelsOnChariots': 'models on Chariots',
    'magic_items.type_figurine.ModelsOnFoot': 'Models on foot',
    'magic_items.type_figurine.MonarchsOfTheDead': 'Monarchs of the Dead',
    'magic_items.type_figurine.Monster': 'Monster',
    'magic_items.type_figurine.MountedCharacter': 'Mounted character',
    'magic_items.type_figurine.NoLargeTarget': 'No large target',
    'magic_items.type_figurine.ParentUnit': 'Parent Unit',
    'magic_items.type_figurine.Wizard': 'Wizard',
    'magic_spell.type_lvl.A': 'EIN',
    'magic_spell.type_lvl.Five': '5',
    'magic_spell.type_lvl.Four': '4',
    'magic_spell.type_lvl.One': '1',
    'magic_spell.type_lvl.Six': '6',
    'magic_spell.type_lvl.Three': '3',
    'magic_spell.type_lvl.Two': '2',
    'magic_spell.type_lvl.Zero': '0',
    'magic_standards.index.show': 'Show',
    'magic_standards.index.title': 'Magische Standards',
    'menu.army_lists': 'Meine Armeelisten',
    'menu.help': 'Hilfe',
    'menu.label': 'Hauptmenü',
    'menu.languages.de': 'Germany',
    'menu.languages.en': 'English',
    'menu.languages.es': 'Spanish - Español',
    'menu.languages.fr': 'French',
    'menu.languages.hu': 'Hungarian',
    'menu.languages.it': 'Italian - Italiano',
    'menu.languages.ko': 'Korean',
    'menu.languages.lang': 'Language',
    'menu.languages.pl': 'Polish',
    'menu.languages.ru': 'Russian',
    'menu.languages.sr': 'Serbian',
    'menu.languages.zh': 'Chinese',
    'menu.preferences': 'Einstellungen',
    'menu.signin': 'Anmelden',
    'menu.signout': 'Ausloggen',
    'menu.signup': 'Anmelden',
    next: 'Nächster',
    'ninth_age.figurine.mount': 'Mount',
    'ninth_age.figurine.pts': 'pts',
    'ninth_age.magic_item.only_wizard.AllWizard': 'Wizard only',
    'ninth_age.magic_item.only_wizard.NoWizard': 'Cannot be taken by Wizards',
    'ninth_age.magic_item.only_wizard.WizardAdept': 'Wizard adept only',
    'ninth_age.magic_item.only_wizard.WizardApprentice':
      'Wizard apprentice only',
    'ninth_age.magic_item.only_wizard.WizardMaster': 'Wizard master only',
    'ninth_age.troop.offensive': 'Offensive',
    'ninth_age.unit.defensive': 'Defensive',
    'ninth_age.unit.fly': 'fly',
    'ninth_age.unit.global': 'Global',
    'ninth_age.unit.rules': 'Model Rules',
    'paint_list.delete.information': 'Are you sure to destroy this list:',
    'paint_list.delete.submit': '!!! Delete !!!',
    'paint_list.delete.title': 'Delete your list',
    'paint_list.edit.title': 'Edit your paint list',
    'paint_list.form.army.error': 'You must select an army.',
    'paint_list.form.army.placeholder': 'Select an army',
    'paint_list.form.army.title': 'Army *',
    'paint_list.form.name.error': 'You must name your list',
    'paint_list.form.name.placeholder': 'Enter a name',
    'paint_list.form.name.title': 'Name *',
    'paint_list.form.version.error': 'You must select a version.',
    'paint_list.form.version.placeholder': 'Select a version',
    'paint_list.form.version.title': 'Version *',
    'paint_list.index.add': 'Create new paint list',
    'paint_list.index.title': 'My paint lists',
    'paint_list.new.title': 'Create a new list',
    'paint_list.show.assembled': 'Assembled',
    'paint_list.show.buy': 'Buy',
    'paint_list.show.comment': 'Comment',
    'paint_list.show.first_color': 'First color',
    'paint_list.show.paint': 'Paint',
    'paint_list.show.plinth': 'Plinth',
    'paint_list.show.size': 'Size',
    'paint_list.show.state.done': 'Done',
    'paint_list.show.state.waiting': 'Waiting',
    'paint_list.show.state.wip': 'Wip',
    'paint_list.show.title': 'Your Paint list:',
    'paint_list.show.trimmed': 'Trimmed',
    'paint_list.show.unit': 'Unit',
    'paint_list.unit.form.comment.placeholder': 'Add a comment',
    'paint_list.unit.form.comment.title': 'Comment',
    'paint_list.unit.form.size.error': 'You must add a number of model',
    'paint_list.unit.form.size.placeholder': 'Select a size',
    'paint_list.unit.form.size.title': 'Size *',
    'paint_list.unit.form.title': 'Add an unit',
    'paint_list.unit.form.unit.error': 'You must select an unit',
    'paint_list.unit.form.unit.placeholder': 'Select an unit',
    'paint_list.unit.form.unit.title': 'Unit *',
    'password_change.form.confirmation': 'Passwort Bestätigung',
    'password_change.form.password': 'Passwort',
    'password_change.form.submit': 'sparen',
    'password_change.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_change.lost.confirmation':
      "I didn't received my confirmation email",
    'password_change.lost.password': 'I have lost my password!',
    'password_change.title': 'Ändern Sie Ihr Passwort',
    'password_lost.form.email': 'Email',
    'password_lost.form.submit': 'Send me reset password instructions',
    'password_lost.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_lost.lost.confirmation':
      "I didn't received my confirmation email",
    'password_lost.title': 'Ich habe mein Passwort verloren',
    'picker.datetime.js': 'YYYY.MM.DD HH:mm',
    'picker.datetime.rb': '%Y.%m.%d %H:%M',
    'profile.back': 'Previous page',
    'profile.delete.information':
      'You are not satisfied? \u003ca href="mailto:support@9thbuilder.com"\u003eContact us\u003c/a\u003e or',
    'profile.delete.link': 'immediately destroy your account',
    'profile.delete.title': 'Account deletion',
    'profile.form.confirmation': 'Password confirmation',
    'profile.form.email': 'Email address',
    'profile.form.game': 'Favorite',
    'profile.form.name': 'Name or nickname',
    'profile.form.password': 'Password',
    'profile.form.password_help':
      "Leave it empty if you don't want to change your password",
    'profile.form.submit': 'Save',
    'profile.title': 'Mein Konto',
    save: 'sparen',
    'search_list.assembled': 'Assembled',
    'search_list.buy': 'Buy',
    'search_list.comment': 'Comment',
    'search_list.first_color': 'First color',
    'search_list.index.search': 'Submit',
    'search_list.index.search_list': 'Search an army list',
    'search_list.paint': 'Paint',
    'search_list.plinth': 'Plinth',
    'search_list.size': 'Size',
    'search_list.trimmed': 'Trimmed',
    'search_list.unit': 'Unit',
    'signin.Confirmation': 'Confirmation',
    'signin.form.email': 'Email',
    'signin.form.lost': 'Forgot ?',
    'signin.form.password': 'Password',
    'signin.form.remember': 'Remember me',
    'signin.form.submit': 'Sign-in',
    'signin.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signin.lost.confirmation': "I didn't received my confirmation email",
    'signin.lost.password': 'I have lost my password!',
    'signin.title': 'Sign in',
    'signup.form.confirmation': 'Password confirmation',
    'signup.form.email': 'Email address',
    'signup.form.game': '--Favorite--',
    'signup.form.name': 'Name or nickname',
    'signup.form.password': 'Password',
    'signup.form.register': 'Join us !',
    'signup.form.submit': 'Sign-up',
    'signup.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signup.lost.confirmation': "I didn't received my confirmation email",
    'signup.lost.password': 'I have lost my password!',
    'signup.title': 'Anmelden',
    'site.accept': 'I accept',
    'site.more': 'Learn more',
    'site.use_cookie':
      'This site uses cookies to offer you the best service. By continuing your navigation, you use the use of cookies.',
    'tool.pairing.done': 'Your pairing is complete',
    'tool.pairing.draft.send_link': 'Send this link to your opponent:',
    'tool.pairing.draft.waiting_opponent': 'We are waiting your opponent',
    'tool.pairing.draw.confirm.draw': 'Confirm Draw',
    'tool.pairing.draw.confirm.response': 'Confirm Response',
    'tool.pairing.draw.confirm.select': 'Confirm select',
    'tool.pairing.draw.or': 'or',
    'tool.pairing.draw.vs': 'Vs',
    'tool.pairing.draw_round.select.draw': 'Select one army for the draft',
    'tool.pairing.draw_round.select.response': 'Select your reponses',
    'tool.pairing.draw_round.select.select': 'Select the army',
    'tool.pairing.draw_round.select.waiting': 'Waiting',
    'tool.pairing.image': 'Copy the pairing url image',
    'tool.pairing.inprogress': 'Your pairing is in progress',
    'tool.pairing.matches.tables': 'Tables:',
    'tool.pairing.my_team.my_armies': 'Your armies',
    'tool.pairing.opponent_team.team': 'Team',
    'tool.pairing.select_armies.choise_armies': 'Choise your armies',
    'tool.pairing.select_armies.confirm': 'Confirm',
    'tool.pairing.select_armies.error':
      'Sorry! There was an error loading the items.',
    'tool.pairing.select_armies.your_team': 'Your Team',
    'tool.pairing.select_team_size.how_many': 'How many players in the team?',
    'tool.pairing.table': 'Table',
    'tool.pairing.team_name.confirm': 'Confirm',
    'tool.pairing.team_name.what_name': "What's the name of your team?",
    'tool.pairing.team_name.your_name': 'Your team name',
    'tool.search_rules.index.search': 'Search',
    'tool.search_rules.index.search_army_select_error':
      'You must select one army',
    'tool.search_rules.index.search_rule': 'Choise one rule',
    'tool.search_rules.index.select_army': 'Choise the army',
    'tool.search_rules.index.select_version': 'Choise the version of 9Th Age',
    'tool.search_rules.index.title': 'Search by rules',
    'tournament.contest.back': 'Back to tournaments',
    'tournament.contest.edit': 'Edit',
    'tournament.contest.form.address': 'Address',
    'tournament.contest.form.end_date': 'End',
    'tournament.contest.form.fees': 'Fees',
    'tournament.contest.form.name': 'Name',
    'tournament.contest.form.round_count': 'Rounds',
    'tournament.contest.form.start_date': 'Start',
    'tournament.contest.form.submit': 'Save',
    'tournament.contest.form.team_max': 'Max teams',
    'tournament.contest.form.user_max': 'Max users',
    'tournament.contest.form.user_team_max': 'Max users by team',
    'tournament.contest.form.version': 'Version',
    'tournament.contest.index.title': 'My tournaments',
    'tournament.contest.name': 'Tournament',
    'tournament.contest.new.title': 'Create a tournament',
    'tournament.contest.print_armies': 'Print all armies',
    'tournament.contest.print_repport': 'Rapport',
    'tournament.contest.total': 'Total',
    'tournament.custom_point.name': 'Paint, Wysiwyg, List',
    'tournament.round.add': 'Add round',
    'tournament.round.name': 'Round',
    'tournament.round.pools.validate': 'Create pools',
    'tournament.team.add': 'Add Team',
    'tournament.team.back': 'Back to teams',
    'tournament.team.edit.title': 'Edition team',
    'tournament.team.export.title': 'Team',
    'tournament.team.first': 'Add your first team',
    'tournament.team.form.email': 'Email',
    'tournament.team.form.name': 'Name',
    'tournament.team.form.submit': 'Save',
    'tournament.team.index.title': 'My Tournament teams',
    'tournament.team.name': 'Teams',
    'tournament.team.new.title': 'Add teams',
    'tournament.teams.add': 'Add Team',
    'tournament.teams.back': 'Back to tournaments',
    'tournament.teams.title': 'Teams',
    'tournament.user_apply.add': 'Add Participant',
    'tournament.user_apply.add_into_team': 'Add partipant in this team',
    'tournament.user_apply.army_list.add_now': 'Add it now!',
    'tournament.user_apply.army_list.create': 'Create a new list',
    'tournament.user_apply.army_list.need':
      'You have not added your army list yet.',
    'tournament.user_apply.army_list.or': 'or',
    'tournament.user_apply.army_list.use_existing': 'Use an existing list',
    'tournament.user_apply.army_list.which': 'Which army list ?',
    'tournament.user_apply.army_list_select.form.submit': 'Save',
    'tournament.user_apply.edit.title': 'Edit your participation',
    'tournament.user_apply.first': 'Add your first Participant',
    'tournament.user_apply.form.name': 'Name',
    'tournament.user_apply.form.name_detail':
      'You can add somes users (1 user by line) with email separated by a comma (name, email).',
    'tournament.user_apply.form.or': 'or',
    'tournament.user_apply.form.submit': 'Add',
    'tournament.user_apply.form.user': 'User',
    'tournament.user_apply.manage': 'Manage Team',
    'tournament.user_apply.name': 'User',
    'tournament.user_apply.new.title': 'Add users',
    'tournament.user_apply.remove': 'Remove Participant',
    'tournament.user_apply.share_link': 'Share invitation link',
    'tournament.user_apply.team_leader': 'Is the team captain',
    'unit.base.label': 'Base',
    'unit.height.Gigantic': 'Gigantic',
    'unit.height.Large': 'Large',
    'unit.height.Standard': 'Standard',
    'unit.limit.model': 'Models/Army',
    'unit.limit.perArmy': 'par Armée',
    'unit.limit.single': 'single model',
    'unit.limit.unit': 'Units/Army',
    'unit.mount': 'Mount',
    'unit.show.add_model':
      ' + \u003cstrong\u003e{pts}\u003c/strong\u003e pts/extra model',
    'unit.show.change':
      '{name} utils of {number} models count towards {new_name}',
    'unit.show.change_with_limit':
      'Units of {number} or more models without {limit} count towards {new_name} instead of {old_name}.',
    'unit.show.size':
      '\u003cstrong\u003e{min_size}-{max_size}\u003c/strong\u003e models',
    'unit.size.Gigantic': 'Gigantic',
    'unit.size.Large': 'Large',
    'unit.size.Standard': 'Standard',
    'unit.type.label': 'Type',
    'unit_option.per_model': '/mod.',
    'unit_option.use_points.free': 'free',
    'unit_option.use_points.no_limit': 'no limit',
    'unit_option.use_points.up_to': 'up to',
    'unit_options.category.C': 'C',
    'unit_options.category.M': 'M',
    'unit_options.category.S': 'S',
    'unit_options.footonly': 'foot only',
    'version.index.pairing': 'Team Pairing',
    'version.index.search': 'Search by rule',
    'version.index.show': 'Show',
    'version.index.title': 'Versions',
    'version.index.tools': 'Tools',
    'version.show.back': 'Zurück',
    welcome: 'Herzlich willkommen',
    with: 'with %',
    without: 'without %',
    'activerecord.attributes.user.current_password': 'Bisheriges Passwort',
    'activerecord.attributes.user.email': 'E-Mail',
    'activerecord.attributes.user.password': 'Passwort',
    'activerecord.attributes.user.password_confirmation': 'Passwortbestätigung',
    'activerecord.attributes.user.remember_me': 'Angemeldet bleiben',
    'activerecord.attributes.user.reset_password_token':
      'Passwort-Zurücksetzen-Token',
    'activerecord.attributes.user.unlock_token': 'Entsperrungs-Token',
    'activerecord.models.user': 'Benutzer',
    'devise.sessions.signed_in': '',
    'devise.sessions.signed_out': '',
    'users.confirmations.confirmed':
      'Ihre E-Mail Adresse wurde erfolgreich bestätigt.',
    'users.confirmations.new.resend_confirmation_instructions':
      'Anleitung zur Bestätigung noch mal schicken',
    'users.confirmations.send_instructions':
      'Sie erhalten in wenigen Minuten eine E-Mail, mit der Sie Ihre Registrierung bestätigen können.',
    'users.confirmations.send_paranoid_instructions':
      'Falls Ihre E-Mail-Adresse in unserer Datenbank existiert, erhalten Sie in wenigen Minuten eine E-Mail, mit der Sie Ihre Registrierung bestätigen können.',
    'users.failure.already_authenticated': 'Sie sind bereits angemeldet.',
    'users.failure.inactive': 'Ihr Account ist nicht aktiv.',
    'users.failure.invalid': 'Ungültige Anmeldedaten.',
    'users.failure.last_attempt':
      'Sie haben noch einen Versuch, bis Ihr Account gesperrt wird.',
    'users.failure.locked': 'Ihr Account ist gesperrt.',
    'users.failure.not_found_in_database': 'Ungültige Anmeldedaten.',
    'users.failure.timeout':
      'Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an.',
    'users.failure.unauthenticated':
      'Sie müssen sich anmelden oder registrieren, bevor Sie fortfahren können.',
    'users.failure.unconfirmed':
      'Sie müssen Ihren Account bestätigen, bevor Sie fortfahren können.',
    'users.mailer.confirmation_instructions.action': 'Mein Konto bestätigen',
    'users.mailer.confirmation_instructions.greeting':
      'Willkommen {recipient}!',
    'users.mailer.confirmation_instructions.instruction':
      'Folgen Sie dem untenstehenden Link, um Ihr Konto zu bestätigen:',
    'users.mailer.confirmation_instructions.subject':
      'Anleitung zur Bestätigung Ihres Accounts',
    'users.mailer.password_change.greeting': 'Hallo {recipient}!',
    'users.mailer.password_change.message':
      'Wir kontaktieren Sie, um Ihnen mitzuteilen, dass Ihr Passwort geändert wurde.',
    'users.mailer.password_change.subject': 'Passwort geändert',
    'users.mailer.reset_password_instructions.action': 'Passwort ändern',
    'users.mailer.reset_password_instructions.greeting': 'Hallo {recipient}!',
    'users.mailer.reset_password_instructions.instruction':
      'Jemand hat einen Link angefordert, um Ihr Passwort zu ändern. Klicken Sie auf den unten aufgeführten Link um das Passwort zu ändern.',
    'users.mailer.reset_password_instructions.instruction_2':
      'Bitte ignorieren Sie diese E-Mail, wenn Sie kein neues Passwort angefordert haben.',
    'users.mailer.reset_password_instructions.instruction_3':
      'Das Passwort wird nicht geändert bis Sie den obenstehenden Link abrufen und ein neues Passwort bestimmen.',
    'users.mailer.reset_password_instructions.subject':
      'Anleitung für das Zurücksetzen Ihres Passworts',
    'users.mailer.unlock_instructions.action': 'Mein Konto entsperren',
    'users.mailer.unlock_instructions.greeting': 'Hallo {recipient}!',
    'users.mailer.unlock_instructions.instruction':
      'Folgen Sie dem untenstehenden Link, um Ihr Konto zu entsperren:',
    'users.mailer.unlock_instructions.message':
      'Ihr Konto wurde aufgrund einer großen Anzahl von fehlgeschlagenen Anmeldeversuchen gesperrt.',
    'users.mailer.unlock_instructions.subject':
      'Anleitung für die Account-Freischaltung',
    'users.omniauth_callbacks.failure':
      'Sie konnten nicht mit Ihrem {kind}-Account angemeldet werden, weil "{reason}".',
    'users.omniauth_callbacks.success':
      'Sie haben sich erfolgreich mit Ihrem {kind}-Account angemeldet.',
    'users.passwords.edit.change_my_password': 'Ändere mein Passwort',
    'users.passwords.edit.change_your_password': 'Passwort ändern',
    'users.passwords.edit.confirm_new_password': 'Neues Passwort bestätigen',
    'users.passwords.edit.new_password': 'Neues Passwort',
    'users.passwords.new.forgot_your_password':
      'Haben Sie Ihr Passwort vergessen?',
    'users.passwords.new.send_me_reset_password_instructions':
      'Schicken Sie mir die Anleitung, mein Passwort zurückzusetzen',
    'users.passwords.no_token':
      'Sie können sich nicht auf dieser Seite anmelden, wenn Sie nicht von einer Passwort-Zurücksetzen-E-Mail kommen. Wenn Sie von solch einer E-Mail kommen, überprüfen Sie bitte, ob Sie die gesamte URL verwendeten.',
    'users.passwords.send_instructions':
      'Sie erhalten in wenigen Minuten eine E-Mail mit der Anleitung, wie Sie Ihr Passwort zurücksetzen können.',
    'users.passwords.send_paranoid_instructions':
      'Falls Ihre E-Mail-Adresse in unserer Datenbank existiert, erhalten Sie in wenigen Minuten eine E-Mail, mit der Anleitung, wie Sie Ihr Passwort zurücksetzen können.',
    'users.passwords.updated':
      'Ihr Passwort wurde geändert. Sie sind jetzt angemeldet.',
    'users.passwords.updated_not_active': 'Ihr Passwort wurde geändert.',
    'users.registrations.destroyed': 'Ihr Account wurde gelöscht.',
    'users.registrations.edit.are_you_sure': 'Sind Sie sicher?',
    'users.registrations.edit.cancel_my_account': 'Konto löschen',
    'users.registrations.edit.currently_waiting_confirmation_for_email':
      'Warte auf Bestätigung von {email}.',
    'users.registrations.edit.leave_blank_if_you_don_t_want_to_change_it':
      'freilassen, wenn Sie das nicht ändern wollen',
    'users.registrations.edit.title': '{resource} bearbeiten',
    'users.registrations.edit.unhappy': 'Unglücklich',
    'users.registrations.edit.update': 'Aktualisieren',
    'users.registrations.edit.we_need_your_current_password_to_confirm_your_changes':
      'wir benötigen Ihr aktuelles Passwort, um die Änderung zu bestätigen',
    'users.registrations.new.sign_up': 'Registrieren',
    'users.registrations.signed_up': 'Sie haben sich erfolgreich registriert.',
    'users.registrations.signed_up_but_inactive':
      'Sie haben sich erfolgreich registriert. Wir konnten Sie jedoch nicht anmelden, weil Ihr Account noch nicht aktiviert ist.',
    'users.registrations.signed_up_but_locked':
      'Sie haben sich erfolgreich registriert. Wir konnten Sie jedoch nicht anmelden, weil Ihr Account gesperrt ist.',
    'users.registrations.signed_up_but_unconfirmed':
      'Sie erhalten in wenigen Minuten eine E-Mail mit einem Link für die Bestätigung der Registrierung. Klicken Sie auf den Link um Ihren Account zu aktivieren.',
    'users.registrations.update_needs_confirmation':
      'Ihre Daten wurden aktualisiert, aber Sie müssen Ihre neue E-Mail-Adresse bestätigen. Sie erhalten in wenigen Minuten eine E-Mail, mit der Sie die Änderung Ihrer E-Mail-Adresse abschließen können.',
    'users.registrations.updated': 'Ihre Daten wurden aktualisiert.',
    'users.sessions.already_signed_out': 'Erfolgreich abgemeldet.',
    'users.sessions.new.sign_in': 'Anmelden',
    'users.sessions.signed_in': 'Erfolgreich angemeldet.',
    'users.sessions.signed_out': 'Erfolgreich abgemeldet.',
    'users.shared.links.back': 'Zurück',
    'users.shared.links.didn_t_receive_confirmation_instructions':
      'Keine Anleitung zur Bestätigung erhalten?',
    'users.shared.links.didn_t_receive_unlock_instructions':
      'Keine Anleitung zum Entsperren erhalten?',
    'users.shared.links.forgot_your_password': 'Passwort vergessen?',
    'users.shared.links.sign_in': 'Anmelden',
    'users.shared.links.sign_in_with_provider': 'Mit {provider} anmelden',
    'users.shared.links.sign_up': 'Registrieren',
    'users.unlocks.new.resend_unlock_instructions':
      'Anleitung zum Entsperren noch mal schicken',
    'users.unlocks.send_instructions':
      'Sie erhalten in wenigen Minuten eine E-Mail mit der Anleitung, wie Sie Ihren Account entsperren können.',
    'users.unlocks.send_paranoid_instructions':
      'Falls Ihre E-Mail-Adresse in unserer Datenbank existiert, erhalten Sie in wenigen Minuten eine E-Mail, mit der Anleitung, wie Sie Ihren Account entsperren können.',
    'users.unlocks.unlocked':
      'Ihr Account wurde entsperrt. Sie sind jetzt angemeldet.',
    'errors.messages.already_confirmed':
      'wurde bereits bestätigt, bitte versuchen Sie, sich anzumelden',
    'errors.messages.confirmation_period_expired':
      'musste innerhalb von {period} bestätigt werden, bitte neu anfordern.',
    'errors.messages.expired': 'ist abgelaufen, bitte neu anfordern',
    'errors.messages.not_found': 'nicht gefunden',
    'errors.messages.not_locked': 'ist nicht gesperrt',
    'errors.messages.not_saved.one':
      '{resource} konnte aufgrund eines Fehlers nicht gespeichert werden:',
    'errors.messages.not_saved.other':
      '{count} Fehler verhinderten das Speichern von {resource}:',
  },
  en: {
    'activerecord.attributes.user.current_password': 'Current password',
    'activerecord.attributes.user.email': 'Email',
    'activerecord.attributes.user.password': 'Password',
    'activerecord.attributes.user.password_confirmation':
      'Password confirmation',
    'activerecord.attributes.user.remember_me': 'Remember me',
    'activerecord.attributes.user.reset_password_token': 'Reset password token',
    'activerecord.attributes.user.unlock_token': 'Unlock token',
    'activerecord.models.user': 'User',
    'devise.sessions.signed_in': '',
    'devise.sessions.signed_out': '',
    'users.confirmations.confirmed':
      'Your email address has been successfully confirmed.',
    'users.confirmations.new.resend_confirmation_instructions':
      'Resend confirmation instructions',
    'users.confirmations.send_instructions':
      'You will receive an email with instructions for how to confirm your email address in a few minutes.',
    'users.confirmations.send_paranoid_instructions':
      'If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes.',
    'users.failure.already_authenticated': 'You are already signed in.',
    'users.failure.inactive': 'Your account is not activated yet.',
    'users.failure.invalid': 'Invalid email or password.',
    'users.failure.last_attempt':
      'You have one more attempt before your account is locked.',
    'users.failure.locked': 'Your account is locked.',
    'users.failure.not_found_in_database': 'Invalid email address or password.',
    'users.failure.timeout':
      'Your session expired. Please sign in again to continue.',
    'users.failure.unauthenticated':
      'You need to sign in or sign up before continuing.',
    'users.failure.unconfirmed':
      'You have to confirm your email address before continuing.',
    'users.mailer.confirmation_instructions.action': 'Confirm my account',
    'users.mailer.confirmation_instructions.greeting': 'Welcome {recipient}!',
    'users.mailer.confirmation_instructions.instruction':
      'You can confirm your account email through the link below:',
    'users.mailer.confirmation_instructions.subject':
      'Confirmation instructions',
    'users.mailer.password_change.greeting': 'Hello {recipient}!',
    'users.mailer.password_change.message':
      "We're contacting you to notify you that your password has been changed.",
    'users.mailer.password_change.subject': 'Password Changed',
    'users.mailer.reset_password_instructions.action': 'Change my password',
    'users.mailer.reset_password_instructions.greeting': 'Hello {recipient}!',
    'users.mailer.reset_password_instructions.instruction':
      'Someone has requested a link to change your password, and you can do this through the link below.',
    'users.mailer.reset_password_instructions.instruction_2':
      "If you didn't request this, please ignore this email.",
    'users.mailer.reset_password_instructions.instruction_3':
      "Your password won't change until you access the link above and create a new one.",
    'users.mailer.reset_password_instructions.subject':
      'Reset password instructions',
    'users.mailer.unlock_instructions.action': 'Unlock my account',
    'users.mailer.unlock_instructions.greeting': 'Hello {recipient}!',
    'users.mailer.unlock_instructions.instruction':
      'Click the link below to unlock your account:',
    'users.mailer.unlock_instructions.message':
      'Your account has been locked due to an excessive amount of unsuccessful sign in attempts.',
    'users.mailer.unlock_instructions.subject': 'Unlock instructions',
    'users.omniauth_callbacks.failure':
      'Could not authenticate you from {kind} because "{reason}".',
    'users.omniauth_callbacks.success':
      'Successfully authenticated from {kind} account.',
    'users.passwords.edit.change_my_password': 'Change my password',
    'users.passwords.edit.change_your_password': 'Change your password',
    'users.passwords.edit.confirm_new_password': 'Confirm new password',
    'users.passwords.edit.new_password': 'New password',
    'users.passwords.new.forgot_your_password': 'Forgot your password?',
    'users.passwords.new.send_me_reset_password_instructions':
      'Send me reset password instructions',
    'users.passwords.no_token':
      "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
    'users.passwords.send_instructions':
      'You will receive an email with instructions on how to reset your password in a few minutes.',
    'users.passwords.send_paranoid_instructions':
      'If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.',
    'users.passwords.updated':
      'Your password has been changed successfully. You are now signed in.',
    'users.passwords.updated_not_active':
      'Your password has been changed successfully.',
    'users.registrations.destroyed':
      'Bye! Your account has been successfully cancelled. We hope to see you again soon.',
    'users.registrations.edit.are_you_sure': 'Are you sure?',
    'users.registrations.edit.cancel_my_account': 'Cancel my account',
    'users.registrations.edit.currently_waiting_confirmation_for_email':
      'Currently waiting confirmation for: {email}',
    'users.registrations.edit.leave_blank_if_you_don_t_want_to_change_it':
      "leave blank if you don't want to change it",
    'users.registrations.edit.title': 'Edit {resource}',
    'users.registrations.edit.unhappy': 'Unhappy?',
    'users.registrations.edit.update': 'Update',
    'users.registrations.edit.we_need_your_current_password_to_confirm_your_changes':
      'we need your current password to confirm your changes',
    'users.registrations.new.sign_up': 'Sign up',
    'users.registrations.signed_up':
      'Welcome! You have signed up successfully.',
    'users.registrations.signed_up_but_inactive':
      'You have signed up successfully. However, we could not sign you in because your account is not yet activated.',
    'users.registrations.signed_up_but_locked':
      'You have signed up successfully. However, we could not sign you in because your account is locked.',
    'users.registrations.signed_up_but_unconfirmed':
      'A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.',
    'users.registrations.update_needs_confirmation':
      'You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirm link to confirm your new email address.',
    'users.registrations.updated':
      'Your account has been updated successfully.',
    'users.sessions.already_signed_out': 'Signed out successfully.',
    'users.sessions.new.sign_in': 'Sign in',
    'users.sessions.signed_in': '',
    'users.sessions.signed_out': '',
    'users.shared.links.back': 'Back',
    'users.shared.links.didn_t_receive_confirmation_instructions':
      "Didn't receive confirmation instructions?",
    'users.shared.links.didn_t_receive_unlock_instructions':
      "Didn't receive unlock instructions?",
    'users.shared.links.forgot_your_password': 'Forgot your password?',
    'users.shared.links.sign_in': 'Sign in',
    'users.shared.links.sign_in_with_provider': 'Sign in with {provider}',
    'users.shared.links.sign_up': 'Sign up',
    'users.unlocks.new.resend_unlock_instructions':
      'Resend unlock instructions',
    'users.unlocks.send_instructions':
      'You will receive an email with instructions for how to unlock your account in a few minutes.',
    'users.unlocks.send_paranoid_instructions':
      'If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.',
    'users.unlocks.unlocked':
      'Your account has been unlocked successfully. Please sign in to continue.',
    'errors.messages.already_confirmed':
      'was already confirmed, please try signing in',
    'errors.messages.confirmation_period_expired':
      'needs to be confirmed within {period}, please request a new one',
    'errors.messages.expired': 'has expired, please request a new one',
    'errors.messages.not_found': 'not found',
    'errors.messages.not_locked': 'was not locked',
    'errors.messages.not_saved.one':
      '1 error prohibited this {resource} from being saved:',
    'errors.messages.not_saved.other':
      '{count} errors prohibited this {resource} from being saved:',
    'activerecord.attributes.builder.army_list.size.Warbands': 'Warbands',
    'activerecord.attributes.builder.army_list.size.Standard': 'Standard',
    'activerecord.attributes.builder.army_list.size.GrandArmies':
      'Grand Armies',
    'activerecord.attributes.data_analytics/report.deployments.CounterThrust':
      'Counter Thrust',
    'activerecord.attributes.data_analytics/report.deployments.DawnAssult':
      'Dawn Assult',
    'activerecord.attributes.data_analytics/report.deployments.Encircle':
      'Encircle',
    'activerecord.attributes.data_analytics/report.deployments.FrontlineClash':
      'Frontline Clash',
    'activerecord.attributes.data_analytics/report.deployments.MarchingColumns':
      'Marching Columns',
    'activerecord.attributes.data_analytics/report.deployments.RefusedFlank':
      'Refused Flank',
    'activerecord.attributes.data_analytics/report.maps.A1':
      'A1 - Shrouded Pool',
    'activerecord.attributes.data_analytics/report.maps.A2':
      'A2 - Foothill Outpost',
    'activerecord.attributes.data_analytics/report.maps.A3':
      'A3 - Dilapidated Manor',
    'activerecord.attributes.data_analytics/report.maps.A4':
      'A4 - Volcanic Lake',
    'activerecord.attributes.data_analytics/report.maps.A5':
      'A5 - Misty Marshes',
    'activerecord.attributes.data_analytics/report.maps.A6':
      'A6 - Ancient Walls',
    'activerecord.attributes.data_analytics/report.maps.A7': 'A7 - Beacon Hill',
    'activerecord.attributes.data_analytics/report.maps.A8':
      'A8 - Witch’s Cottage',
    'activerecord.attributes.data_analytics/report.maps.B1':
      'B1 - Mage’s Sanctum',
    'activerecord.attributes.data_analytics/report.maps.B2':
      'B2 - Villa Grounds',
    'activerecord.attributes.data_analytics/report.maps.B3':
      'B3 - Ancient Fortress',
    'activerecord.attributes.data_analytics/report.maps.B4':
      'B4 - Frontier Farm',
    'activerecord.attributes.data_analytics/report.maps.B5':
      'B5 - Ravaged Watchtower',
    'activerecord.attributes.data_analytics/report.maps.B6':
      'B6 - Creeping Forest',
    'activerecord.attributes.data_analytics/report.maps.B7':
      'B7 - Eerie Graveyard',
    'activerecord.attributes.data_analytics/report.maps.B8':
      'B8 - Shattered Bridge',
    'activerecord.attributes.data_analytics/report.objectives.Breakthrough':
      'Breakthrough',
    'activerecord.attributes.data_analytics/report.objectives.CaptureFlags':
      'Capture the Flags',
    'activerecord.attributes.data_analytics/report.objectives.HoldGround':
      'Hold the Ground',
    'activerecord.attributes.data_analytics/report.objectives.KingHill':
      'King of the Hill',
    'activerecord.attributes.data_analytics/report.objectives.SecureTarget':
      'Secure Target',
    'activerecord.attributes.data_analytics/report.objectives.SpoilsWar':
      'Spoils of War',
    'activerecord.attributes.data_analytics/report.opponent_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.opponent_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.opponent_objective':
      'Take the objective',
    'activerecord.attributes.data_analytics/report.your_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.your_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.your_objective':
      'Take the objective',
    'activerecord.attributes.ninth_age/magic_item.only_foot':
      'Prohibited mount',
    'activerecord.attributes.ninth_age/magic_item.only_wizard':
      'Only wizard can use it',
    'activerecord.attributes.ninth_age/magic_item.organisation_ids':
      'Organisations required from the model',
    'activerecord.attributes.ninth_age/magic_item.model_rule_ids':
      'Prohibited  model rules on model',
    'activerecord.attributes.ninth_age/magic_item.unit_ids':
      'For this units only',
    'activerecord.attributes.ninth_age/magic_item.unit_size':
      'Unit with this size can not use this item',
    'activerecord.attributes.ninth_age/magic_standard.organisation':
      'Add organisation to unit',
    'activerecord.attributes.ninth_age/magic_standard.organisation_ids':
      "Only organisation's units",
    'activerecord.attributes.ninth_age/troop.carac_agi': 'Agi',
    'activerecord.attributes.ninth_age/troop.carac_ap': 'Ap',
    'activerecord.attributes.ninth_age/troop.carac_att': 'Att',
    'activerecord.attributes.ninth_age/troop.carac_of': 'Off',
    'activerecord.attributes.ninth_age/troop.carac_str': 'Str',
    'activerecord.attributes.ninth_age/unit.carac_cha': 'Cha',
    'activerecord.attributes.ninth_age/unit.carac_mob': 'Mob',
    'activerecord.attributes.ninth_age/unit.carac_cou': 'Cou',
    'activerecord.attributes.ninth_age/unit.carac_aeg': 'Aeg',
    'activerecord.attributes.ninth_age/unit.carac_arm': 'Arm',
    'activerecord.attributes.ninth_age/unit.carac_def': 'Def',
    'activerecord.attributes.ninth_age/unit.carac_dis': 'Dis',
    'activerecord.attributes.ninth_age/unit.carac_evoked': 'Rea',
    'activerecord.attributes.ninth_age/unit.carac_fly_adv': 'Fly adv',
    'activerecord.attributes.ninth_age/unit.carac_fly_mar': 'Fly mar',
    'activerecord.attributes.ninth_age/unit.carac_ground_adv': 'Adv',
    'activerecord.attributes.ninth_age/unit.carac_ground_mar': 'Mar',
    'activerecord.attributes.ninth_age/unit.carac_hp': 'HP',
    'activerecord.attributes.ninth_age/unit.carac_res': 'Res',
    'activerecord.attributes.ninth_age/unit.base.one': 'Base',
    'activerecord.attributes.ninth_age/unit.base.HundredHundredFifty':
      '100x150',
    'activerecord.attributes.ninth_age/unit.base.EightyEighty': '80x80',
    'activerecord.attributes.ninth_age/unit.base.FiftyFifty': '50x50',
    'activerecord.attributes.ninth_age/unit.base.FiftyHundred': '50x100',
    'activerecord.attributes.ninth_age/unit.base.FiftySeventyFive': '50x75',
    'activerecord.attributes.ninth_age/unit.base.FortyForty': '40x40',
    'activerecord.attributes.ninth_age/unit.base.FortyRound': '40',
    'activerecord.attributes.ninth_age/unit.base.FortySixty': '40x60',
    'activerecord.attributes.ninth_age/unit.base.FortyTwenty': '40x20',
    'activerecord.attributes.ninth_age/unit.base.HundredFifty': '100x50',
    'activerecord.attributes.ninth_age/unit.base.HundredFiftyHundred':
      '150x100',
    'activerecord.attributes.ninth_age/unit.base.HundredHundred': '100x100',
    'activerecord.attributes.ninth_age/unit.base.SeventyFiveFifty': '75x50',
    'activerecord.attributes.ninth_age/unit.base.SeventyFiveHundred': '75x100',
    'activerecord.attributes.ninth_age/unit.base.SeventyFiveRound': '75',
    'activerecord.attributes.ninth_age/unit.base.SixtyHundred': '60x100',
    'activerecord.attributes.ninth_age/unit.base.SixtyRound': '60',
    'activerecord.attributes.ninth_age/unit.base.TwentyFiveFifty': '25x50',
    'activerecord.attributes.ninth_age/unit.base.TwentyRound': '20',
    'activerecord.attributes.ninth_age/unit.base.TwentyFiveRound': '25',
    'activerecord.attributes.ninth_age/unit.base.TwentyFiveTwentyFive': '25x25',
    'activerecord.attributes.ninth_age/unit.base.TwentyTwenty': '20x20',
    'activerecord.attributes.ninth_age/unit.base.SeventyFiveSeventyFive':
      '75x75',
    'activerecord.attributes.ninth_age/unit.base.HundredTwoHundred': '100x200',
    'activerecord.attributes.ninth_age/unit.base.ThirtyThirty': '30x30',
    'activerecord.attributes.ninth_age/unit.base.ThirtySixty': '30x60',
    'activerecord.attributes.ninth_age/unit.base.FortyEighty': '40x80',
    'activerecord.attributes.ninth_age_army.source.FanMade': 'Fan Made',
    'activerecord.attributes.ninth_age_army.source.Official': 'Official',
    'activerecord.attributes.ninth_age_army.source.Supplement': 'Supplement',
    'activerecord.attributes.ninth_age_unit_option.category.BSB':
      'Battle Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.C': 'Champion',
    'activerecord.attributes.ninth_age_unit_option.category.Equipment':
      'Equipment',
    'activerecord.attributes.ninth_age_unit_option.category.ExtraSpells':
      'Spells',
    'activerecord.attributes.ninth_age_unit_option.category.General': 'General',
    'activerecord.attributes.ninth_age_unit_option.category.Generic': 'Generic',
    'activerecord.attributes.ninth_age_unit_option.category.M': 'Musician',
    'activerecord.attributes.ninth_age_unit_option.category.MagicBanner':
      'Banner Enchantment',
    'activerecord.attributes.ninth_age_unit_option.category.MagicEquipment':
      'Magic items',
    'activerecord.attributes.ninth_age_unit_option.category.MagicLvl':
      'Magic LVL',
    'activerecord.attributes.ninth_age_unit_option.category.MagicPath':
      'Magic Path',
    'activerecord.attributes.ninth_age_unit_option.category.MayTake':
      'May take',
    'activerecord.attributes.ninth_age_unit_option.category.Mount': 'Mount',
    'activerecord.attributes.ninth_age_unit_option.category.MustChoice':
      'Must choose',
    'activerecord.attributes.ninth_age_unit_option.category.OneChoice':
      'One choice only',
    'activerecord.attributes.ninth_age_unit_option.category.S':
      'Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.SpecialRule':
      'Special Rule',
    'activerecord.attributes.ninth_age_unit_option.category.WizardAdept':
      'Wizard Adept',
    'activerecord.attributes.ninth_age_unit_option.category.WizardApprentice':
      'Wizard Apprentice',
    'activerecord.attributes.ninth_age_unit_option.category.WizardMaster':
      'Wizard Master',
    'activerecord.attributes.ninth_age_unit_option.category.Spell': 'Spell',
    'activerecord.attributes.ninth_age_unit_option.category.MagicItemCategory':
      'Magic Item Category',
    'activerecord.attributes.ninth_age_unit_option.category.MagicItem':
      'Magic Item',
    'activerecord.attributes.ninth_age_unit_option.category.MagicStandard':
      'Magic Standard',
    'activerecord.attributes.ninth_age_unit_option.category.UnitEquipment':
      'Unit Equipment',
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ChangeUnitOrganisation':
      "Change unit's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ExcludeAddOrganisation':
      "Not affected with other unit option's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.Unit':
      'All the unit',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_availability.action.DisableForAll':
      'Disable for all units if present',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_availability.action.ChangePoints':
      'Change the cost of other option',
    'activerecord.attributes.ninth_age_unit_option_availability.action.AutoSelect':
      'Auto select another option',
    'activerecord.attributes.ninth_age_unit_option_availability.action.ChangeChoiseLimit':
      'Change the limit choise of an option',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Add':
      'Add',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Replace':
      'Replace',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.A':
      'V1-A',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.BS':
      'V1-BS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.E':
      'V1-E',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.I':
      'V1-I',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.LD':
      'V1-Ld',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.M':
      'V1-M',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.S':
      'V1-S',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.T':
      'V1-T',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.W':
      'V1-W',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.WS':
      'V1-WS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_aeg':
      'V2-Aeg',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_agi':
      'V2-Agi',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ap':
      'V2-Ap',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_arm':
      'V2-Arm',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_att':
      'V2-Att',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_def':
      'V2-Def',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_dis':
      'V2-Dis',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_evoked':
      'V2-Evoked',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_adv':
      'V2-Fly-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_mar':
      'V2-Fly-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_adv':
      'V2-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_mar':
      'V2-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_hp':
      'V2-Hp',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_of':
      'V2-Of',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_res':
      'V2-Res',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_str':
      'V2-Str',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByArmy':
      'per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByModel':
      'item per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.MaxRatioByArmy':
      'Max Ratio per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Model':
      'Models per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ModelByUnit':
      'Models per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Units':
      'Units per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Quantity':
      'Quantity from the option',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Selection':
      'Option selected',
    'activerecord.attributes.ninth_age_version.game.EssenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.WarhammerBattle':
      'Warhammer Battle',
    'activerecord.attributes.ninth_age_version.game.TheOldWorld':
      'The Old World',
    'activerecord.attributes.ninth_age_version.game.essenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.ninthAge': 'Ninth Age',
    'activerecord.attributes.ninth_age_version.game.battle': 'Warhammer Battle',
    'activerecord.attributes.ninth_age_version.game.theOldWorld':
      'The Old World',
    'activerecord.attributes.tournament/contest.participation': 'Participation',
    'activerecord.attributes.user.game.one': 'Game',
    'activerecord.attributes.user.game.essenceOfWar': 'Essence of War',
    'activerecord.attributes.user.game.ninthAge': 'Ninth Age',
    'activerecord.attributes.user.game.battle': 'Warhammer Battle',
    'activerecord.attributes.user.builder_interface.classic': 'Classic',
    'activerecord.attributes.user.builder_interface.oldSkool':
      'Old Skool (wahb)',
    'activerecord.attributes.publication_latex_build.status.one': 'Status',
    'activerecord.attributes.publication_latex_build.status.other': 'Status',
    'activerecord.attributes.publication_latex_build.status.pending': 'Pending',
    'activerecord.attributes.publication_latex_build.status.success': 'Success',
    'activerecord.attributes.publication_latex_build.status.failed': 'Failed',
    'activerecord.models.ninth_age/magic_standard.one': 'Magic banner',
    'activerecord.models.ninth_age/magic_standard.other': 'Magic banners',
    'activerecord.models.ninth_age/unit.one': 'Unit',
    'activerecord.models.ninth_age/unit.other': 'Units',
    'admin.dashboard': 'Administration',
    'admin.tournament': 'Tournament Org',
    and: ' and ',
    'army.armybook': 'Army book',
    'army.banner': 'Banner enchantement',
    'army.index.show': 'Show',
    'army.index.title': 'All armies',
    'army.show.back': 'Back',
    'army_list.clone.form.action': 'Are you sure to duplicate list:',
    'army_list.clone.form.title': 'Duplicate list',
    'army_list.delete.form.action': 'Are you sure to destroy this list:',
    'army_list.delete.form.title': 'Delete list',
    'army_list.edit.title': 'Update the list',
    'army_list.export.html_full': 'Full HTML',
    'army_list.export.html_lite': 'Lite HTML',
    'army_list.export.include_magics': 'Include magic paths?',
    'army_list.export.include_qrcodes': 'Include QR codes?',
    'army_list.export.information': 'Choose format for list export:',
    'army_list.export.pdf_full': 'Full PDF',
    'army_list.export.pdf_lite': 'Lite PDF',
    'army_list.export.print': 'Print',
    'army_list.export.separator': 'Separator',
    'army_list.export.title': 'Export list',
    'army_list.export.txt.general': 'General',
    'army_list.export.verbosity': 'Verbosity',
    'army_list.form.army.error': 'You must select an army.',
    'army_list.form.army.placeholder': 'Select an army',
    'army_list.form.army.title': 'Army *',
    'army_list.form.folder.placeholder': 'Select a folder',
    'army_list.form.folder.title': 'Folder',
    'army_list.form.max.name': 'You must choose the max of your army',
    'army_list.form.max.placeholder': 'Enter a max',
    'army_list.form.max.title': 'Max *',
    'army_list.form.min.name': 'You must choose the min of your army',
    'army_list.form.min.placeholder': 'Enter a min',
    'army_list.form.min.title': 'Min *',
    'army_list.form.name.error': 'You must name your list',
    'army_list.form.name.placeholder': 'Enter a name',
    'army_list.form.name.title': 'Name *',
    'army_list.form.notes.placeholder': 'My notes',
    'army_list.form.notes.title': 'Notes',
    'army_list.form.private.title': 'is a private list',
    'army_list.form.rate.title': 'Rate with max',
    'army_list.form.version.error': 'You must select a version.',
    'army_list.form.version.placeholder': 'Select a version',
    'army_list.form.version.title': 'Version *',
    'army_list.format.title': 'Format \u0026 Import an army list',
    'army_list.index.add': 'Create new army list',
    'army_list.index.and': 'and',
    'army_list.index.contest': 'Create a contest',
    'army_list.index.filter': 'Filter by',
    'army_list.index.folder': 'Create new folder',
    'army_list.index.name_or_notes': 'Name or notes',
    'army_list.index.search': 'Submit',
    'army_list.index.title': 'My army lists',
    'army_list.new.title': 'Create new list',
    'army_list.new.infos':
      'You can now filter armies with the last version, this can be modified in your profil',
    'army_list.paint.form.action': 'Do you want to create it from :',
    'army_list.paint.form.title': 'Convert to paint list',
    'army_list.show.builder_interface':
      'You can now change the default interface that you want to use directly in your profile.',
    'army_list.show.add_unit': 'Add unit',
    'army_list.show.delete': 'Delete',
    'army_list.show.duplicate': 'Duplicate',
    'army_list.show.edit': 'Edit',
    'army_list.show.export': 'Export',
    'army_list.show.notes': 'Notes',
    'army_list.show.organisation.excess': 'Excess',
    'army_list.show.organisation.missing': 'Missing',
    'army_list.show.organisation.remaining': 'Remaining',
    'army_list.show.print': 'Print',
    'army_list.show.rearrange_units': 'Rearrange Units',
    'army_list.show.title': 'Army list • {name}',
    'army_list.unit.clone.form.action': 'Do you want to copy:',
    'army_list.unit.clone.form.title': 'Copy Unit',
    'army_list.unit.delete.form.action': 'Do you want to remove:',
    'army_list.unit.delete.form.title': 'Delete Unit',
    'army_list.unit.favorite.form.action':
      'Do you want to create a favorite from this unit:',
    'army_list.unit.favorite.form.title': 'Create favorite',
    'army_list.unit.favorite.form.description':
      'You can now create a favorite from this unit, this will be added to your favorites. When a new version of this army will be released, it will be possible to use this unit in your new lists.',
    'army_list.unit.form.name.placeholder': 'Add a name',
    'army_list.unit.form.name.title': 'Name',
    'army_list.unit.form.title': 'Add an unit',
    'army_list.unit.form.unit.error': 'You must select an unit',
    'army_list.unit.form.unit.placeholder': 'Select an unit',
    'army_list.unit.form.unit.title': 'Unit *',
    'army_list.unit.magic': 'Magic',
    'army_list.unit.note': 'Notes',
    'army_list.unit.option.form.banner.title': 'Banners',
    'army_list.unit.option.form.command.title': 'Command Group Options',
    'army_list.unit.option.form.enchantement.title': 'Enchant your equipment',
    'army_list.unit.option.form.magic.title': 'Magic Options',
    'army_list.unit.option.form.magic_item.title': 'Magic items',
    'army_list.unit.option.form.mount.title': 'Mount Options',
    'army_list.unit.option.form.option.title': 'Options',
    'army_list_unit.delete.information': 'Are you sure to destroy this unit:',
    'army_list_unit.delete.submit': '!!! Delete !!!',
    'army_list_unit.delete.title': 'Delete\u003cbr /\u003eunit',
    'army_list_unit.duplicate.new_army_list': 'New {name} list',
    'army_list_unit.duplicate.target': 'To:',
    'army_list_unit.duplicate.title': 'Duplicate',
    'army_list_unit.edit.form.magic': 'Magic',
    'army_list_unit.edit.form.notes': 'Notes',
    'army_list_unit.edit.magic_items': 'Magic items',
    'army_list_unit.edit.magic_standards': 'Magic banners',
    'army_list_unit.edit.options': 'Options',
    'army_list_unit.edit.title': 'Edit',
    'army_list_unit.form.name': 'Name',
    'army_list_unit.form.submit': 'Create Unit',
    'army_list_unit.new.title': 'Add new unit',
    'army_list_unit.show.command_group_unit_options': 'Command Group Options',
    'army_list_unit.show.delete': 'Delete',
    'army_list_unit.show.duplicate': 'Duplicate',
    'army_list_unit.show.edit': 'Edit',
    'army_list_unit.show.model_rules': 'Model Rules',
    'army_list_unit.show.magic': 'Magic',
    'army_list_unit.show.magic_items': 'Magic items',
    'army_list_unit.show.magic_lvl_unit_options':
      'May become (one choice only)',
    'army_list_unit.show.magic_standards': 'Magic banners',
    'army_list_unit.show.equipment_options': 'Enchantment Options',
    'army_list_unit.show.magic_item_options': 'Magic items',
    'army_list_unit.show.magic_unit_options': 'Magic Options',
    'army_list_unit.show.mount_unit_options': 'Mount Options',
    'army_list_unit.show.notes': 'Notes',
    'army_list_unit.show.path_unit_options': 'Must generate spells from',
    'army_list_unit.show.path_unit_options_choose_one':
      'Must generate spells from (choose one)',
    'army_list_unit.show.qrcode.title': 'Qr codes of your army',
    'army_list_unit.show.qrcode.description':
      "Your can print this page to have all your army's units qrcode and cut them to stick them on your units, with them you can directly access to the unit's profil with your phone.",
    'army_list_unit.show.troops.A': 'A',
    'army_list_unit.show.troops.BS': 'BS',
    'army_list_unit.show.troops.E': 'Evoked',
    'army_list_unit.show.troops.I': 'I',
    'army_list_unit.show.troops.LD': 'Ld',
    'army_list_unit.show.troops.M': 'M',
    'army_list_unit.show.troops.S': 'S',
    'army_list_unit.show.troops.T': 'T',
    'army_list_unit.show.troops.W': 'W',
    'army_list_unit.show.troops.WS': 'WS',
    'army_list_unit.show.troops.name': 'Troops',
    'army_list_unit.show.troops.profile': 'Profile',
    'army_list_unit.show.troops.type': "Troop's type",
    'army_list_unit.show.unit_options': 'Options',
    'army_magic_spell.name': 'Racial Trait Spell',
    'arsenal.armies.index.add': 'Create a new army',
    'arsenal.armies.index.title': 'My miniatures',
    'arsenal.army.form.game.error': 'You must select a game!',
    'arsenal.army.form.game.placeholder': 'Select a game',
    'arsenal.army.form.game.title': 'Your game',
    'arsenal.army.form.army.error': 'You must select an army!',
    'arsenal.army.form.army.placeholder': 'Select an army',
    'arsenal.army.form.army.title': 'Your army',
    'arsenal.army.form.name.error': 'Your army need a name!',
    'arsenal.army.form.name.placeholder': 'My model army',
    'arsenal.army.form.name.title': 'Name of your models',
    'arsenal.army.new.title': 'Create a new army',
    'arsenal.army.show.comment': 'Comment',
    'arsenal.army.show.quantity': 'Quantity',
    'arsenal.army.show.title': 'Your army',
    'arsenal.army.show.unit': 'Unit',
    'arsenal.army.share.title': 'Share your miniatures',
    'arsenal.army.share.description':
      'If you send this link to a friend, he will be possible for him to see all your miniatures from this army:',
    'arsenal.unit.form.comment.placeholder': 'Add a comment...',
    'arsenal.unit.form.comment.title': 'Comment',
    'arsenal.unit.form.title': 'Add an unit',
    'arsenal.unit.form.unit.error': 'You must select an unit!',
    'arsenal.unit.form.unit.placeholder': 'Select an unit',
    'arsenal.unit.form.unit.title': 'Your unit',
    'arsenal.step.Project': 'Project',
    'arsenal.step.Bought': 'Bought',
    'arsenal.step.Unassembled': 'Unassembled',
    'arsenal.step.Assembled': 'Assembled',
    'arsenal.step.Primed': 'Primed',
    'arsenal.step.Painted': 'Painted',
    'arsenal.step.Based': 'Based',
    'builder.searchs.index.and': 'and',
    'builder.searchs.index.between': 'between',
    'builder.searchs.index.points': 'points',
    'builder.searchs.index.search': 'Search',
    'builder.searchs.index.search_army_select_error':
      'You must select one army',
    'builder.searchs.index.select_army': 'Choise the army',
    'builder.searchs.index.select_points_range': 'Number of point',
    'builder.searchs.index.select_version': 'Choise the version of 9Th Age',
    'builder.searchs.index.title': 'Search an Army list',
    'builder.searchs.show.and': 'and',
    'builder.searchs.show.between': 'between',
    'builder.searchs.show.points': 'points',
    'builder.searchs.show.title': 'Army list found',
    close: 'Close',
    common: 'Common',
    'confirmation.form.email': 'Email',
    'confirmation.form.submit': 'Save',
    'confirmation.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'confirmation.lost.password': 'I have lost my password!',
    'confirmation.title': 'Re-send confirmation instructions',
    'contest.back': 'back',
    'contest.delete.information': 'Are you sure to delete:',
    'contest.delete.submit': '!!! Delete !!!',
    'contest.delete.title': 'Delete contest',
    'contest.edit.title': 'Edit my contest',
    'contest.form.armyListMax.error': 'Your contest need a max points by army',
    'contest.form.armyListMax.placeholder': 'Enter a max points by army',
    'contest.form.armyListMax.title': 'Max points by army',
    'contest.form.endDate.error': 'Your contest need a end date',
    'contest.form.endDate.placeholder': 'Enter a end date',
    'contest.form.endDate.title': 'End date *',
    'contest.form.name.error': 'You must name your list',
    'contest.form.name.placeholder': 'Enter a name',
    'contest.form.name.title': 'Name *',
    'contest.form.participation.error':
      'Your contest need a participation mode',
    'contest.form.participation.placeholder': 'Enter a participation mode',
    'contest.form.participation.title': 'Individual or by Team',
    'contest.form.startDate.error': 'Your contest need a start date',
    'contest.form.startDate.placeholder': 'Enter a start date',
    'contest.form.startDate.title': 'Start date *',
    'contest.form.teamMax.error': 'Your contest need a number of team',
    'contest.form.teamMax.placeholder': 'Enter a number of team',
    'contest.form.teamMax.title': 'Number of team',
    'contest.form.userMax.error':
      'Your contest need a number of participant or team size',
    'contest.form.userMax.placeholder':
      'Enter a number of participant or team size',
    'contest.form.userMax.title': 'Number of participant or team size',
    'contest.form.versionid.error': 'Your contest need a game version',
    'contest.form.versionid.placeholder': 'Enter a game version',
    'contest.form.versionid.title': 'Game version *',
    'contest.name': 'Tournament',
    'contest.new.title': 'Create a contest',
    'contest.show.title': 'Contest: {name}',
    'data_analytics.analytics.title': 'Project: Better data for T9A',
    'data_analytics.report.new.title': 'Report a game',
    'model_rules.index.show': 'Show',
    'model_rules.index.title': 'Model Rules',
    'export.format': 'Format',
    'export.full': 'Full',
    'export.lite': 'Lite',
    'export.magics': 'Magics',
    'export.nomagics': 'No Magics',
    'export.print': 'print',
    'export.verbosity': 'Verbosity',
    'export.withmagics': 'With magics',
    'federation.club.new.title': 'Create or edit a club',
    'federation.club.form.name.title': 'Name',
    'federation.club.form.name.placeholder': 'My club',
    'federation.club.form.name.error': 'You must name your club',
    'federation.club.form.country.title': 'Country',
    'federation.club.form.country.placeholder': 'Which country ?',
    'federation.club.form.country.error': 'You must select a country',
    'federation.club.form.location.title': 'Where ?',
    'federation.club.form.location.placeholder': 'My club is ...',
    'federation.club.form.location.error': 'You must add a location',
    'federation.club.form.notes.title': 'Information',
    'federation.club.form.notes.placeholder': 'Describe my club ...',
    'federation.club.form.contact.title': 'Contact',
    'federation.club.form.contact.placeholder': 'Who contact ?',
    'federation.club.form.contact.error': 'You must add a contact',
    'federation.club.form.members.title': 'How many ?',
    'federation.club.form.members.placeholder': 'We are ....',
    'federation.club.form.meets.title': 'When ?',
    'federation.club.form.meets.placeholder': 'We can meet us ...',
    'federation.club.form.website.title': 'Website',
    'federation.club.form.website.placeholder': 'https://www.myclub.com',
    'federation.club.form.category.title': 'Game',
    'federation.club.form.category.placeholder': 'Select a played game',
    'folder.add_army_list.form.select': 'Select an army list',
    'folder.add_army_list.title': 'Add a list into this folder',
    'folder.back': 'back',
    'folder.delete.information': 'Are you sure to delete:',
    'folder.delete.submit': '!!! Delete !!!',
    'folder.delete.title': 'Delete folder',
    'folder.edit.title': 'Edit my folder',
    'folder.form.is_share.title': 'Share this folder',
    'folder.form.name.error': 'You must name your list',
    'folder.form.name.placeholder': 'Enter a name',
    'folder.form.name.title': 'Name *',
    'folder.form.parent.placeholder': 'Select the parent',
    'folder.form.parent.title': 'Parent',
    'folder.name': 'Folder',
    'folder.new.title': 'Create a folder',
    'folder.share.title': 'Share folder',
    'folder.show.title': 'Folder: {name}',
    'folder.tournament.information':
      'You can convert this folder into a tournament!',
    'folder.tournament.submit': '!!! Create !!!',
    'folder.tournament.title': 'Create a tournament',
    'footerlink.accessibility': 'Accessibility',
    'footerlink.privacy': 'Privacy Policy',
    'form.add': 'Add',
    'form.cancel': 'Cancel',
    'form.clone': 'Duplicate',
    'form.create': 'Create',
    'form.delete': 'Delete',
    'form.edit': 'Edit',
    'form.format': 'Format',
    'form.import': 'Import',
    'form.save': 'Save',
    'form.validate': 'Validate',
    'form.build': 'Build',
    'form.send': 'Send',
    'form.search': 'Search',
    'form.share': 'Share',
    'location.center': 'Center:',
    'location.display.location': 'Show your location',
    'location.display.refresh': 'Refresh your location',
    'location.share.description':
      'Do you want to show your location to others players?',
    'location.share.info':
      'Only location, name and favorite game will be displayed.',
    'format.form.date.error': 'You must select a creation date for your list',
    'format.form.date.placeholder': '01/01/2022',
    'format.form.date.title': 'Creation date *',
    'format.form.formated.title': 'Your formated army list',
    'format.form.game.error':
      "You must select the game's name that you want to play",
    'format.form.game.placeholder': 'T9A, EoW, WHB,....',
    'format.form.game.title': 'Your game *',
    'format.form.source.error': 'You must add your list',
    'format.form.source.placeholder': 'Enter an army list',
    'format.form.source.title': 'Your army list *',
    'format.new.title': 'Format and Import an army list',
    help: 'help',
    'home.app.available.google': 'Get it on Google Play',
    'home.app.available.on_platform':
      'Currently under development, available on:',
    'home.app.mobile': 'A mobile app',
    'home.locale.available': '9ThBuilder is available in several languages.',
    'home.locale.default':
      'By default, if the content is not available in the language you have chosen, the English content will automatically be displayed.',
    'home.no_account':
      'You can now use all the features of 9ThBuilder without having to create an account first. \nBe careful however, your lists are linked to your local session and therefore will not be available on another browser and may be lost if you delete your cache or your session."\n',
    'home.welcome': '9TH BUILDER',
    'home.whoarewe.cardmagic': 'Magic cards',
    'home.whoarewe.compose': 'Compose and archive your favorite armies!',
    'home.whoarewe.description_small':
      '9Th Builder is an effective and easy-to-use tool for creating your army lists and sharing them for T9A, Old World, Warhammer Battle and Essence of War\n',
    'home.whoarewe.description':
      'A passionate of Battle since many years. I took the 9Th Builder since several years, creates a mobile application and helps the 9Th Age administration.\nHelped by Kaos War who greatly contributed to enter army lists and for the new homePage.\n9Th Builder is an effective and easy-to-use tool for creating your army lists and sharing them. It does not generate any income :)\n',
    'home.whoarewe.discord': 'Discord',
    'home.whoarewe.draft': 'Make a team pairing',
    'home.whoarewe.format': 'Format or import your army',
    'home.whoarewe.list': 'Create an Army list',
    'home.whoarewe.news': 'News',
    'home.whoarewe.newsfb': 'News Facebook',
    'home.whoarewe.paint': 'Create an Paint list',
    'home.whoarewe.readarmy': 'Read Army Books',
    'home.whoarewe.readmagic': 'Read Magic Paths',
    'home.whoarewe.title': 'Who are we?',
    'home.whoarewe.try': 'Do you want to try?',
    'home.whoarewe.whatdo': 'What can you do?',
    'home.whoarewe.clubs': 'Find a club',
    'home.whoarewe.donate': 'Donate',
    'lexicon.index.show': 'Army books \u0026 Tools',
    'lexicon.magic_paths.cards.index':
      'You can find all magic paths for the games, ordered by version.',
    'magic.casting': 'Casting',
    'magic.effect': 'Effect',
    'magic.index.show': 'Show',
    'magic.index.title': 'Magics',
    'magic.range': 'Range',
    'magic.show.back': 'Back',
    'magic.type': 'Type',
    'magic.duration': 'Duration',
    'magic_item_categories.index.show': 'Show',
    'magic_item_categories.index.title': 'Magic item categories',
    'magic_items.Cbtbmw': 'Cannot be taken by models with',
    'magic_items.Enchantment': 'Enchantment',
    'magic_items.dominant': 'Dominant',
    'magic_items.footonly': 'foot only',
    'magic_items.index.show': 'Show',
    'magic_items.index.title': 'Magic items',
    'magic_items.only': 'only',
    'magic_items.perArmy': 'par Armée',
    'magic_items.type_figurine.All': 'All',
    'magic_items.type_figurine.AnimisteBestial': 'Animiste bestial',
    'magic_items.type_figurine.Character': 'Character',
    'magic_items.type_figurine.FeralOrc': 'Feral Orc',
    'magic_items.type_figurine.Goblins': 'Goblins',
    'magic_items.type_figurine.Infantry': 'Infantry',
    'magic_items.type_figurine.KnightCommanders': 'Knight Commanders',
    'magic_items.type_figurine.MageOnFoot': 'Mage On Foot',
    'magic_items.type_figurine.MarshalsMountedOnHorse':
      'Marshals mounted on Horse',
    'magic_items.type_figurine.ModelsOnChariots': 'models on Chariots',
    'magic_items.type_figurine.ModelsOnFoot': 'Models on foot',
    'magic_items.type_figurine.MonarchsOfTheDead': 'Monarchs of the Dead',
    'magic_items.type_figurine.Monster': 'Monster',
    'magic_items.type_figurine.MountedCharacter': 'Mounted character',
    'magic_items.type_figurine.NoLargeTarget': 'No large target',
    'magic_items.type_figurine.ParentUnit': 'Parent Unit',
    'magic_items.type_figurine.Wizard': 'Wizard',
    'magic_spell.type_lvl.A': 'A',
    'magic_spell.type_lvl.Five': '5',
    'magic_spell.type_lvl.Four': '4',
    'magic_spell.type_lvl.One': '1',
    'magic_spell.type_lvl.Six': '6',
    'magic_spell.type_lvl.Three': '3',
    'magic_spell.type_lvl.Two': '2',
    'magic_spell.type_lvl.Zero': '0',
    'magic_standards.index.show': 'Show',
    'magic_standards.index.title': 'Magic banners',
    'menu.army_lists': 'My army lists',
    'menu.help': 'Help',
    'menu.label': 'Main menu',
    'menu.languages.de': 'Germany',
    'menu.languages.en': 'English',
    'menu.languages.es': 'Spanish - Español',
    'menu.languages.fr': 'French',
    'menu.languages.hu': 'Hungarian',
    'menu.languages.it': 'Italian - Italiano',
    'menu.languages.ko': 'Korean',
    'menu.languages.lang': 'Language',
    'menu.languages.pl': 'Polish',
    'menu.languages.ru': 'Russian',
    'menu.languages.sr': 'Serbian',
    'menu.languages.zh': 'Chinese',
    'menu.preferences': 'Preferences',
    'menu.signin': 'Sign in',
    'menu.signout': 'Sign out',
    'menu.signup': 'Sign up',
    'menu.profil': 'My Profile',
    'menu.arsenal': 'My Miniatures',
    next: 'Next',
    'ninth_age.magic_path.magic_cards': 'Magic path cards',
    'ninth_age.army.translation_reference_sheet.title':
      'Correspondence of translations with another language',
    'ninth_age.army.quik_reference_sheet': 'Quick Reference Sheet',
    'ninth_age.army.magic_cards': 'Army magic cards',
    'ninth_age.figurine.mount': 'Mount',
    'ninth_age.figurine.pts': 'pts',
    'ninth_age.magic_item.only_wizard.AllWizard': 'Wizard only',
    'ninth_age.magic_item.only_wizard.NoWizard': 'Cannot be taken by Wizards',
    'ninth_age.magic_item.only_wizard.WizardAdept': 'Wizard adept only',
    'ninth_age.magic_item.only_wizard.WizardApprentice':
      'Wizard apprentice only',
    'ninth_age.magic_item.only_wizard.WizardMaster': 'Wizard master only',
    'ninth_age.troop.offensive': 'Offensive',
    'ninth_age.unit.defensive': 'Defensive',
    'ninth_age.unit.fly': 'fly',
    'ninth_age.unit.global': 'Global',
    'ninth_age.unit.rules': 'Model Rules',
    'paint_list.delete.information': 'Are you sure to destroy this list:',
    'paint_list.delete.submit': '!!! Delete !!!',
    'paint_list.delete.title': 'Delete your list',
    'paint_list.edit.title': 'Edit your paint list',
    'paint_list.form.army.error': 'You must select an army.',
    'paint_list.form.army.placeholder': 'Select an army',
    'paint_list.form.army.title': 'Army *',
    'paint_list.form.name.error': 'You must name your list',
    'paint_list.form.name.placeholder': 'Enter a name',
    'paint_list.form.name.title': 'Name *',
    'paint_list.form.version.error': 'You must select a version.',
    'paint_list.form.version.placeholder': 'Select a version',
    'paint_list.form.version.title': 'Version *',
    'paint_list.index.add': 'Create new paint list',
    'paint_list.index.title': 'My paint lists',
    'paint_list.new.title': 'Create a new list',
    'paint_list.show.assembled': 'Assembled',
    'paint_list.show.buy': 'Buy',
    'paint_list.show.comment': 'Comment',
    'paint_list.show.first_color': 'First color',
    'paint_list.show.paint': 'Paint',
    'paint_list.show.plinth': 'Plinth',
    'paint_list.show.size': 'Size',
    'paint_list.show.state.done': 'Done',
    'paint_list.show.state.waiting': 'Waiting',
    'paint_list.show.state.wip': 'Wip',
    'paint_list.show.title': 'Your Paint list:',
    'paint_list.show.trimmed': 'Trimmed',
    'paint_list.show.unit': 'Unit',
    'paint_list.unit.form.comment.placeholder': 'Add a comment',
    'paint_list.unit.form.comment.title': 'Comment',
    'paint_list.unit.form.size.error': 'You must add a number of model',
    'paint_list.unit.form.size.placeholder': 'Select a size',
    'paint_list.unit.form.size.title': 'Size *',
    'paint_list.unit.form.title': 'Add an unit',
    'paint_list.unit.form.unit.error': 'You must select an unit',
    'paint_list.unit.form.unit.placeholder': 'Select an unit',
    'paint_list.unit.form.unit.title': 'Unit *',
    'password_change.form.confirmation': 'Password confirmation',
    'password_change.form.password': 'Password',
    'password_change.form.submit': 'Save',
    'password_change.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_change.lost.confirmation':
      "I didn't received my confirmation email",
    'password_change.lost.password': 'I have lost my password!',
    'password_change.title': 'Change your password',
    'password_lost.form.email': 'Email',
    'password_lost.form.submit': 'Send me reset password instructions',
    'password_lost.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_lost.lost.confirmation':
      "I didn't received my confirmation email",
    'password_lost.title': 'I have lost my password',
    'picker.datetime.js': 'YYYY.MM.DD HH:mm',
    'picker.datetime.rb': '%Y.%m.%d %H:%M',
    'profile.back': 'Previous page',
    'profile.delete.information':
      'You are not satisfied? \u003ca href="mailto:support@9thbuilder.com"\u003eContact us\u003c/a\u003e or',
    'profile.delete.link': 'immediately destroy your account',
    'profile.delete.title': 'Account deletion',
    'profile.form.confirmation': 'Password confirmation',
    'profile.form.email': 'Email address',
    'profile.form.game': 'Favorite',
    'profile.form.name': 'Name or nickname',
    'profile.form.password': 'Password',
    'profile.form.password_help':
      "Leave it empty if you don't want to change your password",
    'profile.form.submit': 'Save',
    'profile.form.builder_interface':
      'What interface for editing your list do you prefer?',
    'profile.form.use_latest_version': 'Only use the last version of each army',
    'profile.form.default_locale': 'Your favorite language',
    'profile.title': 'My account',
    save: 'Save',
    'search_list.assembled': 'Assembled',
    'search_list.buy': 'Buy',
    'search_list.comment': 'Comment',
    'search_list.first_color': 'First color',
    'search_list.index.search': 'Submit',
    'search_list.index.search_list': 'Search an army list',
    'search_list.paint': 'Paint',
    'search_list.plinth': 'Plinth',
    'search_list.size': 'Size',
    'search_list.trimmed': 'Trimmed',
    'search_list.unit': 'Unit',
    'signin.Confirmation': 'Confirmation',
    'signin.form.email': 'Email',
    'signin.form.lost': 'Forgot ?',
    'signin.form.password': 'Password',
    'signin.form.remember': 'Remember me',
    'signin.form.submit': 'Sign-in',
    'signin.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signin.lost.confirmation': "I didn't received my confirmation email",
    'signin.lost.password': 'I have lost my password!',
    'signin.title': 'Sign in',
    'signup.form.confirmation': 'Password confirmation',
    'signup.form.email': 'Email address',
    'signup.form.game': '--Favorite--',
    'signup.form.name': 'Name or nickname',
    'signup.form.password': 'Password',
    'signup.form.register': 'Join us !',
    'signup.form.submit': 'Sign-up',
    'signup.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signup.lost.confirmation': "I didn't received my confirmation email",
    'signup.lost.password': 'I have lost my password!',
    'signup.title': 'Sign up',
    'site.accept': 'I accept',
    'site.more': 'Learn more',
    'site.use_cookie':
      'This site uses cookies to offer you the best service. By continuing your navigation, you use the use of cookies.',
    'tool.game_help': 'Game helpers',
    'tool.pairing.done': 'Your pairing is complete',
    'tool.pairing.draft.index.title': 'My Drafts',
    'tool.pairing.draft.send_link': 'Send this link to your opponent:',
    'tool.pairing.draft.waiting_opponent': 'We are waiting your opponent',
    'tool.pairing.draw.confirm.draw': 'Confirm Draw',
    'tool.pairing.draw.confirm.response': 'Confirm Response',
    'tool.pairing.draw.confirm.select': 'Confirm select',
    'tool.pairing.draw.or': 'or',
    'tool.pairing.draw.vs': 'Vs',
    'tool.pairing.draw_round.select.draw': 'Select one army for the draft',
    'tool.pairing.draw_round.select.response': 'Select your reponses',
    'tool.pairing.draw_round.select.select': 'Select the army',
    'tool.pairing.draw_round.select.waiting': 'Waiting',
    'tool.pairing.form.name.error': 'Your must name your Team!',
    'tool.pairing.form.size.error': 'Your must select a size!',
    'tool.pairing.form.versionId.error': 'Your must select a game version!',
    'tool.pairing.form.tables.label': 'Your tables',
    'tool.pairing.form.tables.error': 'Your must select yours tables!',
    'tool.pairing.form.tables.no_maps': 'No map available for this game',
    'tool.pairing.form.armies.label': 'Your armies',
    'tool.pairing.form.armies.error':
      'Your must select the same number of armies that the size of the draft!',
    'tool.pairing.image': 'Copy the pairing url image',
    'tool.pairing.inprogress': 'Your pairing is in progress',
    'tool.pairing.matches.tables': 'Tables:',
    'tool.pairing.my_team.my_armies': 'Your armies',
    'tool.pairing.opponent_team.team': 'Team',
    'tool.pairing.player.name': 'Player:',
    'tool.pairing.player.placeholder': 'Player name',
    'tool.pairing.select_armies.choise_armies': 'Choise your armies',
    'tool.pairing.select_armies.confirm': 'Confirm',
    'tool.pairing.select_armies.error':
      'Sorry! There was an error loading the items.',
    'tool.pairing.select_armies.your_team': 'Your Team',
    'tool.pairing.select_team_size.how_many': 'How many players in the team?',
    'tool.pairing.select_game': 'Which game do you want to play?',
    'tool.pairing.table': 'Table',
    'tool.pairing.team.name.confirm': 'Confirm',
    'tool.pairing.team.name.what_name': "What's the name of your team?",
    'tool.pairing.team.name.your_name': 'Your team name',
    'tool.search_rules.index.search': 'Search',
    'tool.search_rules.index.search_army_select_error':
      'You must select one army',
    'tool.search_rules.index.search_rule': 'Choise one rule',
    'tool.search_rules.index.select_army': 'Choise the army',
    'tool.search_rules.index.select_version': 'Choise the version of 9Th Age',
    'tool.search_rules.index.title': 'Search by rules',
    'tournament.contest.back': 'Back to tournaments',
    'tournament.contest.edit': 'Edit',
    'tournament.contest.form.address': 'Address',
    'tournament.contest.form.end_date': 'End',
    'tournament.contest.form.fees': 'Fees',
    'tournament.contest.form.name': 'Name',
    'tournament.contest.form.round_count': 'Rounds',
    'tournament.contest.form.start_date': 'Start',
    'tournament.contest.form.submit': 'Save',
    'tournament.contest.form.team_max': 'Max teams',
    'tournament.contest.form.user_max': 'Max users',
    'tournament.contest.form.user_team_max': 'Max users by team',
    'tournament.contest.form.version': 'Version',
    'tournament.contest.index.title': 'My tournaments',
    'tournament.contest.name': 'Tournament',
    'tournament.contest.new.title': 'Create a tournament',
    'tournament.contest.print_armies': 'Print all armies',
    'tournament.contest.print_repport': 'Rapport',
    'tournament.contest.total': 'Total',
    'tournament.custom_point.name': 'Paint, Wysiwyg, List',
    'tournament.round.add': 'Add round',
    'tournament.round.name': 'Round',
    'tournament.round.pools.validate': 'Create pools',
    'tournament.team.add': 'Add Team',
    'tournament.team.back': 'Back to teams',
    'tournament.team.edit.title': 'Edition team',
    'tournament.team.export.title': 'Team',
    'tournament.team.first': 'Add your first team',
    'tournament.team.form.email': 'Email',
    'tournament.team.form.name': 'Name',
    'tournament.team.form.submit': 'Save',
    'tournament.team.index.title': 'My Tournament teams',
    'tournament.team.name': 'Teams',
    'tournament.team.new.title': 'Add teams',
    'tournament.teams.add': 'Add Team',
    'tournament.teams.back': 'Back to tournaments',
    'tournament.teams.title': 'Teams',
    'tournament.user_apply.add': 'Add Participant',
    'tournament.user_apply.add_into_team': 'Add partipant in this team',
    'tournament.user_apply.army_list.add_now': 'Add it now!',
    'tournament.user_apply.army_list.create': 'Create a new list',
    'tournament.user_apply.army_list.need':
      'You have not added your army list yet.',
    'tournament.user_apply.army_list.or': 'or',
    'tournament.user_apply.army_list.use_existing': 'Use an existing list',
    'tournament.user_apply.army_list.which': 'Which army list ?',
    'tournament.user_apply.army_list_select.form.submit': 'Save',
    'tournament.user_apply.edit.title': 'Edit your participation',
    'tournament.user_apply.first': 'Add your first Participant',
    'tournament.user_apply.form.armyId.placeholder': 'Player army',
    'tournament.user_apply.form.armyId.title': 'Army',
    'tournament.user_apply.form.email.placeholder': 'Player email',
    'tournament.user_apply.form.email.title': 'email',
    'tournament.user_apply.form.name.error': 'Player name is required',
    'tournament.user_apply.form.name.placeholder': 'Player name',
    'tournament.user_apply.form.name.title': 'Name',
    'tournament.user_apply.form.name_detail':
      'You can add somes users (1 user by line) with email separated by a comma (name, email).',
    'tournament.user_apply.form.or': 'or',
    'tournament.user_apply.form.submit': 'Add',
    'tournament.user_apply.form.user': 'User',
    'tournament.user_apply.manage': 'Manage Team',
    'tournament.user_apply.name': 'User',
    'tournament.user_apply.new.title': 'Add users',
    'tournament.user_apply.remove': 'Remove Participant',
    'tournament.user_apply.share_link': 'Share invitation link',
    'tournament.user_apply.team_leader': 'Is the team captain',
    'unit.base.HundredHundredFifty': '100x150mm',
    'unit.base.EightyEighty': '80x80mm',
    'unit.base.FiftyFifty': '50x50mm',
    'unit.base.FiftyHundred': '50x100mm',
    'unit.base.FiftySeventyFive': '50x75mm',
    'unit.base.FortyForty': '40x40mm',
    'unit.base.FortyRound': '40mm round',
    'unit.base.FortySixty': '40x60mm',
    'unit.base.FortyTwenty': '40x20mm',
    'unit.base.HundredFifty': '100x50mm',
    'unit.base.HundredFiftyHundred': '150x100mm',
    'unit.base.HundredHundred': '100x100mm',
    'unit.base.SeventyFiveFifty': '75x50mm',
    'unit.base.SeventyFiveHundred': '75x100mm',
    'unit.base.SeventyFiveRound': '75mm round',
    'unit.base.SixtyHundred': '60x100mm',
    'unit.base.SixtyRound': '60mm round',
    'unit.base.TwentyFiveFifty': '25x50mm',
    'unit.base.TwentyFiveRound': '25mm round',
    'unit.base.TwentyFiveTwentyFive': '25x25mm',
    'unit.base.TwentyTwenty': '20x20mm',
    'unit.base.SeventyFiveSeventyFive': '75x75mm',
    'unit.base.HundredTwoHundred': '100x200mm',
    'unit.base.label': 'Base',
    'unit.height.Gigantic': 'Gigantic',
    'unit.height.Large': 'Large',
    'unit.height.Standard': 'Standard',
    'unit.limit.model': 'Units by Army',
    'unit.limit.perArmy': 'par Armée',
    'unit.limit.single': 'single model',
    'unit.limit.unit': 'Units/Army',
    'unit.mount': 'Mount',
    'unit.show.add_model':
      ' + \u003cstrong\u003e{pts}\u003c/strong\u003e pts/extra model',
    'unit.show.change.no_max': 'Units {change}',
    'unit.show.change.max': 'A maximum of {max} units {change}',
    'unit.show.change.limit': ' without {limit}',
    'unit.show.change.to_min':
      'of {number} or more models{limit} count towards {new_name} instead of {old_name}.',
    'unit.show.change.to_max':
      'of {number} or less models{limit} count towards {new_name} instead of {old_name}.',
    'unit.show.size':
      '\u003cstrong\u003e{min_size}-{max_size}\u003c/strong\u003e models',
    'unit.size.Gigantic': 'Gigantic',
    'unit.size.Large': 'Large',
    'unit.size.Standard': 'Standard',
    'unit.size.label': 'Height',
    'unit.type.label': 'Type',
    'unit_option.per_model': '/mod.',
    'unit_option.use_points.free': 'free',
    'unit_option.use_points.no_limit': 'no limit',
    'unit_option.use_points.up_to': 'up to',
    'user.profile.favorit_game': 'Your favorite game is',
    'user.profile.prefert_user': 'You prefert use',
    'user.profile.favorit_builder_interface':
      'interface for building your army',
    'user.profile.use_latest_army': 'You use the last version of each army:',
    'user.profile.default_locale': 'Your default language is:',
    'user.profile.edit': 'Edit your Profile',
    'user.password.edit': 'Change your password',
    'user.user_bug_report.new.title': 'Report a bug',
    'user.user_bug_report.form.reason_type.title': 'What the reason?*',
    'user.user_bug_report.form.reason_type.placeholder':
      'Can you give me the reason?',
    'user.user_bug_report.form.reason_type.error': 'You must select a reason',
    'user.user_bug_report.form.report.title': 'What the problem?*',
    'user.user_bug_report.form.report.placeholder':
      'Can you give me the problem?',
    'user.user_bug_report.form.report.error': 'You must give a problem',
    'user.user_bug_report.form.unit_id.title': 'The unit',
    'user.user_bug_report.form.unit_id.placeholder':
      'Can you give me the unit?',
    'user.user_bug_report.form.unit_option_id.title': 'The option',
    'user.user_bug_report.form.unit_option_id.placeholder':
      'Can you give me the option?',
    'user.user_bug_report.form.value.title': 'Correct value',
    'user.user_bug_report.form.value.placeholder':
      'Can you give me the correct value?',
    'unit_options.category.C': 'C',
    'unit_options.category.M': 'M',
    'unit_options.category.S': 'S',
    'unit_options.footonly': 'foot only',
    'version.index.pairing': 'Team Pairing',
    'version.index.search': 'Search by rule',
    'version.index.show': 'Show',
    'version.index.title': 'Versions',
    'version.index.tools': 'Tools',
    'version.show.back': 'Back',
    welcome: 'Welcome',
    with: 'with %',
    without: 'without %',
    'simulator.unit.mount': '{name} on {mount}',
    'simulator.unit.equipment': '{name} with {equipment}',
    'survey.campaign.index.available.title': 'Available campaings',
    'survey.campaign.index.old.title': 'Old campaings',
    'publication.army_books.index.title': 'All Armies',
    'publication.army_book.form.name.label': 'Name',
    'publication.army_book.form.name.placeholder': 'Enter a name',
    'publication.army_book.form.prefix.label': 'Prefix',
    'publication.army_book.form.prefix.placeholder': 'Enter a prefix',
    'publication.army_book.form.version.label': 'Version',
    'publication.army_book.form.version.placeholder': 'Enter a version',
    'publication.army_book.form.logo_path.label': 'Logo path',
    'publication.army_book.form.logo_path.placeholder': 'Enter a logo path',
    'publication.army_book.form.category.name.label': 'Name',
    'publication.army_book.form.category.name.placeholder': 'Enter a name',
    'publication.army_book.form.category.logo.label': 'Logo',
    'publication.army_book.form.category.logo.placeholder': 'Enter a logo',
    'publication.army_book.form.category.value.label': 'Value',
    'publication.army_book.form.category.value.placeholder': 'Enter a value',
    'publication.army_book.form.category.minimum.label': 'Minimum',
    'publication.army_book.form.category.minimum.placeholder': 'min or max ?',
    'publication.army_book.form.magic_item.name.label': 'Name',
    'publication.army_book.form.magic_item.name.placeholder': 'Enter a name',
    'publication.army_book.form.magic_item.type.label': 'Type',
    'publication.army_book.form.magic_item.type.placeholder': 'Enter a type',
    'publication.army_book.form.magic_item.cost.label': 'Cost',
    'publication.army_book.form.magic_item.cost.placeholder': 'Enter a cost',
    'publication.army_book.form.magic_item.support.label': 'Support',
    'publication.army_book.form.magic_item.support.placeholder':
      'Enter a support',
    'publication.army_book.form.magic_item.rarity.label': 'Rarity',
    'publication.army_book.form.magic_item.rarity.placeholder':
      'Enter a rarity',
    'publication.army_book.form.magic_item.dominant.label': 'Dominant',
    'publication.army_book.form.magic_item.dominant.placeholder': 'If Dominant',
    'publication.army_book.form.magic_item.restriction.label': 'Restriction',
    'publication.army_book.form.magic_item.restriction.placeholder':
      'Enter restrictions',
    'publication.army_book.form.magic_item.inherits.label': 'Inherits',
    'publication.army_book.form.magic_item.inherits.placeholder':
      'Enter parent key',
    'publication.army_book.form.army_list.name.label': 'Name',
    'publication.army_book.form.army_list.name.placeholder': 'Enter a name',
    'publication.army_book.form.army_list.inherits.label': 'Inherits',
    'publication.army_book.form.army_list.inherits.placeholder':
      'Enter parent key',
    'publication.army_book.form.army_list.categories.label': 'Categories',
    'publication.army_book.form.army_list.categories.placeholder':
      'Enter categories',
    'publication.army_book.form.army_list.unit_size.label': 'Unit size',
    'publication.army_book.form.army_list.unit_size.placeholder':
      'Enter a unit size',
    'publication.army_book.form.army_list.cost.label': 'Cost',
    'publication.army_book.form.army_list.cost.placeholder': 'Enter a cost',
    'publication.army_book.form.army_list.height.label': 'Height',
    'publication.army_book.form.army_list.height.placeholder': 'Enter a height',
    'publication.army_book.form.army_list.fluff.label': 'Fluff',
    'publication.army_book.form.army_list.fluff.placeholder': 'Enter a fluff',
    'publication.army_book.form.army_list.profile.global.charge_rate.label':
      'Charge Rate',
    'publication.army_book.form.army_list.profile.global.charge_rate.placeholder':
      'Enter a charge rate value',
    'publication.army_book.form.army_list.profile.global.march_rate.label':
      'March Rate',
    'publication.army_book.form.army_list.profile.global.march_rate.placeholder':
      'Enter a march rate value',
    'publication.army_book.form.army_list.profile.global.discipline.label':
      'Discipline',
    'publication.army_book.form.army_list.profile.global.discipline.placeholder':
      'Enter a discipline value',
    'publication.army_book.form.army_list.profile.defensive.hp.label': 'HP',
    'publication.army_book.form.army_list.profile.defensive.hp.placeholder':
      'Enter a HP value',
    'publication.army_book.form.army_list.profile.defensive.defensive_skill.label':
      'Defensive Skill',
    'publication.army_book.form.army_list.profile.defensive.defensive_skill.placeholder':
      'Enter a defensive skill value',
    'publication.army_book.form.army_list.profile.defensive.resistance.label':
      'Resistance',
    'publication.army_book.form.army_list.profile.defensive.resistance.placeholder':
      'Enter a resistance value',
    'publication.army_book.form.army_list.profile.defensive.armour.label':
      'Armour',
    'publication.army_book.form.army_list.profile.defensive.armour.placeholder':
      'Enter a armour value',
    'publication.army_book.form.loc.name.label': 'LaTeX key',
    'publication.army_book.form.loc.name.placeholder': 'Enter a key name',
    'publication.army_book.form.loc.value.label': 'Value',
    'publication.army_book.form.loc.value.placeholder': 'Enter a translation',
    'publication.books.index.title': 'Yours books',
    'publication.books.index.add': 'Create a new book',
    'publication.book.new.title': 'Create a new book',
    'publication.book.show.title': 'Edit your book',
    'publication.book.build.form.title': 'Build your book',
    'publication.book.form.version.error': 'Version is required',
    'publication.book.form.army.error': 'Army is required',
    'publication.book.form.name.error': 'Name is required',
    'publication.book.section.type.ARMY_LIST': 'Army list',
    'publication.book.section.type.ARMY_ORG': 'Army organisation',
    'publication.book.section.type.ARMY_SPECIFIC_RULE': 'Army specific rule',
    'publication.book.section.type.HEREDITARY_SPELL': 'Hereditary spell',
    'publication.book.section.type.QUICK_REF_SHEET': 'Quick ref sheet',
    'publication.book.section.type.SPECIAL_EQUIPMENT': 'Special equipment',
    'publication.book.section.type.MODEL_RULE': 'Model rule',
    'publication.book.section.clone.form.title': 'Clone this section',
    'publication.book.section.delete.form.title': 'Delete this section',
    'publication.book.section.edit.form.title': 'Edit this section',
    'publication.book.section.form.type.title': 'Section to create',
    'publication.book.section.form.type.placeholder':
      'Select a section to create',
    'publication.book.section.form.type.error': 'Select a selection to create',
    'army_allies.title': 'Allies',
  },
  es: {
    'activerecord.attributes.user.current_password': 'Contraseña actual',
    'activerecord.attributes.user.email': 'Correo electrónico',
    'activerecord.attributes.user.password': 'Contraseña',
    'activerecord.attributes.user.password_confirmation':
      'Confirmación de la contraseña',
    'activerecord.attributes.user.remember_me': 'Recordarme',
    'activerecord.attributes.user.reset_password_token':
      'Restablecer token contraseña',
    'activerecord.attributes.user.unlock_token': 'Desbloquear token',
    'activerecord.models.user': 'Usuario',
    'devise.sessions.signed_in': '',
    'devise.sessions.signed_out': '',
    'users.confirmations.confirmed':
      'Tu cuenta ha sido confirmada satisfactoriamente.',
    'users.confirmations.new.resend_confirmation_instructions':
      'Reenviar instrucciones de confirmación',
    'users.confirmations.send_instructions':
      'Vas a recibir un correo con instrucciones sobre cómo confirmar tu cuenta en unos minutos.',
    'users.confirmations.send_paranoid_instructions':
      'Si tu correo existe en nuestra base de datos, en unos minutos recibirás un correo con instrucciones sobre cómo confirmar tu cuenta.',
    'users.failure.already_authenticated': 'Ya has iniciado sesión.',
    'users.failure.inactive': 'Tu cuenta aún no ha sido activada.',
    'users.failure.invalid': 'Email o contraseña no válidos.',
    'users.failure.last_attempt':
      'Tienes un intento más antes de que tu cuenta sea bloqueada.',
    'users.failure.locked': 'Tu cuenta está bloqueada.',
    'users.failure.not_found_in_database': 'Email o contraseña no válidos.',
    'users.failure.timeout':
      'Tu sesión expiró. Por favor, inicia sesión nuevamente para continuar.',
    'users.failure.unauthenticated':
      'Tienes que iniciar sesión o registrarte para poder continuar.',
    'users.failure.unconfirmed':
      'Tienes que confirmar tu cuenta para poder continuar.',
    'users.mailer.confirmation_instructions.action': 'Confirmar mi cuenta',
    'users.mailer.confirmation_instructions.greeting':
      '¡Bienvenido {recipient}!',
    'users.mailer.confirmation_instructions.instruction':
      'Usted puede confirmar el correo electrónico de su cuenta a través de este enlace:',
    'users.mailer.confirmation_instructions.subject':
      'Instrucciones de confirmación',
    'users.mailer.password_change.greeting': 'Hola {recipient}!',
    'users.mailer.password_change.message':
      'Le estamos contactando para notificarle que su contraseña ha sido cambiada.',
    'users.mailer.password_change.subject': 'Contraseña cambiada',
    'users.mailer.reset_password_instructions.action': 'Cambiar mi contraseña',
    'users.mailer.reset_password_instructions.greeting': '¡Hola {recipient}!',
    'users.mailer.reset_password_instructions.instruction':
      'Alguien ha solicitado un enlace para cambiar su contraseña, lo que se puede realizar a través del siguiente enlace.',
    'users.mailer.reset_password_instructions.instruction_2':
      'Si usted no lo ha solicitado, por favor ignore este correo electrónico.',
    'users.mailer.reset_password_instructions.instruction_3':
      'Su contraseña no será cambiada hasta que usted acceda el enlace y cree uno nuevo.',
    'users.mailer.reset_password_instructions.subject':
      'Instrucciones de recuperación de contraseña',
    'users.mailer.unlock_instructions.action': 'Desbloquear mi cuenta',
    'users.mailer.unlock_instructions.greeting': '¡Hola {recipient}!',
    'users.mailer.unlock_instructions.instruction':
      'Haga click en el siguiente enlace para desbloquear su cuenta:',
    'users.mailer.unlock_instructions.message':
      'Su cuenta ha sido bloqueada debido a una cantidad excesiva de intentos infructuosos para ingresar.',
    'users.mailer.unlock_instructions.subject':
      'Instrucciones para desbloquear',
    'users.omniauth_callbacks.failure':
      'No has sido autorizado en la cuenta {kind} porque "{reason}".',
    'users.omniauth_callbacks.success':
      'Has sido autorizado satisfactoriamente en la cuenta {kind}.',
    'users.passwords.edit.change_my_password': 'Cambiar mi contraseña',
    'users.passwords.edit.change_your_password': 'Cambie su contraseña',
    'users.passwords.edit.confirm_new_password': 'Confirme la nueva contraseña',
    'users.passwords.edit.new_password': 'Nueva contraseña',
    'users.passwords.new.forgot_your_password': '¿Ha olvidado su contraseña?',
    'users.passwords.new.send_me_reset_password_instructions':
      'Envíeme las instrucciones para resetear mi contraseña',
    'users.passwords.no_token':
      'No puedes acceder a esta página si no es a través de un enlace para resetear tu contraseña. Si has llegado hasta aquí desde el email para resetear tu contraseña, por favor asegúrate de que la URL introducida está completa.',
    'users.passwords.send_instructions':
      'Recibirás un correo con instrucciones sobre cómo resetear tu contraseña en unos pocos minutos.',
    'users.passwords.send_paranoid_instructions':
      'Si tu correo existe en nuestra base de datos, recibirás un correo con instrucciones sobre cómo resetear tu contraseña en tu bandeja de entrada.',
    'users.passwords.updated':
      'Se ha cambiado tu contraseña. Ya iniciaste sesión.',
    'users.passwords.updated_not_active': 'Tu contraseña fue cambiada.',
    'users.registrations.destroyed':
      '¡Adiós! Tu cuenta ha sido cancelada correctamente. Esperamos verte pronto.',
    'users.registrations.edit.are_you_sure': '¿Está usted seguro?',
    'users.registrations.edit.cancel_my_account': 'Anular mi cuenta',
    'users.registrations.edit.currently_waiting_confirmation_for_email':
      'Actualmente esperando la confirmacion de: {email} ',
    'users.registrations.edit.leave_blank_if_you_don_t_want_to_change_it':
      'dejar en blanco si no desea cambiarlo',
    'users.registrations.edit.title': 'Editar {resource}',
    'users.registrations.edit.unhappy': 'Infeliz',
    'users.registrations.edit.update': 'Actualizar',
    'users.registrations.edit.we_need_your_current_password_to_confirm_your_changes':
      'necesitamos su contraseña actual para confirmar los cambios',
    'users.registrations.new.sign_up': 'Registrarse',
    'users.registrations.signed_up': 'Bienvenido. Tu cuenta fue creada.',
    'users.registrations.signed_up_but_inactive':
      'Tu cuenta ha sido creada correctamente. Sin embargo, no hemos podido iniciar la sesión porque tu cuenta aún no está activada.',
    'users.registrations.signed_up_but_locked':
      'Tu cuenta ha sido creada correctamente. Sin embargo, no hemos podido iniciar la sesión porque que tu cuenta está bloqueada.',
    'users.registrations.signed_up_but_unconfirmed':
      'Se ha enviado un mensaje con un enlace de confirmación a tu correo electrónico. Abre el enlace para activar tu cuenta.',
    'users.registrations.update_needs_confirmation':
      'Has actualizado tu cuenta correctamente, pero es necesario confirmar tu nuevo correo electrónico. Por favor, comprueba tu correo y sigue el enlace de confirmación para finalizar la comprobación del nuevo correo electrónico.',
    'users.registrations.updated': 'Tu cuenta se ha actualizada.',
    'users.sessions.already_signed_out': 'Sesión finalizada.',
    'users.sessions.new.sign_in': 'Iniciar sesión',
    'users.sessions.signed_in': 'Sesión iniciada.',
    'users.sessions.signed_out': 'Sesión finalizada.',
    'users.shared.links.back': 'Atrás',
    'users.shared.links.didn_t_receive_confirmation_instructions':
      '¿No ha recibido las instrucciones de confirmación?',
    'users.shared.links.didn_t_receive_unlock_instructions':
      '¿No ha recibido instrucciones para desbloquear?',
    'users.shared.links.forgot_your_password': '¿Ha olvidado su contraseña?',
    'users.shared.links.sign_in': 'Iniciar sesión',
    'users.shared.links.sign_in_with_provider': 'Iniciar sesión con {provider}',
    'users.shared.links.sign_up': 'Registrarse',
    'users.unlocks.new.resend_unlock_instructions':
      'Reenviar instrucciones para desbloquear',
    'users.unlocks.send_instructions':
      'Vas a recibir instrucciones para desbloquear tu cuenta en unos pocos minutos.',
    'users.unlocks.send_paranoid_instructions':
      'Si tu cuenta existe, vas a recibir instrucciones para desbloquear tu cuenta en unos pocos minutos.',
    'users.unlocks.unlocked':
      'Tu cuenta ha sido desbloqueada. Ya puedes iniciar sesión.',
    'errors.messages.already_confirmed':
      'ya ha sido confirmada, por favor intenta iniciar sesión',
    'errors.messages.confirmation_period_expired':
      'necesita confirmarse dentro de {period}, por favor solicita una nueva',
    'errors.messages.expired': 'ha expirado, por favor solicita una nueva',
    'errors.messages.not_found': 'no se ha encontrado',
    'errors.messages.not_locked': 'no estaba bloqueada',
    'errors.messages.not_saved.one':
      'Ocurrió un error al tratar de guardar {resource}:',
    'errors.messages.not_saved.other':
      'Ocurrieron {count} errores al tratar de guardar {resource}:',
    Common: 'Común',
    'active_admin.menu.admin': 'Administración',
    'active_admin.menu.armies': 'Ejércitos',
    'active_admin.menu.builder': 'Creador',
    'active_admin.menu.dashboard': 'Administración',
    'active_admin.menu.import': 'Importar',
    'active_admin.menu.log': 'Iniciar sesión',
    'active_admin.menu.magic': 'mágia',
    'active_admin.menu.map': 'Mapas',
    'active_admin.menu.ninth_age': 'The Ninth Age',
    'active_admin.menu.organisation': 'Organización',
    'active_admin.menu.paint': 'Pintura',
    'active_admin.menu.statistique': 'Estadísticas',
    'active_admin.menu.tournament': 'Torneo',
    'active_admin.menu.unit': 'Unidad',
    'active_admin.menu.user_annoncement': 'Anuncios',
    'active_admin.menu.users': 'Usuarios',
    'active_admin.menu.versioning': 'Versiones',
    'active_admin.translate.ko': 'Coreano',
    'active_admin.translate.pl': 'Polaco',
    'active_admin.translate.ru': 'Ruso',
    'active_admin.translate.zh': 'Chino',
    'activerecord.attributes.data_analytics/report.deployments.CounterThrust':
      'Contragolpe',
    'activerecord.attributes.data_analytics/report.deployments.DawnAssult':
      'Asalto al Amanecer',
    'activerecord.attributes.data_analytics/report.deployments.Encircle':
      'Rodear',
    'activerecord.attributes.data_analytics/report.deployments.FrontlineClash':
      'Coche Frontal',
    'activerecord.attributes.data_analytics/report.deployments.MarchingColumns':
      'Columnas de Marcha',
    'activerecord.attributes.data_analytics/report.deployments.RefusedFlank':
      'Flanco Rehusado',
    'activerecord.attributes.data_analytics/report.maps.A1':
      'A1 - Laguna Misteriosa',
    'activerecord.attributes.data_analytics/report.maps.A2':
      'A2 - Puesto Fronterizo',
    'activerecord.attributes.data_analytics/report.maps.A3':
      'A3 - Mansión Abandonada',
    'activerecord.attributes.data_analytics/report.maps.A4':
      'A4 - Lago Volcánico',
    'activerecord.attributes.data_analytics/report.maps.A5':
      'A5 - Marismas Brumosas',
    'activerecord.attributes.data_analytics/report.maps.A6':
      'A6 - Antiguos Muros',
    'activerecord.attributes.data_analytics/report.maps.A7':
      'A7 - Colina de la Almenara',
    'activerecord.attributes.data_analytics/report.maps.A8':
      'A8 - Cabaña de la Bruja',
    'activerecord.attributes.data_analytics/report.maps.B1':
      'B1 - Santuario del Mago',
    'activerecord.attributes.data_analytics/report.maps.B2':
      'B2 - Terrenos de la Villa',
    'activerecord.attributes.data_analytics/report.maps.B3':
      'B3 - Fortaleza Antigua',
    'activerecord.attributes.data_analytics/report.maps.B4':
      'B4 - Granja Fronteriza',
    'activerecord.attributes.data_analytics/report.maps.B5':
      'B5 - Torre Destruida',
    'activerecord.attributes.data_analytics/report.maps.B6':
      'B6 - Bosque Insidioso',
    'activerecord.attributes.data_analytics/report.maps.B7':
      'B7 - Cementerio Escalofriante',
    'activerecord.attributes.data_analytics/report.maps.B8':
      'B8 - Puente Derruido',
    'activerecord.attributes.data_analytics/report.objectives.Breakthrough':
      'Romper el Frente',
    'activerecord.attributes.data_analytics/report.objectives.CaptureFlags':
      'Captura la Bandera',
    'activerecord.attributes.data_analytics/report.objectives.HoldGround':
      'Mantener el Terreno',
    'activerecord.attributes.data_analytics/report.objectives.KingHill':
      'Rey de la Colina',
    'activerecord.attributes.data_analytics/report.objectives.SecureTarget':
      'Asegurar el Objetivo',
    'activerecord.attributes.data_analytics/report.objectives.SpoilsWar':
      'Botín de Guerra',
    'activerecord.attributes.data_analytics/report.opponent_deployment':
      'Primero en Desplegar',
    'activerecord.attributes.data_analytics/report.opponent_first_turn':
      'Primer Turno',
    'activerecord.attributes.data_analytics/report.opponent_objective':
      'Ganar el Objetivo',
    'activerecord.attributes.data_analytics/report.your_deployment':
      'Primero en Desplegar',
    'activerecord.attributes.data_analytics/report.your_first_turn':
      'Primer Turno',
    'activerecord.attributes.data_analytics/report.your_objective':
      'Ganar el Objetivo',
    'activerecord.attributes.ninth_age/magic_item.only_foot':
      'Montura Prohibida',
    'activerecord.attributes.ninth_age/magic_item.only_wizard':
      'Solo Hechiceros',
    'activerecord.attributes.ninth_age/magic_item.organisation_ids':
      'Organisations required from the model',
    'activerecord.attributes.ninth_age/magic_item.model_rule_ids':
      'Reglas especiales prohibidas en la miniatura',
    'activerecord.attributes.ninth_age/magic_item.unit_ids':
      'Solo para esta unidad',
    'activerecord.attributes.ninth_age/magic_item.unit_size':
      'Las unidades de este tamaño no pueden usar este objeto',
    'activerecord.attributes.ninth_age/magic_standard.organisation':
      'Add organisation to unit',
    'activerecord.attributes.ninth_age/magic_standard.organisation_ids':
      "Only organisation's units",
    'activerecord.attributes.ninth_age/troop.carac_agi': 'Agi',
    'activerecord.attributes.ninth_age/troop.carac_ap': 'PA',
    'activerecord.attributes.ninth_age/troop.carac_att': 'Ata',
    'activerecord.attributes.ninth_age/troop.carac_of': 'Ofe',
    'activerecord.attributes.ninth_age/troop.carac_str': 'Fue',
    'activerecord.attributes.ninth_age/unit.carac_aeg': 'Égi',
    'activerecord.attributes.ninth_age/unit.carac_arm': 'Arm',
    'activerecord.attributes.ninth_age/unit.carac_def': 'Def',
    'activerecord.attributes.ninth_age/unit.carac_dis': 'Dis',
    'activerecord.attributes.ninth_age/unit.carac_evoked': 'Rea',
    'activerecord.attributes.ninth_age/unit.carac_fly_adv': 'Ava Vuelo',
    'activerecord.attributes.ninth_age/unit.carac_fly_mar': 'Mar Vuelo',
    'activerecord.attributes.ninth_age/unit.carac_ground_adv': 'Ava',
    'activerecord.attributes.ninth_age/unit.carac_ground_mar': 'Mar',
    'activerecord.attributes.ninth_age/unit.carac_hp': 'PV',
    'activerecord.attributes.ninth_age/unit.carac_res': 'Res',
    'activerecord.attributes.ninth_age_unit_option.category.BSB':
      'Portaestandarte de Batalla',
    'activerecord.attributes.ninth_age_unit_option.category.C': 'Campeón',
    'activerecord.attributes.ninth_age_unit_option.category.ModelRule':
      'Equipo',
    'activerecord.attributes.ninth_age_unit_option.category.ExtraSpells':
      'Hechizos',
    'activerecord.attributes.ninth_age_unit_option.category.General': 'General',
    'activerecord.attributes.ninth_age_unit_option.category.Generic':
      'Genérico',
    'activerecord.attributes.ninth_age_unit_option.category.M': 'Músico',
    'activerecord.attributes.ninth_age_unit_option.category.MagicBanner':
      'Encantamiento de Estandarte',
    'activerecord.attributes.ninth_age_unit_option.category.MagicEquipment':
      'Equipo Especial',
    'activerecord.attributes.ninth_age_unit_option.category.MagicLvl':
      'Nivel de Magia',
    'activerecord.attributes.ninth_age_unit_option.category.MagicPath':
      'Senda de la Magia',
    'activerecord.attributes.ninth_age_unit_option.category.MayTake':
      'Puede elegir',
    'activerecord.attributes.ninth_age_unit_option.category.Mount': 'Montura',
    'activerecord.attributes.ninth_age_unit_option.category.MustChoice':
      'Debe elegir',
    'activerecord.attributes.ninth_age_unit_option.category.OneChoice':
      'Una única opción',
    'activerecord.attributes.ninth_age_unit_option.category.S':
      'Portaestandarte de Batalla',
    'activerecord.attributes.ninth_age_unit_option.category.SpecialRule':
      'Regla Especial',
    'activerecord.attributes.ninth_age_unit_option.category.WizardAdept':
      'Hechicero Adepto',
    'activerecord.attributes.ninth_age_unit_option.category.WizardApprentice':
      'Aprendiz de Hechicero',
    'activerecord.attributes.ninth_age_unit_option.category.WizardMaster':
      'Maestro Hechicero',
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ChangeUnitOrganisation':
      "Change unit's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ExcludeAddOrganisation':
      "Not affected with other unit option's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.Unit':
      'All the unit',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Disable':
      'Desactivar',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Enable':
      'Activar',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Disable':
      'Desactivar',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Enable':
      'Activar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Add':
      'Añadir',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Replace':
      'Reemplazar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.A':
      'V1-A',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.BS':
      'V1-BS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.E':
      'V1-E',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.I':
      'V1-I',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.LD':
      'V1-Ld',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.M':
      'V1-M',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.S':
      'V1-S',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.T':
      'V1-T',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.W':
      'V1-W',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.WS':
      'V1-WS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_aeg':
      'V2-Égi',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_agi':
      'V2-Agi',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ap':
      'V2-PA',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_arm':
      'V2-Arm',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_att':
      'V2-Ata',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_def':
      'V2-Def',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_dis':
      'V2-Dis',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_evoked':
      'V2-Ranimado',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_adv':
      'V2-Ava-Vuelo',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_mar':
      'V2-Mar-Vuelo',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_adv':
      'V2-Ava',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_mar':
      'V2-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_hp':
      'V2-PV',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_of':
      'V2-Ofe',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_res':
      'V2-Res',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_str':
      'V2-Fue',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByArmy':
      'por Ejército',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByModel':
      'objetos por Unidad',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.MaxRatioByArmy':
      'Ratio máximo por Ejército',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Model':
      'Miniaturas por Ejército',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ModelByUnit':
      'Miniaturas por Unidad',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Units':
      'Unidades por Ejército',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Quantity':
      'Cantidad',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Selection':
      'Opción elegida',
    'activerecord.attributes.ninth_age_version.game.EssenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.WarhammerBattle':
      'Warhammer Battle',
    'activerecord.attributes.ninth_age_version.game.essenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.ninthAge': 'The Ninth Age',
    'activerecord.attributes.ninth_age_version.game.battle': 'Warhammer Battle',
    'activerecord.attributes.tournament/contest.participation': 'Participar',
    'activerecord.models.ninth_age/magic_standard.one': 'Estandate Mágico',
    'activerecord.models.ninth_age/magic_standard.other': 'Estandartes Mágicos',
    'activerecord.models.ninth_age/unit.one': 'Unidad',
    'activerecord.models.ninth_age/unit.other': 'Unidades',
    'admin.dashboard': 'Administración',
    'admin.tournament': 'Organizar Torneo',
    and: ' y ',
    'army.armybook': 'Libro de Ejército',
    'army.banner': 'Encantamiento de Estandarte',
    'army.index.show': 'Mostrar',
    'army.index.title': 'Todos los Ejércitos',
    'army.index.unofficial': 'Ejércitos no oficiales',
    'army.show.back': 'Volver',
    'army_list.clone.information': '¿Seguro que quiers copiar la lista?:',
    'army_list.clone.submit': 'Copiar',
    'army_list.clone.title': 'Copiar lista',
    'army_list.delete.information': '¿Seguro que quieres borrar esta lista?:',
    'army_list.delete.submit': '¡¡¡ Borrar !!!',
    'army_list.delete.title': 'Borrar\u003cbr /\u003elista',
    'army_list.edit.title': 'Editar lista',
    'army_list.export.html_full': 'HTML completo',
    'army_list.export.html_lite': 'HTML simple',
    'army_list.export.include_magics': 'Incluir Sendas de la Magia',
    'army_list.export.information': 'Elige el formato para exportar la lista:',
    'army_list.export.pdf_full': 'PDF completo',
    'army_list.export.pdf_lite': 'PDF simple',
    'army_list.export.print': 'Imprimir',
    'army_list.export.separator': 'Separador',
    'army_list.export.title': 'Exportar\u003cbr /\u003elista',
    'army_list.export.txt.general': 'General',
    'army_list.export.verbosity': 'Full blabla',
    'army_list.form.army.error': 'Debes elegir un ejército.',
    'army_list.form.army.placeholder': 'Elegir un ejército',
    'army_list.form.army.title': 'Ejército *',
    'army_list.form.folder.placeholder': 'Elegir carpeta',
    'army_list.form.folder.title': 'Carpeta',
    'army_list.form.max.name': 'Debes elegir el máximo de tu ejército',
    'army_list.form.max.placeholder': 'Introduce un valor máximo',
    'army_list.form.max.title': 'Máx *',
    'army_list.form.name.error': 'Debes nombrar tu lista',
    'army_list.form.name.placeholder': 'Introduce un nombre',
    'army_list.form.name.title': 'Nombre *',
    'army_list.form.notes.placeholder': 'Mis notas',
    'army_list.form.notes.title': 'Notas',
    'army_list.form.private.title': 'es una lista privada',
    'army_list.form.rate.title': 'Valorar con máximo',
    'army_list.form.version.error': 'Debes elegir una versión.',
    'army_list.form.version.placeholder': 'Elegir versión',
    'army_list.form.version.title': 'Versión *',
    'army_list.format.title': 'Crea e Importa Listas de Ejército',
    'army_list.index.add': 'Crear nueva lista de ejército',
    'army_list.index.and': 'y',
    'army_list.index.contest': 'Crear concurso',
    'army_list.index.filter': 'Filtrar por',
    'army_list.index.folder': 'Crear nueva carpeta',
    'army_list.index.name_or_notes': 'Nombre o notas',
    'army_list.index.search': 'Buscar',
    'army_list.index.title': 'Mis Listas de Ejército',
    'army_list.new.title': 'Crear nueva lista',
    'army_list.show.add_unit': 'Añadir unidad',
    'army_list.show.delete': 'Borrar',
    'army_list.show.duplicate': 'Duplicar',
    'army_list.show.edit': 'Editar',
    'army_list.show.export': 'Exportar',
    'army_list.show.notes': 'Notas',
    'army_list.show.organisation.excess': 'De más',
    'army_list.show.organisation.missing': 'Faltantes',
    'army_list.show.organisation.remaining': 'Restantes',
    'army_list.show.print': 'Imprimir',
    'army_list.show.rearrange_units': 'Reordenar unidades',
    'army_list.show.title': 'Lista de Ejército • {name}',
    'army_list.unit.form.name.placeholder': 'Añadir nombre',
    'army_list.unit.form.name.title': 'Nombre',
    'army_list.unit.form.title': 'Añadir unidad',
    'army_list.unit.form.unit.error': 'Debes elegir una unidad',
    'army_list.unit.form.unit.placeholder': 'Elegir unidad',
    'army_list.unit.form.unit.title': 'Unidad *',
    'army_list_unit.delete.information':
      'Seguro que quieres borrar esta unidad:',
    'army_list_unit.delete.submit': '¡¡¡ Borrar !!!',
    'army_list_unit.delete.title': 'Borrar\u003cbr /\u003eunidad',
    'army_list_unit.duplicate.new_army_list': 'Nueva {name} Lista',
    'army_list_unit.duplicate.target': 'A:',
    'army_list_unit.duplicate.title': 'Duplicar',
    'army_list_unit.edit.form.magic': 'Magia',
    'army_list_unit.edit.form.notes': 'Notas',
    'army_list_unit.edit.magic_items': 'Objetos Mágicos',
    'army_list_unit.edit.magic_standards': 'Estandartes Mágicos',
    'army_list_unit.edit.options': 'Opciones',
    'army_list_unit.edit.title': 'Editar',
    'army_list_unit.form.name': 'Nombre',
    'army_list_unit.form.submit': 'Crear Unidad',
    'army_list_unit.new.title': 'Añadir unidad',
    'army_list_unit.show.command_group_unit_options':
      'Opciones de Grupo de Mando',
    'army_list_unit.show.delete': 'Borrar',
    'army_list_unit.show.duplicate': 'Duplicar',
    'army_list_unit.show.edit': 'Editar',
    'army_list_unit.show.model_rules': 'Equipo',
    'army_list_unit.show.magic': 'Magia',
    'army_list_unit.show.magic_items': 'Objetos Mágicos',
    'army_list_unit.show.magic_lvl_unit_options': 'Puede ser (una sola opción)',
    'army_list_unit.show.magic_standards': 'Estandartes mágicos',
    'army_list_unit.show.magic_unit_options': 'Opciones mágicas',
    'army_list_unit.show.mount_unit_options': 'Opciones de Montura',
    'army_list_unit.show.notes': 'Notas',
    'army_list_unit.show.path_unit_options': 'Debe elegir hechizos de',
    'army_list_unit.show.path_unit_options_choose_one':
      'Debe elegir hechizos de (elige una)',
    'army_list_unit.show.troops.A': 'A',
    'army_list_unit.show.troops.BS': 'BS',
    'army_list_unit.show.troops.E': 'Evoked',
    'army_list_unit.show.troops.I': 'I',
    'army_list_unit.show.troops.LD': 'Ld',
    'army_list_unit.show.troops.M': 'M',
    'army_list_unit.show.troops.S': 'S',
    'army_list_unit.show.troops.T': 'T',
    'army_list_unit.show.troops.W': 'W',
    'army_list_unit.show.troops.WS': 'WS',
    'army_list_unit.show.troops.name': 'Tropas',
    'army_list_unit.show.troops.profile': 'Perfil',
    'army_list_unit.show.troops.type': 'Tipo de Tropa',
    'army_list_unit.show.unit_options': 'Opciones',
    'army_magic_spell.name': 'Hechizo Hereditario',
    'builder.searchs.index.and': 'y',
    'builder.searchs.index.between': 'entre',
    'builder.searchs.index.points': 'puntos',
    'builder.searchs.index.search': 'Buscar',
    'builder.searchs.index.search_army_select_error': 'Elige un ejército',
    'builder.searchs.index.select_army': 'Elegir Ejército',
    'builder.searchs.index.select_points_range': 'Valor en puntos',
    'builder.searchs.index.select_version': 'Elige la versión de The 9th Age',
    'builder.searchs.index.title': 'Buscar Lista de Ejército',
    'builder.searchs.show.and': 'y',
    'builder.searchs.show.between': 'entre',
    'builder.searchs.show.points': 'puntos',
    'builder.searchs.show.title': 'Listas de Ejército encontradas',
    close: 'Cerrar',
    'confirmation.form.email': 'E-mail',
    'confirmation.form.submit': 'Guardar',
    'confirmation.information':
      'Para cualquier duda, contáctanos en \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'confirmation.lost.password': 'He olvidado mi contraseña',
    'confirmation.title':
      'Enviar instrucciones para recuperar mi contraseña de nuevo',
    'contest.back': 'volver',
    'contest.delete.information': 'Seguro que lo quieres borrar:',
    'contest.delete.submit': '¡¡¡ Borrar !!!',
    'contest.delete.title': 'Borrar concurso',
    'contest.edit.title': 'Editar concurso',
    'contest.form.armyListMax.error':
      'Tu concurso necesita un número máximo de puntos',
    'contest.form.armyListMax.placeholder':
      'Introduce el máximo de puntos por ejército',
    'contest.form.armyListMax.title': 'Puntos máximos por ejército',
    'contest.form.endDate.error':
      'Tu concurso necesita una fecha en que acabar',
    'contest.form.endDate.placeholder': 'Introduce la fehca en que acaba',
    'contest.form.endDate.title': 'Fecha fin *',
    'contest.form.name.error': 'Debes nombrar tu lista',
    'contest.form.name.placeholder': 'Introducir nombre',
    'contest.form.name.title': 'Nombre *',
    'contest.form.participation.error':
      'Tu concurso necesita un modo de participación',
    'contest.form.participation.placeholder': 'Elegir modo de participación',
    'contest.form.participation.title': 'Individual o por equipos',
    'contest.form.startDate.error': 'Tu concurso necesita una fecha de inicio',
    'contest.form.startDate.placeholder': 'Introducir fecha de inicio',
    'contest.form.startDate.title': 'Fecha de inicio *',
    'contest.form.teamMax.error': 'Tu concurso necesita un número de equipos',
    'contest.form.teamMax.placeholder': 'Introduce el número de equipos',
    'contest.form.teamMax.title': 'Número de equipos',
    'contest.form.userMax.error':
      'Tu concurso necesita un número de participates o un tamaño del equipo',
    'contest.form.userMax.placeholder':
      'Introduce un número de participantes o un tamaño del equipo',
    'contest.form.userMax.title': 'Número de participantes o tamaño del equipo',
    'contest.form.versionid.error': 'Tu concurso necesita una versión',
    'contest.form.versionid.placeholder': 'Introducir la versión del juego',
    'contest.form.versionid.title': 'Versión del juego *',
    'contest.name': 'Torneo',
    'contest.new.title': 'Crear Concurso',
    'contest.show.title': 'Concurso: {name}',
    'data_analytics.analytics.title': 'Projecto: mejores datos para T9A',
    'data_analytics.report.new.title': 'Reportar una partida',
    'model_rules.index.show': 'Mostrar',
    'model_rules.index.title': 'Reglas Especiales',
    'export.format': 'Formato',
    'export.full': 'Todo',
    'export.lite': 'Simple',
    'export.magics': 'Magia',
    'export.nomagics': 'Sin Magia',
    'export.print': 'imprimir',
    'export.verbosity': 'Con blablabla',
    'export.withmagics': 'Con Magia',
    'folder.add_army_list.form.select': 'Seleccionar lista',
    'folder.add_army_list.title': 'Añadir lista a esta carpeta',
    'folder.back': 'Volver',
    'folder.delete.information': 'Seguro que la quieres borrar:',
    'folder.delete.submit': '¡¡¡ Borrar !!!',
    'folder.delete.title': 'Borrar carpeta',
    'folder.edit.title': 'Editar mi carpeta',
    'folder.form.is_share.title': 'Compartir carpeta',
    'folder.form.name.error': 'Debes nombrar tu lista',
    'folder.form.name.placeholder': 'Insertar nombre',
    'folder.form.name.title': 'Nombre *',
    'folder.form.parent.placeholder': 'Selecciona el padre',
    'folder.form.parent.title': 'Padre',
    'folder.name': 'Carpeta',
    'folder.new.title': 'Crear carpeta',
    'folder.share.title': 'Compartir carpeta',
    'folder.show.title': 'Carpeta: {name}',
    'folder.tournament.information':
      'Puedes transformar esta carpeta en un torneo',
    'folder.tournament.submit': '¡¡¡ Crear !!!',
    'folder.tournament.title': 'Crear torneo',
    'footerlink.accessibility': 'Accesibilidad',
    'footerlink.privacy': 'Política de Privacidad',
    'form.add': 'A',
    'form.cancel': 'Cancelar',
    'form.create': 'Crear',
    'form.format': 'Formato',
    'form.import': 'Importar',
    'form.save': 'Guardar',
    'format.form.date.error':
      'Debes elegir una fecha de creación para tu lista',
    'format.form.date.placeholder': '01/01/2022',
    'format.form.date.title': 'Fecha de Creación *',
    'format.form.formated.title': 'Lista de Ejército editada',
    'format.form.game.error': 'Debes elegir el juego al que jugar',
    'format.form.game.placeholder': 'T9A, EoW, WHB,....',
    'format.form.game.title': 'Tu partida *',
    'format.form.source.error': 'Debes añadir una Lista de Ejército',
    'format.form.source.placeholder': 'Introducir Lista de Ejército',
    'format.form.source.title': 'Tu Lista de Ejército *',
    'format.new.title': 'Editar Lista de Ejército',
    help: 'ayuda',
    'home.app.available.google': 'Obtener en Google Play',
    'home.app.available.on_platform': 'Endesarrollo, disponible en:',
    'home.app.mobile': 'Aplicación móvil',
    'home.locale.available': '9ThBuilder está disponible en varios idiomas.',
    'home.locale.default':
      'De forma predeterminada, si el contenido no está disponible en el idioma elegido, el contenido en inglés se mostrará automáticamente.',
    'home.no_account':
      'Puedes usar todas las funciones de 9th Builder sin crear una cuenta. \nPero ten en cuenta que tus listas están ligadas a tu sesión local, y no estarán disponibles en otro navegador, o después de borrar tu caché o reiniciar tu sesión."\n',
    'home.welcome': '9TH BUILDER',
    'home.whoarewe.compose': '¡Construye y guarda tus ejércitos favoritos!',
    'home.whoarewe.description':
      'A passionate of Battle since many years. I took the 9Th Builder since several years, creates a mobile application and helps the 9Th Age administration.\nHelped by Kaos War who greatly contributed to enter army lists and for the new homePage.\n9Th Builder is an effective and easy-to-use tool for creating your army lists and sharing them. It does not generate any income :)\n',
    'home.whoarewe.discord': 'Discord',
    'home.whoarewe.draft': 'Crear un emparejamiento',
    'home.whoarewe.format': 'Crea o importa tu ejército',
    'home.whoarewe.list': 'Crear Lista de Ejército',
    'home.whoarewe.newsfb': 'Noticias Facebook',
    'home.whoarewe.paint': 'Crear Lista de Pintura',
    'home.whoarewe.readarmy': 'Leer Libros de Ejército',
    'home.whoarewe.readmagic': 'Leer Sendas de la Mágia',
    'home.whoarewe.title': '¿Quienes somos?',
    'home.whoarewe.try': 'Probar',
    'home.whoarewe.whatdo': '¿Qué puedes hacer?',
    'lexicon.index.show': 'Libro de Ejército y Herramientas',
    'magic.casting': 'Lanzamiento',
    'magic.duration': 'Duración',
    'magic.effect': 'Efecto',
    'magic.index.show': 'Mostrar',
    'magic.index.title': 'Magia',
    'magic.range': 'Alcance',
    'magic.show.back': 'Volver',
    'magic.type': 'Tipo',
    'magic_item_categories.index.show': 'Mostrar',
    'magic_item_categories.index.title': 'Categorías de Objetos Mágicos',
    'magic_items.Cbtbmw': 'No puede llevarse por miniaturas con',
    'magic_items.Enchantment': 'Encantamiento',
    'magic_items.dominant': 'Dominante',
    'magic_items.footonly': 'solo a pie',
    'magic_items.index.show': 'Mostrar',
    'magic_items.index.title': 'Objetos Mágicos',
    'magic_items.only': 'solo',
    'magic_items.perArmy': 'par Armée',
    'magic_items.type_figurine.All': 'All',
    'magic_items.type_figurine.AnimisteBestial': 'Animiste bestial',
    'magic_items.type_figurine.Character': 'Personaje',
    'magic_items.type_figurine.FeralOrc': 'Orco Zalvaje',
    'magic_items.type_figurine.Goblins': 'Goblins',
    'magic_items.type_figurine.Infantry': 'Infanteria',
    'magic_items.type_figurine.KnightCommanders': 'Caballeros Comandante',
    'magic_items.type_figurine.MageOnFoot': 'Mago a pie',
    'magic_items.type_figurine.MarshalsMountedOnHorse': 'Mariscales a Caballo',
    'magic_items.type_figurine.ModelsOnChariots': 'miniaturas en Carro',
    'magic_items.type_figurine.ModelsOnFoot': 'Miniaturas a pie',
    'magic_items.type_figurine.MonarchsOfTheDead': 'Monarcas de la Muerte',
    'magic_items.type_figurine.Monster': 'Monstruo',
    'magic_items.type_figurine.MountedCharacter': 'Personaje Montado',
    'magic_items.type_figurine.NoLargeTarget': 'No large target',
    'magic_items.type_figurine.ParentUnit': 'Unidad Parental',
    'magic_items.type_figurine.Wizard': 'Hechicero',
    'magic_spell.type_lvl.A': 'A',
    'magic_spell.type_lvl.Five': '5',
    'magic_spell.type_lvl.Four': '4',
    'magic_spell.type_lvl.One': '1',
    'magic_spell.type_lvl.Six': '6',
    'magic_spell.type_lvl.Three': '3',
    'magic_spell.type_lvl.Two': '2',
    'magic_spell.type_lvl.Zero': '0',
    'magic_standards.index.show': 'Mostrar',
    'magic_standards.index.title': 'Estandartes Mágicos',
    'menu.army_lists': 'Mis listas de ejército',
    'menu.help': 'Ayuda',
    'menu.label': 'Menu principal',
    'menu.languages.de': 'Alemán',
    'menu.languages.en': 'Inglés',
    'menu.languages.es': 'Español',
    'menu.languages.fr': 'Francés',
    'menu.languages.hu': 'Húngaro',
    'menu.languages.it': 'Italiano',
    'menu.languages.ko': 'Coreano',
    'menu.languages.lang': 'Idioma',
    'menu.languages.pl': 'Polaco',
    'menu.languages.ru': 'Ruso',
    'menu.languages.sr': 'Serbio',
    'menu.languages.zh': 'Chino',
    'menu.preferences': 'Preferencias',
    'menu.signin': 'Iniciar sesión',
    'menu.signout': 'Cerrar sesión',
    'menu.signup': 'Registrarse',
    next: 'Siguient',
    'ninth_age.figurine.mount': 'Montura',
    'ninth_age.figurine.pts': 'pts',
    'ninth_age.magic_item.only_wizard.AllWizard': 'Solo Hechiceros',
    'ninth_age.magic_item.only_wizard.NoWizard':
      'No puede llevarse por Hechiceros',
    'ninth_age.magic_item.only_wizard.WizardAdept': 'Solo Hechicero Adepto',
    'ninth_age.magic_item.only_wizard.WizardApprentice':
      'Solo Aprendiz de Hechicero',
    'ninth_age.magic_item.only_wizard.WizardMaster': 'Solo Maestro Hechicero',
    'ninth_age.troop.offensive': 'Ofensivo',
    'ninth_age.unit.defensive': 'Defensivo',
    'ninth_age.unit.fly': 'vuelo',
    'ninth_age.unit.global': 'Global',
    'ninth_age.unit.rules': 'Reglas de Miniaturas',
    'paint_list.delete.information': 'Seguro que quieres borrar esta lista:',
    'paint_list.delete.submit': '¡¡¡ Borrar !!!',
    'paint_list.delete.title': 'Borrar lista',
    'paint_list.edit.title': 'Editar lista de pintura',
    'paint_list.form.army.error': 'Debes elegir un ejército.',
    'paint_list.form.army.placeholder': 'Elegir un ejército',
    'paint_list.form.army.title': 'Ejército *',
    'paint_list.form.name.error': 'Debes nombrar tu lista de ejército',
    'paint_list.form.name.placeholder': 'Introducir nombre',
    'paint_list.form.name.title': 'Nombre *',
    'paint_list.form.version.error': 'Debes elegir una versión.',
    'paint_list.form.version.placeholder': 'Elegir Versión',
    'paint_list.form.version.title': 'Versión *',
    'paint_list.index.add': 'Crear Lista de Pintura',
    'paint_list.index.title': 'Mis Listas de Pintura',
    'paint_list.new.title': 'Crear nueva lista',
    'paint_list.show.assembled': 'Montar',
    'paint_list.show.buy': 'Comprar',
    'paint_list.show.comment': 'Comentario',
    'paint_list.show.first_color': 'Capa base',
    'paint_list.show.paint': 'Pintura',
    'paint_list.show.plinth': 'Peana',
    'paint_list.show.size': 'Tamaño',
    'paint_list.show.state.done': '¡Finiquitao!',
    'paint_list.show.state.waiting': 'En espera',
    'paint_list.show.state.wip': 'En proceso',
    'paint_list.show.title': 'Tu Lista de Pintura:',
    'paint_list.show.trimmed': 'Limpiar',
    'paint_list.show.unit': 'Unidad',
    'paint_list.unit.form.comment.placeholder': 'Añadir comentario',
    'paint_list.unit.form.comment.title': 'Comentario',
    'paint_list.unit.form.size.error': 'Debes indicar el número de miniaturas',
    'paint_list.unit.form.size.placeholder': 'Indica el tamaño',
    'paint_list.unit.form.size.title': 'Tamaño *',
    'paint_list.unit.form.title': 'Añadir unidad',
    'paint_list.unit.form.unit.error': 'Debes elegir una unidad',
    'paint_list.unit.form.unit.placeholder': 'Elegir unidad',
    'paint_list.unit.form.unit.title': 'Unidad *',
    'password_change.form.confirmation': 'Confirmar contraseña',
    'password_change.form.password': 'Contraseña',
    'password_change.form.submit': 'Guardar',
    'password_change.information':
      'Para cualquier duda, contáctanos en \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_change.lost.confirmation':
      'No he recibido mi e-mail de confirmación',
    'password_change.lost.password': 'He olvidado mi contraseña',
    'password_change.title': 'Cambiar contraseña',
    'password_lost.form.email': 'E-mail',
    'password_lost.form.submit':
      'Enviar instrucciones para recuperar mi contraseña',
    'password_lost.information':
      'Para cualquier duda, contáctanos en \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_lost.lost.confirmation':
      'No he recibido mi e-mail de confirmación',
    'password_lost.title': 'He olvidado mi contraseña',
    'picker.datetime.js': 'YYYY.MM.DD HH:mm',
    'picker.datetime.rb': '%Y.%m.%d %H:%M',
    'profile.back': 'Página anterior',
    'profile.delete.information':
      '¿No estás satisfecho? \u003ca href="mailto:support@9thbuilder.com"\u003eContáctanos\u003c/a\u003e o',
    'profile.delete.link': 'Borra tu cuenta',
    'profile.delete.title': 'Borrar cuenta',
    'profile.form.confirmation': 'Confirmar contraseña',
    'profile.form.email': 'E-mail',
    'profile.form.game': 'Favorito',
    'profile.form.name': 'Nombre o alias',
    'profile.form.password': 'Contraseña',
    'profile.form.password_help':
      'Rellenar solo si quieres cambiar tu contraseña',
    'profile.form.submit': 'Guardar',
    'profile.title': 'Mi cuenta',
    save: 'Guardar',
    'search_list.assembled': 'Montar',
    'search_list.buy': 'Comprar',
    'search_list.comment': 'Comentario',
    'search_list.first_color': 'Capa base',
    'search_list.index.search': 'Buscar',
    'search_list.index.search_list': 'Buscar listas de ejército',
    'search_list.paint': 'Pintura',
    'search_list.plinth': 'Peana',
    'search_list.size': 'Tamaño',
    'search_list.trimmed': 'Limpiar',
    'search_list.unit': 'Unidad',
    'signin.Confirmation': 'Confirmation',
    'signin.form.email': 'E-mail',
    'signin.form.lost': '¿Olvidada ?',
    'signin.form.password': 'Contraseña',
    'signin.form.remember': 'Recordarme',
    'signin.form.submit': 'Iniciar Sesión',
    'signin.information':
      'Para cualquier duda, contáctanos en \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signin.lost.confirmation': 'No he recibido mi e-mail de confirmación',
    'signin.lost.password': 'He olvidado mi contraseña',
    'signin.title': 'Iniciar Sesión',
    'signup.form.confirmation': 'Confirmar contraseña',
    'signup.form.email': 'E-mail',
    'signup.form.game': '--Favorito--',
    'signup.form.name': 'Nombre o alias',
    'signup.form.password': 'Contraseña',
    'signup.form.register': '¡Únete!',
    'signup.form.submit': 'Registrarse',
    'signup.information':
      'Para cualquier duda, contáctanos en \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signup.lost.confirmation': 'No he recibido mi e-mail de confirmación',
    'signup.lost.password': 'He olvidado mi contraseña',
    'signup.title': 'Registrarse',
    'site.accept': 'De acuerdo',
    'site.more': 'Cuéntame más',
    'site.use_cookie':
      'Esta página usa cookies para ofrecerte el mejor servicio posible. Al continuar navegando, aceptas el uso de cookies.',
    'tool.pairing.done': 'Emparejamiento completo',
    'tool.pairing.draft.send_link': 'Envia este enlace a tu oponente:',
    'tool.pairing.draft.waiting_opponent': 'Estamos esperando a tu oponente',
    'tool.pairing.draw.confirm.draw': 'Confirmar selección',
    'tool.pairing.draw.confirm.response': 'Confirmar respuesta',
    'tool.pairing.draw.confirm.select': 'Confirmar selección',
    'tool.pairing.draw.or': 'o',
    'tool.pairing.draw.vs': 'Contra',
    'tool.pairing.draw_round.select.draw': 'Selecciona un ejército',
    'tool.pairing.draw_round.select.response': 'Selecciona tu respuesta',
    'tool.pairing.draw_round.select.select': 'Selecciona el ejército',
    'tool.pairing.draw_round.select.waiting': 'Esperando',
    'tool.pairing.image': 'Copiar url de la imagen del emparejamiento',
    'tool.pairing.inprogress': 'Emparejamiento en proceso',
    'tool.pairing.matches.tables': 'Mesas:',
    'tool.pairing.my_team.my_armies': 'Tus Ejércitos',
    'tool.pairing.opponent_team.team': 'Equipo',
    'tool.pairing.select_armies.choise_armies': 'Elige tus ejércitos',
    'tool.pairing.select_armies.confirm': 'Confirmar',
    'tool.pairing.select_armies.error':
      '¡Ha habido un error cargado los elementos!.',
    'tool.pairing.select_armies.your_team': 'Tu equipo',
    'tool.pairing.select_team_size.how_many':
      '¿Cuántos jugadores hay en el equipo?',
    'tool.pairing.table': 'Mesa',
    'tool.pairing.team_name.confirm': 'Confirmar',
    'tool.pairing.team_name.what_name': '¿Cuál es el nombre del equipo?',
    'tool.pairing.team_name.your_name': 'Nombre del equipo',
    'tool.search_rules.index.search': 'Buscar',
    'tool.search_rules.index.search_army_select_error':
      'Debes elegir un ejército',
    'tool.search_rules.index.search_rule': 'Elegir regla',
    'tool.search_rules.index.select_army': 'Elegir ejército',
    'tool.search_rules.index.select_version': 'Elegir versión de The 9th Age',
    'tool.search_rules.index.title': 'Buscar según reglas',
    'tournament.contest.back': 'Volver a Torneos',
    'tournament.contest.edit': 'Editar',
    'tournament.contest.form.address': 'Dirección',
    'tournament.contest.form.end_date': 'Fin',
    'tournament.contest.form.fees': 'Coste',
    'tournament.contest.form.name': 'Nombre',
    'tournament.contest.form.round_count': 'Rondas',
    'tournament.contest.form.start_date': 'Inicio',
    'tournament.contest.form.submit': 'Guardar',
    'tournament.contest.form.team_max': 'Máximo de Equipos',
    'tournament.contest.form.user_max': 'Máximo de Jugadores',
    'tournament.contest.form.user_team_max': 'Máximo de jugadores por equipo',
    'tournament.contest.form.version': 'Versión',
    'tournament.contest.index.title': 'Mis torneos',
    'tournament.contest.name': 'Torneo',
    'tournament.contest.new.title': 'Crear Torneo',
    'tournament.contest.print_armies': 'Imprimir todos los ejércitos',
    'tournament.contest.print_repport': 'Reportar',
    'tournament.contest.total': 'Total',
    'tournament.custom_point.name': 'Pintura, Wysiwyg, Lista',
    'tournament.round.add': 'Añadir Ronda',
    'tournament.round.name': 'Ronda',
    'tournament.round.pools.validate': 'Crear reserva',
    'tournament.team.add': 'Añadir Equpos',
    'tournament.team.back': 'Back to teams',
    'tournament.team.edit.title': 'Volver a Equipos',
    'tournament.team.export.title': 'Equipo',
    'tournament.team.first': 'Añadir tu primer equipo',
    'tournament.team.form.email': 'E-mail',
    'tournament.team.form.name': 'Nombre',
    'tournament.team.form.submit': 'Guardar',
    'tournament.team.index.title': 'My Tournament teams',
    'tournament.team.name': 'Equipos',
    'tournament.team.new.title': 'Añadir Equipos',
    'tournament.teams.add': 'Añadir Equipo',
    'tournament.teams.back': 'Volver a Torneos',
    'tournament.teams.title': 'Equpos',
    'tournament.user_apply.add': 'Añadir participante',
    'tournament.user_apply.add_into_team': 'Añadir participante a este equipo',
    'tournament.user_apply.army_list.add_now': 'Añadir',
    'tournament.user_apply.army_list.create': 'Crear lista nueva',
    'tournament.user_apply.army_list.need':
      'Aún no has añadido tu lista de ejército.',
    'tournament.user_apply.army_list.or': 'o',
    'tournament.user_apply.army_list.use_existing': 'Usar lista existente',
    'tournament.user_apply.army_list.which': '¿Qué lista?',
    'tournament.user_apply.army_list_select.form.submit': 'Guardar',
    'tournament.user_apply.edit.title': 'Editar tu participación',
    'tournament.user_apply.first': 'Añade tu primer participante',
    'tournament.user_apply.form.name': 'Nombre',
    'tournament.user_apply.form.name_detail':
      'Puedes añadir usuarios (1 por línea) separando el e-mail con una coma (nombre, e-mail).',
    'tournament.user_apply.form.or': 'o',
    'tournament.user_apply.form.submit': 'Añadir',
    'tournament.user_apply.form.user': 'Usuario',
    'tournament.user_apply.manage': 'Organizar equipo',
    'tournament.user_apply.name': 'Usuario',
    'tournament.user_apply.new.title': 'Añadir usuarios',
    'tournament.user_apply.remove': 'Borrar participante',
    'tournament.user_apply.share_link': 'Compartir invitación',
    'tournament.user_apply.team_leader': 'Capitán',
    'unit.base.label': 'Peana',
    'unit.height.Gigantic': 'Gigantesca',
    'unit.height.Large': 'Grande',
    'unit.height.Standard': 'Standard',
    'unit.limit.model': 'Miniaturas/Ejército',
    'unit.limit.perArmy': 'par Armée',
    'unit.limit.single': 'miniatura individual',
    'unit.limit.unit': 'Unidades/Ejército',
    'unit.mount': 'Montura',
    'unit.show.add_model':
      ' + \u003cstrong\u003e{pts}\u003c/strong\u003e pts/miniatura adicional',
    'unit.show.change':
      '{name} unidades de {number} miniaturas cuentan para {new_name}',
    'unit.show.change_with_limit':
      'Unidades de {number} o más miniaturas sin {limit} cuentan para {new_name} en lugar de {old_name}.',
    'unit.show.size':
      '\u003cstrong\u003e{min_size}-{max_size}\u003c/strong\u003e miniaturas',
    'unit.size.Gigantic': 'Gigantic',
    'unit.size.Large': 'Large',
    'unit.size.Standard': 'Standard',
    'unit.type.label': 'Tipo',
    'unit_option.per_model': '/mini.',
    'unit_option.use_points.free': 'gratis',
    'unit_option.use_points.no_limit': 'sin límite',
    'unit_option.use_points.up_to': 'hasta',
    'unit_options.category.C': 'C',
    'unit_options.category.M': 'M',
    'unit_options.category.S': 'S',
    'unit_options.footonly': 'solo a pie',
    'version.index.pairing': 'Emparejamiento',
    'version.index.search': 'Buscar por reglas',
    'version.index.show': 'Mostrar',
    'version.index.title': 'Versiones',
    'version.index.tools': 'Herramientas',
    'version.show.back': 'Volver',
    welcome: 'Bienvenido',
    with: 'con %',
    without: 'sin %',
  },
  fr: {
    'activerecord.attributes.user.current_password': 'Mot de passe actuel',
    'activerecord.attributes.user.email': 'Courriel',
    'activerecord.attributes.user.password': 'Mot de passe',
    'activerecord.attributes.user.password_confirmation':
      'Confirmation du mot de passe',
    'activerecord.attributes.user.remember_me': 'Se souvenir de moi',
    'activerecord.attributes.user.reset_password_token':
      'Clé de Réinitialisation du Mot de Passe',
    'activerecord.attributes.user.unlock_token': 'Clé de déblocage',
    'activerecord.models.user': 'Utilisateur',
    'devise.sessions.signed_in': '',
    'devise.sessions.signed_out': '',
    'users.confirmations.confirmed': 'Votre compte a été confirmé avec succès.',
    'users.confirmations.new.resend_confirmation_instructions':
      'Renvoyer les instructions de confirmation',
    'users.confirmations.send_instructions':
      'Vous allez recevoir sous quelques minutes un courriel comportant des instructions pour confirmer votre compte.',
    'users.confirmations.send_paranoid_instructions':
      'Si votre courriel existe sur notre base de données, vous recevrez sous quelques minutes un message avec des instructions pour confirmer votre compte.',
    'users.failure.already_authenticated': 'Vous êtes déjà connecté(e).',
    'users.failure.inactive': 'Votre compte n’est pas encore activé.',
    'users.failure.invalid': 'Courriel ou mot de passe incorrect.',
    'users.failure.last_attempt':
      'Il vous reste une chance avant que votre compte soit bloqué.',
    'users.failure.locked': 'Votre compte est verrouillé.',
    'users.failure.not_found_in_database':
      'Courriel ou mot de passe incorrect.',
    'users.failure.timeout':
      'Votre session est expirée, veuillez vous reconnecter pour continuer.',
    'users.failure.unauthenticated':
      'Vous devez vous connecter ou vous enregistrer pour continuer.',
    'users.failure.unconfirmed':
      'Vous devez confirmer votre compte par courriel.',
    'users.mailer.confirmation_instructions.action': 'Confirmer mon courriel',
    'users.mailer.confirmation_instructions.greeting': 'Bienvenue {recipient}!',
    'users.mailer.confirmation_instructions.instruction':
      'Vous pouvez confirmer votre courriel grâce au lien ci-dessous:',
    'users.mailer.confirmation_instructions.subject':
      'Instructions de confirmation',
    'users.mailer.password_change.greeting': 'Bonjour {recipient}!',
    'users.mailer.password_change.message':
      'Nous vous contactons pour vous notifier que votre mot de passe a été modifié.',
    'users.mailer.password_change.subject': 'Mot de passe modifié.',
    'users.mailer.reset_password_instructions.action':
      'Changer mon mot de passe',
    'users.mailer.reset_password_instructions.greeting': 'Bonjour {recipient}!',
    'users.mailer.reset_password_instructions.instruction':
      "Quelqu'un a demandé un lien pour changer votre mot de passe, le voici :",
    'users.mailer.reset_password_instructions.instruction_2':
      "Si vous n'avez pas émis cette demande, merci d'ignorer ce courriel.",
    'users.mailer.reset_password_instructions.instruction_3':
      "Votre mot de passe ne changera pas tant que vous n'aurez pas cliqué sur ce lien et renseigné un nouveau mot de passe.",
    'users.mailer.reset_password_instructions.subject':
      'Instructions pour changer le mot de passe',
    'users.mailer.unlock_instructions.action': 'Débloquer mon compte',
    'users.mailer.unlock_instructions.greeting': 'Bonjour {recipient}!',
    'users.mailer.unlock_instructions.instruction':
      'Suivez ce lien pour débloquer votre compte:',
    'users.mailer.unlock_instructions.message':
      "Votre compte a été bloqué suite à un nombre d'essais de connexions manquées trop important",
    'users.mailer.unlock_instructions.subject':
      'Instructions pour déverrouiller le compte',
    'users.omniauth_callbacks.failure':
      "Nous ne pouvons pas vous authentifier depuis {kind} pour la raison suivante : '{reason}'.",
    'users.omniauth_callbacks.success':
      'Autorisé avec succès par votre compte {kind}.',
    'users.passwords.edit.change_my_password': 'Changer mon mot de passe',
    'users.passwords.edit.change_your_password': 'Changer votre mot de passe',
    'users.passwords.edit.confirm_new_password':
      'Confirmez votre nouveau mot de passe',
    'users.passwords.edit.new_password': 'Nouveau mot de passe',
    'users.passwords.new.forgot_your_password': 'Mot de passe oublié ?',
    'users.passwords.new.send_me_reset_password_instructions':
      'Envoyez-moi des instructions pour réinitialiser mon mot de passe',
    'users.passwords.no_token':
      'Vous ne pouvez pas accéder à cette page si vous n’y accédez pas depuis un courriel de réinitialisation de mot de passe. Si vous venez en effet d’un tel courriel, vérifiez que vous avez copié l’adresse URL en entier.',
    'users.passwords.send_instructions':
      'Vous allez recevoir sous quelques minutes un courriel vous indiquant comment réinitialiser votre mot de passe.',
    'users.passwords.send_paranoid_instructions':
      'Si votre courriel existe dans notre base de données, vous recevrez un lien vous permettant de récupérer votre mot de passe.',
    'users.passwords.updated':
      'Votre mot de passe a été modifié avec succès. Vous êtes maintenant connecté(e).',
    'users.passwords.updated_not_active':
      'Votre mot de passe a été modifié avec succès.',
    'users.registrations.destroyed':
      'Au revoir ! Votre compte a été annulé avec succès. Nous espérons vous revoir bientôt.',
    'users.registrations.edit.are_you_sure': 'Êtes-vous sûr ?',
    'users.registrations.edit.cancel_my_account': 'Supprimer mon compte',
    'users.registrations.edit.currently_waiting_confirmation_for_email':
      'Confirmation en attente pour: {email}',
    'users.registrations.edit.leave_blank_if_you_don_t_want_to_change_it':
      'laissez ce champ vide pour le laisser inchangé',
    'users.registrations.edit.title': 'Éditer {resource}',
    'users.registrations.edit.unhappy': 'Pas content ',
    'users.registrations.edit.update': 'Modifier',
    'users.registrations.edit.we_need_your_current_password_to_confirm_your_changes':
      'nous avons besoin de votre mot de passe actuel pour valider ces modifications',
    'users.registrations.new.sign_up': 'Inscription',
    'users.registrations.signed_up':
      'Bienvenue ! Vous vous êtes enregistré(e) avec succès.',
    'users.registrations.signed_up_but_inactive':
      'Vous vous êtes enregistré(e) avec succès. Cependant, nous n’avons pas pu vous connecter car votre compte n’a pas encore été activé.',
    'users.registrations.signed_up_but_locked':
      'Vous vous êtes enregistré(e) avec succès. Cependant, nous n’avons pas pu vous connecter car votre compte est verrouillé.',
    'users.registrations.signed_up_but_unconfirmed':
      'Un message avec un lien de confirmation vous a été envoyé par mail. Veuillez suivre ce lien pour activer votre compte.',
    'users.registrations.update_needs_confirmation':
      'Vous avez modifié votre compte avec succès, mais nous devons vérifier votre nouvelle adresse de courriel. Veuillez consulter vos courriels et cliquer sur le lien de confirmation pour confirmer votre nouvelle adresse.',
    'users.registrations.updated': 'Votre compte a été modifié avec succès.',
    'users.sessions.already_signed_out': 'Déconnecté(e).',
    'users.sessions.new.sign_in': 'Connexion',
    'users.sessions.signed_in': 'Connecté(e) avec succès.',
    'users.sessions.signed_out': 'Déconnecté(e) avec succès.',
    'users.shared.links.back': 'Retour',
    'users.shared.links.didn_t_receive_confirmation_instructions':
      "Vous n'avez pas reçu le courriel de confirmation ?",
    'users.shared.links.didn_t_receive_unlock_instructions':
      "Vous n'avez pas reçu le courriel de déblocage ?",
    'users.shared.links.forgot_your_password': 'Mot de passe oublié ?',
    'users.shared.links.sign_in': 'Connexion',
    'users.shared.links.sign_in_with_provider': 'Connexion avec {provider}',
    'users.shared.links.sign_up': 'Inscription',
    'users.unlocks.new.resend_unlock_instructions':
      'Renvoyer les instructions de déblocage',
    'users.unlocks.send_instructions':
      'Vous allez recevoir sous quelques minutes un courriel comportant des instructions pour déverrouiller votre compte.',
    'users.unlocks.send_paranoid_instructions':
      'Si votre courriel existe sur notre base de données, vous recevrez sous quelques minutes un message avec des instructions pour déverrouiller votre compte.',
    'users.unlocks.unlocked':
      'Votre compte a été déverrouillé avec succès. Veuillez vous connecter.',
    'errors.messages.already_confirmed': 'a déjà été confirmé(e)',
    'errors.messages.confirmation_period_expired':
      'doit être confirmé(e) en {period}, veuillez en demander un(e) autre',
    'errors.messages.expired': 'est expiré, veuillez en demander un autre',
    'errors.messages.not_found': 'n’a pas été trouvé(e)',
    'errors.messages.not_locked': 'n’était pas verrouillé(e)',
    'errors.messages.not_saved.one':
      'une erreur a empêché ce (cet ou cette) {resource} d’être enregistré(e) :',
    'errors.messages.not_saved.other':
      '{count} erreurs ont empêché ce (cet ou cette) {resource} d’être enregistré(e) :',
    Common: 'Commun',
    'activerecord.attributes.data_analytics/report.deployments.CounterThrust':
      'Contre-poussée',
    'activerecord.attributes.data_analytics/report.deployments.DawnAssult':
      "Assaut à l'aube",
    'activerecord.attributes.data_analytics/report.deployments.Encircle':
      'Encercler',
    'activerecord.attributes.data_analytics/report.deployments.FrontlineClash':
      'Affrontement Frontal',
    'activerecord.attributes.data_analytics/report.deployments.MarchingColumns':
      'Colonnes de marche',
    'activerecord.attributes.data_analytics/report.deployments.RefusedFlank':
      'Flanc refusé',
    'activerecord.attributes.data_analytics/report.maps.A1':
      'A1 - étang enveloppée',
    'activerecord.attributes.data_analytics/report.maps.A2':
      'A2 - Avant-poste des contreforts',
    'activerecord.attributes.data_analytics/report.maps.A3':
      'A3 - Manoir délabré',
    'activerecord.attributes.data_analytics/report.maps.A4':
      'A4 - Lac volcanique',
    'activerecord.attributes.data_analytics/report.maps.A5':
      'A5 - Marais brumeux',
    'activerecord.attributes.data_analytics/report.maps.A6':
      'A6 - Murs anciens',
    'activerecord.attributes.data_analytics/report.maps.A7':
      'A7 - Colline de balise',
    'activerecord.attributes.data_analytics/report.maps.A8':
      'A8 - Cottage de la sorcière',
    'activerecord.attributes.data_analytics/report.maps.B1':
      'B1 - Sanctuaire du mage',
    'activerecord.attributes.data_analytics/report.maps.B2':
      'B2 - Terrain de la villa',
    'activerecord.attributes.data_analytics/report.maps.B3':
      'B3 - Ancienne forteresse',
    'activerecord.attributes.data_analytics/report.maps.B4':
      'B4 - Ferme frontière',
    'activerecord.attributes.data_analytics/report.maps.B5':
      'B5 - Tour de guet ravagée',
    'activerecord.attributes.data_analytics/report.maps.B6':
      'B6 - Forêt rampante',
    'activerecord.attributes.data_analytics/report.maps.B7':
      'B7 - Cimetière mystérieux',
    'activerecord.attributes.data_analytics/report.maps.B8': 'B8 - Pont brisé',
    'activerecord.attributes.data_analytics/report.objectives.Breakthrough':
      'Percée',
    'activerecord.attributes.data_analytics/report.objectives.CaptureFlags':
      'Capturer les drapeaux',
    'activerecord.attributes.data_analytics/report.objectives.HoldGround':
      'Tenir le terrain',
    'activerecord.attributes.data_analytics/report.objectives.KingHill':
      'Roi de la colline',
    'activerecord.attributes.data_analytics/report.objectives.SecureTarget':
      'Cible sécurisée',
    'activerecord.attributes.data_analytics/report.objectives.SpoilsWar':
      'Butin de guerre',
    'activerecord.attributes.data_analytics/report.opponent_deployment':
      'Premier à déployer',
    'activerecord.attributes.data_analytics/report.opponent_first_turn':
      'Premier tour',
    'activerecord.attributes.data_analytics/report.opponent_objective':
      "Prenez l'objectif",
    'activerecord.attributes.data_analytics/report.your_deployment':
      'Premier à déployer',
    'activerecord.attributes.data_analytics/report.your_first_turn':
      'Premier tour',
    'activerecord.attributes.data_analytics/report.your_objective':
      "Prenez l'objectif",
    'activerecord.attributes.ninth_age/magic_item.only_foot':
      'Monture interdite',
    'activerecord.attributes.ninth_age/magic_item.only_wizard':
      "Seul un magicien peut l'utiliser",
    'activerecord.attributes.ninth_age/magic_item.organisation_ids':
      'Organisations requises du modèle',
    'activerecord.attributes.ninth_age/magic_item.model_rule_ids':
      'Règles spéciales interdites sur le modèle',
    'activerecord.attributes.ninth_age/magic_item.unit_ids':
      'Pour ces unités uniquement',
    'activerecord.attributes.ninth_age/magic_item.unit_size':
      'une unité de cette taille ne peut pas utiliser cet objects',
    'activerecord.attributes.ninth_age/magic_standard.organisation':
      "Ajouter une organisation à l'unité",
    'activerecord.attributes.ninth_age/magic_standard.organisation_ids':
      "Seules les unités de l'organisation",
    'activerecord.attributes.ninth_age/troop.carac_agi': 'Agi',
    'activerecord.attributes.ninth_age/troop.carac_ap': 'PA',
    'activerecord.attributes.ninth_age/troop.carac_att': 'Att',
    'activerecord.attributes.ninth_age/troop.carac_of': 'Off',
    'activerecord.attributes.ninth_age/troop.carac_str': 'Fo',
    'activerecord.attributes.ninth_age/unit.carac_aeg': 'Aeg',
    'activerecord.attributes.ninth_age/unit.carac_arm': 'Arm',
    'activerecord.attributes.ninth_age/unit.carac_def': 'Déf',
    'activerecord.attributes.ninth_age/unit.carac_dis': 'Dis',
    'activerecord.attributes.ninth_age/unit.carac_evoked': 'Rea',
    'activerecord.attributes.ninth_age/unit.carac_fly_adv': 'Vol MS',
    'activerecord.attributes.ninth_age/unit.carac_fly_mar': 'Vol MF',
    'activerecord.attributes.ninth_age/unit.carac_ground_adv': 'MS',
    'activerecord.attributes.ninth_age/unit.carac_ground_mar': 'MF',
    'activerecord.attributes.ninth_age/unit.carac_hp': 'PV',
    'activerecord.attributes.ninth_age/unit.carac_res': 'Rés',
    'activerecord.attributes.ninth_age_army.source.FanMade': 'Fan Made',
    'activerecord.attributes.ninth_age_army.source.Official': 'Officielle',
    'activerecord.attributes.ninth_age_army.source.Supplement': 'Supplement',
    'activerecord.attributes.ninth_age_unit_option.category.BSB':
      'Porteur de la grande bannière',
    'activerecord.attributes.ninth_age_unit_option.category.C': 'Champion',
    'activerecord.attributes.ninth_age_unit_option.category.ModelRule':
      'ModelRule',
    'activerecord.attributes.ninth_age_unit_option.category.ExtraSpells':
      'Sort',
    'activerecord.attributes.ninth_age_unit_option.category.General': 'Général',
    'activerecord.attributes.ninth_age_unit_option.category.Generic':
      'Générique',
    'activerecord.attributes.ninth_age_unit_option.category.M': 'Musicien',
    'activerecord.attributes.ninth_age_unit_option.category.MagicBanner':
      'Enchantement d’étendard',
    'activerecord.attributes.ninth_age_unit_option.category.MagicEquipment':
      'Objets spéciaux',
    'activerecord.attributes.ninth_age_unit_option.category.MagicLvl':
      'Niveau de Magie',
    'activerecord.attributes.ninth_age_unit_option.category.MagicPath':
      'Domaine de magie',
    'activerecord.attributes.ninth_age_unit_option.category.MayTake':
      'peut prendre',
    'activerecord.attributes.ninth_age_unit_option.category.Mount': 'Monture',
    'activerecord.attributes.ninth_age_unit_option.category.MustChoice':
      'doit choisir',
    'activerecord.attributes.ninth_age_unit_option.category.OneChoice':
      'Un seul choix',
    'activerecord.attributes.ninth_age_unit_option.category.S':
      'Porte-étendard',
    'activerecord.attributes.ninth_age_unit_option.category.SpecialRule':
      'Règle spéciale',
    'activerecord.attributes.ninth_age_unit_option.category.WizardAdept':
      'Adepte magiciens',
    'activerecord.attributes.ninth_age_unit_option.category.WizardApprentice':
      'Apprenti magiciens',
    'activerecord.attributes.ninth_age_unit_option.category.WizardMaster':
      'Maître magiciens',
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ChangeUnitOrganisation':
      "Change l'organisation de l'unité",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ExcludeAddOrganisation':
      "Non affecté par l'organisation d'une autre option d'unité",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.Unit':
      "Toute l'unité",
    'activerecord.attributes.ninth_age_unit_option_availability.action.Disable':
      'Déactivé',
    'activerecord.attributes.ninth_age_unit_option_availability.action.DisableForAll':
      'Désactive pour toutes les unités si présent',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Enable':
      'activé',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Disable':
      'Désactiver',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Enable':
      'Activer',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Add':
      'Ajout',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Replace':
      'Remplace',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.A':
      'V1-A',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.BS':
      'V1-BS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.E':
      'V1-E',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.I':
      'V1-I',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.LD':
      'V1-Ld',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.M':
      'V1-M',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.S':
      'V1-S',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.T':
      'V1-T',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.W':
      'V1-W',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.WS':
      'V1-WS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_aeg':
      'V2-Aeg',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_agi':
      'V2-Agi',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ap':
      'V2-Pa',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_arm':
      'V2-Arm',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_att':
      'V2-Att',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_def':
      'V2-Def',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_dis':
      'V2-Dis',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_evoked':
      'V2-Rea',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_adv':
      'V2-Vol-MS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_mar':
      'V2-Vol-MF',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_adv':
      'V2-MS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_mar':
      'V2-MF',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_hp':
      'V2-Pv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_of':
      'V2-Off',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_res':
      'V2-Res',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_str':
      'V2-Fo',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByArmy':
      'par Armée',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByModel':
      'par unité',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.MaxRatioByArmy':
      'Max Ratio per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Model':
      'Figurines',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ModelByUnit':
      'Figurine par Unité',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Units':
      'Unités par Armée',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Quantity':
      'Quantity from the option',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Selection':
      'Option selected',
    'activerecord.attributes.ninth_age_version.game.EssenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.WarhammerBattle':
      'Warhammer Battle',
    'activerecord.attributes.ninth_age_version.game.essenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.ninthAge': '9th Age',
    'activerecord.attributes.ninth_age_version.game.battle': 'Warhammer Battle',
    'activerecord.attributes.user.game.essenceOfWar': 'Essence of War',
    'activerecord.attributes.user.game.ninthAge': '9th Age',
    'activerecord.attributes.user.game.battle': 'Warhammer Battle',
    'activerecord.attributes.user.builder_interface.classic': 'Classic',
    'activerecord.attributes.user.builder_interface.oldSkool':
      'Old Skool (wahb)',
    'activerecord.attributes.tournament/contest.participation': 'Participation',
    'activerecord.models.ninth_age/magic_standard.one':
      'Enchantement d’étendard',
    'activerecord.models.ninth_age/magic_standard.other':
      'Enchantements d’étendard',
    'activerecord.models.ninth_age/unit.one': 'Unité',
    'activerecord.models.ninth_age/unit.other': 'Unités',
    'admin.dashboard': 'tableau de bord',
    'admin.tournament': 'Orga Tournois',
    and: ' et ',
    'army.armybook': "Livre d'Armées",
    'army.banner': 'Enchantement de Bannière',
    'army.index.show': 'Voir',
    'army.index.title': 'toute les Armées',
    'army.show.back': 'Retour',
    'army_list.clone.form.action':
      'Etes-vous certain de vouloir dupliquer la liste :',
    'army_list.clone.form.title': 'Dupliquer la liste',
    'army_list.delete.form.action':
      'Etes-vous certain de vouloir supprimer la liste :',
    'army_list.delete.form.title': 'Supprimer la liste',
    'army_list.edit.title': 'Editer la liste',
    'army_list.export.html_full': 'HTML complet',
    'army_list.export.html_lite': 'HTML tournoi',
    'army_list.export.include_magics': 'Inclure les objects magiques?',
    'army_list.export.information':
      'Choisissez le format pour exporter la liste :',
    'army_list.export.pdf_full': 'PDF complet',
    'army_list.export.pdf_lite': 'PDF tournoi',
    'army_list.export.print': 'Imprimer',
    'army_list.export.separator': 'Séparateur',
    'army_list.export.title': 'Exporter votre liste',
    'army_list.export.txt.general': 'Générale',
    'army_list.export.verbosity': 'Verbosité',
    'army_list.form.army.error': 'Tu Doit Choisir une armée.',
    'army_list.form.army.placeholder': 'Choisir une armée',
    'army_list.form.army.title': 'Armée *',
    'army_list.form.folder.placeholder': 'Choisir un Dossier',
    'army_list.form.folder.title': 'Dossier',
    'army_list.form.max.name': 'Tu dois choisir un max pour ton armée',
    'army_list.form.max.placeholder': 'Entré un max',
    'army_list.form.max.title': 'Max *',
    'army_list.form.name.error': 'Tu dois nommer ta liste',
    'army_list.form.name.placeholder': 'Entré un nom',
    'army_list.form.name.title': 'Nom *',
    'army_list.form.notes.placeholder': 'Mes notes',
    'army_list.form.notes.title': 'Notes',
    'army_list.form.private.title': 'est une liste privée',
    'army_list.form.rate.title': 'Taux avec le Max',
    'army_list.form.version.error': 'Tu dois Choisir une version.',
    'army_list.form.version.placeholder': 'choisir une version',
    'army_list.form.version.title': 'Version *',
    'army_list.format.title': "Mettre en forme et importer une liste d'armée",
    'army_list.index.add': "Créer une nouvelle liste d'armée",
    'army_list.index.and': 'et',
    'army_list.index.contest': 'Créer un competition',
    'army_list.index.filter': 'Filtrer par',
    'army_list.index.folder': 'Nouveau dossier',
    'army_list.index.name_or_notes': 'Nom et remarques',
    'army_list.index.search': 'Valider',
    'army_list.index.title': "Mes listes d'armée",
    'army_list.new.title': 'Créer une nouvelle liste',
    'army_list.new.infos':
      "Voous pouvez maintenant filtrer les armées pour n'afficher que la dernière version. Vous pouvez le modifier directement dans votre profil.",
    'army_list.paint.form.action':
      'Voulez-vous créer une liste de peinture depuis :',
    'army_list.paint.form.title': 'Convertir en liste de peinture',
    'army_list.show.builder_interface':
      "Vous pouvez maintenant changer l'interface par défaut que vous voulez utiliser directement dans votre profil.",
    'army_list.show.add_unit': 'Ajouter une unité',
    'army_list.show.delete': 'Supprimer',
    'army_list.show.duplicate': 'Dupliquer',
    'army_list.show.edit': 'Editer',
    'army_list.show.export': 'Exporter',
    'army_list.show.notes': 'Remarques',
    'army_list.show.organisation.excess': 'Excès :',
    'army_list.show.organisation.missing': 'Manquants :',
    'army_list.show.organisation.remaining': 'Restants :',
    'army_list.show.print': 'Imprimer',
    'army_list.show.rearrange_units': 'réorganiser les unités',
    'army_list.show.title': "Liste d'armée • {name}",
    'army_list.unit.clone.form.action': "Voulez-vous copier l'unité :",
    'army_list.unit.clone.form.title': "Copier l'unité",
    'army_list.unit.delete.form.action': "Voulez-vous supprimer l'unité :",
    'army_list.unit.delete.form.title': "Supprimer l'unité",
    'army_list.unit.form.name.placeholder': 'Ajouter un nom',
    'army_list.unit.form.name.title': 'Nom',
    'army_list.unit.form.title': 'Ajouter une unité',
    'army_list.unit.form.unit.error': 'Tu dois Choisir une unité',
    'army_list.unit.form.unit.placeholder': 'choisir une unité',
    'army_list.unit.form.unit.title': 'Unité *',
    'army_list.unit.magic': 'Magie',
    'army_list.unit.note': 'Notes',
    'army_list.unit.option.form.banner.title': 'Bannières',
    'army_list.unit.option.form.command.title': 'État-major',
    'army_list.unit.option.form.enchantement.title':
      "Enchantement de l'équipement",
    'army_list.unit.option.form.magic.title': 'Magie',
    'army_list.unit.option.form.magic_item.title': 'Objects magiques',
    'army_list.unit.option.form.mount.title': 'Montures',
    'army_list.unit.option.form.option.title': 'Options',
    'army_list_unit.delete.information':
      "Etes-vous certain de vouloir supprimer l'unité :",
    'army_list_unit.delete.submit': '!!! Supprimer !!!',
    'army_list_unit.delete.title': 'Supprimer\u003cbr /\u003eune unite',
    'army_list_unit.duplicate.new_army_list': 'Nouvelle liste {name}',
    'army_list_unit.duplicate.target': 'Vers :',
    'army_list_unit.duplicate.title': 'Dupliquer',
    'army_list_unit.edit.form.magic': 'Magie',
    'army_list_unit.edit.form.notes': 'Remarques',
    'army_list_unit.edit.magic_items': 'Objets magiques',
    'army_list_unit.edit.magic_standards': 'Bannieres magiques',
    'army_list_unit.edit.options': 'Options',
    'army_list_unit.edit.title': 'Editer',
    'army_list_unit.form.name': 'Nom',
    'army_list_unit.form.submit': 'Crée Unité',
    'army_list_unit.new.title': 'Ajouter une unite',
    'army_list_unit.show.command_group_unit_options': "Options de L'état major",
    'army_list_unit.show.delete': 'Supprimer',
    'army_list_unit.show.duplicate': 'Dupliquer',
    'army_list_unit.show.edit': 'Editer',
    'army_list_unit.show.magic': 'Magie',
    'army_list_unit.show.magic_items': 'Objets magiques',
    'army_list_unit.show.magic_lvl_unit_options': 'un seul choix',
    'army_list_unit.show.magic_standards': 'Bannières magiques',
    'army_list_unit.show.magic_unit_options': 'Options magiques',
    'army_list_unit.show.mount_unit_options': 'Choix de la monture',
    'army_list_unit.show.notes': 'Remarques',
    'army_list_unit.show.path_unit_options': 'Doit choisir ses sorts dans',
    'army_list_unit.show.path_unit_options_choose_one':
      'Doit choisir ses sorts dans (un seul choix)',
    'army_list_unit.show.qrcode.title': 'Qr codes de votre armée',
    'army_list_unit.show.qrcode.description':
      'Vous pouvez imprimer cette page pour avoir les QR codes de votre armée et les coller sur vos unités pour en retrouver les profils durant la bataille avec votre smatphone.',
    'army_list_unit.show.model_rules': 'Règles spéciales',
    'army_list_unit.show.troops.A': 'A',
    'army_list_unit.show.troops.BS': 'CT',
    'army_list_unit.show.troops.E': 'Ressuscité',
    'army_list_unit.show.troops.I': 'I',
    'army_list_unit.show.troops.LD': 'Cd',
    'army_list_unit.show.troops.M': 'M',
    'army_list_unit.show.troops.S': 'F',
    'army_list_unit.show.troops.T': 'E',
    'army_list_unit.show.troops.W': 'PV',
    'army_list_unit.show.troops.WS': 'CC',
    'army_list_unit.show.troops.name': 'Troupes',
    'army_list_unit.show.troops.profile': 'Profil',
    'army_list_unit.show.troops.type': 'Type de troupe',
    'army_list_unit.show.unit_options': 'Options',
    'army_magic_spell.name': 'Sort héréditaire',
    'arsenal.armies.index.add': 'Ajouter une figurines pour une armée',
    'arsenal.armies.index.title': 'Mes figurines par armées',
    'arsenal.army.form.army.error': 'Vous devez choisir une armée !',
    'arsenal.army.form.army.placeholder': 'Sélectionner votre armée',
    'arsenal.army.form.army.title': 'Votre armée',
    'arsenal.army.form.name.error': "Votre list a besoin d'un nom !",
    'arsenal.army.form.name.placeholder': 'Mon armée de ...',
    'arsenal.army.form.name.title': 'Nom de la liste',
    'arsenal.army.new.title': 'Ajouter une figurines pour une armée',
    'builder.searchs.index.and': 'et',
    'builder.searchs.index.between': 'entre',
    'builder.searchs.index.points': 'points',
    'builder.searchs.index.search': 'Chercher',
    'builder.searchs.index.search_army_select_error':
      'Vous devez sélectionner une armée',
    'builder.searchs.index.select_army': "Choisir l'armée",
    'builder.searchs.index.select_points_range': 'Nombre de point',
    'builder.searchs.index.select_version': 'Choisissez la version de 9Th Age',
    'builder.searchs.index.title': "Rechercher une liste d'armée",
    'builder.searchs.show.and': 'et',
    'builder.searchs.show.between': 'entre',
    'builder.searchs.show.points': 'points',
    'builder.searchs.show.title': "Liste d'armée trouvée",
    close: 'Fermer',
    'confirmation.form.email': 'Email',
    'confirmation.form.submit': 'Valider',
    'confirmation.information':
      'Pour toutes questions n\'hésitez pas à consulter l\'\u003ca href="mailto:support@9thbuilder.com"\u003eaide en ligne\u003c/a\u003e',
    'confirmation.lost.password': "J'ai perdu mon mot de passe !",
    'confirmation.title': 'Renvoyer les instructions de confirmation',
    'contest.back': 'retour',
    'contest.delete.information': 'Êtes-vous sûr de vouloir supprimer:',
    'contest.delete.submit': '!!! Supprimer !!!',
    'contest.delete.title': 'Supprimer le concours',
    'contest.edit.title': 'Modifier mon competition',
    'contest.form.armyListMax.error':
      'Votre competition nécessite un max de points par armée',
    'contest.form.armyListMax.placeholder': 'Entrez un max de points par armée',
    'contest.form.armyListMax.title': 'Points max par armée',
    'contest.form.endDate.error':
      "Votre competition a besoin d'une date de fin",
    'contest.form.endDate.placeholder': 'Entrez une date de fin',
    'contest.form.endDate.title': 'Date de fin *',
    'contest.form.name.error': 'Vous devez nommer votre liste',
    'contest.form.name.placeholder': 'Entrez un nom',
    'contest.form.name.title': 'Nom *',
    'contest.form.participation.error':
      "Votre competition a besoin d'un mode de participation",
    'contest.form.participation.placeholder':
      'Entrer dans un mode de participation',
    'contest.form.participation.title': 'Individuel ou par équipe',
    'contest.form.startDate.error':
      "Votre competition a besoin d'une date de début",
    'contest.form.startDate.placeholder': 'Entrez une date de début',
    'contest.form.startDate.title': 'Date de début *',
    'contest.form.teamMax.error':
      "Votre competition a besoin d'un certain nombre d'équipe",
    'contest.form.teamMax.placeholder': "Entrez un numéro d'équipe",
    'contest.form.teamMax.title': "Nombre d'équipe",
    'contest.form.userMax.error':
      "Votre competition a besoin d'un nombre de participants ou d'une taille d'équipe",
    'contest.form.userMax.placeholder':
      "Entrez un nombre de participants ou la taille de l'équipe",
    'contest.form.userMax.title':
      "Nombre de participants ou taille de l'équipe",
    'contest.form.versionid.error':
      "Votre competition a besoin d'une version de jeu",
    'contest.form.versionid.placeholder': 'Entrez une version du jeu',
    'contest.form.versionid.title': 'version du jeu *',
    'contest.name': 'Tournoi',
    'contest.new.title': 'Créer un competition',
    'contest.show.title': 'competition: {name}',
    'data_analytics.analytics.title': 'Projet : De meilleures données pour T9A',
    'data_analytics.report.new.title': 'Signaler une partie',
    'model_rules.index.show': 'Voir',
    'model_rules.index.title': 'Règles spéciales',
    'export.format': 'Format',
    'export.full': 'complète',
    'export.lite': 'léger',
    'export.magics': 'Magic',
    'export.nomagics': 'sans Magic',
    'export.print': 'imprimer',
    'export.verbosity': 'verbosité',
    'export.withmagics': 'avec magic',
    'folder.add_army_list.form.select': "Sélectionnez une liste d'armée",
    'folder.add_army_list.title': 'Ajouter une liste dans ce dossier',
    'folder.back': 'retour',
    'folder.delete.information': 'Êtes-vous sûr de vouloir supprimer:',
    'folder.delete.submit': '!!! Supprimer !!!',
    'folder.delete.title': 'Supprimer le dossier',
    'folder.edit.title': 'Modifier mon dossier',
    'folder.form.is_share.title': 'Partager ce dossier',
    'folder.form.name.error': 'Vous devez nommer votre liste',
    'folder.form.name.placeholder': 'Entrer un nom',
    'folder.form.name.title': 'Nom *',
    'folder.form.parent.placeholder': 'Choisir le parent',
    'folder.form.parent.title': 'Parent',
    'folder.name': 'Dossier',
    'folder.new.title': 'Créer un dossier',
    'folder.share.title': 'Dossier de partage',
    'folder.show.title': 'Dossier: {name}',
    'folder.tournament.information':
      'Vous pouvez convertir ce dossier en tournoi !',
    'folder.tournament.submit': '!!! Créer !!!',
    'folder.tournament.title': 'Créer un tournoi',
    'footerlink.accessibility': 'Accessibilité: non conforme',
    'footerlink.privacy': 'Politique de confidentialité',
    'form.add': 'Ajouter',
    'form.cancel': 'Annuler',
    'form.clone': 'Dupliquer',
    'form.create': 'Créer',
    'form.delete': 'Supprimer',
    'form.edit': 'Éditer',
    'form.format': 'Mise en forme',
    'form.import': 'Importer',
    'form.save': 'Valider',
    'form.validate': 'Valider',
    'format.form.date.error':
      'Vous devez sélectionner une date de création pour votre liste',
    'format.form.date.placeholder': '01/01/2022',
    'format.form.date.title': 'Date de création *',
    'format.form.formated.title': "Votre liste d'armée mise en forme",
    'format.form.game.error':
      'Vous devez sélectionner le nom du jeu auquel vous voulez jouer',
    'format.form.game.placeholder': 'T9A, EoW, WHB,....',
    'format.form.game.title': 'Ton jeu *',
    'format.form.source.error': 'Vous devez ajouter votre liste',
    'format.form.source.placeholder': "Entrer une liste d'armée",
    'format.form.source.title': "Votre liste d'armée *",
    'format.new.title': "Mettre en forme une liste d'armée",
    help: 'aide',
    'home.app.available.google': 'Obtenez la sur Google Play',
    'home.app.available.on_platform':
      'En cours de développement, disponible sur:',
    'home.app.mobile': 'Appli mobile',
    'home.locale.available': '9ThBuilder est disponible en plusieurs langues.',
    'home.locale.default':
      "Par défaut, si le contenu n'est pas disponible dans la langue que vous avez choisi, le conenu en anglais sera automatiquement affiché.",
    'home.no_account':
      'Vous pouvez maintenant utiliser toutes les fonctionnalités de 9ThBuilder sans avoir à créer un compte au préalable.\nAttention toutefois, vos listes sont liées à votre session locale et ne seront donc pas disponibles sur un autre navigateur et risquent d\'être perdues si vous supprimez votre cache ou votre session."\n',
    'home.welcome': '9TH BUILDER',
    'home.whoarewe.cardmagic': 'Cartes de magie',
    'home.whoarewe.compose': 'Composez et archivez vos armees favorites !',
    'home.whoarewe.description':
      "Un passionné de Battle depuis de nombreuses années. J'ai repris le 9Th Builder depuis plusieurs années, créé une application mobile et aide à l'administration du 9Th Age.\nAidé par Kaos War qui a grandement contribué à la saisie dans les listes d'armée et pour la nouvelle page d'accueil.\n9Th Builder est un outil efficace et facile à utiliser pour créer vos listes d'armées et les partager. Il ne génère aucun revenu :)\n",
    'home.whoarewe.discord': 'Discord',
    'home.whoarewe.draft': 'Faire un pairing par équipe',
    'home.whoarewe.format': 'Formatez ou importez votre armée',
    'home.whoarewe.list': 'Créer une nouvelle liste',
    'home.whoarewe.newsfb': 'Actualité Facebook',
    'home.whoarewe.paint': 'Créer une liste de peinture',
    'home.whoarewe.readarmy': "Lire les Livres d'Armée",
    'home.whoarewe.readmagic': 'Lire le Recueil Arcanique',
    'home.whoarewe.title': 'Qui sommes-nous ?',
    'home.whoarewe.try': 'Voulez-vous essayer?',
    'home.whoarewe.whatdo': 'Que pouvez-vous faire?',
    'home.whoarewe.clubs': 'Trouver un club',
    'home.whoarewe.donate': 'Faire un don',
    'lexicon.index.show': "Livres d'armée \u0026 outils",
    'lexicon.magic_paths.cards.index':
      'Vous pouvez trouvers les domaines de magie pour tous ces jeux.',
    'magic.casting': 'lancement',
    'magic.duration': 'Durée',
    'magic.effect': 'Effet',
    'magic.index.show': 'Voir',
    'magic.index.title': 'Magies',
    'magic.range': 'Portée',
    'magic.show.back': 'Retour',
    'magic.type': 'Type',
    'magic_item_categories.index.show': 'Voir',
    'magic_item_categories.index.title': "Catégories d'objects magiques",
    'magic_items.Cbtbmw': 'Figurines sans la règle',
    'magic_items.Enchantment': 'Enchantement',
    'magic_items.dominant': 'Dominant',
    'magic_items.footonly': 'Figurine à pied uniquement',
    'magic_items.index.show': 'Voir',
    'magic_items.index.title': 'Objets magiques',
    'magic_items.only': 'uniquement.',
    'magic_items.perArmy': 'par Armée',
    'magic_items.type_figurine.All': 'tous',
    'magic_items.type_figurine.AnimisteBestial': 'Bête',
    'magic_items.type_figurine.Character': 'Personnage',
    'magic_items.type_figurine.FeralOrc': 'Orques feral',
    'magic_items.type_figurine.Goblins': 'Gobelins',
    'magic_items.type_figurine.Infantry': 'Infanterie',
    'magic_items.type_figurine.KnightCommanders': 'Commandants chevaliers',
    'magic_items.type_figurine.MageOnFoot': 'Magicien à pied',
    'magic_items.type_figurine.MarshalsMountedOnHorse':
      'Maréchaux montés à cheval',
    'magic_items.type_figurine.ModelsOnChariots': 'Assemblage',
    'magic_items.type_figurine.ModelsOnFoot': 'Figurine à pied',
    'magic_items.type_figurine.MonarchsOfTheDead': 'Monarque de la Mort',
    'magic_items.type_figurine.Monster': 'Monstre',
    'magic_items.type_figurine.MountedCharacter': 'Cavalerie',
    'magic_items.type_figurine.NoLargeTarget': 'pas une grande cible',
    'magic_items.type_figurine.ParentUnit': 'Unité Parent',
    'magic_items.type_figurine.Wizard': 'Magiciens',
    'magic_spell.type_lvl.A': 'A',
    'magic_spell.type_lvl.Five': '5',
    'magic_spell.type_lvl.Four': '4',
    'magic_spell.type_lvl.One': '1',
    'magic_spell.type_lvl.Six': '6',
    'magic_spell.type_lvl.Three': '3',
    'magic_spell.type_lvl.Two': '2',
    'magic_spell.type_lvl.Zero': '0',
    'magic_standards.index.show': 'Voir',
    'magic_standards.index.title': 'Etendard magiques',
    'menu.army_lists': "Mes listes d'armées",
    'menu.help': 'Aide',
    'menu.label': 'Menu principal',
    'menu.languages.de': 'Allemagne',
    'menu.languages.en': 'Anglais',
    'menu.languages.es': 'Espagnol - Español',
    'menu.languages.fr': 'français',
    'menu.languages.hu': 'hongrois',
    'menu.languages.it': 'Italien - Italiano',
    'menu.languages.ko': 'coréen',
    'menu.languages.lang': 'Langue',
    'menu.languages.pl': 'polonais',
    'menu.languages.ru': 'russe',
    'menu.languages.sr': 'serbe',
    'menu.languages.zh': 'Chinois',
    'menu.preferences': 'Préférences',
    'menu.signin': 'Se connecter',
    'menu.signout': 'Déconnexion',
    'menu.signup': "S'inscrire",
    'menu.profil': 'Mon Profil',
    'menu.arsenal': 'Mes Figurines',
    next: 'Suivant',
    'ninth_age.magic_path.magic_cards': 'Cartes de magie',
    'ninth_age.army.translation_reference_sheet.title':
      'Correspondance des traductions avec la VO',
    'ninth_age.army.quik_reference_sheet': "Feuille de résumé de l'armée",
    'ninth_age.army.magic_cards': "Cartes de magie de l'armée",
    'ninth_age.figurine.mount': 'Monture',
    'ninth_age.figurine.pts': 'pts',
    'ninth_age.magic_item.only_wizard.AllWizard': 'magiciens seulement',
    'ninth_age.magic_item.only_wizard.NoWizard':
      'Ne peut pas être pris par les magiciens',
    'ninth_age.magic_item.only_wizard.WizardAdept':
      'Adepte magiciens seulement',
    'ninth_age.magic_item.only_wizard.WizardApprentice':
      'Apprenti magiciens seulement',
    'ninth_age.magic_item.only_wizard.WizardMaster':
      'Maître magiciens seulement',
    'ninth_age.troop.offensive': 'Offensif',
    'ninth_age.unit.defensive': 'Défensif',
    'ninth_age.unit.fly': 'Vol',
    'ninth_age.unit.global': 'Global',
    'ninth_age.unit.rules': 'Règle de Figurine',
    'paint_list.delete.information': 'Êtes-vous sûr de détruire cette liste:',
    'paint_list.delete.submit': '!!! Supprimmer !!!',
    'paint_list.delete.title': 'Supprimer la liste',
    'paint_list.edit.title': 'Modifier votre liste de peinture',
    'paint_list.form.army.error': 'Tu dois choisir une armée.',
    'paint_list.form.army.placeholder': 'Choisir une armée',
    'paint_list.form.army.title': 'Armée *',
    'paint_list.form.name.error': 'Tu dois Nommer ta liste',
    'paint_list.form.name.placeholder': 'Entré un nom',
    'paint_list.form.name.title': 'Nom *',
    'paint_list.form.version.error': 'tu doit choisir une version.',
    'paint_list.form.version.placeholder': 'Choisir une version',
    'paint_list.form.version.title': 'Version *',
    'paint_list.index.add': 'Créer une liste de peinture',
    'paint_list.index.title': 'Ma liste de peinture',
    'paint_list.new.title': 'Créer une liste de peinture',
    'paint_list.show.assembled': 'Assemblée',
    'paint_list.show.buy': 'Acheter',
    'paint_list.show.comment': 'Commentaire',
    'paint_list.show.first_color': 'Première couleur',
    'paint_list.show.paint': 'Peinture',
    'paint_list.show.plinth': 'Socle',
    'paint_list.show.size': 'Taille',
    'paint_list.show.state.done': 'Fait',
    'paint_list.show.state.waiting': 'Attente',
    'paint_list.show.state.wip': 'Effacer',
    'paint_list.show.title': 'Votre liste de peinture:',
    'paint_list.show.trimmed': 'Ebarbé',
    'paint_list.show.unit': 'Unité',
    'paint_list.unit.form.comment.placeholder': 'Ajouter un commentaire',
    'paint_list.unit.form.comment.title': 'Commentaire',
    'paint_list.unit.form.size.error':
      'Tu dois ajouter une quantité de figurine',
    'paint_list.unit.form.size.placeholder': 'choisir une taille',
    'paint_list.unit.form.size.title': 'taille *',
    'paint_list.unit.form.title': 'Ajouter une unité',
    'paint_list.unit.form.unit.error': 'Tu dois choisir une unité',
    'paint_list.unit.form.unit.placeholder': 'choisir une unité',
    'paint_list.unit.form.unit.title': 'Unité *',
    'password_change.form.confirmation': 'Confirmation du mot de passe',
    'password_change.form.password': 'Mot de passe',
    'password_change.form.submit': 'Valider',
    'password_change.information':
      'Pour toutes questions n\'hésitez pas à consulter l\'\u003ca href="mailto:support@9thbuilder.com"\u003eaide en ligne\u003c/a\u003e',
    'password_change.lost.confirmation':
      "Je n'ai pas reçu d'email de confirmation",
    'password_change.lost.password': "J'ai perdu mon mot de passe !",
    'password_change.title': 'Changer votre mot de passe',
    'password_lost.form.email': 'Email',
    'password_lost.form.submit': 'Valider',
    'password_lost.information':
      'Pour toutes questions n\'hésitez pas à consulter l\'\u003ca href="mailto:support@9thbuilder.com"\u003eaide en ligne\u003c/a\u003e',
    'password_lost.lost.confirmation':
      "Je n'ai pas reçu d'email de confirmation",
    'password_lost.title': "J'ai perdu mon mot de passe",
    'picker.datetime.js': 'DD.MM.YYYY HH:mm',
    'picker.datetime.rb': '%d.%m.%Y %H:%M',
    'profile.back': 'Page précédente',
    'profile.delete.information':
      'Vous n\'êtes pas satisfait ? \u003ca href="mailto:support@9thbuilder.com"\u003eÉcrivez nous\u003c/a\u003e ou',
    'profile.delete.link': 'supprimer votre compte directement',
    'profile.delete.title': 'Supprimer mon compte',
    'profile.form.confirmation': 'Confirmation du mot de passe',
    'profile.form.email': 'Adresse email',
    'profile.form.game': 'favorit',
    'profile.form.name': 'Nom ou pseudo',
    'profile.form.password': 'Mot de passe',
    'profile.form.password_help':
      'Laissez vide si vous ne désirez pas changer de mot de passe',
    'profile.form.submit': 'Valider',
    'profile.form.builder_interface':
      "Quelle interface pour éditer votre liste d'armée préférez-vous ?",
    'profile.form.use_latest_version':
      'Utiliser seulement la dernière version de chaque armée',
    'profile.form.default_locale': 'Votre langue préférée',
    'profile.title': 'Mon compte',
    save: 'Valider',
    'search_list.assembled': 'Monté',
    'search_list.buy': 'Acheté',
    'search_list.comment': 'Commentaire',
    'search_list.first_color': 'Sous-chouché',
    'search_list.index.search': 'Valider',
    'search_list.index.search_list': "Rechercher une liste d'armée",
    'search_list.paint': 'Peint',
    'search_list.plinth': 'Soclé',
    'search_list.size': 'Taille',
    'search_list.trimmed': 'Ebarbé',
    'search_list.unit': 'Unité',
    'signin.Confirmation': 'Confirmation',
    'signin.form.email': 'Email',
    'signin.form.lost': 'mot de passe oublié ?',
    'signin.form.password': 'Mot de passe',
    'signin.form.remember': 'Se souvenir de moi',
    'signin.form.submit': 'Se connecter',
    'signin.information':
      'Pour toutes questions n\'hésitez pas à consulter l\'\u003ca href="mailto:support@9thbuilder.com"\u003eaide en ligne\u003c/a\u003e',
    'signin.lost.confirmation': "Je n'ai pas reçu d'email de confirmation",
    'signin.lost.password': "J'ai perdu mon mot de passe !",
    'signin.title': 'Se connecter',
    'signup.form.confirmation': 'Confirmation du mot de passe',
    'signup.form.email': 'Adresse email',
    'signup.form.game': '--favorit--',
    'signup.form.name': 'Nom ou pseudo',
    'signup.form.password': 'Mot de passe',
    'signup.form.register': 'Rejoignez-nous !',
    'signup.form.submit': "S'inscrire",
    'signup.information':
      'Pour toutes questions n\'hésitez pas à consulter l\'\u003ca href="mailto:support@9thbuilder.com"\u003eaide en ligne\u003c/a\u003e',
    'signup.lost.confirmation': "Je n'ai pas reçu d'email de confirmation",
    'signup.lost.password': "J'ai perdu mon mot de passe !",
    'signup.title': "S'inscrire",
    'site.accept': 'J’accepte',
    'site.more': 'En savoir plus',
    'site.use_cookie':
      'Ce site utilise des cookies pour vous offrir le meilleur service. En poursuivant votre navigation, vous acceptez l’utilisation des cookies.',
    'tool.game_help': 'Les Aides de jeu',
    'tool.pairing.done': 'Votre appariement est terminé',
    'tool.pairing.draft.index.title': 'Mes Pairings',
    'tool.pairing.draft.send_link': 'Envoyer ce lien à votre adversaire :',
    'tool.pairing.draft.waiting_opponent': 'Nous attendons votre adversaire',
    'tool.pairing.draw.confirm.draw': "Confirmer l'armée",
    'tool.pairing.draw.confirm.response': 'Confirmer votre réponse',
    'tool.pairing.draw.confirm.select': 'Confirmer votre sélection',
    'tool.pairing.draw.or': 'ou',
    'tool.pairing.draw.vs': 'Contre',
    'tool.pairing.draw_round.select.draw':
      "Sélectionner l'une de vos armées pour le tirage",
    'tool.pairing.draw_round.select.response':
      "Sélectionner vos armées pour combatre l'armée de votre adversaire",
    'tool.pairing.draw_round.select.select': "Sélectionner l'armée à affronter",
    'tool.pairing.draw_round.select.waiting': 'En attente',
    'tool.pairing.image': "Copiez l'image de l'URL d'appariement",
    'tool.pairing.inprogress': 'Votre appariement est en cours',
    'tool.pairing.matches.tables': 'Tables :',
    'tool.pairing.my_team.my_armies': 'Vos armées',
    'tool.pairing.opponent_team.team': 'Equipe',
    'tool.pairing.select_armies.choise_armies': 'Choisissez vos armées',
    'tool.pairing.select_armies.confirm': 'Confirmer',
    'tool.pairing.select_armies.error':
      'Désolé ! Il y a eu une erreur lors du chargement.',
    'tool.pairing.select_armies.your_team': 'Votre équipe',
    'tool.pairing.select_team_size.how_many':
      'Combien de joueurs dans votre équipe ?',
    'tool.pairing.table': 'Table',
    'tool.pairing.team_name.confirm': 'Confirmer',
    'tool.pairing.team_name.what_name': 'Quel est le nom de votre équipe ?',
    'tool.pairing.team_name.your_name': "Votre nom d'équipe",
    'tool.search_rules.index.search': 'Recherche',
    'tool.search_rules.index.search_army_select_error':
      'Vous devez sélectionner une armée',
    'tool.search_rules.index.search_rule': 'Choisir une règle',
    'tool.search_rules.index.select_army': "Choisissez l'armée",
    'tool.search_rules.index.select_version':
      'Choisissez la version de 9Th Age',
    'tool.search_rules.index.title': 'Recherche par règles',
    'tournament.contest.back': 'Retour à la listes des tournois',
    'tournament.contest.edit': 'Modifier',
    'tournament.contest.form.address': 'Addresse',
    'tournament.contest.form.end_date': 'Fin',
    'tournament.contest.form.fees': 'Participation',
    'tournament.contest.form.name': 'Nom',
    'tournament.contest.form.round_count': 'Rondes',
    'tournament.contest.form.start_date': 'Départ',
    'tournament.contest.form.submit': 'Valider',
    'tournament.contest.form.team_max': 'Max Equipes',
    'tournament.contest.form.user_max': 'Max Joueurs',
    'tournament.contest.form.user_team_max': 'Max Joueurs par équipes',
    'tournament.contest.form.version': 'Version',
    'tournament.contest.index.title': 'Mon tournoi',
    'tournament.contest.name': 'Tournois',
    'tournament.contest.new.title': 'Créer un Tournois',
    'tournament.contest.print_armies': 'Imprimer toutes les armées',
    'tournament.contest.print_repport': 'Rapport',
    'tournament.contest.total': 'Total',
    'tournament.custom_point.name': 'PWL',
    'tournament.round.add': 'Ajouter une Rondes',
    'tournament.round.name': 'Ronde',
    'tournament.round.pools.validate': 'Créer une pools',
    'tournament.team.add': 'Ajouter équipes',
    'tournament.team.back': "Retour à l'équipes",
    'tournament.team.edit.title': 'Modifier équipes',
    'tournament.team.export.title': 'Equipes',
    'tournament.team.first': 'Ajoutez votre première équipe',
    'tournament.team.form.email': 'Email',
    'tournament.team.form.name': 'Nom',
    'tournament.team.form.submit': 'Valider',
    'tournament.team.index.title': 'mon Équipes de tournoi',
    'tournament.team.name': 'Equipes',
    'tournament.team.new.title': 'Ajouter équipes',
    'tournament.teams.add': 'Ajouter équipes',
    'tournament.teams.back': 'Retour au tournois',
    'tournament.teams.title': 'Equipes',
    'tournament.user_apply.add': 'Ajouter Participant',
    'tournament.user_apply.add_into_team':
      'Ajouter partipant dans cette équipe',
    'tournament.user_apply.army_list.add_now': 'Ajoutez maintenant!',
    'tournament.user_apply.army_list.create': 'Créer une nouvelle liste',
    'tournament.user_apply.army_list.need':
      "Vous n'avez pas encore ajouté votre liste d'armée.",
    'tournament.user_apply.army_list.or': 'ou',
    'tournament.user_apply.army_list.use_existing':
      'Utiliser une liste existante',
    'tournament.user_apply.army_list.which': "Quelle liste d'armée?",
    'tournament.user_apply.army_list_select.form.submit': 'Valider',
    'tournament.user_apply.edit.title': 'Modifiez votre participation',
    'tournament.user_apply.first': 'Ajoutez votre premier Participant',
    'tournament.user_apply.form.name': 'Nom',
    'tournament.user_apply.form.name_detail':
      'Vous pouvez ajouter des Joueurs (1 Joueurs par ligne) avec un email séparé par une virgule (nom, email).',
    'tournament.user_apply.form.or': 'ou',
    'tournament.user_apply.form.submit': 'Ajouter',
    'tournament.user_apply.form.user': 'Joueurs',
    'tournament.user_apply.manage': "Gérer l'équipe",
    'tournament.user_apply.name': 'Joueurs',
    'tournament.user_apply.new.title': 'Ajouter Joueurs',
    'tournament.user_apply.remove': 'Supprimer Participant',
    'tournament.user_apply.share_link': "Partager le lien d'invitation",
    'tournament.user_apply.team_leader': "Le capitaine de l'équipe",
    'unit.base.label': 'Socle',
    'unit.height.Gigantic': 'Gigantesque',
    'unit.height.Large': 'Grande',
    'unit.height.Standard': 'Standard',
    'unit.limit.model': 'figurines par armée',
    'unit.limit.perArmy': 'par Armée',
    'unit.limit.single': 'Figurine seule',
    'unit.limit.unit': 'unités par armée',
    'unit.mount': 'monture',
    'unit.show.add_model':
      ' + \u003cstrong\u003e{pts}\u003c/strong\u003e pts/figurine',
    'unit.show.change.no_max': 'Les unités {change}',
    'unit.show.change.max': 'Au maximum {max} unités {change}',
    'unit.show.change.limit': ' sans {limit}',
    'unit.show.change.to_min':
      'de {number} figurines ou plus{limit} compte comme {new_name} à la place de {old_name}.',
    'unit.show.change.to_max':
      'de {number} figurines ou moins{limit} compte comme {new_name} à la place de {old_name}.',
    'unit.show.size':
      '\u003cstrong\u003e{min_size}-{max_size}\u003c/strong\u003e models',
    'unit.size.Gigantic': 'Gigantesque',
    'unit.size.Large': 'Grande',
    'unit.size.Standard': 'Standard',
    'unit.size.label': 'Taille',
    'unit.type.label': 'Type',
    'unit_option.per_model': '/fig.',
    'unit_option.use_points.free': 'gratuit',
    'unit_option.use_points.no_limit': 'sans limite',
    'unit_option.use_points.up_to': "Jusqu'à",
    'user.profile.favorit_game': 'Votre jeu favori est',
    'user.profile.prefert_user': "Vous préférez utiliser l'interface",
    'user.profile.favorit_builder_interface': 'pour éditer votre armée',
    'user.profile.use_latest_army':
      'Vous utiliser la dernière version de chaque armée :',
    'user.profile.default_locale': 'Votre lanque par défaut:',
    'user.profile.edit': 'Éditer votre profil',
    'user.password.edit': 'Change your password',
    'unit_options.category.C': 'C',
    'unit_options.category.M': 'M',
    'unit_options.category.S': 'E',
    'unit_options.footonly': 'à pied seulement',
    'version.index.pairing': "Association d'équipe",
    'version.index.search': 'Recherche par règle',
    'version.index.show': 'Voir',
    'version.index.title': 'Versions',
    'version.index.tools': 'Outils',
    'version.show.back': 'Retour',
    welcome: 'Bienvenue',
    with: 'avec %',
    without: 'sans %',
    'simulator.unit.mount': '{name} sur {mount}',
    'simulator.unit.equipment': '{name} avec {equipment}',
  },
  it: {
    'activerecord.attributes.user.confirmation_sent_at': null,
    'activerecord.attributes.user.confirmation_token': null,
    'activerecord.attributes.user.confirmed_at': null,
    'activerecord.attributes.user.created_at': null,
    'activerecord.attributes.user.current_password': 'Password corrente',
    'activerecord.attributes.user.current_sign_in_at': null,
    'activerecord.attributes.user.current_sign_in_ip': null,
    'activerecord.attributes.user.email': 'Email',
    'activerecord.attributes.user.encrypted_password': null,
    'activerecord.attributes.user.failed_attempts': null,
    'activerecord.attributes.user.last_sign_in_at': null,
    'activerecord.attributes.user.last_sign_in_ip': null,
    'activerecord.attributes.user.locked_at': null,
    'activerecord.attributes.user.password': 'Password',
    'activerecord.attributes.user.password_confirmation': 'Conferma password',
    'activerecord.attributes.user.remember_created_at': null,
    'activerecord.attributes.user.remember_me': 'Ricordami',
    'activerecord.attributes.user.reset_password_sent_at': null,
    'activerecord.attributes.user.reset_password_token':
      'Token di reset password',
    'activerecord.attributes.user.sign_in_count': null,
    'activerecord.attributes.user.unconfirmed_email': null,
    'activerecord.attributes.user.unlock_token': 'Token di sblocco',
    'activerecord.attributes.user.updated_at': null,
    'activerecord.models.user': 'Utente',
    'devise.sessions.signed_in': '',
    'devise.sessions.signed_out': '',
    'users.confirmations.confirmed':
      'Il tuo account è stato correttamente confermato.',
    'users.confirmations.new.resend_confirmation_instructions':
      'Invia di nuovo le istruzioni per la conferma',
    'users.confirmations.send_instructions':
      'Riceverai un messaggio email con le istruzioni per confermare il tuo account entro qualche minuto.',
    'users.confirmations.send_paranoid_instructions':
      'Se la tua e-mail esiste nel nostro database, riceverai un messaggio email con le istruzioni per confermare il tuo account entro qualche minuto.',
    'users.failure.already_authenticated': "Hai già effettuato l'accesso.",
    'users.failure.inactive': 'Il tuo account non è stato ancora attivato.',
    'users.failure.invalid': 'Indirizzo email o password non validi.',
    'users.failure.last_attempt':
      "Hai ancora un tentativo prima che l'account venga bloccato.",
    'users.failure.locked': 'Il tuo account è bloccato.',
    'users.failure.not_found_in_database': 'Email o password non validi.',
    'users.failure.timeout':
      'Sessione scaduta, accedere nuovamente per continuare.',
    'users.failure.unauthenticated':
      'Devi accedere o registrarti per continuare.',
    'users.failure.unconfirmed':
      'Devi confermare il tuo account per continuare.',
    'users.mailer.confirmation_instructions.action': 'Conferma il mio account',
    'users.mailer.confirmation_instructions.greeting': 'Benvenuto {recipient}!',
    'users.mailer.confirmation_instructions.instruction':
      'Puoi confermare il tuo account cliccando sul link qui sotto:',
    'users.mailer.confirmation_instructions.subject':
      'Istruzioni per la conferma',
    'users.mailer.password_change.greeting': 'Ciao {recipient}!',
    'users.mailer.password_change.message':
      'Ti stiamo contattando per notificarti che la tua password è stata modificata.',
    'users.mailer.password_change.subject': 'Password modificata',
    'users.mailer.reset_password_instructions.action': 'Cambia la mia password',
    'users.mailer.reset_password_instructions.greeting': 'Ciao {recipient}!',
    'users.mailer.reset_password_instructions.instruction':
      'Qualcuno ha richiesto di resettare la tua password, se lo vuoi davvero puoi farlo cliccando sul link qui sotto.',
    'users.mailer.reset_password_instructions.instruction_2':
      'Se non sei stato tu ad effettuare questa richiesta puoi ignorare questa mail.',
    'users.mailer.reset_password_instructions.instruction_3':
      'La tua password non cambierà finchè non accederai al link sopra.',
    'users.mailer.reset_password_instructions.subject':
      'Istruzioni per reimpostare la password',
    'users.mailer.unlock_instructions.action': 'Sblocca il mio account',
    'users.mailer.unlock_instructions.greeting': 'Ciao {recipient}!',
    'users.mailer.unlock_instructions.instruction':
      'Clicca sul link qui sotto per sbloccare il tuo account:',
    'users.mailer.unlock_instructions.message':
      'Il tuo account è stato bloccato a seguito di un numero eccessivo di tentativi di accesso falliti.',
    'users.mailer.unlock_instructions.subject':
      "Istruzioni per sbloccare l'account",
    'users.omniauth_callbacks.failure':
      'Non è stato possibile autorizzarti da {kind} perchè "{reason}".',
    'users.omniauth_callbacks.success':
      "Autorizzato con successo dall'account {kind}.",
    'users.passwords.edit.change_my_password': 'Cambia la mia password',
    'users.passwords.edit.change_your_password': 'Cambia la tua password',
    'users.passwords.edit.confirm_new_password': 'Conferma la nuova password',
    'users.passwords.edit.new_password': 'Nuova password',
    'users.passwords.new.forgot_your_password': 'Password dimenticata?',
    'users.passwords.new.send_me_reset_password_instructions':
      'Inviami le istruzioni per resettare la password',
    'users.passwords.no_token':
      "Puoi accedere a questa pagina solamente dalla email di reset della password. Se vieni dalla email controlla di aver inserito l'url completo riportato nella email.",
    'users.passwords.send_instructions':
      'Riceverai un messaggio email con le istruzioni per reimpostare la tua password entro qualche minuto.',
    'users.passwords.send_paranoid_instructions':
      'Se la tua e-mail esiste nel nostro database, riceverai un messaggio email contentente un link per il ripristino della password',
    'users.passwords.updated':
      'La tua password è stata cambiata. Ora sei collegato.',
    'users.passwords.updated_not_active': 'La tua password è stata cambiata.',
    'users.registrations.destroyed':
      "Arrivederci! L'account è stato cancellato. Speriamo di rivederci presto.",
    'users.registrations.edit.are_you_sure': 'Sei sicuro?',
    'users.registrations.edit.cancel_my_account': 'Rimuovi il mio account',
    'users.registrations.edit.currently_waiting_confirmation_for_email':
      'In attesa di conferma per: {email}',
    'users.registrations.edit.leave_blank_if_you_don_t_want_to_change_it':
      'lascia in bianco se non vuoi cambiarla',
    'users.registrations.edit.title': 'Modifica {resource}',
    'users.registrations.edit.unhappy': 'Scontento',
    'users.registrations.edit.update': 'Aggiorna',
    'users.registrations.edit.we_need_your_current_password_to_confirm_your_changes':
      'abbiamo bisogno della tua password attuale per confermare i cambiamenti',
    'users.registrations.new.sign_up': 'Registrati',
    'users.registrations.signed_up':
      'Iscrizione eseguita correttamente. Se abilitata, una conferma è stata inviata al tuo indirizzo email.',
    'users.registrations.signed_up_but_inactive':
      'Iscrizione eseguita correttamente. Però non puoi accedere in quanto il tuo account non è ancora attivo.',
    'users.registrations.signed_up_but_locked':
      'Iscrizione eseguita correttamente. Però non puoi accedere in quanto il tuo account è bloccato.',
    'users.registrations.signed_up_but_unconfirmed':
      'Ti è stato inviato un messaggio con un link di conferma. Ti invitiamo a visitare il link per attivare il tuo account.',
    'users.registrations.update_needs_confirmation':
      'Il tuo account è stato aggiornato, ma dobbiamo verificare la tua email. Ti invitiamo a consultare la tua email e cliccare sul link di conferma.',
    'users.registrations.updated': 'Il tuo account è stato aggiornato.',
    'users.sessions.already_signed_out': 'Sei uscito correttamente.',
    'users.sessions.new.sign_in': 'Accedi',
    'users.sessions.signed_in': 'Accesso effettuato con successo.',
    'users.sessions.signed_out': 'Sei uscito correttamente.',
    'users.shared.links.back': 'Indietro',
    'users.shared.links.didn_t_receive_confirmation_instructions':
      'Non hai ricevuto le istruzioni per la conferma?',
    'users.shared.links.didn_t_receive_unlock_instructions':
      'Non hai ricevuto le istruzioni per lo sblocco?',
    'users.shared.links.forgot_your_password': 'Password dimenticata?',
    'users.shared.links.sign_in': 'Accedi',
    'users.shared.links.sign_in_with_provider': 'Accedi con {provider}',
    'users.shared.links.sign_up': 'Registrati',
    'users.unlocks.new.resend_unlock_instructions':
      'Invia di nuovo le istruzioni per lo sblocco',
    'users.unlocks.send_instructions':
      'Riceverai un messaggio email con le istruzioni per sbloccare il tuo account entro qualche minuto.',
    'users.unlocks.send_paranoid_instructions':
      'Se la tua e-mail esiste nel nostro database, riceverai un messaggio email con le istruzioni per sbloccare il tuo account entro qualche minuto.',
    'users.unlocks.unlocked':
      'Il tuo account è stato correttamente sbloccato. Ora sei collegato.',
    'errors.messages.already_confirmed': 'è stato già confermato',
    'errors.messages.confirmation_period_expired':
      'deve essere confermato entro {period}, richiedi una nuova conferma',
    'errors.messages.expired': 'è scaduto, si prega di richiederne uno nuovo',
    'errors.messages.not_found': 'non trovato',
    'errors.messages.not_locked': 'non era bloccato',
    'errors.messages.not_saved.one':
      'Non posso salvare questo {resource}: 1 errore',
    'errors.messages.not_saved.other':
      'Non posso salvare questo {resource}: {count} errori.',
    Common: 'Common',
    'active_admin.menu.admin': 'Administration',
    'active_admin.menu.armies': 'Armies',
    'active_admin.menu.builder': 'Builder',
    'active_admin.menu.dashboard': 'Administration',
    'active_admin.menu.import': 'Import',
    'active_admin.menu.log': 'Log',
    'active_admin.menu.magic': 'magic',
    'active_admin.menu.map': 'Maps',
    'active_admin.menu.ninth_age': 'Ninth Age',
    'active_admin.menu.organisation': 'Organisation',
    'active_admin.menu.paint': 'Paint',
    'active_admin.menu.statistique': 'Statistiques',
    'active_admin.menu.tournament': 'Tournament',
    'active_admin.menu.unit': 'Unit',
    'active_admin.menu.user_annoncement': 'Annoncements',
    'active_admin.menu.users': 'Users',
    'active_admin.menu.versioning': 'Versioning',
    'active_admin.translate.ko': 'Coreano',
    'active_admin.translate.pl': 'Polacco',
    'active_admin.translate.ru': 'Russian',
    'active_admin.translate.zh': 'Chinese',
    'activerecord.attributes.data_analytics/report.deployments.CounterThrust':
      'Counter Thrust',
    'activerecord.attributes.data_analytics/report.deployments.DawnAssult':
      'Dawn Assult',
    'activerecord.attributes.data_analytics/report.deployments.Encircle':
      'Encircle',
    'activerecord.attributes.data_analytics/report.deployments.FrontlineClash':
      'Frontline Clash',
    'activerecord.attributes.data_analytics/report.deployments.MarchingColumns':
      'Marching Columns',
    'activerecord.attributes.data_analytics/report.deployments.RefusedFlank':
      'Refused Flank',
    'activerecord.attributes.data_analytics/report.maps.A1':
      'A1 - Shrouded Pool',
    'activerecord.attributes.data_analytics/report.maps.A2':
      'A2 - Foothill Outpost',
    'activerecord.attributes.data_analytics/report.maps.A3':
      'A3 - Dilapidated Manor',
    'activerecord.attributes.data_analytics/report.maps.A4':
      'A4 - Volcanic Lake',
    'activerecord.attributes.data_analytics/report.maps.A5':
      'A5 - Misty Marshes',
    'activerecord.attributes.data_analytics/report.maps.A6':
      'A6 - Ancient Walls',
    'activerecord.attributes.data_analytics/report.maps.A7': 'A7 - Beacon Hill',
    'activerecord.attributes.data_analytics/report.maps.A8':
      'A8 - Witch’s Cottage',
    'activerecord.attributes.data_analytics/report.maps.B1':
      'B1 - Mage’s Sanctum',
    'activerecord.attributes.data_analytics/report.maps.B2':
      'B2 - Villa Grounds',
    'activerecord.attributes.data_analytics/report.maps.B3':
      'B3 - Ancient Fortress',
    'activerecord.attributes.data_analytics/report.maps.B4':
      'B4 - Frontier Farm',
    'activerecord.attributes.data_analytics/report.maps.B5':
      'B5 - Ravaged Watchtower',
    'activerecord.attributes.data_analytics/report.maps.B6':
      'B6 - Creeping Forest',
    'activerecord.attributes.data_analytics/report.maps.B7':
      'B7 - Eerie Graveyard',
    'activerecord.attributes.data_analytics/report.maps.B8':
      'B8 - Shattered Bridge',
    'activerecord.attributes.data_analytics/report.objectives.Breakthrough':
      'Breakthrough',
    'activerecord.attributes.data_analytics/report.objectives.CaptureFlags':
      'Capture the Flags',
    'activerecord.attributes.data_analytics/report.objectives.HoldGround':
      'Hold the Ground',
    'activerecord.attributes.data_analytics/report.objectives.KingHill':
      'King of the Hill',
    'activerecord.attributes.data_analytics/report.objectives.SecureTarget':
      'Secure Target',
    'activerecord.attributes.data_analytics/report.objectives.SpoilsWar':
      'Spoils of War',
    'activerecord.attributes.data_analytics/report.opponent_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.opponent_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.opponent_objective':
      'Take the objective',
    'activerecord.attributes.data_analytics/report.your_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.your_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.your_objective':
      'Take the objective',
    'activerecord.attributes.ninth_age/magic_item.only_foot':
      'Prohibited mount',
    'activerecord.attributes.ninth_age/magic_item.only_wizard':
      'Only wizard can use it',
    'activerecord.attributes.ninth_age/magic_item.organisation_ids':
      'Organisations required from the model',
    'activerecord.attributes.ninth_age/magic_item.model_rule_ids':
      'Prohibited  model rules on model',
    'activerecord.attributes.ninth_age/magic_item.unit_ids':
      'For this units only',
    'activerecord.attributes.ninth_age/magic_item.unit_size':
      'Unit with this size can not use this item',
    'activerecord.attributes.ninth_age/magic_standard.organisation':
      "Aggiungi organizzazione all'unità",
    'activerecord.attributes.ninth_age/magic_standard.organisation_ids':
      "Unità dell'organizzazione vietata",
    'activerecord.attributes.ninth_age/troop.carac_agi': 'Agi',
    'activerecord.attributes.ninth_age/troop.carac_ap': 'Pen',
    'activerecord.attributes.ninth_age/troop.carac_att': 'Att',
    'activerecord.attributes.ninth_age/troop.carac_of': 'Off',
    'activerecord.attributes.ninth_age/troop.carac_str': 'For',
    'activerecord.attributes.ninth_age/unit.carac_aeg': 'Aeg',
    'activerecord.attributes.ninth_age/unit.carac_arm': 'Arm',
    'activerecord.attributes.ninth_age/unit.carac_def': 'Dif',
    'activerecord.attributes.ninth_age/unit.carac_dis': 'Dis',
    'activerecord.attributes.ninth_age/unit.carac_evoked': 'Rsr',
    'activerecord.attributes.ninth_age/unit.carac_fly_adv': 'Fly ada',
    'activerecord.attributes.ninth_age/unit.carac_fly_mar': 'Fly mar',
    'activerecord.attributes.ninth_age/unit.carac_ground_adv': 'Ava',
    'activerecord.attributes.ninth_age/unit.carac_ground_mar': 'Mar',
    'activerecord.attributes.ninth_age/unit.carac_hp': 'Vit',
    'activerecord.attributes.ninth_age/unit.carac_res': 'Res',
    'activerecord.attributes.ninth_age_army.source.FanMade': 'Fan Made',
    'activerecord.attributes.ninth_age_army.source.Official': 'Official',
    'activerecord.attributes.ninth_age_army.source.Supplement': 'Supplement',
    'activerecord.attributes.ninth_age_unit_option.category.BSB':
      'Alfiere da battaglia',
    'activerecord.attributes.ninth_age_unit_option.category.C': 'Campione',
    'activerecord.attributes.ninth_age_unit_option.category.ModelRule':
      'Equipaggiamento',
    'activerecord.attributes.ninth_age_unit_option.category.ExtraSpells':
      'Spells',
    'activerecord.attributes.ninth_age_unit_option.category.General':
      'is Général',
    'activerecord.attributes.ninth_age_unit_option.category.Generic': 'Generic',
    'activerecord.attributes.ninth_age_unit_option.category.M': 'Musico',
    'activerecord.attributes.ninth_age_unit_option.category.MagicBanner':
      'Banner Enchantment',
    'activerecord.attributes.ninth_age_unit_option.category.MagicEquipment':
      'Equipaggiamento speciale',
    'activerecord.attributes.ninth_age_unit_option.category.MagicLvl':
      'Magic LVL',
    'activerecord.attributes.ninth_age_unit_option.category.MagicPath':
      'Magic path',
    'activerecord.attributes.ninth_age_unit_option.category.MayTake':
      'May take',
    'activerecord.attributes.ninth_age_unit_option.category.Mount': 'Mount',
    'activerecord.attributes.ninth_age_unit_option.category.MustChoice':
      'Must choose',
    'activerecord.attributes.ninth_age_unit_option.category.OneChoice':
      'One choice only',
    'activerecord.attributes.ninth_age_unit_option.category.S': 'Alfiere',
    'activerecord.attributes.ninth_age_unit_option.category.SpecialRule':
      'Special Rule',
    'activerecord.attributes.ninth_age_unit_option.category.WizardAdept':
      'Wizard Adept',
    'activerecord.attributes.ninth_age_unit_option.category.WizardApprentice':
      'Wizard Apprentice',
    'activerecord.attributes.ninth_age_unit_option.category.WizardMaster':
      'Wizard Master',
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ChangeUnitOrganisation':
      "Change unit's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ExcludeAddOrganisation':
      "Not affected with other unit option's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.Unit':
      'All the unit',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Add':
      'Add',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Replace':
      'Replace',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.A':
      'V1-A',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.BS':
      'V1-BS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.E':
      'V1-E',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.I':
      'V1-I',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.LD':
      'V1-Ld',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.M':
      'V1-M',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.S':
      'V1-S',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.T':
      'V1-T',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.W':
      'V1-W',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.WS':
      'V1-WS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_aeg':
      'V2-Aeg',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_agi':
      'V2-Agi',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ap':
      'V2-Ap',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_arm':
      'V2-Arm',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_att':
      'V2-Att',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_def':
      'V2-Def',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_dis':
      'V2-Dis',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_evoked':
      'V2-Evoked',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_adv':
      'V2-Fly-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_mar':
      'V2-Fly-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_adv':
      'V2-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_mar':
      'V2-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_hp':
      'V2-Hp',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_of':
      'V2-Of',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_res':
      'V2-Res',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_str':
      'V2-Str',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByArmy':
      'per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByModel':
      'item per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.MaxRatioByArmy':
      'Max Ratio per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Model':
      'Models per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ModelByUnit':
      'Models per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Units':
      'Units per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Quantity':
      'Quantity from the option',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Selection':
      'Option selected',
    'activerecord.attributes.ninth_age_version.game.EssenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.WarhammerBattle':
      'Warhammer Battle',
    'activerecord.attributes.ninth_age_version.game.essenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.ninthAge': 'Ninth Age',
    'activerecord.attributes.ninth_age_version.game.battle': 'Warhammer Battle',
    'activerecord.attributes.tournament/contest.participation': 'Participation',
    'activerecord.models.ninth_age/magic_standard.one': 'Banner magico',
    'activerecord.models.ninth_age/magic_standard.other': 'Striscioni magici',
    'activerecord.models.ninth_age/unit.one': 'Unità',
    'activerecord.models.ninth_age/unit.other': 'Unità',
    'admin.dashboard': 'Administration',
    'admin.tournament': 'Tournament Org',
    and: ' and ',
    'army.armybook': 'Army book',
    'army.banner': 'Banner enchantement',
    'army.index.show': 'Mostrare',
    'army.index.title': 'Eserciti',
    'army.show.back': 'Indietro',
    'army_list.clone.information': "Sei sicuro di duplicare l'elenco:",
    'army_list.clone.submit': 'Duplica',
    'army_list.clone.title': 'Duplica',
    'army_list.delete.information': 'Sei sicuro di distruggere questa lista:',
    'army_list.delete.submit': '!!! Elimina !!!',
    'army_list.delete.title': 'Elimina',
    'army_list.edit.title': 'Aggiornamento',
    'army_list.export.html_full': 'HTML completo',
    'army_list.export.html_lite': 'Lite HTML',
    'army_list.export.include_magics': 'Include magic paths?',
    'army_list.export.information':
      "Scegli il formato per l'esportazione di elenco:",
    'army_list.export.pdf_full': 'PDF completo',
    'army_list.export.pdf_lite': 'Lite PDF',
    'army_list.export.print': 'Print',
    'army_list.export.separator': 'Separator',
    'army_list.export.title': 'Esporta',
    'army_list.export.txt.general': 'General',
    'army_list.export.verbosity': 'Verbosity',
    'army_list.form.army.error': 'You must select an army.',
    'army_list.form.army.placeholder': 'Select an army',
    'army_list.form.army.title': 'Army *',
    'army_list.form.folder.placeholder': 'Select a folder',
    'army_list.form.folder.title': 'Folder',
    'army_list.form.max.name': 'You must choose the max of your army',
    'army_list.form.max.placeholder': 'Enter a max',
    'army_list.form.max.title': 'Max *',
    'army_list.form.name.error': 'You must name your list',
    'army_list.form.name.placeholder': 'Enter a name',
    'army_list.form.name.title': 'Name *',
    'army_list.form.notes.placeholder': 'My notes',
    'army_list.form.notes.title': 'Notes',
    'army_list.form.private.title': 'is a private list',
    'army_list.form.rate.title': 'Rate with max',
    'army_list.form.version.error': 'You must select a version.',
    'army_list.form.version.placeholder': 'Select a version',
    'army_list.form.version.title': 'Version *',
    'army_list.format.title': 'Format \u0026 Import an army list',
    'army_list.index.add': 'Crea un nuovo elenco di eserciti',
    'army_list.index.and': 'e',
    'army_list.index.filter': 'Filtra per',
    'army_list.index.folder': 'Create new folder',
    'army_list.index.name_or_notes': 'Nome o appunti',
    'army_list.index.search': 'Sottoscrivi',
    'army_list.index.title': 'I miei eserciti elenchi',
    'army_list.new.title': 'Create new list',
    'army_list.show.add_unit': 'Aggiungi unità',
    'army_list.show.delete': 'Elimina',
    'army_list.show.duplicate': 'Duplicare',
    'army_list.show.edit': 'Modifica',
    'army_list.show.export': 'Esportare',
    'army_list.show.notes': 'Gli appunti',
    'army_list.show.organisation.excess': 'Excess',
    'army_list.show.organisation.missing': 'Missing',
    'army_list.show.organisation.remaining': 'Remaining',
    'army_list.show.print': 'Stampare',
    'army_list.show.rearrange_units': 'Rearrange Units',
    'army_list.show.title': 'Army list • {name}',
    'army_list.unit.form.name.placeholder': 'Add a name',
    'army_list.unit.form.name.title': 'Name',
    'army_list.unit.form.title': 'Add an unit',
    'army_list.unit.form.unit.error': 'You must select an unit',
    'army_list.unit.form.unit.placeholder': 'Select an unit',
    'army_list.unit.form.unit.title': 'Unit *',
    'army_list_unit.delete.information':
      'Sei sicuro di distruggere questa unità:',
    'army_list_unit.delete.submit': '!!! Elimina !!!',
    'army_list_unit.delete.title': 'Elimina',
    'army_list_unit.duplicate.new_army_list': 'New {name} list',
    'army_list_unit.duplicate.target': 'A:',
    'army_list_unit.duplicate.title': 'Duplicare',
    'army_list_unit.edit.form.magic': 'Magia',
    'army_list_unit.edit.form.notes': 'Gli appunti',
    'army_list_unit.edit.magic_items': 'Articoli magici',
    'army_list_unit.edit.magic_standards': 'Standard magici',
    'army_list_unit.edit.options': 'Opzioni',
    'army_list_unit.edit.title': 'Modifica',
    'army_list_unit.form.name': 'Name',
    'army_list_unit.form.submit': 'Create Unit',
    'army_list_unit.new.title': 'Aggiungere \u003cbr',
    'army_list_unit.show.command_group_unit_options':
      'Opzioni del gruppo di comando',
    'army_list_unit.show.delete': 'Elimina',
    'army_list_unit.show.duplicate': 'Duplicare',
    'army_list_unit.show.edit': 'Modifica',
    'army_list_unit.show.model_rules': 'apparecchiature',
    'army_list_unit.show.magic': 'Magia',
    'army_list_unit.show.magic_items': 'Articoli magici',
    'army_list_unit.show.magic_lvl_unit_options':
      'Può diventare (una sola scelta)',
    'army_list_unit.show.magic_standards': 'Standard magici',
    'army_list_unit.show.magic_unit_options': 'Opzioni magiche',
    'army_list_unit.show.mount_unit_options': 'Opzioni di montaggio',
    'army_list_unit.show.notes': 'Gli appunti',
    'army_list_unit.show.path_unit_options':
      'Deve generare incantesimi da (sceglierne uno)',
    'army_list_unit.show.path_unit_options_choose_one':
      'Must generate spells from (choose one)',
    'army_list_unit.show.troops.A': 'UN',
    'army_list_unit.show.troops.BS': 'BS',
    'army_list_unit.show.troops.E': 'evocati',
    'army_list_unit.show.troops.I': 'io',
    'army_list_unit.show.troops.LD': 'Ld',
    'army_list_unit.show.troops.M': 'M',
    'army_list_unit.show.troops.S': 'S',
    'army_list_unit.show.troops.T': 'T',
    'army_list_unit.show.troops.W': 'W',
    'army_list_unit.show.troops.WS': 'WS',
    'army_list_unit.show.troops.name': 'Truppe',
    'army_list_unit.show.troops.profile': 'Profilo',
    'army_list_unit.show.troops.type': 'Tipo di truppa',
    'army_list_unit.show.unit_options': 'Opzioni',
    'army_magic_spell.name': 'Racial Trait Spell',
    'builder.searchs.index.and': 'and',
    'builder.searchs.index.between': 'between',
    'builder.searchs.index.points': 'points',
    'builder.searchs.index.search': 'Search',
    'builder.searchs.index.search_army_select_error':
      'You must select one army',
    'builder.searchs.index.select_army': 'Choise the army',
    'builder.searchs.index.select_points_range': 'Number of point',
    'builder.searchs.index.select_version': 'Choise the version of 9Th Age',
    'builder.searchs.index.title': 'Search an Army list',
    'builder.searchs.show.and': 'and',
    'builder.searchs.show.between': 'between',
    'builder.searchs.show.points': 'points',
    'builder.searchs.show.title': 'Army list found',
    close: 'Vicino',
    'confirmation.form.email': 'E-mail',
    'confirmation.form.submit': 'Salvare',
    'confirmation.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'confirmation.lost.password': 'Ho perso la mia password!',
    'confirmation.title': 'Invia nuovamente istruzioni di conferma',
    'contest.back': 'back',
    'contest.delete.information': 'Are you sure to delete:',
    'contest.delete.submit': '!!! Delete !!!',
    'contest.delete.title': 'Delete contest',
    'contest.edit.title': 'Edit my contest',
    'contest.form.armyListMax.error': 'Your contest need a max points by army',
    'contest.form.armyListMax.placeholder': 'Enter a max points by army',
    'contest.form.armyListMax.title': 'Max points by army',
    'contest.form.endDate.error': 'Your contest need a end date',
    'contest.form.endDate.placeholder': 'Enter a end date',
    'contest.form.endDate.title': 'End date *',
    'contest.form.name.error': 'You must name your list',
    'contest.form.name.placeholder': 'Enter a name',
    'contest.form.name.title': 'Name *',
    'contest.form.participation.error':
      'Your contest need a participation mode',
    'contest.form.participation.placeholder': 'Enter a participation mode',
    'contest.form.participation.title': 'Individual or by Team',
    'contest.form.startDate.error': 'Your contest need a start date',
    'contest.form.startDate.placeholder': 'Enter a start date',
    'contest.form.startDate.title': 'Start date *',
    'contest.form.teamMax.error': 'Your contest need a number of team',
    'contest.form.teamMax.placeholder': 'Enter a number of team',
    'contest.form.teamMax.title': 'Number of team',
    'contest.form.userMax.error':
      'Your contest need a number of participant or team size',
    'contest.form.userMax.placeholder':
      'Enter a number of participant or team size',
    'contest.form.userMax.title': 'Number of participant or team size',
    'contest.form.versionid.error': 'Your contest need a game version',
    'contest.form.versionid.placeholder': 'Enter a game version',
    'contest.form.versionid.title': 'Game version *',
    'contest.name': 'Tournament',
    'contest.new.title': 'Create a contest',
    'contest.show.title': 'Contest: {name}',
    'data_analytics.analytics.title': 'Project: Better data for T9A',
    'data_analytics.report.new.title': 'Report a game',
    'model_rules.index.show': 'Mostrare',
    'model_rules.index.title': 'Regole speciali',
    'export.format': 'Format',
    'export.full': 'Full',
    'export.lite': 'Lite',
    'export.magics': 'Magics',
    'export.nomagics': 'No Magics',
    'export.print': 'print',
    'export.verbosity': 'Verbosity',
    'export.withmagics': 'With magics',
    'folder.add_army_list.form.select': 'Select an army list',
    'folder.add_army_list.title': 'Add a list into this folder',
    'folder.back': 'back',
    'folder.delete.information': 'Are you sure to delete:',
    'folder.delete.submit': '!!! Delete !!!',
    'folder.delete.title': 'Delete folder',
    'folder.edit.title': 'Edit my folder',
    'folder.form.is_share.title': 'Share this folder',
    'folder.form.name.error': 'You must name your list',
    'folder.form.name.placeholder': 'Enter a name',
    'folder.form.name.title': 'Name *',
    'folder.form.parent.placeholder': 'Select the parent',
    'folder.form.parent.title': 'Parent',
    'folder.name': 'Folder',
    'folder.new.title': 'Create a folder',
    'folder.share.title': 'Share folder',
    'folder.show.title': 'Folder: {name}',
    'folder.tournament.information':
      'You can convert this folder into a tournament!',
    'folder.tournament.submit': '!!! Create !!!',
    'folder.tournament.title': 'Create a tournament',
    'footerlink.privacy': 'Privacy Policy',
    'form.add': 'Add',
    'form.cancel': 'Cancel',
    'form.create': 'Create',
    'form.format': 'Format',
    'form.import': 'Import',
    'form.save': 'Save',
    'format.form.date.error': 'You must select a creation date for your list',
    'format.form.date.placeholder': '01/01/2022',
    'format.form.date.title': 'Creation date *',
    'format.form.formated.title': 'Your formated army list',
    'format.form.game.error':
      "You must select the game's name that you want to play",
    'format.form.game.placeholder': 'T9A, EoW, WHB,....',
    'format.form.game.title': 'Your game *',
    'format.form.source.error': 'You must add your list',
    'format.form.source.placeholder': 'Enter an army list',
    'format.form.source.title': 'Your army list *',
    'format.new.title': 'Format and Import an army list',
    help: 'Aiuto',
    'home.app.available.google': 'Prendi su Google Play',
    'home.app.available.on_platform': 'Attualmente disponibile su:',
    'home.app.mobile': 'A mobile app',
    'home.locale.available': '9ThBuilder è disponibile in diverse lingue.',
    'home.locale.default':
      'Per impostazione predefinita, se il contenuto non è disponibile nella lingua scelta, verrà visualizzato automaticamente il contenuto in inglese.',
    'home.no_account':
      'You can now use all the features of 9ThBuilder without having to create an account first. \nBe careful however, your lists are linked to your local session and therefore will not be available on another browser and may be lost if you delete your cache or your session."\n',
    'home.welcome': '9TH BUILDER',
    'home.whoarewe.compose': 'Compose and archive your favorite armies!',
    'home.whoarewe.description':
      'A passionate of Battle since many years. I took the 9Th Builder since several years, creates a mobile application and helps the 9Th Age administration.\nHelped by Kaos War who greatly contributed to enter army lists and for the new homePage.\n9Th Builder is an effective and easy-to-use tool for creating your army lists and sharing them. It does not generate any income :)\n',
    'home.whoarewe.discord': 'Discord',
    'home.whoarewe.draft': 'Make a team pairing',
    'home.whoarewe.format': 'Format or import your army',
    'home.whoarewe.list': 'Create an Army list',
    'home.whoarewe.newsfb': 'News Facebook',
    'home.whoarewe.paint': 'Create an Paint list',
    'home.whoarewe.readarmy': 'Read Army Books',
    'home.whoarewe.readmagic': 'Read Magic Paths',
    'home.whoarewe.title': 'Who are we?',
    'home.whoarewe.try': 'Do you want to try?',
    'home.whoarewe.whatdo': 'What can you do?',
    'lexicon.index.show': "Libri dell'esercito",
    'magic.casting': 'getto',
    'magic.duration': 'Durata',
    'magic.effect': 'Effetto',
    'magic.index.show': 'Mostrare',
    'magic.index.title': 'Magics',
    'magic.range': 'Gamma',
    'magic.show.back': 'Indietro',
    'magic.type': 'Tipo',
    'magic_item_categories.index.show': 'Show',
    'magic_item_categories.index.title': 'Magic item categories',
    'magic_items.Cbtbmw': 'Cannot be taken by models with',
    'magic_items.Enchantment': 'Enchantment',
    'magic_items.dominant': 'Dominant',
    'magic_items.footonly': 'foot only',
    'magic_items.index.show': 'Mostrare',
    'magic_items.index.title': 'Articoli magici',
    'magic_items.only': 'only',
    'magic_items.perArmy': 'par Armée',
    'magic_items.type_figurine.All': 'All',
    'magic_items.type_figurine.AnimisteBestial': 'Animista bestiale',
    'magic_items.type_figurine.Character': 'Carattere',
    'magic_items.type_figurine.FeralOrc': 'Feral Orc',
    'magic_items.type_figurine.Goblins': 'Goblins',
    'magic_items.type_figurine.Infantry': 'Fanteria',
    'magic_items.type_figurine.KnightCommanders': 'Knight Commanders',
    'magic_items.type_figurine.MageOnFoot': 'Mago sul piede',
    'magic_items.type_figurine.MarshalsMountedOnHorse':
      'Marshals mounted on Horse',
    'magic_items.type_figurine.ModelsOnChariots': 'models on Chariots',
    'magic_items.type_figurine.ModelsOnFoot': 'Modelli a piedi',
    'magic_items.type_figurine.MonarchsOfTheDead': 'Monarchs of the Dead',
    'magic_items.type_figurine.Monster': 'Mostro',
    'magic_items.type_figurine.MountedCharacter': 'Carattere montato',
    'magic_items.type_figurine.NoLargeTarget': 'Nessun obiettivo grande',
    'magic_items.type_figurine.ParentUnit': 'Parent Unit',
    'magic_items.type_figurine.Wizard': 'Wizard',
    'magic_spell.type_lvl.A': 'UN',
    'magic_spell.type_lvl.Five': 5,
    'magic_spell.type_lvl.Four': 4,
    'magic_spell.type_lvl.One': 1,
    'magic_spell.type_lvl.Six': 6,
    'magic_spell.type_lvl.Three': 3,
    'magic_spell.type_lvl.Two': 2,
    'magic_spell.type_lvl.Zero': 0,
    'magic_standards.index.show': 'Mostrare',
    'magic_standards.index.title': 'Standard magici',
    'menu.army_lists': 'I miei eserciti elenchi',
    'menu.help': 'Aiuto',
    'menu.label': 'Menu principale',
    'menu.languages.de': 'Germany',
    'menu.languages.en': 'English',
    'menu.languages.es': 'Spanish - Español',
    'menu.languages.fr': 'French',
    'menu.languages.hu': 'Hungarian',
    'menu.languages.it': 'Italian - Italiano',
    'menu.languages.ko': 'Korean',
    'menu.languages.lang': 'Language',
    'menu.languages.pl': 'Polish',
    'menu.languages.ru': 'Russian',
    'menu.languages.sr': 'Serbian',
    'menu.languages.zh': 'Chinese',
    'menu.preferences': 'Preferenze',
    'menu.signin': 'registrati',
    'menu.signout': 'disconnessione',
    'menu.signup': 'Registrazione',
    next: 'Il prossimo',
    'ninth_age.figurine.mount': 'Mount',
    'ninth_age.figurine.pts': 'pti',
    'ninth_age.magic_item.only_wizard.AllWizard': 'Wizard only',
    'ninth_age.magic_item.only_wizard.NoWizard': 'Cannot be taken by Wizards',
    'ninth_age.magic_item.only_wizard.WizardAdept': 'Wizard adept only',
    'ninth_age.magic_item.only_wizard.WizardApprentice':
      'Wizard apprentice only',
    'ninth_age.magic_item.only_wizard.WizardMaster': 'Wizard master only',
    'ninth_age.troop.offensive': 'Offensive',
    'ninth_age.unit.defensive': 'Difensive',
    'ninth_age.unit.fly': 'fly',
    'ninth_age.unit.global': 'Globali',
    'ninth_age.unit.rules': 'Regole del modello',
    'paint_list.delete.information': 'Are you sure to destroy this list:',
    'paint_list.delete.submit': '!!! Delete !!!',
    'paint_list.delete.title': 'Delete your list',
    'paint_list.edit.title': 'Edit your paint list',
    'paint_list.form.army.error': 'You must select an army.',
    'paint_list.form.army.placeholder': 'Select an army',
    'paint_list.form.army.title': 'Army *',
    'paint_list.form.name.error': 'You must name your list',
    'paint_list.form.name.placeholder': 'Enter a name',
    'paint_list.form.name.title': 'Name *',
    'paint_list.form.version.error': 'You must select a version.',
    'paint_list.form.version.placeholder': 'Select a version',
    'paint_list.form.version.title': 'Version *',
    'paint_list.index.add': 'Create new paint list',
    'paint_list.index.title': 'My paint lists',
    'paint_list.new.title': 'Create a new list',
    'paint_list.show.assembled': 'Assembled',
    'paint_list.show.buy': 'Buy',
    'paint_list.show.comment': 'Comment',
    'paint_list.show.first_color': 'First color',
    'paint_list.show.paint': 'Paint',
    'paint_list.show.plinth': 'Plinth',
    'paint_list.show.size': 'Size',
    'paint_list.show.state.done': 'Done',
    'paint_list.show.state.waiting': 'Waiting',
    'paint_list.show.state.wip': 'Wip',
    'paint_list.show.title': 'Your Paint list:',
    'paint_list.show.trimmed': 'Trimmed',
    'paint_list.show.unit': 'Unit',
    'paint_list.unit.form.comment.placeholder': 'Add a comment',
    'paint_list.unit.form.comment.title': 'Comment',
    'paint_list.unit.form.size.error': 'You must add a number of model',
    'paint_list.unit.form.size.placeholder': 'Select a size',
    'paint_list.unit.form.size.title': 'Size *',
    'paint_list.unit.form.title': 'Add an unit',
    'paint_list.unit.form.unit.error': 'You must select an unit',
    'paint_list.unit.form.unit.placeholder': 'Select an unit',
    'paint_list.unit.form.unit.title': 'Unit *',
    'password_change.form.confirmation': 'conferma password',
    'password_change.form.password': "Parola d'ordine",
    'password_change.form.submit': 'Salvare',
    'password_change.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_change.lost.confirmation':
      'Non ho ricevuto la mia email di conferma',
    'password_change.lost.password': 'Ho perso la mia password!',
    'password_change.title': 'Cambia la tua password',
    'password_lost.form.email': 'Email',
    'password_lost.form.submit': 'Send me reset password instructions',
    'password_lost.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_lost.lost.confirmation':
      'Non ho ricevuto la mia email di conferma',
    'password_lost.title': 'Ho perso la mia password',
    'picker.datetime.js': 'YYYY.MM.DD HH:mm',
    'picker.datetime.rb': '%Y.%m.%d %H:%M',
    'profile.back': 'Pagina precedente',
    'profile.delete.information':
      'You are not satisfied? \u003ca href="mailto:support@9thbuilder.com"\u003eContact us\u003c/a\u003e or',
    'profile.delete.link': 'distruggere immediatamente il tuo account',
    'profile.delete.title': 'Cancellazione del conto',
    'profile.form.confirmation': 'conferma password',
    'profile.form.email': 'Indirizzo email',
    'profile.form.game': 'Preferito',
    'profile.form.name': 'Nome o soprannome',
    'profile.form.password': "Parola d'ordine",
    'profile.form.password_help':
      'Lasciare vuoto se non si desidera modificare la password',
    'profile.form.submit': 'Salvare',
    'profile.title': 'Il mio account',
    save: 'Salvare',
    'search_list.assembled': 'Assembled',
    'search_list.buy': 'Buy',
    'search_list.comment': 'Comment',
    'search_list.first_color': 'First color',
    'search_list.index.search': 'Submit',
    'search_list.index.search_list': 'Search an army list',
    'search_list.paint': 'Paint',
    'search_list.plinth': 'Plinth',
    'search_list.size': 'Size',
    'search_list.trimmed': 'Trimmed',
    'search_list.unit': 'Unit',
    'signin.Confirmation': 'Confirmation',
    'signin.form.email': 'Email',
    'signin.form.lost': 'Hai dimenticato?',
    'signin.form.password': "Parola d'ordine",
    'signin.form.remember': 'Ricordati di me',
    'signin.form.submit': 'Registrati',
    'signin.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signin.lost.confirmation': 'Non ho ricevuto la mia email di conferma',
    'signin.lost.password': 'Ho perso la mia password!',
    'signin.title': 'Registrati',
    'signup.form.confirmation': 'conferma password',
    'signup.form.email': 'Indirizzo email',
    'signup.form.game': '- Preferito--',
    'signup.form.name': 'Nome o soprannome',
    'signup.form.password': "Parola d'ordine",
    'signup.form.register': 'Join us !',
    'signup.form.submit': 'Registrazione',
    'signup.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signup.lost.confirmation': 'Non ho ricevuto la mia email di conferma',
    'signup.lost.password': 'Ho perso la mia password!',
    'signup.title': 'Registrazione',
    'site.accept': 'I accept',
    'site.more': 'Learn more',
    'site.use_cookie':
      'This site uses cookies to offer you the best service. By continuing your navigation, you use the use of cookies.',
    'tool.pairing.done': 'Your pairing is complete',
    'tool.pairing.draft.send_link': 'Send this link to your opponent:',
    'tool.pairing.draft.waiting_opponent': 'We are waiting your opponent',
    'tool.pairing.draw.confirm.draw': 'Confirm Draw',
    'tool.pairing.draw.confirm.response': 'Confirm Response',
    'tool.pairing.draw.confirm.select': 'Confirm select',
    'tool.pairing.draw.or': 'or',
    'tool.pairing.draw.vs': 'Vs',
    'tool.pairing.draw_round.select.draw': 'Select one army for the draft',
    'tool.pairing.draw_round.select.response': 'Select your reponses',
    'tool.pairing.draw_round.select.select': 'Select the army',
    'tool.pairing.draw_round.select.waiting': 'Waiting',
    'tool.pairing.image': 'Copy the pairing url image',
    'tool.pairing.inprogress': 'Your pairing is in progress',
    'tool.pairing.matches.tables': 'Tables:',
    'tool.pairing.my_team.my_armies': 'Your armies',
    'tool.pairing.opponent_team.team': 'Team',
    'tool.pairing.select_armies.choise_armies': 'Choise your armies',
    'tool.pairing.select_armies.confirm': 'Confirm',
    'tool.pairing.select_armies.error':
      'Sorry! There was an error loading the items.',
    'tool.pairing.select_armies.your_team': 'Your Team',
    'tool.pairing.select_team_size.how_many': 'How many players in the team?',
    'tool.pairing.table': 'Table',
    'tool.pairing.team_name.confirm': 'Confirm',
    'tool.pairing.team_name.what_name': "What's the name of your team?",
    'tool.pairing.team_name.your_name': 'Your team name',
    'tool.search_rules.index.search': 'Search',
    'tool.search_rules.index.search_army_select_error':
      'You must select one army',
    'tool.search_rules.index.search_rule': 'Choise one rule',
    'tool.search_rules.index.select_army': 'Choise the army',
    'tool.search_rules.index.select_version': 'Choise the version of 9Th Age',
    'tool.search_rules.index.title': 'Search by rules',
    'tournament.contest.back': 'Back to tournaments',
    'tournament.contest.edit': 'Edit',
    'tournament.contest.form.address': 'Address',
    'tournament.contest.form.end_date': 'End',
    'tournament.contest.form.fees': 'Fees',
    'tournament.contest.form.name': 'Name',
    'tournament.contest.form.round_count': 'Rounds',
    'tournament.contest.form.start_date': 'Start',
    'tournament.contest.form.submit': 'Save',
    'tournament.contest.form.team_max': 'Max teams',
    'tournament.contest.form.user_max': 'Max users',
    'tournament.contest.form.user_team_max': 'Max users by team',
    'tournament.contest.form.version': 'Version',
    'tournament.contest.index.title': 'My tournaments',
    'tournament.contest.name': 'Tournament',
    'tournament.contest.new.title': 'Create a tournament',
    'tournament.contest.print_armies': 'Print all armies',
    'tournament.contest.print_repport': 'Rapport',
    'tournament.contest.total': 'Total',
    'tournament.custom_point.name': 'Paint, Wysiwyg, List',
    'tournament.round.add': 'Add round',
    'tournament.round.name': 'Round',
    'tournament.round.pools.validate': 'Create pools',
    'tournament.team.add': 'Add Team',
    'tournament.team.back': 'Back to teams',
    'tournament.team.edit.title': 'Edition team',
    'tournament.team.export.title': 'Team',
    'tournament.team.first': 'Add your first team',
    'tournament.team.form.email': 'Email',
    'tournament.team.form.name': 'Name',
    'tournament.team.form.submit': 'Save',
    'tournament.team.index.title': 'My Tournament teams',
    'tournament.team.name': 'Teams',
    'tournament.team.new.title': 'Add teams',
    'tournament.teams.add': 'Add Team',
    'tournament.teams.back': 'Back to tournaments',
    'tournament.teams.title': 'Teams',
    'tournament.user_apply.add': 'Add Participant',
    'tournament.user_apply.add_into_team': 'Add partipant in this team',
    'tournament.user_apply.army_list.add_now': 'Add it now!',
    'tournament.user_apply.army_list.create': 'Create a new list',
    'tournament.user_apply.army_list.need':
      'You have not added your army list yet.',
    'tournament.user_apply.army_list.or': 'or',
    'tournament.user_apply.army_list.use_existing': 'Use an existing list',
    'tournament.user_apply.army_list.which': 'Which army list ?',
    'tournament.user_apply.army_list_select.form.submit': 'Save',
    'tournament.user_apply.edit.title': 'Edit your participation',
    'tournament.user_apply.first': 'Add your first Participant',
    'tournament.user_apply.form.name': 'Name',
    'tournament.user_apply.form.name_detail':
      'You can add somes users (1 user by line) with email separated by a comma (name, email).',
    'tournament.user_apply.form.or': 'or',
    'tournament.user_apply.form.submit': 'Add',
    'tournament.user_apply.form.user': 'User',
    'tournament.user_apply.manage': 'Manage Team',
    'tournament.user_apply.name': 'User',
    'tournament.user_apply.new.title': 'Add users',
    'tournament.user_apply.remove': 'Remove Participant',
    'tournament.user_apply.share_link': 'Share invitation link',
    'tournament.user_apply.team_leader': 'Is the team captain',
    'unit.base.label': 'Base',
    'unit.height.Gigantic': 'Gigantic',
    'unit.height.Large': 'Large',
    'unit.height.Standard': 'Standard',
    'unit.limit.model': 'Modelli/Esercito',
    'unit.limit.perArmy': 'par Armée',
    'unit.limit.single': 'mod. singolo',
    'unit.limit.unit': 'Unità/Esercito',
    'unit.mount': 'Mount',
    'unit.show.add_model':
      ' + \u003cstrong\u003e{pts}\u003c/strong\u003e pti/modello extra',
    'unit.show.change': 'Le unità {name} di {number} contano a {new_name}',
    'unit.show.change_with_limit':
      'Units of {number} or more models without {limit} count towards {new_name} instead of {old_name}.',
    'unit.show.size':
      '\u003cstrong\u003e{min_size}-{max_size}\u003c/strong\u003e modello',
    'unit.size.Gigantic': 'Gigantesco',
    'unit.size.Large': 'Grande',
    'unit.size.Standard': 'Normale',
    'unit.type.label': 'Tipo',
    'unit_option.per_model': '/mod.',
    'unit_option.use_points.free': 'free',
    'unit_option.use_points.no_limit': 'no limit',
    'unit_option.use_points.up_to': 'fino a',
    'unit_options.category.C': 'C',
    'unit_options.category.M': 'M',
    'unit_options.category.S': 'S',
    'unit_options.footonly': 'foot only',
    'version.index.pairing': 'Team Pairing',
    'version.index.search': 'Search by rule',
    'version.index.show': 'Mostrare',
    'version.index.title': 'Versioni',
    'version.index.tools': 'Tools',
    'version.show.back': 'Indietro',
    welcome: 'Benvenuto',
    with: 'with %',
    without: 'without %',
  },
  pl: {
    'activerecord.attributes.user.current_password': 'Aktualne hasło',
    'activerecord.attributes.user.email': 'Adres e-mail',
    'activerecord.attributes.user.password': 'Hasło',
    'activerecord.attributes.user.password_confirmation': 'Potwierdzenie hasła',
    'activerecord.attributes.user.remember_me': 'Zapamiętaj mnie',
    'activerecord.attributes.user.reset_password_token': null,
    'activerecord.attributes.user.unlock_token': null,
    'activerecord.models.user': 'Użytkownik',
    'devise.sessions.signed_in': '',
    'devise.sessions.signed_out': '',
    'users.confirmations.confirmed': 'Konto zostało poprawnie aktywowane.',
    'users.confirmations.new.resend_confirmation_instructions':
      'Wyślij ponownie instrukcje aktywacji',
    'users.confirmations.send_instructions':
      'Instrukcja jak aktywować konto zostanie niezwłocznie wysłana na podany adres e-mail.',
    'users.confirmations.send_paranoid_instructions':
      'Jeśli Twój adres e-mail istnieje w naszej bazie, w ciągu najbliższych minut otrzymasz instrukcje jak aktywować konto.',
    'users.failure.already_authenticated': 'Jesteś już zalogowany.',
    'users.failure.inactive': 'Konto nie zostało jeszcze aktywowane.',
    'users.failure.invalid': 'Niepoprawny adres e-mail lub hasło.',
    'users.failure.last_attempt':
      'Masz jeszcze jedną próbę nim Twoje konto zostanie zablokowane.',
    'users.failure.locked': 'Twoje konto jest zablokowane.',
    'users.failure.not_found_in_database':
      'Niepoprawny adres e-mail lub hasło.',
    'users.failure.timeout':
      'Sesja wygasła, aby kontynuować zaloguj się ponownie.',
    'users.failure.unauthenticated':
      'Aby kontynuować zaloguj lub zarejestruj się.',
    'users.failure.unconfirmed': 'Aby kontynuować aktywuj konto.',
    'users.mailer.confirmation_instructions.action': 'Potwierdź swoje konto',
    'users.mailer.confirmation_instructions.greeting': 'Witaj {recipient}!',
    'users.mailer.confirmation_instructions.instruction':
      'Możesz potwierdzić swoje konto przy pomocy poniższego linku:',
    'users.mailer.confirmation_instructions.subject':
      'Instrukcja aktywacji konta',
    'users.mailer.password_change.greeting': 'Witaj {recipient}!',
    'users.mailer.password_change.message':
      'Kontaktujemy się z Tobą w celu poinformowania, że Twoje hasło zostało zmienione.',
    'users.mailer.password_change.subject': 'Hasło zostało zmienione',
    'users.mailer.reset_password_instructions.action': 'Zmień swoje hasło',
    'users.mailer.reset_password_instructions.greeting': 'Cześć {recipient}!',
    'users.mailer.reset_password_instructions.instruction':
      'Ktoś zażądał zmiany hasła do Twojego konta. Hasło możesz zmienić wchodząc na poniższy link.',
    'users.mailer.reset_password_instructions.instruction_2':
      'Jeśli to nie Ty zażądałeś zmiany hasła, proszę zignoruj tę wiadomość.',
    'users.mailer.reset_password_instructions.instruction_3':
      'Twoje hasło nie ulegnie zmianie dopóki nie wejdziesz na poniższy link i nie ustawisz nowego.',
    'users.mailer.reset_password_instructions.subject':
      'Instrukcja ustawienia nowego hasła',
    'users.mailer.unlock_instructions.action': 'Odblokuj swoje konto',
    'users.mailer.unlock_instructions.greeting': 'Cześć {recipient}!',
    'users.mailer.unlock_instructions.instruction':
      'Kliknij poniższy link, aby odblokować swoje konto:',
    'users.mailer.unlock_instructions.message':
      'Twoje konto zostało zablokowane z powodu zbyt dużej ilości nieprawidłowych prób zalogowania się na nie.',
    'users.mailer.unlock_instructions.subject': 'Instrukcja odblokowania konta',
    'users.omniauth_callbacks.failure':
      'Logowanie przez konto {kind} zakończyło się błędem z powodu "{reason}".',
    'users.omniauth_callbacks.success':
      'Logowanie przez konto {kind} zakończyło się sukcesem.',
    'users.passwords.edit.change_my_password': 'Zmień moje hasło',
    'users.passwords.edit.change_your_password': 'Zmień swoje hasło',
    'users.passwords.edit.confirm_new_password': 'Powtórz nowe hasło',
    'users.passwords.edit.new_password': 'Nowe hasło',
    'users.passwords.new.forgot_your_password': 'Zapomniałeś swojego hasła?',
    'users.passwords.new.send_me_reset_password_instructions':
      'Wyślij instrukcje zmiany hasła',
    'users.passwords.no_token':
      'Do tej strony możesz dostać się tylko poprzez wiadomość e-mail resetującą hasło. Jeśli to z niej tu trafiłeś, upewnij się, że użyłeś pełnego adresu.',
    'users.passwords.send_instructions':
      'Instrukcja zmiany hasła zostanie niezwłocznie wysłana na podany adres e-mail.',
    'users.passwords.send_paranoid_instructions':
      'Jeśli Twój adres e-mail istnieje w naszej bazie, otrzymasz zaraz wiadomość z instrukcjami odzyskiwania hasła.',
    'users.passwords.updated':
      'Hasło zmienione poprawnie. Zostałeś automatycznie zalogowany.',
    'users.passwords.updated_not_active': 'Hasło zmienione poprawnie.',
    'users.registrations.destroyed': 'Konto zostało usunięte.',
    'users.registrations.edit.are_you_sure': 'Jesteś pewny?',
    'users.registrations.edit.cancel_my_account': 'Anuluj moje konto',
    'users.registrations.edit.currently_waiting_confirmation_for_email':
      'Aktualnie oczekujemy na potwierdzenie z: {email}',
    'users.registrations.edit.leave_blank_if_you_don_t_want_to_change_it':
      'pozostaw puste, jeśli nie chcesz wprowadzać zmian',
    'users.registrations.edit.title': 'Edytuj {resource}',
    'users.registrations.edit.unhappy': 'Niezadowolony',
    'users.registrations.edit.update': 'Zaktualizuj',
    'users.registrations.edit.we_need_your_current_password_to_confirm_your_changes':
      'potrzebujemy Twojego bieżącego hasła, aby potwierdzić zmiany',
    'users.registrations.new.sign_up': 'Zarejestruj się',
    'users.registrations.signed_up':
      'Witaj! Rejestracja zakończyła się sukcesem.',
    'users.registrations.signed_up_but_inactive':
      'Konto zostało utworzone pomyślnie. Zanim się jednak zalogujesz, musi ono zostać jeszcze aktywowane.',
    'users.registrations.signed_up_but_locked':
      'Konto zostało utworzone pomyślnie. Nie możesz się jednak zalogować, ponieważ jest ono zablokowane.',
    'users.registrations.signed_up_but_unconfirmed':
      'Wiadomość z linkiem aktywacyjnym została wysłana na podany adres e-mail. Otwórz link w celu aktywacji konta.',
    'users.registrations.update_needs_confirmation':
      'Konto zostało zaktualizowane, musimy jednak potwierdzić nowy adres e-mail. Sprawdź swoją skrzynkę pocztową i otwórz link aktywacyjny, aby ukończyć zmianę adresu.',
    'users.registrations.updated': 'Konto zostało pomyślnie zaktualizowane.',
    'users.sessions.already_signed_out': 'Wylogowano pomyślnie.',
    'users.sessions.new.sign_in': 'Zaloguj się',
    'users.sessions.signed_in': 'Zalogowano pomyślnie.',
    'users.sessions.signed_out': 'Wylogowano pomyślnie.',
    'users.shared.links.back': 'Powrót',
    'users.shared.links.didn_t_receive_confirmation_instructions':
      'Nie otrzymałeś instrukcji aktywacji konta?',
    'users.shared.links.didn_t_receive_unlock_instructions':
      'Nie otrzymałeś instrukcji odblokowania konta?',
    'users.shared.links.forgot_your_password': 'Zapomniałeś hasła?',
    'users.shared.links.sign_in': 'Zaloguj się',
    'users.shared.links.sign_in_with_provider': 'Zaloguj się przez {provider}',
    'users.shared.links.sign_up': 'Zarejestruj się',
    'users.unlocks.new.resend_unlock_instructions':
      'Wyślij instrukcje odblokowania konta',
    'users.unlocks.send_instructions':
      'Wkrótce powinieneś otrzymać e-mail z instrukcjami jak odblokować swoje konto.',
    'users.unlocks.send_paranoid_instructions':
      'Jeśli Twoje konto istnieje w naszej bazie, otrzymasz zaraz e-mail z instrukcjami jak odblokować swoje konto.',
    'users.unlocks.unlocked':
      'Twoje konto zostało odblokowane. Zaloguj się, aby kontynuować.',
    'errors.messages.already_confirmed':
      'już został aktywowany, możesz się zalogować',
    'errors.messages.confirmation_period_expired':
      'musi być potwierdzone w ciągu {period}, zamów nową wiadomość aktywacyjną',
    'errors.messages.expired': 'stracił ważność, wyślij zapytanie o nowy',
    'errors.messages.not_found': 'nie znaleziono',
    'errors.messages.not_locked': 'nie był zablokowany',
    'errors.messages.not_saved.few':
      '{resource} nie został zapisany z powodu {count} błędów:',
    'errors.messages.not_saved.many':
      '{resource} nie został zapisany z powodu {count} błędów:',
    'errors.messages.not_saved.one':
      '{resource} nie został zapisany z powodu jednego błędu:',
    'errors.messages.not_saved.other':
      '{resource} nie został zapisany z powodu {count} błędów:',
    Common: 'Common',
    'active_admin.menu.admin': 'Administration',
    'active_admin.menu.armies': 'Armies',
    'active_admin.menu.builder': 'Builder',
    'active_admin.menu.dashboard': 'Administration',
    'active_admin.menu.import': 'Import',
    'active_admin.menu.log': 'Log',
    'active_admin.menu.magic': 'magic',
    'active_admin.menu.map': 'Maps',
    'active_admin.menu.ninth_age': 'Ninth Age',
    'active_admin.menu.organisation': 'Organisation',
    'active_admin.menu.paint': 'Paint',
    'active_admin.menu.statistique': 'Statistiques',
    'active_admin.menu.tournament': 'Tournament',
    'active_admin.menu.unit': 'Unit',
    'active_admin.menu.user_annoncement': 'Annoncements',
    'active_admin.menu.users': 'Users',
    'active_admin.menu.versioning': 'Versioning',
    'active_admin.translate.ko': 'Korean',
    'active_admin.translate.pl': 'Polish',
    'active_admin.translate.ru': 'Russian',
    'active_admin.translate.zh': 'Chinese',
    'activerecord.attributes.data_analytics/report.deployments.CounterThrust':
      'Counter Thrust',
    'activerecord.attributes.data_analytics/report.deployments.DawnAssult':
      'Dawn Assult',
    'activerecord.attributes.data_analytics/report.deployments.Encircle':
      'Encircle',
    'activerecord.attributes.data_analytics/report.deployments.FrontlineClash':
      'Frontline Clash',
    'activerecord.attributes.data_analytics/report.deployments.MarchingColumns':
      'Marching Columns',
    'activerecord.attributes.data_analytics/report.deployments.RefusedFlank':
      'Refused Flank',
    'activerecord.attributes.data_analytics/report.maps.A1':
      'A1 - Shrouded Pool',
    'activerecord.attributes.data_analytics/report.maps.A2':
      'A2 - Foothill Outpost',
    'activerecord.attributes.data_analytics/report.maps.A3':
      'A3 - Dilapidated Manor',
    'activerecord.attributes.data_analytics/report.maps.A4':
      'A4 - Volcanic Lake',
    'activerecord.attributes.data_analytics/report.maps.A5':
      'A5 - Misty Marshes',
    'activerecord.attributes.data_analytics/report.maps.A6':
      'A6 - Ancient Walls',
    'activerecord.attributes.data_analytics/report.maps.A7': 'A7 - Beacon Hill',
    'activerecord.attributes.data_analytics/report.maps.A8':
      'A8 - Witch’s Cottage',
    'activerecord.attributes.data_analytics/report.maps.B1':
      'B1 - Mage’s Sanctum',
    'activerecord.attributes.data_analytics/report.maps.B2':
      'B2 - Villa Grounds',
    'activerecord.attributes.data_analytics/report.maps.B3':
      'B3 - Ancient Fortress',
    'activerecord.attributes.data_analytics/report.maps.B4':
      'B4 - Frontier Farm',
    'activerecord.attributes.data_analytics/report.maps.B5':
      'B5 - Ravaged Watchtower',
    'activerecord.attributes.data_analytics/report.maps.B6':
      'B6 - Creeping Forest',
    'activerecord.attributes.data_analytics/report.maps.B7':
      'B7 - Eerie Graveyard',
    'activerecord.attributes.data_analytics/report.maps.B8':
      'B8 - Shattered Bridge',
    'activerecord.attributes.data_analytics/report.objectives.Breakthrough':
      'Breakthrough',
    'activerecord.attributes.data_analytics/report.objectives.CaptureFlags':
      'Capture the Flags',
    'activerecord.attributes.data_analytics/report.objectives.HoldGround':
      'Hold the Ground',
    'activerecord.attributes.data_analytics/report.objectives.KingHill':
      'King of the Hill',
    'activerecord.attributes.data_analytics/report.objectives.SecureTarget':
      'Secure Target',
    'activerecord.attributes.data_analytics/report.objectives.SpoilsWar':
      'Spoils of War',
    'activerecord.attributes.data_analytics/report.opponent_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.opponent_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.opponent_objective':
      'Take the objective',
    'activerecord.attributes.data_analytics/report.your_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.your_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.your_objective':
      'Take the objective',
    'activerecord.attributes.ninth_age/magic_item.only_foot':
      'Prohibited mount',
    'activerecord.attributes.ninth_age/magic_item.only_wizard':
      'Only wizard can use it',
    'activerecord.attributes.ninth_age/magic_item.organisation_ids':
      'Organisations required from the model',
    'activerecord.attributes.ninth_age/magic_item.model_rule_ids':
      'Prohibited  model rules on model',
    'activerecord.attributes.ninth_age/magic_item.unit_ids':
      'For this units only',
    'activerecord.attributes.ninth_age/magic_item.unit_size':
      'Unit with this size can not use this item',
    'activerecord.attributes.ninth_age/magic_standard.organisation':
      'Add organisation to unit',
    'activerecord.attributes.ninth_age/magic_standard.organisation_ids':
      "Only organisation's units",
    'activerecord.attributes.ninth_age/troop.carac_agi': 'Agi',
    'activerecord.attributes.ninth_age/troop.carac_ap': 'Ap',
    'activerecord.attributes.ninth_age/troop.carac_att': 'Att',
    'activerecord.attributes.ninth_age/troop.carac_of': 'Off',
    'activerecord.attributes.ninth_age/troop.carac_str': 'Str',
    'activerecord.attributes.ninth_age/unit.carac_aeg': 'Aeg',
    'activerecord.attributes.ninth_age/unit.carac_arm': 'Arm',
    'activerecord.attributes.ninth_age/unit.carac_def': 'Def',
    'activerecord.attributes.ninth_age/unit.carac_dis': 'Dis',
    'activerecord.attributes.ninth_age/unit.carac_evoked': 'Rea',
    'activerecord.attributes.ninth_age/unit.carac_fly_adv': 'Fly adv',
    'activerecord.attributes.ninth_age/unit.carac_fly_mar': 'Fly mar',
    'activerecord.attributes.ninth_age/unit.carac_ground_adv': 'Adv',
    'activerecord.attributes.ninth_age/unit.carac_ground_mar': 'Mar',
    'activerecord.attributes.ninth_age/unit.carac_hp': 'HP',
    'activerecord.attributes.ninth_age/unit.carac_res': 'Res',
    'activerecord.attributes.ninth_age_army.source.FanMade': 'Fan Made',
    'activerecord.attributes.ninth_age_army.source.Official': 'Official',
    'activerecord.attributes.ninth_age_army.source.Supplement': 'Supplement',
    'activerecord.attributes.ninth_age_unit_option.category.BSB':
      'Battle Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.C': 'Champion',
    'activerecord.attributes.ninth_age_unit_option.category.ModelRule':
      'ModelRule',
    'activerecord.attributes.ninth_age_unit_option.category.ExtraSpells':
      'Spells',
    'activerecord.attributes.ninth_age_unit_option.category.General': 'General',
    'activerecord.attributes.ninth_age_unit_option.category.Generic': 'Generic',
    'activerecord.attributes.ninth_age_unit_option.category.M': 'Musician',
    'activerecord.attributes.ninth_age_unit_option.category.MagicBanner':
      'Banner Enchantment',
    'activerecord.attributes.ninth_age_unit_option.category.MagicEquipment':
      'Magic items',
    'activerecord.attributes.ninth_age_unit_option.category.MagicLvl':
      'Magic LVL',
    'activerecord.attributes.ninth_age_unit_option.category.MagicPath':
      'Magic Path',
    'activerecord.attributes.ninth_age_unit_option.category.MayTake':
      'May take',
    'activerecord.attributes.ninth_age_unit_option.category.Mount': 'Mount',
    'activerecord.attributes.ninth_age_unit_option.category.MustChoice':
      'Must choose',
    'activerecord.attributes.ninth_age_unit_option.category.OneChoice':
      'One choice only',
    'activerecord.attributes.ninth_age_unit_option.category.S':
      'Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.SpecialRule':
      'Special Rule',
    'activerecord.attributes.ninth_age_unit_option.category.WizardAdept':
      'Wizard Adept',
    'activerecord.attributes.ninth_age_unit_option.category.WizardApprentice':
      'Wizard Apprentice',
    'activerecord.attributes.ninth_age_unit_option.category.WizardMaster':
      'Wizard Master',
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ChangeUnitOrganisation':
      "Change unit's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ExcludeAddOrganisation':
      "Not affected with other unit option's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.Unit':
      'All the unit',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Add':
      'Add',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Replace':
      'Replace',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.A':
      'V1-A',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.BS':
      'V1-BS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.E':
      'V1-E',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.I':
      'V1-I',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.LD':
      'V1-Ld',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.M':
      'V1-M',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.S':
      'V1-S',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.T':
      'V1-T',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.W':
      'V1-W',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.WS':
      'V1-WS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_aeg':
      'V2-Aeg',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_agi':
      'V2-Agi',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ap':
      'V2-Ap',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_arm':
      'V2-Arm',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_att':
      'V2-Att',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_def':
      'V2-Def',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_dis':
      'V2-Dis',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_evoked':
      'V2-Evoked',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_adv':
      'V2-Fly-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_mar':
      'V2-Fly-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_adv':
      'V2-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_mar':
      'V2-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_hp':
      'V2-Hp',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_of':
      'V2-Of',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_res':
      'V2-Res',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_str':
      'V2-Str',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByArmy':
      'per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByModel':
      'item per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.MaxRatioByArmy':
      'Max Ratio per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Model':
      'Models per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ModelByUnit':
      'Models per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Units':
      'Units per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Quantity':
      'Quantity from the option',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Selection':
      'Option selected',
    'activerecord.attributes.ninth_age_version.game.EssenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.WarhammerBattle':
      'Warhammer Battle',
    'activerecord.attributes.ninth_age_version.game.essenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.ninthAge': 'Ninth Age',
    'activerecord.attributes.ninth_age_version.game.battle': 'Warhammer Battle',
    'activerecord.attributes.tournament/contest.participation': 'Participation',
    'activerecord.models.ninth_age/magic_standard.one': 'Magic banner',
    'activerecord.models.ninth_age/magic_standard.other': 'Magic banners',
    'activerecord.models.ninth_age/unit.one': 'Unit',
    'activerecord.models.ninth_age/unit.other': 'Units',
    'admin.dashboard': 'Administration',
    'admin.tournament': 'Tournament Org',
    and: ' and ',
    'army.armybook': 'Army book',
    'army.banner': 'Banner enchantement',
    'army.index.show': 'Show',
    'army.index.title': 'All armies',
    'army.show.back': 'Back',
    'army_list.clone.information': 'Are you sure to duplicate list:',
    'army_list.clone.submit': 'Duplicate',
    'army_list.clone.title': 'Duplicate list',
    'army_list.delete.information': 'Are you sure to destroy this list:',
    'army_list.delete.submit': '!!! Delete !!!',
    'army_list.delete.title': 'Delete\u003cbr /\u003elist',
    'army_list.edit.title': 'Update the list',
    'army_list.export.html_full': 'Full HTML',
    'army_list.export.html_lite': 'Lite HTML',
    'army_list.export.include_magics': 'Include magic paths?',
    'army_list.export.information': 'Choose format for list export:',
    'army_list.export.pdf_full': 'Full PDF',
    'army_list.export.pdf_lite': 'Lite PDF',
    'army_list.export.print': 'Print',
    'army_list.export.separator': 'Separator',
    'army_list.export.title': 'Export list',
    'army_list.export.txt.general': 'General',
    'army_list.export.verbosity': 'Verbosity',
    'army_list.form.army.error': 'You must select an army.',
    'army_list.form.army.placeholder': 'Select an army',
    'army_list.form.army.title': 'Army *',
    'army_list.form.folder.placeholder': 'Select a folder',
    'army_list.form.folder.title': 'Folder',
    'army_list.form.max.name': 'You must choose the max of your army',
    'army_list.form.max.placeholder': 'Enter a max',
    'army_list.form.max.title': 'Max *',
    'army_list.form.name.error': 'You must name your list',
    'army_list.form.name.placeholder': 'Enter a name',
    'army_list.form.name.title': 'Name *',
    'army_list.form.notes.placeholder': 'My notes',
    'army_list.form.notes.title': 'Notes',
    'army_list.form.private.title': 'is a private list',
    'army_list.form.rate.title': 'Rate with max',
    'army_list.form.version.error': 'You must select a version.',
    'army_list.form.version.placeholder': 'Select a version',
    'army_list.form.version.title': 'Version *',
    'army_list.format.title': 'Format \u0026 Import an army list',
    'army_list.index.add': 'Create new army list',
    'army_list.index.and': 'and',
    'army_list.index.contest': 'Create a contest',
    'army_list.index.filter': 'Filter by',
    'army_list.index.folder': 'Create new folder',
    'army_list.index.name_or_notes': 'Name or notes',
    'army_list.index.search': 'Submit',
    'army_list.index.title': 'My army lists',
    'army_list.new.title': 'Create new list',
    'army_list.show.add_unit': 'Add unit',
    'army_list.show.delete': 'Delete',
    'army_list.show.duplicate': 'Duplicate',
    'army_list.show.edit': 'Edit',
    'army_list.show.export': 'Export',
    'army_list.show.notes': 'Notes',
    'army_list.show.organisation.excess': 'Excess',
    'army_list.show.organisation.missing': 'Missing',
    'army_list.show.organisation.remaining': 'Remaining',
    'army_list.show.print': 'Print',
    'army_list.show.rearrange_units': 'Rearrange Units',
    'army_list.show.title': 'Army list • {name}',
    'army_list.unit.form.name.placeholder': 'Add a name',
    'army_list.unit.form.name.title': 'Name',
    'army_list.unit.form.title': 'Add an unit',
    'army_list.unit.form.unit.error': 'You must select an unit',
    'army_list.unit.form.unit.placeholder': 'Select an unit',
    'army_list.unit.form.unit.title': 'Unit *',
    'army_list_unit.delete.information': 'Are you sure to destroy this unit:',
    'army_list_unit.delete.submit': '!!! Delete !!!',
    'army_list_unit.delete.title': 'Delete\u003cbr /\u003eunit',
    'army_list_unit.duplicate.new_army_list': 'New {name} list',
    'army_list_unit.duplicate.target': 'To:',
    'army_list_unit.duplicate.title': 'Duplicate',
    'army_list_unit.edit.form.magic': 'Magic',
    'army_list_unit.edit.form.notes': 'Notes',
    'army_list_unit.edit.magic_items': 'Magic items',
    'army_list_unit.edit.magic_standards': 'Magic banners',
    'army_list_unit.edit.options': 'Options',
    'army_list_unit.edit.title': 'Edit',
    'army_list_unit.form.name': 'Name',
    'army_list_unit.form.submit': 'Create Unit',
    'army_list_unit.new.title': 'Add new unit',
    'army_list_unit.show.command_group_unit_options': 'Command Group Options',
    'army_list_unit.show.delete': 'Delete',
    'army_list_unit.show.duplicate': 'Duplicate',
    'army_list_unit.show.edit': 'Edit',
    'army_list_unit.show.model_rules': 'ModelRules',
    'army_list_unit.show.magic': 'Magic',
    'army_list_unit.show.magic_items': 'Magic items',
    'army_list_unit.show.magic_lvl_unit_options':
      'May become (one choice only)',
    'army_list_unit.show.magic_standards': 'Magic banners',
    'army_list_unit.show.magic_unit_options': 'Magic Options',
    'army_list_unit.show.mount_unit_options': 'Mount Options',
    'army_list_unit.show.notes': 'Notes',
    'army_list_unit.show.path_unit_options': 'Must generate spells from',
    'army_list_unit.show.path_unit_options_choose_one':
      'Must generate spells from (choose one)',
    'army_list_unit.show.troops.A': 'A',
    'army_list_unit.show.troops.BS': 'BS',
    'army_list_unit.show.troops.E': 'Evoked',
    'army_list_unit.show.troops.I': 'I',
    'army_list_unit.show.troops.LD': 'Ld',
    'army_list_unit.show.troops.M': 'M',
    'army_list_unit.show.troops.S': 'S',
    'army_list_unit.show.troops.T': 'T',
    'army_list_unit.show.troops.W': 'W',
    'army_list_unit.show.troops.WS': 'WS',
    'army_list_unit.show.troops.name': 'Troops',
    'army_list_unit.show.troops.profile': 'Profile',
    'army_list_unit.show.troops.type': "Troop's type",
    'army_list_unit.show.unit_options': 'Options',
    'army_magic_spell.name': 'Racial Trait Spell',
    'builder.searchs.index.and': 'and',
    'builder.searchs.index.between': 'between',
    'builder.searchs.index.points': 'points',
    'builder.searchs.index.search': 'Search',
    'builder.searchs.index.search_army_select_error':
      'You must select one army',
    'builder.searchs.index.select_army': 'Choise the army',
    'builder.searchs.index.select_points_range': 'Number of point',
    'builder.searchs.index.select_version': 'Choise the version of 9Th Age',
    'builder.searchs.index.title': 'Search an Army list',
    'builder.searchs.show.and': 'and',
    'builder.searchs.show.between': 'between',
    'builder.searchs.show.points': 'points',
    'builder.searchs.show.title': 'Army list found',
    close: 'Blisko',
    'confirmation.form.email': 'Email',
    'confirmation.form.submit': 'Save',
    'confirmation.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'confirmation.lost.password': 'I have lost my password!',
    'confirmation.title': 'Re-send confirmation instructions',
    'contest.back': 'back',
    'contest.delete.information': 'Are you sure to delete:',
    'contest.delete.submit': '!!! Delete !!!',
    'contest.delete.title': 'Delete contest',
    'contest.edit.title': 'Edit my contest',
    'contest.form.armyListMax.error': 'Your contest need a max points by army',
    'contest.form.armyListMax.placeholder': 'Enter a max points by army',
    'contest.form.armyListMax.title': 'Max points by army',
    'contest.form.endDate.error': 'Your contest need a end date',
    'contest.form.endDate.placeholder': 'Enter a end date',
    'contest.form.endDate.title': 'End date *',
    'contest.form.name.error': 'You must name your list',
    'contest.form.name.placeholder': 'Enter a name',
    'contest.form.name.title': 'Name *',
    'contest.form.participation.error':
      'Your contest need a participation mode',
    'contest.form.participation.placeholder': 'Enter a participation mode',
    'contest.form.participation.title': 'Individual or by Team',
    'contest.form.startDate.error': 'Your contest need a start date',
    'contest.form.startDate.placeholder': 'Enter a start date',
    'contest.form.startDate.title': 'Start date *',
    'contest.form.teamMax.error': 'Your contest need a number of team',
    'contest.form.teamMax.placeholder': 'Enter a number of team',
    'contest.form.teamMax.title': 'Number of team',
    'contest.form.userMax.error':
      'Your contest need a number of participant or team size',
    'contest.form.userMax.placeholder':
      'Enter a number of participant or team size',
    'contest.form.userMax.title': 'Number of participant or team size',
    'contest.form.versionid.error': 'Your contest need a game version',
    'contest.form.versionid.placeholder': 'Enter a game version',
    'contest.form.versionid.title': 'Game version *',
    'contest.name': 'Tournament',
    'contest.new.title': 'Create a contest',
    'contest.show.title': 'Contest: {name}',
    'data_analytics.analytics.title': 'Project: Better data for T9A',
    'data_analytics.report.new.title': 'Report a game',
    'model_rules.index.show': 'Show',
    'model_rules.index.title': 'model rules',
    'export.format': 'Format',
    'export.full': 'Full',
    'export.lite': 'Lite',
    'export.magics': 'Magics',
    'export.nomagics': 'No Magics',
    'export.print': 'print',
    'export.verbosity': 'Verbosity',
    'export.withmagics': 'With magics',
    'folder.add_army_list.form.select': 'Select an army list',
    'folder.add_army_list.title': 'Add a list into this folder',
    'folder.back': 'back',
    'folder.delete.information': 'Are you sure to delete:',
    'folder.delete.submit': '!!! Delete !!!',
    'folder.delete.title': 'Delete folder',
    'folder.edit.title': 'Edit my folder',
    'folder.form.is_share.title': 'Share this folder',
    'folder.form.name.error': 'You must name your list',
    'folder.form.name.placeholder': 'Enter a name',
    'folder.form.name.title': 'Name *',
    'folder.form.parent.placeholder': 'Select the parent',
    'folder.form.parent.title': 'Parent',
    'folder.name': 'Folder',
    'folder.new.title': 'Create a folder',
    'folder.share.title': 'Share folder',
    'folder.show.title': 'Folder: {name}',
    'folder.tournament.information':
      'You can convert this folder into a tournament!',
    'folder.tournament.submit': '!!! Create !!!',
    'folder.tournament.title': 'Create a tournament',
    'footerlink.privacy': 'Privacy Policy',
    'form.add': 'Add',
    'form.cancel': 'Cancel',
    'form.create': 'Create',
    'form.format': 'Format',
    'form.import': 'Import',
    'form.save': 'Save',
    'format.form.date.error': 'You must select a creation date for your list',
    'format.form.date.placeholder': '01/01/2022',
    'format.form.date.title': 'Creation date *',
    'format.form.formated.title': 'Your formated army list',
    'format.form.game.error':
      "You must select the game's name that you want to play",
    'format.form.game.placeholder': 'T9A, EoW, WHB,....',
    'format.form.game.title': 'Your game *',
    'format.form.source.error': 'You must add your list',
    'format.form.source.placeholder': 'Enter an army list',
    'format.form.source.title': 'Your army list *',
    'format.new.title': 'Format and Import an army list',
    help: 'Wsparcie',
    'home.app.available.google': 'Get it on Google Play',
    'home.app.available.on_platform':
      'Currently under development, available on:',
    'home.app.mobile': 'A mobile app',
    'home.no_account':
      'You can now use all the features of 9ThBuilder without having to create an account first. \nBe careful however, your lists are linked to your local session and therefore will not be available on another browser and may be lost if you delete your cache or your session."\n',
    'home.welcome': '9TH BUILDER',
    'home.whoarewe.compose': 'Compose and archive your favorite armies!',
    'home.whoarewe.description':
      'A passionate of Battle since many years. I took the 9Th Builder since several years, creates a mobile application and helps the 9Th Age administration.\nHelped by Kaos War who greatly contributed to enter army lists and for the new homePage.\n9Th Builder is an effective and easy-to-use tool for creating your army lists and sharing them. It does not generate any income :)\n',
    'home.whoarewe.discord': 'Discord',
    'home.whoarewe.draft': 'Make a team pairing',
    'home.whoarewe.format': 'Format or import your army',
    'home.whoarewe.list': 'Create an Army list',
    'home.whoarewe.newsfb': 'News Facebook',
    'home.whoarewe.paint': 'Create an Paint list',
    'home.whoarewe.readarmy': 'Read Army Books',
    'home.whoarewe.readmagic': 'Read Magic Paths',
    'home.whoarewe.title': 'Who are we?',
    'home.whoarewe.try': 'Do you want to try?',
    'home.whoarewe.whatdo': 'What can you do?',
    'lexicon.index.show': 'Army books \u0026 Tools',
    'magic.casting': 'Casting',
    'magic.duration': 'Duration',
    'magic.effect': 'Effect',
    'magic.index.show': 'Show',
    'magic.index.title': 'Magics',
    'magic.range': 'Range',
    'magic.show.back': 'Back',
    'magic.type': 'Type',
    'magic_item_categories.index.show': 'Show',
    'magic_item_categories.index.title': 'Magic item categories',
    'magic_items.Cbtbmw': 'Cannot be taken by models with',
    'magic_items.Enchantment': 'Enchantment',
    'magic_items.dominant': 'Dominant',
    'magic_items.footonly': 'foot only',
    'magic_items.index.show': 'Show',
    'magic_items.index.title': 'Magic items',
    'magic_items.only': 'only',
    'magic_items.perArmy': 'par Armée',
    'magic_items.type_figurine.All': 'All',
    'magic_items.type_figurine.AnimisteBestial': 'Animiste bestial',
    'magic_items.type_figurine.Character': 'Character',
    'magic_items.type_figurine.FeralOrc': 'Feral Orc',
    'magic_items.type_figurine.Goblins': 'Goblins',
    'magic_items.type_figurine.Infantry': 'Infantry',
    'magic_items.type_figurine.KnightCommanders': 'Knight Commanders',
    'magic_items.type_figurine.MageOnFoot': 'Mage On Foot',
    'magic_items.type_figurine.MarshalsMountedOnHorse':
      'Marshals mounted on Horse',
    'magic_items.type_figurine.ModelsOnChariots': 'models on Chariots',
    'magic_items.type_figurine.ModelsOnFoot': 'Models on foot',
    'magic_items.type_figurine.MonarchsOfTheDead': 'Monarchs of the Dead',
    'magic_items.type_figurine.Monster': 'Monster',
    'magic_items.type_figurine.MountedCharacter': 'Mounted character',
    'magic_items.type_figurine.NoLargeTarget': 'No large target',
    'magic_items.type_figurine.ParentUnit': 'Parent Unit',
    'magic_items.type_figurine.Wizard': 'Wizard',
    'magic_spell.type_lvl.A': 'A',
    'magic_spell.type_lvl.Five': '5',
    'magic_spell.type_lvl.Four': '4',
    'magic_spell.type_lvl.One': '1',
    'magic_spell.type_lvl.Six': '6',
    'magic_spell.type_lvl.Three': '3',
    'magic_spell.type_lvl.Two': '2',
    'magic_spell.type_lvl.Zero': '0',
    'magic_standards.index.show': 'Show',
    'magic_standards.index.title': 'Magic banners',
    'menu.army_lists': 'My army lists',
    'menu.help': 'Help',
    'menu.label': 'Main menu',
    'menu.languages.de': 'Germany',
    'menu.languages.en': 'English',
    'menu.languages.es': 'Spanish - Español',
    'menu.languages.fr': 'French',
    'menu.languages.hu': 'Hungarian',
    'menu.languages.it': 'Italian - Italiano',
    'menu.languages.ko': 'Korean',
    'menu.languages.lang': 'Language',
    'menu.languages.pl': 'Polish',
    'menu.languages.ru': 'Russian',
    'menu.languages.sr': 'Serbian',
    'menu.languages.zh': 'Chinese',
    'menu.preferences': 'Preferences',
    'menu.signin': 'Sign in',
    'menu.signout': 'Sign out',
    'menu.signup': 'Sign up',
    next: 'Następny',
    'ninth_age.figurine.mount': 'Mount',
    'ninth_age.figurine.pts': 'pts',
    'ninth_age.magic_item.only_wizard.AllWizard': 'Wizard only',
    'ninth_age.magic_item.only_wizard.NoWizard': 'Cannot be taken by Wizards',
    'ninth_age.magic_item.only_wizard.WizardAdept': 'Wizard adept only',
    'ninth_age.magic_item.only_wizard.WizardApprentice':
      'Wizard apprentice only',
    'ninth_age.magic_item.only_wizard.WizardMaster': 'Wizard master only',
    'ninth_age.troop.offensive': 'Offensive',
    'ninth_age.unit.defensive': 'Defensive',
    'ninth_age.unit.fly': 'fly',
    'ninth_age.unit.global': 'Global',
    'ninth_age.unit.rules': 'Model Rules',
    'paint_list.delete.information': 'Are you sure to destroy this list:',
    'paint_list.delete.submit': '!!! Delete !!!',
    'paint_list.delete.title': 'Delete your list',
    'paint_list.edit.title': 'Edit your paint list',
    'paint_list.form.army.error': 'You must select an army.',
    'paint_list.form.army.placeholder': 'Select an army',
    'paint_list.form.army.title': 'Army *',
    'paint_list.form.name.error': 'You must name your list',
    'paint_list.form.name.placeholder': 'Enter a name',
    'paint_list.form.name.title': 'Name *',
    'paint_list.form.version.error': 'You must select a version.',
    'paint_list.form.version.placeholder': 'Select a version',
    'paint_list.form.version.title': 'Version *',
    'paint_list.index.add': 'Create new paint list',
    'paint_list.index.title': 'My paint lists',
    'paint_list.new.title': 'Create a new list',
    'paint_list.show.assembled': 'Assembled',
    'paint_list.show.buy': 'Buy',
    'paint_list.show.comment': 'Comment',
    'paint_list.show.first_color': 'First color',
    'paint_list.show.paint': 'Paint',
    'paint_list.show.plinth': 'Plinth',
    'paint_list.show.size': 'Size',
    'paint_list.show.state.done': 'Done',
    'paint_list.show.state.waiting': 'Waiting',
    'paint_list.show.state.wip': 'Wip',
    'paint_list.show.title': 'Your Paint list:',
    'paint_list.show.trimmed': 'Trimmed',
    'paint_list.show.unit': 'Unit',
    'paint_list.unit.form.comment.placeholder': 'Add a comment',
    'paint_list.unit.form.comment.title': 'Comment',
    'paint_list.unit.form.size.error': 'You must add a number of model',
    'paint_list.unit.form.size.placeholder': 'Select a size',
    'paint_list.unit.form.size.title': 'Size *',
    'paint_list.unit.form.title': 'Add an unit',
    'paint_list.unit.form.unit.error': 'You must select an unit',
    'paint_list.unit.form.unit.placeholder': 'Select an unit',
    'paint_list.unit.form.unit.title': 'Unit *',
    'password_change.form.confirmation': 'Password confirmation',
    'password_change.form.password': 'Password',
    'password_change.form.submit': 'Save',
    'password_change.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_change.lost.confirmation':
      "I didn't received my confirmation email",
    'password_change.lost.password': 'I have lost my password!',
    'password_change.title': 'Change your password',
    'password_lost.form.email': 'Email',
    'password_lost.form.submit': 'Send me reset password instructions',
    'password_lost.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_lost.lost.confirmation':
      "I didn't received my confirmation email",
    'password_lost.title': 'I have lost my password',
    'picker.datetime.js': 'YYYY.MM.DD HH:mm',
    'picker.datetime.rb': '%Y.%m.%d %H:%M',
    'profile.back': 'Previous page',
    'profile.delete.information':
      'You are not satisfied? \u003ca href="mailto:support@9thbuilder.com"\u003eContact us\u003c/a\u003e or',
    'profile.delete.link': 'immediately destroy your account',
    'profile.delete.title': 'Account deletion',
    'profile.form.confirmation': 'Password confirmation',
    'profile.form.email': 'Email address',
    'profile.form.game': 'Favorite',
    'profile.form.name': 'Name or nickname',
    'profile.form.password': 'Password',
    'profile.form.password_help':
      "Leave it empty if you don't want to change your password",
    'profile.form.submit': 'Save',
    'profile.title': 'My account',
    save: 'Zapisać',
    'search_list.assembled': 'Assembled',
    'search_list.buy': 'Buy',
    'search_list.comment': 'Comment',
    'search_list.first_color': 'First color',
    'search_list.index.search': 'Submit',
    'search_list.index.search_list': 'Search an army list',
    'search_list.paint': 'Paint',
    'search_list.plinth': 'Plinth',
    'search_list.size': 'Size',
    'search_list.trimmed': 'Trimmed',
    'search_list.unit': 'Unit',
    'signin.Confirmation': 'Confirmation',
    'signin.form.email': 'Email',
    'signin.form.lost': 'Forgot ?',
    'signin.form.password': 'Password',
    'signin.form.remember': 'Remember me',
    'signin.form.submit': 'Sign-in',
    'signin.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signin.lost.confirmation': "I didn't received my confirmation email",
    'signin.lost.password': 'I have lost my password!',
    'signin.title': 'Sign in',
    'signup.form.confirmation': 'Password confirmation',
    'signup.form.email': 'Email address',
    'signup.form.game': '--Favorite--',
    'signup.form.name': 'Name or nickname',
    'signup.form.password': 'Password',
    'signup.form.register': 'Join us !',
    'signup.form.submit': 'Sign-up',
    'signup.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signup.lost.confirmation': "I didn't received my confirmation email",
    'signup.lost.password': 'I have lost my password!',
    'signup.title': 'Sign up',
    'site.accept': 'I accept',
    'site.more': 'Learn more',
    'site.use_cookie':
      'This site uses cookies to offer you the best service. By continuing your navigation, you use the use of cookies.',
    'tool.pairing.done': 'Your pairing is complete',
    'tool.pairing.draft.send_link': 'Send this link to your opponent:',
    'tool.pairing.draft.waiting_opponent': 'We are waiting your opponent',
    'tool.pairing.draw.confirm.draw': 'Confirm Draw',
    'tool.pairing.draw.confirm.response': 'Confirm Response',
    'tool.pairing.draw.confirm.select': 'Confirm select',
    'tool.pairing.draw.or': 'or',
    'tool.pairing.draw.vs': 'Vs',
    'tool.pairing.draw_round.select.draw': 'Select one army for the draft',
    'tool.pairing.draw_round.select.response': 'Select your reponses',
    'tool.pairing.draw_round.select.select': 'Select the army',
    'tool.pairing.draw_round.select.waiting': 'Waiting',
    'tool.pairing.image': 'Copy the pairing url image',
    'tool.pairing.inprogress': 'Your pairing is in progress',
    'tool.pairing.matches.tables': 'Tables:',
    'tool.pairing.my_team.my_armies': 'Your armies',
    'tool.pairing.opponent_team.team': 'Team',
    'tool.pairing.select_armies.choise_armies': 'Choise your armies',
    'tool.pairing.select_armies.confirm': 'Confirm',
    'tool.pairing.select_armies.error':
      'Sorry! There was an error loading the items.',
    'tool.pairing.select_armies.your_team': 'Your Team',
    'tool.pairing.select_team_size.how_many': 'How many players in the team?',
    'tool.pairing.table': 'Table',
    'tool.pairing.team_name.confirm': 'Confirm',
    'tool.pairing.team_name.what_name': "What's the name of your team?",
    'tool.pairing.team_name.your_name': 'Your team name',
    'tool.search_rules.index.search': 'Search',
    'tool.search_rules.index.search_army_select_error':
      'You must select one army',
    'tool.search_rules.index.search_rule': 'Choise one rule',
    'tool.search_rules.index.select_army': 'Choise the army',
    'tool.search_rules.index.select_version': 'Choise the version of 9Th Age',
    'tool.search_rules.index.title': 'Search by rules',
    'tournament.contest.back': 'Back to tournaments',
    'tournament.contest.edit': 'Edit',
    'tournament.contest.form.address': 'Address',
    'tournament.contest.form.end_date': 'End',
    'tournament.contest.form.fees': 'Fees',
    'tournament.contest.form.name': 'Name',
    'tournament.contest.form.round_count': 'Rounds',
    'tournament.contest.form.start_date': 'Start',
    'tournament.contest.form.submit': 'Save',
    'tournament.contest.form.team_max': 'Max teams',
    'tournament.contest.form.user_max': 'Max users',
    'tournament.contest.form.user_team_max': 'Max users by team',
    'tournament.contest.form.version': 'Version',
    'tournament.contest.index.title': 'My tournaments',
    'tournament.contest.name': 'Tournament',
    'tournament.contest.new.title': 'Create a tournament',
    'tournament.contest.print_armies': 'Print all armies',
    'tournament.contest.print_repport': 'Rapport',
    'tournament.contest.total': 'Total',
    'tournament.custom_point.name': 'Paint, Wysiwyg, List',
    'tournament.round.add': 'Add round',
    'tournament.round.name': 'Round',
    'tournament.round.pools.validate': 'Create pools',
    'tournament.team.add': 'Add Team',
    'tournament.team.back': 'Back to teams',
    'tournament.team.edit.title': 'Edition team',
    'tournament.team.export.title': 'Team',
    'tournament.team.first': 'Add your first team',
    'tournament.team.form.email': 'Email',
    'tournament.team.form.name': 'Name',
    'tournament.team.form.submit': 'Save',
    'tournament.team.index.title': 'My Tournament teams',
    'tournament.team.name': 'Teams',
    'tournament.team.new.title': 'Add teams',
    'tournament.teams.add': 'Add Team',
    'tournament.teams.back': 'Back to tournaments',
    'tournament.teams.title': 'Teams',
    'tournament.user_apply.add': 'Add Participant',
    'tournament.user_apply.add_into_team': 'Add partipant in this team',
    'tournament.user_apply.army_list.add_now': 'Add it now!',
    'tournament.user_apply.army_list.create': 'Create a new list',
    'tournament.user_apply.army_list.need':
      'You have not added your army list yet.',
    'tournament.user_apply.army_list.or': 'or',
    'tournament.user_apply.army_list.use_existing': 'Use an existing list',
    'tournament.user_apply.army_list.which': 'Which army list ?',
    'tournament.user_apply.army_list_select.form.submit': 'Save',
    'tournament.user_apply.edit.title': 'Edit your participation',
    'tournament.user_apply.first': 'Add your first Participant',
    'tournament.user_apply.form.name': 'Name',
    'tournament.user_apply.form.name_detail':
      'You can add somes users (1 user by line) with email separated by a comma (name, email).',
    'tournament.user_apply.form.or': 'or',
    'tournament.user_apply.form.submit': 'Add',
    'tournament.user_apply.form.user': 'User',
    'tournament.user_apply.manage': 'Manage Team',
    'tournament.user_apply.name': 'User',
    'tournament.user_apply.new.title': 'Add users',
    'tournament.user_apply.remove': 'Remove Participant',
    'tournament.user_apply.share_link': 'Share invitation link',
    'tournament.user_apply.team_leader': 'Is the team captain',
    'unit.base.label': 'Base',
    'unit.height.Gigantic': 'Gigantic',
    'unit.height.Large': 'Large',
    'unit.height.Standard': 'Standard',
    'unit.limit.model': 'Models/Army',
    'unit.limit.perArmy': 'par Armée',
    'unit.limit.single': 'single model',
    'unit.limit.unit': 'Units/Army',
    'unit.mount': 'Mount',
    'unit.show.add_model':
      ' + \u003cstrong\u003e{pts}\u003c/strong\u003e pts/extra model',
    'unit.show.change':
      '{name} utils of {number} models count towards {new_name}',
    'unit.show.change_with_limit':
      'Units of {number} or more models without {limit} count towards {new_name} instead of {old_name}.',
    'unit.show.size':
      '\u003cstrong\u003e{min_size}-{max_size}\u003c/strong\u003e models',
    'unit.size.Gigantic': 'Gigantic',
    'unit.size.Large': 'Large',
    'unit.size.Standard': 'Standard',
    'unit.type.label': 'Type',
    'unit_option.per_model': '/mod.',
    'unit_option.use_points.free': 'free',
    'unit_option.use_points.no_limit': 'no limit',
    'unit_option.use_points.up_to': 'up to',
    'unit_options.category.C': 'C',
    'unit_options.category.M': 'M',
    'unit_options.category.S': 'S',
    'unit_options.footonly': 'foot only',
    'version.index.pairing': 'Team Pairing',
    'version.index.search': 'Search by rule',
    'version.index.show': 'Show',
    'version.index.title': 'Versions',
    'version.index.tools': 'Tools',
    'version.show.back': 'Back',
    welcome: 'Witamy',
    with: 'with %',
    without: 'without %',
  },
  zh: {
    'activerecord.attributes.user.confirmation_sent_at': '确认邮件发送自',
    'activerecord.attributes.user.confirmation_token': '确认令牌',
    'activerecord.attributes.user.confirmed_at': '确认于',
    'activerecord.attributes.user.created_at': '创建于',
    'activerecord.attributes.user.current_password': '当前密码',
    'activerecord.attributes.user.current_sign_in_at': '最近登录于',
    'activerecord.attributes.user.current_sign_in_ip': '最近登录 IP',
    'activerecord.attributes.user.email': '电子邮箱',
    'activerecord.attributes.user.encrypted_password': '密码被加密',
    'activerecord.attributes.user.failed_attempts': '失败尝试',
    'activerecord.attributes.user.last_sign_in_at': '最后登录于',
    'activerecord.attributes.user.last_sign_in_ip': '最后登录的 IP',
    'activerecord.attributes.user.locked_at': '锁定于',
    'activerecord.attributes.user.password': '密码',
    'activerecord.attributes.user.password_confirmation': '密码确认',
    'activerecord.attributes.user.remember_created_at': '记住创建于',
    'activerecord.attributes.user.remember_me': '记住登录信息',
    'activerecord.attributes.user.reset_password_sent_at': '重置密码发送于',
    'activerecord.attributes.user.reset_password_token': '密码重置令牌',
    'activerecord.attributes.user.sign_in_count': '登录次数',
    'activerecord.attributes.user.unconfirmed_email': '未确认邮件',
    'activerecord.attributes.user.unlock_token': '帐户解锁令牌',
    'activerecord.attributes.user.updated_at': '更新于',
    'activerecord.models.user': '用户',
    'devise.confirmations.confirmed': '恭喜您，注册成功，现在可以登录了',
    'devise.confirmations.new.resend_confirmation_instructions':
      '重新发送确认邮件',
    'devise.confirmations.send_instructions':
      '几分钟后，您将收到确认帐户的电子邮件。',
    'devise.confirmations.send_paranoid_instructions':
      '如果您的邮箱存在于我们的数据库中，您将在几分钟内收到一封确认帐户的邮件。',
    'devise.failure.already_authenticated': '登录成功',
    'devise.failure.inactive': '您的帐户还未激活',
    'devise.failure.invalid': '{authentication_keys}或密码错误。',
    'devise.failure.last_attempt':
      '您还有最后一次尝试机会，再次失败您的帐户将被锁定。',
    'devise.failure.locked': '您的帐户正被锁定。',
    'devise.failure.not_found_in_database': '{authentication_keys}或密码错误。',
    'devise.failure.timeout': '登录超时，请重新登录。',
    'devise.failure.unauthenticated': '继续操作前请确保您已登录。',
    'devise.failure.unconfirmed': '继续操作前请先确认您的帐户。',
    'devise.mailer.confirmation_instructions.action': '确认我的帐户',
    'devise.mailer.confirmation_instructions.greeting': '欢迎 {recipient}！',
    'devise.mailer.confirmation_instructions.instruction':
      '您可以通过下面的链接确认您的帐户的电子邮件：',
    'devise.mailer.confirmation_instructions.subject': '确认信息',
    'devise.mailer.email_changed.greeting': '您好 {recipient}!',
    'devise.mailer.email_changed.message':
      '收到此邮件是因为您的电子邮件地址已被更改为 {email}。',
    'devise.mailer.email_changed.subject': '电子邮件地址已更改',
    'devise.mailer.password_change.greeting': '您好 {recipient}！',
    'devise.mailer.password_change.message':
      '收到此邮件是因为您的帐户密码已被修改。',
    'devise.mailer.password_change.subject': '密码已被修改',
    'devise.mailer.reset_password_instructions.action': '更改我的密码',
    'devise.mailer.reset_password_instructions.greeting': '您好 {recipient}！',
    'devise.mailer.reset_password_instructions.instruction':
      '有人要求更改密码的链接，您可以通过下面的链接更改密码：',
    'devise.mailer.reset_password_instructions.instruction_2':
      '如果您没有要求请求更改密码，请忽略此电子邮件。',
    'devise.mailer.reset_password_instructions.instruction_3':
      '如果您没有访问上面的链接并更改密码，您的密码就不会被改变。',
    'devise.mailer.reset_password_instructions.subject': '重置密码信息',
    'devise.mailer.unlock_instructions.action': '帐户解锁',
    'devise.mailer.unlock_instructions.greeting': '您好 {recipient}！',
    'devise.mailer.unlock_instructions.instruction':
      '点击下面的链接以解锁您的帐户：',
    'devise.mailer.unlock_instructions.message':
      '由于多次登录失败，您的帐户已被锁定。',
    'devise.mailer.unlock_instructions.subject': '解锁信息',
    'devise.omniauth_callbacks.failure': '由于{reason}，无法从{kind}获得授权。',
    'devise.omniauth_callbacks.success': '成功地从{kind}获得授权。',
    'devise.passwords.edit.change_my_password': '更改我的密码',
    'devise.passwords.edit.change_your_password': '更改您的密码',
    'devise.passwords.edit.confirm_new_password': '确认新密码',
    'devise.passwords.edit.new_password': '新密码',
    'devise.passwords.new.forgot_your_password': '忘记密码？',
    'devise.passwords.new.send_me_reset_password_instructions':
      '请给我发送重设密码的邮件',
    'devise.passwords.no_token':
      '您暂时不能访问此页面。您需要通过密码重置邮件中的重置链接来访问此页面，如果您正是通过重置链接访问，请确定链接的正确性。',
    'devise.passwords.send_instructions':
      '几分钟后，您将收到重置密码的电子邮件。',
    'devise.passwords.send_paranoid_instructions':
      '如果您的邮箱存在于我们的数据库中，您将收到一封找回密码的邮件。',
    'devise.passwords.updated': '您的密码已修改成功，您现在已登录。',
    'devise.passwords.updated_not_active': '密码修改成功。',
    'devise.registrations.destroyed':
      '再见！您的帐户已成功注销。我们希望很快可以再见到您。',
    'devise.registrations.edit.are_you_sure': '您确定吗？',
    'devise.registrations.edit.cancel_my_account': '注销我的帐户',
    'devise.registrations.edit.currently_waiting_confirmation_for_email':
      '等待确认 {email}',
    'devise.registrations.edit.leave_blank_if_you_don_t_want_to_change_it':
      '如不想更改，则无需填写',
    'devise.registrations.edit.title': '修改{resource}',
    'devise.registrations.edit.unhappy': '不喜欢',
    'devise.registrations.edit.update': '更新',
    'devise.registrations.edit.we_need_your_current_password_to_confirm_your_changes':
      '我们需要您的当前密码以确认更改',
    'devise.registrations.new.sign_up': '注册',
    'devise.registrations.signed_up': '欢迎您！您已注册成功。',
    'devise.registrations.signed_up_but_inactive':
      '您的帐户还未被激活，激活前无法登录。',
    'devise.registrations.signed_up_but_locked': '您的帐户已被锁定，无法登录。',
    'devise.registrations.signed_up_but_unconfirmed':
      '谢谢您！一封确认邮件已经发至您的邮箱，请点击其中的链接激活您的帐户。',
    'devise.registrations.update_needs_confirmation':
      '新的帐户信息已成功提交，确认邮件已经发至您的邮箱，请点击其中的链接以使您的新电子邮箱地址生效。',
    'devise.registrations.updated': '帐户资料更新成功。',
    'devise.registrations.updated_but_not_signed_in': null,
    'devise.sessions.already_signed_out': '已登出',
    'devise.sessions.new.sign_in': '登录',
    'devise.sessions.signed_in': '登录成功。',
    'devise.sessions.signed_out': '登出成功。',
    'devise.shared.links.back': '返回',
    'devise.shared.links.didn_t_receive_confirmation_instructions':
      '没有收到确认邮件？',
    'devise.shared.links.didn_t_receive_unlock_instructions':
      '没有收到解锁邮件？',
    'devise.shared.links.forgot_your_password': '忘记密码？',
    'devise.shared.links.sign_in': '登录',
    'devise.shared.links.sign_in_with_provider': '通过 {provider} 登录',
    'devise.shared.links.sign_up': '注册',
    'devise.shared.minimum_password_length': '（最少{count}个字符）',
    'devise.unlocks.new.resend_unlock_instructions': '重发解锁邮件',
    'devise.unlocks.send_instructions':
      '几分钟后，您将收到一封解锁帐户的邮件。',
    'devise.unlocks.send_paranoid_instructions':
      '如果您的邮箱存在于我们的数据库中，您将收到一封解锁帐户的邮件。',
    'devise.unlocks.unlocked': '您的帐户已成功解锁，现在已登录。',
    'errors.messages.already_confirmed': '已经确认，请重新登录。',
    'errors.messages.confirmation_period_expired':
      '必须在 {period}以内确认。请重新发起请求',
    'errors.messages.expired': '已过期。请重新发起请求',
    'errors.messages.not_found': '找不到',
    'errors.messages.not_locked': '未被锁定',
    'errors.messages.not_saved.one': '发生 1 个错误，导致{resource}保存失败：',
    'errors.messages.not_saved.other':
      '发生 {count} 个错误，导致{resource}保存失败：',
    'active_admin.dashboard': 'Administration',
    'active_admin.log': 'Log',
    'active_admin.statistique': 'Statistiques',
    'active_admin.tournament': 'Tournaments',
    'active_admin.translate.ko': 'Korean',
    'active_admin.translate.pl': 'Polish',
    'active_admin.translate.zh': '中文',
    'activerecord.attributes.data_analytics/report.deployments.CounterThrust':
      'Counter Thrust',
    'activerecord.attributes.data_analytics/report.deployments.DawnAssult':
      'Dawn Assult',
    'activerecord.attributes.data_analytics/report.deployments.Encircle':
      'Encircle',
    'activerecord.attributes.data_analytics/report.deployments.FrontlineClash':
      'Frontline Clash',
    'activerecord.attributes.data_analytics/report.deployments.MarchingColumns':
      'Marching Columns',
    'activerecord.attributes.data_analytics/report.deployments.RefusedFlank':
      'Refused Flank',
    'activerecord.attributes.data_analytics/report.maps.A1':
      'A1 - Shrouded Pool',
    'activerecord.attributes.data_analytics/report.maps.A2':
      'A2 - Foothill Outpost',
    'activerecord.attributes.data_analytics/report.maps.A3':
      'A3 - Dilapidated Manor',
    'activerecord.attributes.data_analytics/report.maps.A4':
      'A4 - Volcanic Lake',
    'activerecord.attributes.data_analytics/report.maps.A5':
      'A5 - Misty Marshes',
    'activerecord.attributes.data_analytics/report.maps.A6':
      'A6 - Ancient Walls',
    'activerecord.attributes.data_analytics/report.maps.A7': 'A7 - Beacon Hill',
    'activerecord.attributes.data_analytics/report.maps.A8':
      'A8 - Witch’s Cottage',
    'activerecord.attributes.data_analytics/report.maps.B1':
      'B1 - Mage’s Sanctum',
    'activerecord.attributes.data_analytics/report.maps.B2':
      'B2 - Villa Grounds',
    'activerecord.attributes.data_analytics/report.maps.B3':
      'B3 - Ancient Fortress',
    'activerecord.attributes.data_analytics/report.maps.B4':
      'B4 - Frontier Farm',
    'activerecord.attributes.data_analytics/report.maps.B5':
      'B5 - Ravaged Watchtower',
    'activerecord.attributes.data_analytics/report.maps.B6':
      'B6 - Creeping Forest',
    'activerecord.attributes.data_analytics/report.maps.B7':
      'B7 - Eerie Graveyard',
    'activerecord.attributes.data_analytics/report.maps.B8':
      'B8 - Shattered Bridge',
    'activerecord.attributes.data_analytics/report.objectives.Breakthrough':
      'Breakthrough',
    'activerecord.attributes.data_analytics/report.objectives.CaptureFlags':
      'Capture the Flags',
    'activerecord.attributes.data_analytics/report.objectives.HoldGround':
      'Hold the Ground',
    'activerecord.attributes.data_analytics/report.objectives.KingHill':
      'King of the Hill',
    'activerecord.attributes.data_analytics/report.objectives.SecureTarget':
      'Secure Target',
    'activerecord.attributes.data_analytics/report.objectives.SpoilsWar':
      'Spoils of War',
    'activerecord.attributes.data_analytics/report.opponent_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.opponent_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.opponent_objective':
      'Take the objective',
    'activerecord.attributes.data_analytics/report.your_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.your_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.your_objective':
      'Take the objective',
    'activerecord.attributes.ninth_age/magic_item.unit_size':
      '此规模的单位无法使用此物品',
    'activerecord.attributes.ninth_age/magic_standard.organisation':
      'Add organisation to unit',
    'activerecord.attributes.ninth_age/magic_standard.organisation_ids':
      "Only organisation's units",
    'activerecord.attributes.ninth_age/troop.carac_agi': 'Agi',
    'activerecord.attributes.ninth_age/troop.carac_ap': 'Ap',
    'activerecord.attributes.ninth_age/troop.carac_att': 'Att',
    'activerecord.attributes.ninth_age/troop.carac_of': 'Off',
    'activerecord.attributes.ninth_age/troop.carac_str': 'Str',
    'activerecord.attributes.ninth_age/unit.carac_aeg': 'Aeg',
    'activerecord.attributes.ninth_age/unit.carac_arm': 'Arm',
    'activerecord.attributes.ninth_age/unit.carac_def': 'Def',
    'activerecord.attributes.ninth_age/unit.carac_dis': 'Dis',
    'activerecord.attributes.ninth_age/unit.carac_evoked': 'Rea',
    'activerecord.attributes.ninth_age/unit.carac_fly_adv': 'Fly adv',
    'activerecord.attributes.ninth_age/unit.carac_fly_mar': 'Fly mar',
    'activerecord.attributes.ninth_age/unit.carac_ground_adv': 'Adv',
    'activerecord.attributes.ninth_age/unit.carac_ground_mar': 'Mar',
    'activerecord.attributes.ninth_age/unit.carac_hp': 'HP',
    'activerecord.attributes.ninth_age/unit.carac_res': 'Res',
    'activerecord.attributes.ninth_age_army.source.FanMade': 'Fan Made',
    'activerecord.attributes.ninth_age_army.source.Official': 'Official',
    'activerecord.attributes.ninth_age_army.source.Supplement': 'Supplement',
    'activerecord.attributes.ninth_age_unit_option.category.BSB': '军旗手',
    'activerecord.attributes.ninth_age_unit_option.category.C': '队长',
    'activerecord.attributes.ninth_age_unit_option.category.ModelRule': '装备',
    'activerecord.attributes.ninth_age_unit_option.category.ExtraSpells':
      '法术',
    'activerecord.attributes.ninth_age_unit_option.category.General': 'General',
    'activerecord.attributes.ninth_age_unit_option.category.Generic': 'Generic',
    'activerecord.attributes.ninth_age_unit_option.category.M': '乐手',
    'activerecord.attributes.ninth_age_unit_option.category.MagicBanner':
      '旗帜附魔',
    'activerecord.attributes.ninth_age_unit_option.category.MagicEquipment':
      '特殊装备',
    'activerecord.attributes.ninth_age_unit_option.category.MagicLvl':
      '魔法等级',
    'activerecord.attributes.ninth_age_unit_option.category.MagicPath':
      '魔法派系',
    'activerecord.attributes.ninth_age_unit_option.category.Mount': '坐骑',
    'activerecord.attributes.ninth_age_unit_option.category.MustChoice':
      '必须选择',
    'activerecord.attributes.ninth_age_unit_option.category.OneChoice':
      '仅限一项',
    'activerecord.attributes.ninth_age_unit_option.category.S': '旗手',
    'activerecord.attributes.ninth_age_unit_option.category.SpecialRule':
      '特殊规则',
    'activerecord.attributes.ninth_age_unit_option.category.WizardAdept':
      '魔法专家',
    'activerecord.attributes.ninth_age_unit_option.category.WizardApprentice':
      '魔法学徒',
    'activerecord.attributes.ninth_age_unit_option.category.WizardMaster':
      '魔法大师',
    'activerecord.attributes.tournament/contest.participation': 'Participation',
    'activerecord.models.ninth_age/magic_standard.one': '魔法旗帜',
    'activerecord.models.ninth_age/magic_standard.other': '魔法旗帜',
    'activerecord.models.ninth_age/unit.one': '单位',
    'activerecord.models.ninth_age/unit.other': '单位',
    'admin.dashboard': 'Administration',
    'admin.tournament': 'Tournament Org',
    'army.armybook': '种族规则',
    'army.index.show': 'Show',
    'army.index.title': '所有种族',
    'army.show.back': 'Back',
    'army_list.clone.information': '是否确定复制军表:',
    'army_list.clone.title': '复制\u003cbr /\u003e军表',
    'army_list.delete.information': '是否确定删除:',
    'army_list.delete.submit': '!!! 删除 !!!',
    'army_list.delete.title': '删除\u003cbr /\u003e军表',
    'army_list.edit.title': 'Update\u003cbr /\u003elist',
    'army_list.export.html_full': '完整HTML',
    'army_list.export.html_lite': '简略HTML',
    'army_list.export.information': '选择输出格式:',
    'army_list.export.pdf_full': '完整PDF',
    'army_list.export.pdf_lite': '简略PDF',
    'army_list.export.title': '输出\u003cbr /\u003elist',
    'army_list.export.txt.general': 'General',
    'army_list.form.max': '最大分数',
    'army_list.form.name': '名称',
    'army_list.form.notes': 'Notes',
    'army_list.form.private.description': '只有你能看到此军表',
    'army_list.form.private.label': '私人',
    'army_list.form.submit': '保存',
    'army_list.index.add': '创建新的军表',
    'army_list.index.and': 'and',
    'army_list.index.filter': 'Filter by',
    'army_list.index.name_or_notes': '名称或备注',
    'army_list.index.search': '提交',
    'army_list.index.title': '我的军表',
    'army_list.new.title': '创建\u003cbr /\u003e军表',
    'army_list.show.add_unit': '增加单位',
    'army_list.show.delete': '删除',
    'army_list.show.duplicate': '复制',
    'army_list.show.edit': '编辑',
    'army_list.show.export': '输出',
    'army_list.show.notes': '备注',
    'army_list.show.print': '打印',
    'army_list.show.title': 'Army list • {name}',
    'army_list_unit.delete.information': '是否确定删除单位:',
    'army_list_unit.delete.submit': '!!! 删除 !!!',
    'army_list_unit.delete.title': '删除\u003cbr /\u003e单位',
    'army_list_unit.duplicate.new_army_list': '新 {name} 军表',
    'army_list_unit.duplicate.target': '到:',
    'army_list_unit.duplicate.title': '复制',
    'army_list_unit.edit.form.magic': 'Magic',
    'army_list_unit.edit.form.notes': 'Notes',
    'army_list_unit.edit.magic_items': '魔法物品',
    'army_list_unit.edit.magic_standards': '魔法选项',
    'army_list_unit.edit.options': '选项',
    'army_list_unit.edit.title': '编辑',
    'army_list_unit.form.name': '名称',
    'army_list_unit.form.submit': '创建单位',
    'army_list_unit.new.title': '添加新单位',
    'army_list_unit.show.command_group_unit_options': '指挥组选项',
    'army_list_unit.show.delete': '删除',
    'army_list_unit.show.duplicate': '复制',
    'army_list_unit.show.edit': '编辑',
    'army_list_unit.show.model_rules': '装备',
    'army_list_unit.show.magic': '魔法',
    'army_list_unit.show.magic_items': '魔法物品  ',
    'army_list_unit.show.magic_lvl_unit_options': '可成为 (仅限一项)',
    'army_list_unit.show.magic_standards': '魔法旗帜',
    'army_list_unit.show.magic_unit_options': '魔法选项',
    'army_list_unit.show.mount_unit_options': '坐骑选项',
    'army_list_unit.show.notes': '备注',
    'army_list_unit.show.path_unit_options': '必须从以下派系选择法术',
    'army_list_unit.show.path_unit_options_choose_one':
      '必须从以下派系选择法术 (选择一项)',
    'army_list_unit.show.troops.A': 'A',
    'army_list_unit.show.troops.BS': 'BS',
    'army_list_unit.show.troops.E': 'Evoked',
    'army_list_unit.show.troops.I': 'I',
    'army_list_unit.show.troops.LD': 'Ld',
    'army_list_unit.show.troops.M': 'M',
    'army_list_unit.show.troops.S': 'S',
    'army_list_unit.show.troops.T': 'T',
    'army_list_unit.show.troops.W': 'W',
    'army_list_unit.show.troops.WS': 'WS',
    'army_list_unit.show.troops.name': '部队',
    'army_list_unit.show.troops.profile': '属性',
    'army_list_unit.show.troops.type': '部队类型',
    'army_list_unit.show.unit_options': '选项',
    'army_magic_spell.name': 'Racial Trait Spell',
    'builder.searchs.index.and': 'and',
    'builder.searchs.index.between': 'between',
    'builder.searchs.index.points': 'points',
    'builder.searchs.index.search': '搜索',
    'builder.searchs.index.search_army_select_error': '必须选择一个种族',
    'builder.searchs.index.select_army': '选择种族',
    'builder.searchs.index.select_points_range': '分数',
    'builder.searchs.index.select_version': '选择版本',
    'builder.searchs.index.title': '搜索军表',
    'builder.searchs.show.and': 'and',
    'builder.searchs.show.between': 'between',
    'builder.searchs.show.points': 'points',
    'builder.searchs.show.title': 'Army list found',
    close: '关闭',
    'confirmation.form.email': 'Email',
    'confirmation.form.submit': 'Save',
    'confirmation.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'confirmation.lost.password': 'I have lost my password!',
    'confirmation.title': 'Re-send confirmation instructions',
    'model_rules.index.show': 'Show',
    'model_rules.index.title': 'model rules',
    'folder.army_list.add': '添加军队',
    'folder.back': '后退',
    'folder.delete': '删除',
    'folder.form.name': '名称',
    'folder.form.submit': '保存',
    'folder.name': '文件夹',
    help: '帮助',
    'home.app.available.google': 'Get it on Google Play',
    'home.app.available.on_platform': 'Currently available on:',
    'home.app.inprogess': '移动端APP正在开发',
    'home.army.first':
      '野兽人, 恶魔军团, 黑暗精灵, 矮人, 高等精灵, 食人魔可汗, 兽人与地精, 上古蜥人, 吸血鬼王庭, 邪神战士 属于 \u003ca href="http://www.avatars-of-war.com" target="_blank"\u003eAvatars of War\u003c/a\u003e 以及由\u003ca href="http://diegogisbertllorens.deviantart.com" target="_blank"\u003eDiego Gisbert Llorens\u003c/a\u003e 绘制',
    'home.army.four':
      '灾祸鼠群由 \u003ca href="http://getsugadante.deviantart.com/art/Warhammer-Fantasy-Rat-Ogre-s-fury-587662192" target="_blank"\u003eGetsugaDante\u003c/a\u003e 绘制',
    'home.army.second':
      '帝国由 \u003ca href="http://wraithdt.deviantart.com/art/Battle-of-Blackheath-416207912" target="_blank"\u003eWraithdt\u003c/a\u003e 绘制',
    'home.army.three':
      '古墓王朝由 \u003ca href="http://theclockworkpainter.deviantart.com/art/Queen-Khalida-493461199" target="_blank"\u003eTheclockworkpainter\u003c/a\u003e绘制',
    'home.thank': '十分感谢允许我们使用他们作品的画师/公司。  ',
    'home.welcome':
      'Compose\u003cspan\u003e and \u003c/span\u003esave\u003cbr\u003e\u003cem\u003eyour favorite armies!\u003c/em\u003e',
    'home.whoarewe.description':
      'Bringing together a team of enthusiasts playing for over 15 years in Battle, Army Builder wants to be an effective and user-friendly tool to create your army lists. Supported by generous patrons, Army Builder generates no income and will never ask for money! In addition, Army Builder is an open source project.',
    'home.whoarewe.title': '我们是谁?',
    'lexicon.index.show': '种族规则',
    'magic.casting': '施法',
    'magic.duration': '持续时间',
    'magic.effect': '效果',
    'magic.index.show': 'Show',
    'magic.index.title': 'Magics',
    'magic.range': '射程',
    'magic.show.back': 'Back',
    'magic.type': '类型',
    'magic_item_categories.index.show': 'Show',
    'magic_item_categories.index.title': 'Magic item categories',
    'magic_items.dominant': 'Dominant',
    'magic_items.index.show': 'Show',
    'magic_items.index.title': 'Magic items',
    'magic_items.type_figurine.All': 'All',
    'magic_items.type_figurine.AnimisteBestial': 'Animiste bestial',
    'magic_items.type_figurine.Character': 'Character',
    'magic_items.type_figurine.FeralOrc': 'Feral Orc',
    'magic_items.type_figurine.Goblins': 'Goblins',
    'magic_items.type_figurine.Infantry': '步兵',
    'magic_items.type_figurine.KnightCommanders': 'Knight Commanders',
    'magic_items.type_figurine.MageOnFoot': 'Mage On Foot',
    'magic_items.type_figurine.MarshalsMountedOnHorse':
      'Marshals mounted on Horse',
    'magic_items.type_figurine.ModelsOnChariots': 'models on Chariots',
    'magic_items.type_figurine.ModelsOnFoot': 'Models on foot',
    'magic_items.type_figurine.MonarchsOfTheDead': 'Monarchs of the Dead',
    'magic_items.type_figurine.Monster': '巨兽',
    'magic_items.type_figurine.MountedCharacter': 'Mounted character',
    'magic_items.type_figurine.NoLargeTarget': 'No large target',
    'magic_items.type_figurine.ParentUnit': 'Parent Unit',
    'magic_items.type_figurine.Wizard': 'Wizard',
    'magic_spell.type_lvl.A': 'A',
    'magic_spell.type_lvl.Five': 5,
    'magic_spell.type_lvl.Four': 4,
    'magic_spell.type_lvl.One': 1,
    'magic_spell.type_lvl.Six': 6,
    'magic_spell.type_lvl.Three': 3,
    'magic_spell.type_lvl.Two': 2,
    'magic_spell.type_lvl.Zero': 0,
    'magic_standards.index.show': 'Show',
    'magic_standards.index.title': 'Magic banners',
    'menu.army_lists': '我的军表',
    'menu.help': '帮助',
    'menu.label': '主菜单',
    'menu.languages.de': 'Germany',
    'menu.languages.en': 'English',
    'menu.languages.es': 'Spanish - Español',
    'menu.languages.fr': 'French',
    'menu.languages.hu': 'Hungarian',
    'menu.languages.it': 'Italian - Italiano',
    'menu.languages.ko': 'Korean',
    'menu.languages.lang': '语言',
    'menu.languages.pl': 'Polish',
    'menu.languages.ru': 'Russian',
    'menu.languages.sr': 'Serbian',
    'menu.languages.zh': '中文',
    'menu.preferences': 'Preferences',
    'menu.signin': '登录',
    'menu.signout': '登出',
    'menu.signup': 'Sign Up',
    next: '下一步',
    'ninth_age.figurine.pts': '分',
    'ninth_age.troop.offensive': '进攻',
    'ninth_age.unit.defensive': '防御',
    'ninth_age.unit.global': '全局',
    'ninth_age.unit.rules': '模型规则',
    'paint_list.index.add': '创建新的涂装清单',
    'paint_list.index.title': '我的涂装清单',
    'password_change.form.confirmation': 'Password confirmation',
    'password_change.form.password': 'Password',
    'password_change.form.submit': 'Save',
    'password_change.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_change.lost.confirmation':
      "I didn't received my confirmation email",
    'password_change.lost.password': 'I have lost my password!',
    'password_change.title': 'Change your password',
    'password_lost.form.email': 'Email',
    'password_lost.form.submit': 'Save',
    'password_lost.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_lost.lost.confirmation':
      "I didn't received my confirmation email",
    'password_lost.title': 'I have lost my password',
    per_model: '/mod.',
    'picker.datetime.js': 'YYYY.MM.DD HH:mm',
    'picker.datetime.rb': '%Y.%m.%d %H:%M',
    'profile.back': 'Previous page',
    'profile.delete.information':
      'You are not satisfied? \u003ca href="mailto:support@9thbuilder.com"\u003eContact us\u003c/a\u003e or',
    'profile.delete.link': 'immediately destroy your account',
    'profile.delete.title': 'Account deletion',
    'profile.form.confirmation': 'Password confirmation',
    'profile.form.email': 'Email address',
    'profile.form.game': 'Favorite',
    'profile.form.name': 'Name or nickname',
    'profile.form.password': 'Password',
    'profile.form.password_help':
      "Leave it empty if you don't want to change your password",
    'profile.form.submit': 'Save',
    'profile.title': 'My account',
    save: '保存',
    'search_list.assembled': '组装',
    'search_list.buy': '购买',
    'search_list.comment': 'Comment',
    'search_list.first_color': 'First color',
    'search_list.index.search': '提交',
    'search_list.index.search_list': '搜索军表',
    'search_list.paint': 'Paint',
    'search_list.plinth': 'Plinth',
    'search_list.size': '规模',
    'search_list.trimmed': '修模',
    'search_list.unit': '单位',
    'signin.form.email': 'Email',
    'signin.form.lost': 'Forgot ?',
    'signin.form.password': 'Password',
    'signin.form.register': 'Join us',
    'signin.form.remember': 'Remember me',
    'signin.form.submit': 'Sign-in',
    'signin.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signin.lost.confirmation': "I didn't received my confirmation email",
    'signin.lost.password': 'I have lost my password!',
    'signin.title': 'Sign in',
    'signup.form.confirmation': 'Password confirmation',
    'signup.form.email': 'Email address',
    'signup.form.game': '--Favorite--',
    'signup.form.name': 'Name or nickname',
    'signup.form.password': 'Password',
    'signup.form.submit': 'Sign-up',
    'signup.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signup.lost.confirmation': "I didn't received my confirmation email",
    'signup.lost.password': 'I have lost my password!',
    'signup.title': 'Sign up',
    'site.accept': '我同意',
    'site.more': '了解更多',
    'site.use_cookie':
      '此网站使用cookies来提供最佳体验。继续浏览将同意使用cookies。',
    'tournament.contest.back': 'Back to tournaments',
    'tournament.contest.edit': '编辑',
    'tournament.contest.form.address': 'Address',
    'tournament.contest.form.end_date': 'End',
    'tournament.contest.form.fees': 'Fees',
    'tournament.contest.form.name': 'Name',
    'tournament.contest.form.round_count': 'Rounds',
    'tournament.contest.form.start_date': 'Start',
    'tournament.contest.form.submit': 'Save',
    'tournament.contest.form.team_max': 'Max teams',
    'tournament.contest.form.user_max': 'Max users',
    'tournament.contest.form.user_team_max': 'Max users by team',
    'tournament.contest.form.version': 'Version',
    'tournament.contest.name': 'Tournament',
    'tournament.contest.new.title': '创建联赛',
    'tournament.contest.print_armies': '打印所有军队',
    'tournament.contest.print_repport': 'Rapport',
    'tournament.contest.total': '合计',
    'tournament.contests.title': 'All tournaments',
    'tournament.custom_point.name': 'PWL',
    'tournament.round.add': 'Add round',
    'tournament.round.name': 'Round',
    'tournament.team.add': 'Add Team',
    'tournament.team.back': 'Back to teams',
    'tournament.team.edit.title': 'Edition team',
    'tournament.team.export.title': 'Team',
    'tournament.team.first': 'Add your first team',
    'tournament.team.form.email': 'Email',
    'tournament.team.form.name': 'Name',
    'tournament.team.form.submit': 'Save',
    'tournament.team.my': 'Tournament teams',
    'tournament.team.name': 'Teams',
    'tournament.team.new.title': 'Add teams',
    'tournament.teams.add': 'Add Team',
    'tournament.teams.back': 'Back to tournaments',
    'tournament.teams.title': 'Teams',
    'tournament.user_apply.add': 'Add Participant',
    'tournament.user_apply.add_into_team': 'Add partipant in this team',
    'tournament.user_apply.army_list.add_now': 'Add it now!',
    'tournament.user_apply.army_list.create': 'Create a new list',
    'tournament.user_apply.army_list.need':
      'You have not added your army list yet.',
    'tournament.user_apply.army_list.or': 'or',
    'tournament.user_apply.army_list.use_existing': 'Use an existing list',
    'tournament.user_apply.army_list.which': 'Which army list ?',
    'tournament.user_apply.army_list_select.form.submit': 'Save',
    'tournament.user_apply.edit.title': 'Edit your participation',
    'tournament.user_apply.first': 'Add your first Participant',
    'tournament.user_apply.form.name': 'Name',
    'tournament.user_apply.form.name_detail':
      'You can add somes users (1 user by line) with email separated by a comma (name, email).',
    'tournament.user_apply.form.or': 'or',
    'tournament.user_apply.form.submit': 'Add',
    'tournament.user_apply.form.user': 'User',
    'tournament.user_apply.manage': 'Manage Team',
    'tournament.user_apply.name': 'User',
    'tournament.user_apply.new.title': 'Add users',
    'tournament.user_apply.remove': 'Remove Participant',
    'tournament.user_apply.share_link': 'Share invitation link',
    'tournament.user_apply.team_leader': 'Is the team captain',
    'unit.base.label': 'Base',
    'unit.limit.model': 'Models/Army',
    'unit.limit.single': 'single model',
    'unit.limit.unit': 'Units/Army',
    'unit.mount': 'Mount',
    'unit.show.add_model':
      ' + \u003cstrong\u003e{pts}\u003c/strong\u003e pts/extra model',
    'unit.show.change':
      '{name} units of {number} models count towards {new_name}',
    'unit.show.size':
      '\u003cstrong\u003e{min_size}-{max_size}\u003c/strong\u003e models',
    'unit.size.Gigantic': 'Gigantic',
    'unit.size.Large': 'Large',
    'unit.size.Standard': 'Standard',
    'unit.type.label': 'Type',
    'unit_options.category.C': 'C',
    'unit_options.category.M': 'M',
    'unit_options.category.S': 'S',
    up_to: 'up to',
    'version.index.show': 'Show',
    'version.index.title': '版本',
    'version.show.back': '后退',
    welcome: '欢迎',
  },
  dk: {
    Common: 'Common',
    'active_admin.menu.admin': 'Administration',
    'active_admin.menu.armies': 'Armies',
    'active_admin.menu.builder': 'Builder',
    'active_admin.menu.dashboard': 'Administration',
    'active_admin.menu.import': 'Import',
    'active_admin.menu.log': 'Log',
    'active_admin.menu.magic': 'magic',
    'active_admin.menu.map': 'Maps',
    'active_admin.menu.ninth_age': 'Ninth Age',
    'active_admin.menu.organisation': 'Organisation',
    'active_admin.menu.paint': 'Paint',
    'active_admin.menu.statistique': 'Statistiques',
    'active_admin.menu.tournament': 'Tournament',
    'active_admin.menu.unit': 'Unit',
    'active_admin.menu.user_annoncement': 'Annoncements',
    'active_admin.menu.users': 'Users',
    'active_admin.menu.versioning': 'Versioning',
    'active_admin.translate.ko': 'Korean',
    'active_admin.translate.pl': 'Polish',
    'active_admin.translate.ru': 'Russian',
    'active_admin.translate.zh': 'Chinese',
    'activerecord.attributes.data_analytics/report.deployments.CounterThrust':
      'Counter Thrust',
    'activerecord.attributes.data_analytics/report.deployments.DawnAssult':
      'Dawn Assult',
    'activerecord.attributes.data_analytics/report.deployments.Encircle':
      'Encircle',
    'activerecord.attributes.data_analytics/report.deployments.FrontlineClash':
      'Frontline Clash',
    'activerecord.attributes.data_analytics/report.deployments.MarchingColumns':
      'Marching Columns',
    'activerecord.attributes.data_analytics/report.deployments.RefusedFlank':
      'Refused Flank',
    'activerecord.attributes.data_analytics/report.maps.A1':
      'A1 - Shrouded Pool',
    'activerecord.attributes.data_analytics/report.maps.A2':
      'A2 - Foothill Outpost',
    'activerecord.attributes.data_analytics/report.maps.A3':
      'A3 - Dilapidated Manor',
    'activerecord.attributes.data_analytics/report.maps.A4':
      'A4 - Volcanic Lake',
    'activerecord.attributes.data_analytics/report.maps.A5':
      'A5 - Misty Marshes',
    'activerecord.attributes.data_analytics/report.maps.A6':
      'A6 - Ancient Walls',
    'activerecord.attributes.data_analytics/report.maps.A7': 'A7 - Beacon Hill',
    'activerecord.attributes.data_analytics/report.maps.A8':
      'A8 - Witch’s Cottage',
    'activerecord.attributes.data_analytics/report.maps.B1':
      'B1 - Mage’s Sanctum',
    'activerecord.attributes.data_analytics/report.maps.B2':
      'B2 - Villa Grounds',
    'activerecord.attributes.data_analytics/report.maps.B3':
      'B3 - Ancient Fortress',
    'activerecord.attributes.data_analytics/report.maps.B4':
      'B4 - Frontier Farm',
    'activerecord.attributes.data_analytics/report.maps.B5':
      'B5 - Ravaged Watchtower',
    'activerecord.attributes.data_analytics/report.maps.B6':
      'B6 - Creeping Forest',
    'activerecord.attributes.data_analytics/report.maps.B7':
      'B7 - Eerie Graveyard',
    'activerecord.attributes.data_analytics/report.maps.B8':
      'B8 - Shattered Bridge',
    'activerecord.attributes.data_analytics/report.objectives.Breakthrough':
      'Breakthrough',
    'activerecord.attributes.data_analytics/report.objectives.CaptureFlags':
      'Capture the Flags',
    'activerecord.attributes.data_analytics/report.objectives.HoldGround':
      'Hold the Ground',
    'activerecord.attributes.data_analytics/report.objectives.KingHill':
      'King of the Hill',
    'activerecord.attributes.data_analytics/report.objectives.SecureTarget':
      'Secure Target',
    'activerecord.attributes.data_analytics/report.objectives.SpoilsWar':
      'Spoils of War',
    'activerecord.attributes.data_analytics/report.opponent_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.opponent_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.opponent_objective':
      'Take the objective',
    'activerecord.attributes.data_analytics/report.your_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.your_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.your_objective':
      'Take the objective',
    'activerecord.attributes.ninth_age/magic_item.only_foot':
      'Prohibited mount',
    'activerecord.attributes.ninth_age/magic_item.only_wizard':
      'Only wizard can use it',
    'activerecord.attributes.ninth_age/magic_item.organisation_ids':
      'Organisations required from the model',
    'activerecord.attributes.ninth_age/magic_item.model_rule_ids':
      'Prohibited  model rules on model',
    'activerecord.attributes.ninth_age/magic_item.unit_ids':
      'For this units only',
    'activerecord.attributes.ninth_age/magic_item.unit_size':
      'Unit with this size can not use this item',
    'activerecord.attributes.ninth_age/magic_standard.organisation':
      'Add organisation to unit',
    'activerecord.attributes.ninth_age/magic_standard.organisation_ids':
      "Only organisation's units",
    'activerecord.attributes.ninth_age/troop.carac_agi': 'Agi',
    'activerecord.attributes.ninth_age/troop.carac_ap': 'Ap',
    'activerecord.attributes.ninth_age/troop.carac_att': 'Att',
    'activerecord.attributes.ninth_age/troop.carac_of': 'Off',
    'activerecord.attributes.ninth_age/troop.carac_str': 'Str',
    'activerecord.attributes.ninth_age/unit.carac_aeg': 'Aeg',
    'activerecord.attributes.ninth_age/unit.carac_arm': 'Arm',
    'activerecord.attributes.ninth_age/unit.carac_def': 'Def',
    'activerecord.attributes.ninth_age/unit.carac_dis': 'Dis',
    'activerecord.attributes.ninth_age/unit.carac_evoked': 'Rea',
    'activerecord.attributes.ninth_age/unit.carac_fly_adv': 'Fly adv',
    'activerecord.attributes.ninth_age/unit.carac_fly_mar': 'Fly mar',
    'activerecord.attributes.ninth_age/unit.carac_ground_adv': 'Adv',
    'activerecord.attributes.ninth_age/unit.carac_ground_mar': 'Mar',
    'activerecord.attributes.ninth_age/unit.carac_hp': 'HP',
    'activerecord.attributes.ninth_age/unit.carac_res': 'Res',
    'activerecord.attributes.ninth_age_army.source.FanMade': 'Fan Made',
    'activerecord.attributes.ninth_age_army.source.Official': 'Official',
    'activerecord.attributes.ninth_age_army.source.Supplement': 'Supplement',
    'activerecord.attributes.ninth_age_unit_option.category.BSB':
      'Battle Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.C': 'Champion',
    'activerecord.attributes.ninth_age_unit_option.category.ModelRule':
      'ModelRule',
    'activerecord.attributes.ninth_age_unit_option.category.ExtraSpells':
      'Spells',
    'activerecord.attributes.ninth_age_unit_option.category.General': 'General',
    'activerecord.attributes.ninth_age_unit_option.category.Generic': 'Generic',
    'activerecord.attributes.ninth_age_unit_option.category.M': 'Musician',
    'activerecord.attributes.ninth_age_unit_option.category.MagicBanner':
      'Banner Enchantment',
    'activerecord.attributes.ninth_age_unit_option.category.MagicEquipment':
      'Magic items',
    'activerecord.attributes.ninth_age_unit_option.category.MagicLvl':
      'Magic LVL',
    'activerecord.attributes.ninth_age_unit_option.category.MagicPath':
      'Magic Path',
    'activerecord.attributes.ninth_age_unit_option.category.MayTake':
      'May take',
    'activerecord.attributes.ninth_age_unit_option.category.Mount': 'Mount',
    'activerecord.attributes.ninth_age_unit_option.category.MustChoice':
      'Must choose',
    'activerecord.attributes.ninth_age_unit_option.category.OneChoice':
      'One choice only',
    'activerecord.attributes.ninth_age_unit_option.category.S':
      'Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.SpecialRule':
      'Special Rule',
    'activerecord.attributes.ninth_age_unit_option.category.WizardAdept':
      'Wizard Adept',
    'activerecord.attributes.ninth_age_unit_option.category.WizardApprentice':
      'Wizard Apprentice',
    'activerecord.attributes.ninth_age_unit_option.category.WizardMaster':
      'Wizard Master',
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ChangeUnitOrganisation':
      "Change unit's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ExcludeAddOrganisation':
      "Not affected with other unit option's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.Unit':
      'All the unit',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Add':
      'Add',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Replace':
      'Replace',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.A':
      'V1-A',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.BS':
      'V1-BS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.E':
      'V1-E',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.I':
      'V1-I',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.LD':
      'V1-Ld',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.M':
      'V1-M',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.S':
      'V1-S',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.T':
      'V1-T',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.W':
      'V1-W',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.WS':
      'V1-WS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_aeg':
      'V2-Aeg',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_agi':
      'V2-Agi',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ap':
      'V2-Ap',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_arm':
      'V2-Arm',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_att':
      'V2-Att',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_def':
      'V2-Def',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_dis':
      'V2-Dis',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_evoked':
      'V2-Evoked',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_adv':
      'V2-Fly-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_mar':
      'V2-Fly-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_adv':
      'V2-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_mar':
      'V2-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_hp':
      'V2-Hp',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_of':
      'V2-Of',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_res':
      'V2-Res',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_str':
      'V2-Str',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByArmy':
      'per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByModel':
      'item per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.MaxRatioByArmy':
      'Max Ratio per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Model':
      'Models per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ModelByUnit':
      'Models per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Units':
      'Units per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Quantity':
      'Quantity from the option',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Selection':
      'Option selected',
    'activerecord.attributes.ninth_age_version.game.EssenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.WarhammerBattle':
      'Warhammer Battle',
    'activerecord.attributes.ninth_age_version.game.essenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.ninthAge': 'Ninth Age',
    'activerecord.attributes.ninth_age_version.game.battle': 'Warhammer Battle',
    'activerecord.attributes.tournament/contest.participation': 'Participation',
    'activerecord.models.ninth_age/magic_standard.one': 'Magic banner',
    'activerecord.models.ninth_age/magic_standard.other': 'Magic banners',
    'activerecord.models.ninth_age/unit.one': 'Unit',
    'activerecord.models.ninth_age/unit.other': 'Units',
    'admin.dashboard': 'Administration',
    'admin.tournament': 'Tournament Org',
    and: ' and ',
    'army.armybook': 'Army book',
    'army.banner': 'Banner enchantement',
    'army.index.show': 'Show',
    'army.index.title': 'All armies',
    'army.show.back': 'Back',
    'army_list.clone.information': 'Are you sure to duplicate list:',
    'army_list.clone.submit': 'Duplicate',
    'army_list.clone.title': 'Duplicate list',
    'army_list.delete.information': 'Are you sure to destroy this list:',
    'army_list.delete.submit': '!!! Delete !!!',
    'army_list.delete.title': 'Delete\u003cbr /\u003elist',
    'army_list.edit.title': 'Update the list',
    'army_list.export.html_full': 'Full HTML',
    'army_list.export.html_lite': 'Lite HTML',
    'army_list.export.include_magics': 'Include magic paths?',
    'army_list.export.information': 'Choose format for list export:',
    'army_list.export.pdf_full': 'Full PDF',
    'army_list.export.pdf_lite': 'Lite PDF',
    'army_list.export.print': 'Print',
    'army_list.export.separator': 'Separator',
    'army_list.export.title': 'Export list',
    'army_list.export.txt.general': 'General',
    'army_list.export.verbosity': 'Verbosity',
    'army_list.form.army.error': 'You must select an army.',
    'army_list.form.army.placeholder': 'Select an army',
    'army_list.form.army.title': 'Army *',
    'army_list.form.folder.placeholder': 'Select a folder',
    'army_list.form.folder.title': 'Folder',
    'army_list.form.max.name': 'You must choose the max of your army',
    'army_list.form.max.placeholder': 'Enter a max',
    'army_list.form.max.title': 'Max *',
    'army_list.form.name.error': 'You must name your list',
    'army_list.form.name.placeholder': 'Enter a name',
    'army_list.form.name.title': 'Name *',
    'army_list.form.notes.placeholder': 'My notes',
    'army_list.form.notes.title': 'Notes',
    'army_list.form.private.title': 'is a private list',
    'army_list.form.rate.title': 'Rate with max',
    'army_list.form.version.error': 'You must select a version.',
    'army_list.form.version.placeholder': 'Select a version',
    'army_list.form.version.title': 'Version *',
    'army_list.format.title': 'Format \u0026 Import an army list',
    'army_list.index.add': 'Create new army list',
    'army_list.index.and': 'and',
    'army_list.index.contest': 'Create a contest',
    'army_list.index.filter': 'Filter by',
    'army_list.index.folder': 'Create new folder',
    'army_list.index.name_or_notes': 'Name or notes',
    'army_list.index.search': 'Submit',
    'army_list.index.title': 'My army lists',
    'army_list.new.title': 'Create new list',
    'army_list.show.add_unit': 'Add unit',
    'army_list.show.delete': 'Delete',
    'army_list.show.duplicate': 'Duplicate',
    'army_list.show.edit': 'Edit',
    'army_list.show.export': 'Export',
    'army_list.show.notes': 'Notes',
    'army_list.show.organisation.excess': 'Excess',
    'army_list.show.organisation.missing': 'Missing',
    'army_list.show.organisation.remaining': 'Remaining',
    'army_list.show.print': 'Print',
    'army_list.show.rearrange_units': 'Rearrange Units',
    'army_list.show.title': 'Army list • {name}',
    'army_list.unit.form.name.placeholder': 'Add a name',
    'army_list.unit.form.name.title': 'Name',
    'army_list.unit.form.title': 'Add an unit',
    'army_list.unit.form.unit.error': 'You must select an unit',
    'army_list.unit.form.unit.placeholder': 'Select an unit',
    'army_list.unit.form.unit.title': 'Unit *',
    'army_list_unit.delete.information': 'Are you sure to destroy this unit:',
    'army_list_unit.delete.submit': '!!! Delete !!!',
    'army_list_unit.delete.title': 'Delete\u003cbr /\u003eunit',
    'army_list_unit.duplicate.new_army_list': 'New {name} list',
    'army_list_unit.duplicate.target': 'To:',
    'army_list_unit.duplicate.title': 'Duplicate',
    'army_list_unit.edit.form.magic': 'Magic',
    'army_list_unit.edit.form.notes': 'Notes',
    'army_list_unit.edit.magic_items': 'Magic items',
    'army_list_unit.edit.magic_standards': 'Magic banners',
    'army_list_unit.edit.options': 'Options',
    'army_list_unit.edit.title': 'Edit',
    'army_list_unit.form.name': 'Name',
    'army_list_unit.form.submit': 'Create Unit',
    'army_list_unit.new.title': 'Add new unit',
    'army_list_unit.show.command_group_unit_options': 'Command Group Options',
    'army_list_unit.show.delete': 'Delete',
    'army_list_unit.show.duplicate': 'Duplicate',
    'army_list_unit.show.edit': 'Edit',
    'army_list_unit.show.model_rules': 'ModelRules',
    'army_list_unit.show.magic': 'Magic',
    'army_list_unit.show.magic_items': 'Magic items',
    'army_list_unit.show.magic_lvl_unit_options':
      'May become (one choice only)',
    'army_list_unit.show.magic_standards': 'Magic banners',
    'army_list_unit.show.magic_unit_options': 'Magic Options',
    'army_list_unit.show.mount_unit_options': 'Mount Options',
    'army_list_unit.show.notes': 'Notes',
    'army_list_unit.show.path_unit_options': 'Must generate spells from',
    'army_list_unit.show.path_unit_options_choose_one':
      'Must generate spells from (choose one)',
    'army_list_unit.show.troops.A': 'A',
    'army_list_unit.show.troops.BS': 'BS',
    'army_list_unit.show.troops.E': 'Evoked',
    'army_list_unit.show.troops.I': 'I',
    'army_list_unit.show.troops.LD': 'Ld',
    'army_list_unit.show.troops.M': 'M',
    'army_list_unit.show.troops.S': 'S',
    'army_list_unit.show.troops.T': 'T',
    'army_list_unit.show.troops.W': 'W',
    'army_list_unit.show.troops.WS': 'WS',
    'army_list_unit.show.troops.name': 'Troops',
    'army_list_unit.show.troops.profile': 'Profile',
    'army_list_unit.show.troops.type': "Troop's type",
    'army_list_unit.show.unit_options': 'Options',
    'army_magic_spell.name': 'Racial Trait Spell',
    'builder.searchs.index.and': 'and',
    'builder.searchs.index.between': 'between',
    'builder.searchs.index.points': 'points',
    'builder.searchs.index.search': 'Search',
    'builder.searchs.index.search_army_select_error':
      'You must select one army',
    'builder.searchs.index.select_army': 'Choise the army',
    'builder.searchs.index.select_points_range': 'Number of point',
    'builder.searchs.index.select_version': 'Choise the version of 9Th Age',
    'builder.searchs.index.title': 'Search an Army list',
    'builder.searchs.show.and': 'and',
    'builder.searchs.show.between': 'between',
    'builder.searchs.show.points': 'points',
    'builder.searchs.show.title': 'Army list found',
    close: 'Close',
    'confirmation.form.email': 'Email',
    'confirmation.form.submit': 'Save',
    'confirmation.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'confirmation.lost.password': 'I have lost my password!',
    'confirmation.title': 'Re-send confirmation instructions',
    'contest.back': 'back',
    'contest.delete.information': 'Are you sure to delete:',
    'contest.delete.submit': '!!! Delete !!!',
    'contest.delete.title': 'Delete contest',
    'contest.edit.title': 'Edit my contest',
    'contest.form.armyListMax.error': 'Your contest need a max points by army',
    'contest.form.armyListMax.placeholder': 'Enter a max points by army',
    'contest.form.armyListMax.title': 'Max points by army',
    'contest.form.endDate.error': 'Your contest need a end date',
    'contest.form.endDate.placeholder': 'Enter a end date',
    'contest.form.endDate.title': 'End date *',
    'contest.form.name.error': 'You must name your list',
    'contest.form.name.placeholder': 'Enter a name',
    'contest.form.name.title': 'Name *',
    'contest.form.participation.error':
      'Your contest need a participation mode',
    'contest.form.participation.placeholder': 'Enter a participation mode',
    'contest.form.participation.title': 'Individual or by Team',
    'contest.form.startDate.error': 'Your contest need a start date',
    'contest.form.startDate.placeholder': 'Enter a start date',
    'contest.form.startDate.title': 'Start date *',
    'contest.form.teamMax.error': 'Your contest need a number of team',
    'contest.form.teamMax.placeholder': 'Enter a number of team',
    'contest.form.teamMax.title': 'Number of team',
    'contest.form.userMax.error':
      'Your contest need a number of participant or team size',
    'contest.form.userMax.placeholder':
      'Enter a number of participant or team size',
    'contest.form.userMax.title': 'Number of participant or team size',
    'contest.form.versionid.error': 'Your contest need a game version',
    'contest.form.versionid.placeholder': 'Enter a game version',
    'contest.form.versionid.title': 'Game version *',
    'contest.name': 'Tournament',
    'contest.new.title': 'Create a contest',
    'contest.show.title': 'Contest: {name}',
    'data_analytics.analytics.title': 'Project: Better data for T9A',
    'data_analytics.report.new.title': 'Report a game',
    'model_rules.index.show': 'Show',
    'model_rules.index.title': 'model rules',
    'export.format': 'Format',
    'export.full': 'Full',
    'export.lite': 'Lite',
    'export.magics': 'Magics',
    'export.nomagics': 'No Magics',
    'export.print': 'print',
    'export.verbosity': 'Verbosity',
    'export.withmagics': 'With magics',
    'folder.add_army_list.form.select': 'Select an army list',
    'folder.add_army_list.title': 'Add a list into this folder',
    'folder.back': 'back',
    'folder.delete.information': 'Are you sure to delete:',
    'folder.delete.submit': '!!! Delete !!!',
    'folder.delete.title': 'Delete folder',
    'folder.edit.title': 'Edit my folder',
    'folder.form.is_share.title': 'Share this folder',
    'folder.form.name.error': 'You must name your list',
    'folder.form.name.placeholder': 'Enter a name',
    'folder.form.name.title': 'Name *',
    'folder.form.parent.placeholder': 'Select the parent',
    'folder.form.parent.title': 'Parent',
    'folder.name': 'Folder',
    'folder.new.title': 'Create a folder',
    'folder.share.title': 'Share folder',
    'folder.show.title': 'Folder: {name}',
    'folder.tournament.information':
      'You can convert this folder into a tournament!',
    'folder.tournament.submit': '!!! Create !!!',
    'folder.tournament.title': 'Create a tournament',
    'footerlink.privacy': 'Privacy Policy',
    'form.add': 'Add',
    'form.cancel': 'Cancel',
    'form.create': 'Create',
    'form.format': 'Format',
    'form.import': 'Import',
    'form.save': 'Save',
    'format.form.date.error': 'You must select a creation date for your list',
    'format.form.date.placeholder': '01/01/2022',
    'format.form.date.title': 'Creation date *',
    'format.form.formated.title': 'Your formated army list',
    'format.form.game.error':
      "You must select the game's name that you want to play",
    'format.form.game.placeholder': 'T9A, EoW, WHB,....',
    'format.form.game.title': 'Your game *',
    'format.form.source.error': 'You must add your list',
    'format.form.source.placeholder': 'Enter an army list',
    'format.form.source.title': 'Your army list *',
    'format.new.title': 'Format and Import an army list',
    help: 'help',
    'home.app.available.google': 'Get it on Google Play',
    'home.app.available.on_platform':
      'Currently under development, available on:',
    'home.app.mobile': 'A mobile app',
    'home.no_account':
      'You can now use all the features of 9ThBuilder without having to create an account first. \nBe careful however, your lists are linked to your local session and therefore will not be available on another browser and may be lost if you delete your cache or your session."\n',
    'home.welcome': '9TH BUILDER',
    'home.whoarewe.compose': 'Compose and archive your favorite armies!',
    'home.whoarewe.description':
      'A passionate of Battle since many years. I took the 9Th Builder since several years, creates a mobile application and helps the 9Th Age administration.\nHelped by Kaos War who greatly contributed to enter army lists and for the new homePage.\n9Th Builder is an effective and easy-to-use tool for creating your army lists and sharing them. It does not generate any income :)\n',
    'home.whoarewe.discord': 'Discord',
    'home.whoarewe.draft': 'Make a team pairing',
    'home.whoarewe.format': 'Format or import your army',
    'home.whoarewe.list': 'Create an Army list',
    'home.whoarewe.newsfb': 'News Facebook',
    'home.whoarewe.paint': 'Create an Paint list',
    'home.whoarewe.readarmy': 'Read Army Books',
    'home.whoarewe.readmagic': 'Read Magic Paths',
    'home.whoarewe.title': 'Who are we?',
    'home.whoarewe.try': 'Do you want to try?',
    'home.whoarewe.whatdo': 'What can you do?',
    'lexicon.index.show': 'Army books \u0026 Tools',
    'magic.casting': 'Casting',
    'magic.effect': 'Effect',
    'magic.index.show': 'Show',
    'magic.index.title': 'Magics',
    'magic.range': 'Range',
    'magic.show.back': 'Back',
    'magic.type': 'Type',
    'magic_item_categories.index.show': 'Show',
    'magic_item_categories.index.title': 'Magic item categories',
    'magic_items.Cbtbmw': 'Cannot be taken by models with',
    'magic_items.Enchantment': 'Enchantment',
    'magic_items.dominant': 'Dominant',
    'magic_items.footonly': 'foot only',
    'magic_items.index.show': 'Show',
    'magic_items.index.title': 'Magic items',
    'magic_items.only': 'only',
    'magic_items.perArmy': 'par Armée',
    'magic_items.type_figurine.All': 'All',
    'magic_items.type_figurine.AnimisteBestial': 'Animiste bestial',
    'magic_items.type_figurine.Character': 'Character',
    'magic_items.type_figurine.FeralOrc': 'Feral Orc',
    'magic_items.type_figurine.Goblins': 'Goblins',
    'magic_items.type_figurine.Infantry': 'Infantry',
    'magic_items.type_figurine.KnightCommanders': 'Knight Commanders',
    'magic_items.type_figurine.MageOnFoot': 'Mage On Foot',
    'magic_items.type_figurine.MarshalsMountedOnHorse':
      'Marshals mounted on Horse',
    'magic_items.type_figurine.ModelsOnChariots': 'models on Chariots',
    'magic_items.type_figurine.ModelsOnFoot': 'Models on foot',
    'magic_items.type_figurine.MonarchsOfTheDead': 'Monarchs of the Dead',
    'magic_items.type_figurine.Monster': 'Monster',
    'magic_items.type_figurine.MountedCharacter': 'Mounted character',
    'magic_items.type_figurine.NoLargeTarget': 'No large target',
    'magic_items.type_figurine.ParentUnit': 'Parent Unit',
    'magic_items.type_figurine.Wizard': 'Wizard',
    'magic_spell.type_lvl.A': 'A',
    'magic_spell.type_lvl.Five': '5',
    'magic_spell.type_lvl.Four': '4',
    'magic_spell.type_lvl.One': '1',
    'magic_spell.type_lvl.Six': '6',
    'magic_spell.type_lvl.Three': '3',
    'magic_spell.type_lvl.Two': '2',
    'magic_spell.type_lvl.Zero': '0',
    'magic_standards.index.show': 'Show',
    'magic_standards.index.title': 'Magic banners',
    'menu.army_lists': 'My army lists',
    'menu.help': 'Help',
    'menu.label': 'Main menu',
    'menu.languages.de': 'Germany',
    'menu.languages.en': 'English',
    'menu.languages.es': 'Spanish - Español',
    'menu.languages.fr': 'French',
    'menu.languages.hu': 'Hungarian',
    'menu.languages.it': 'Italian - Italiano',
    'menu.languages.ko': 'Korean',
    'menu.languages.lang': 'Language',
    'menu.languages.pl': 'Polish',
    'menu.languages.ru': 'Russian',
    'menu.languages.sr': 'Serbian',
    'menu.languages.zh': 'Chinese',
    'menu.preferences': 'Preferences',
    'menu.signin': 'Sign in',
    'menu.signout': 'Sign out',
    'menu.signup': 'Sign up',
    next: 'Next',
    'ninth_age.figurine.mount': 'Mount',
    'ninth_age.figurine.pts': 'pts',
    'ninth_age.magic_item.only_wizard.AllWizard': 'Wizard only',
    'ninth_age.magic_item.only_wizard.NoWizard': 'Cannot be taken by Wizards',
    'ninth_age.magic_item.only_wizard.WizardAdept': 'Wizard adept only',
    'ninth_age.magic_item.only_wizard.WizardApprentice':
      'Wizard apprentice only',
    'ninth_age.magic_item.only_wizard.WizardMaster': 'Wizard master only',
    'ninth_age.troop.offensive': 'Offensive',
    'ninth_age.unit.defensive': 'Defensive',
    'ninth_age.unit.fly': 'fly',
    'ninth_age.unit.global': 'Global',
    'ninth_age.unit.rules': 'Model Rules',
    'paint_list.delete.information': 'Are you sure to destroy this list:',
    'paint_list.delete.submit': '!!! Delete !!!',
    'paint_list.delete.title': 'Delete your list',
    'paint_list.edit.title': 'Edit your paint list',
    'paint_list.form.army.error': 'You must select an army.',
    'paint_list.form.army.placeholder': 'Select an army',
    'paint_list.form.army.title': 'Army *',
    'paint_list.form.name.error': 'You must name your list',
    'paint_list.form.name.placeholder': 'Enter a name',
    'paint_list.form.name.title': 'Name *',
    'paint_list.form.version.error': 'You must select a version.',
    'paint_list.form.version.placeholder': 'Select a version',
    'paint_list.form.version.title': 'Version *',
    'paint_list.index.add': 'Create new paint list',
    'paint_list.index.title': 'My paint lists',
    'paint_list.new.title': 'Create a new list',
    'paint_list.show.assembled': 'Assembled',
    'paint_list.show.buy': 'Buy',
    'paint_list.show.comment': 'Comment',
    'paint_list.show.first_color': 'First color',
    'paint_list.show.paint': 'Paint',
    'paint_list.show.plinth': 'Plinth',
    'paint_list.show.size': 'Size',
    'paint_list.show.state.done': 'Done',
    'paint_list.show.state.waiting': 'Waiting',
    'paint_list.show.state.wip': 'Wip',
    'paint_list.show.title': 'Your Paint list:',
    'paint_list.show.trimmed': 'Trimmed',
    'paint_list.show.unit': 'Unit',
    'paint_list.unit.form.comment.placeholder': 'Add a comment',
    'paint_list.unit.form.comment.title': 'Comment',
    'paint_list.unit.form.size.error': 'You must add a number of model',
    'paint_list.unit.form.size.placeholder': 'Select a size',
    'paint_list.unit.form.size.title': 'Size *',
    'paint_list.unit.form.title': 'Add an unit',
    'paint_list.unit.form.unit.error': 'You must select an unit',
    'paint_list.unit.form.unit.placeholder': 'Select an unit',
    'paint_list.unit.form.unit.title': 'Unit *',
    'password_change.form.confirmation': 'Password confirmation',
    'password_change.form.password': 'Password',
    'password_change.form.submit': 'Save',
    'password_change.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_change.lost.confirmation':
      "I didn't received my confirmation email",
    'password_change.lost.password': 'I have lost my password!',
    'password_change.title': 'Change your password',
    'password_lost.form.email': 'Email',
    'password_lost.form.submit': 'Send me reset password instructions',
    'password_lost.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_lost.lost.confirmation':
      "I didn't received my confirmation email",
    'password_lost.title': 'I have lost my password',
    'picker.datetime.js': 'YYYY.MM.DD HH:mm',
    'picker.datetime.rb': '%Y.%m.%d %H:%M',
    'profile.back': 'Previous page',
    'profile.delete.information':
      'You are not satisfied? \u003ca href="mailto:support@9thbuilder.com"\u003eContact us\u003c/a\u003e or',
    'profile.delete.link': 'immediately destroy your account',
    'profile.delete.title': 'Account deletion',
    'profile.form.confirmation': 'Password confirmation',
    'profile.form.email': 'Email address',
    'profile.form.game': 'Favorite',
    'profile.form.name': 'Name or nickname',
    'profile.form.password': 'Password',
    'profile.form.password_help':
      "Leave it empty if you don't want to change your password",
    'profile.form.submit': 'Save',
    'profile.title': 'My account',
    save: 'Save',
    'search_list.assembled': 'Assembled',
    'search_list.buy': 'Buy',
    'search_list.comment': 'Comment',
    'search_list.first_color': 'First color',
    'search_list.index.search': 'Submit',
    'search_list.index.search_list': 'Search an army list',
    'search_list.paint': 'Paint',
    'search_list.plinth': 'Plinth',
    'search_list.size': 'Size',
    'search_list.trimmed': 'Trimmed',
    'search_list.unit': 'Unit',
    'signin.Confirmation': 'Confirmation',
    'signin.form.email': 'Email',
    'signin.form.lost': 'Forgot ?',
    'signin.form.password': 'Password',
    'signin.form.remember': 'Remember me',
    'signin.form.submit': 'Sign-in',
    'signin.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signin.lost.confirmation': "I didn't received my confirmation email",
    'signin.lost.password': 'I have lost my password!',
    'signin.title': 'Sign in',
    'signup.form.confirmation': 'Password confirmation',
    'signup.form.email': 'Email address',
    'signup.form.game': '--Favorite--',
    'signup.form.name': 'Name or nickname',
    'signup.form.password': 'Password',
    'signup.form.register': 'Join us !',
    'signup.form.submit': 'Sign-up',
    'signup.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signup.lost.confirmation': "I didn't received my confirmation email",
    'signup.lost.password': 'I have lost my password!',
    'signup.title': 'Sign up',
    'site.accept': 'I accept',
    'site.more': 'Learn more',
    'site.use_cookie':
      'This site uses cookies to offer you the best service. By continuing your navigation, you use the use of cookies.',
    'tool.pairing.done': 'Your pairing is complete',
    'tool.pairing.draft.send_link': 'Send this link to your opponent:',
    'tool.pairing.draft.waiting_opponent': 'We are waiting your opponent',
    'tool.pairing.draw.confirm.draw': 'Confirm Draw',
    'tool.pairing.draw.confirm.response': 'Confirm Response',
    'tool.pairing.draw.confirm.select': 'Confirm select',
    'tool.pairing.draw.or': 'or',
    'tool.pairing.draw.vs': 'Vs',
    'tool.pairing.draw_round.select.draw': 'Select one army for the draft',
    'tool.pairing.draw_round.select.response': 'Select your reponses',
    'tool.pairing.draw_round.select.select': 'Select the army',
    'tool.pairing.draw_round.select.waiting': 'Waiting',
    'tool.pairing.image': 'Copy the pairing url image',
    'tool.pairing.inprogress': 'Your pairing is in progress',
    'tool.pairing.matches.tables': 'Tables:',
    'tool.pairing.my_team.my_armies': 'Your armies',
    'tool.pairing.opponent_team.team': 'Team',
    'tool.pairing.select_armies.choise_armies': 'Choise your armies',
    'tool.pairing.select_armies.confirm': 'Confirm',
    'tool.pairing.select_armies.error':
      'Sorry! There was an error loading the items.',
    'tool.pairing.select_armies.your_team': 'Your Team',
    'tool.pairing.select_team_size.how_many': 'How many players in the team?',
    'tool.pairing.table': 'Table',
    'tool.pairing.team_name.confirm': 'Confirm',
    'tool.pairing.team_name.what_name': "What's the name of your team?",
    'tool.pairing.team_name.your_name': 'Your team name',
    'tool.search_rules.index.search': 'Search',
    'tool.search_rules.index.search_army_select_error':
      'You must select one army',
    'tool.search_rules.index.search_rule': 'Choise one rule',
    'tool.search_rules.index.select_army': 'Choise the army',
    'tool.search_rules.index.select_version': 'Choise the version of 9Th Age',
    'tool.search_rules.index.title': 'Search by rules',
    'tournament.contest.back': 'Back to tournaments',
    'tournament.contest.edit': 'Edit',
    'tournament.contest.form.address': 'Address',
    'tournament.contest.form.end_date': 'End',
    'tournament.contest.form.fees': 'Fees',
    'tournament.contest.form.name': 'Name',
    'tournament.contest.form.round_count': 'Rounds',
    'tournament.contest.form.start_date': 'Start',
    'tournament.contest.form.submit': 'Save',
    'tournament.contest.form.team_max': 'Max teams',
    'tournament.contest.form.user_max': 'Max users',
    'tournament.contest.form.user_team_max': 'Max users by team',
    'tournament.contest.form.version': 'Version',
    'tournament.contest.index.title': 'My tournaments',
    'tournament.contest.name': 'Tournament',
    'tournament.contest.new.title': 'Create a tournament',
    'tournament.contest.print_armies': 'Print all armies',
    'tournament.contest.print_repport': 'Rapport',
    'tournament.contest.total': 'Total',
    'tournament.custom_point.name': 'Paint, Wysiwyg, List',
    'tournament.round.add': 'Add round',
    'tournament.round.name': 'Round',
    'tournament.round.pools.validate': 'Create pools',
    'tournament.team.add': 'Add Team',
    'tournament.team.back': 'Back to teams',
    'tournament.team.edit.title': 'Edition team',
    'tournament.team.export.title': 'Team',
    'tournament.team.first': 'Add your first team',
    'tournament.team.form.email': 'Email',
    'tournament.team.form.name': 'Name',
    'tournament.team.form.submit': 'Save',
    'tournament.team.index.title': 'My Tournament teams',
    'tournament.team.name': 'Teams',
    'tournament.team.new.title': 'Add teams',
    'tournament.teams.add': 'Add Team',
    'tournament.teams.back': 'Back to tournaments',
    'tournament.teams.title': 'Teams',
    'tournament.user_apply.add': 'Add Participant',
    'tournament.user_apply.add_into_team': 'Add partipant in this team',
    'tournament.user_apply.army_list.add_now': 'Add it now!',
    'tournament.user_apply.army_list.create': 'Create a new list',
    'tournament.user_apply.army_list.need':
      'You have not added your army list yet.',
    'tournament.user_apply.army_list.or': 'or',
    'tournament.user_apply.army_list.use_existing': 'Use an existing list',
    'tournament.user_apply.army_list.which': 'Which army list ?',
    'tournament.user_apply.army_list_select.form.submit': 'Save',
    'tournament.user_apply.edit.title': 'Edit your participation',
    'tournament.user_apply.first': 'Add your first Participant',
    'tournament.user_apply.form.name': 'Name',
    'tournament.user_apply.form.name_detail':
      'You can add somes users (1 user by line) with email separated by a comma (name, email).',
    'tournament.user_apply.form.or': 'or',
    'tournament.user_apply.form.submit': 'Add',
    'tournament.user_apply.form.user': 'User',
    'tournament.user_apply.manage': 'Manage Team',
    'tournament.user_apply.name': 'User',
    'tournament.user_apply.new.title': 'Add users',
    'tournament.user_apply.remove': 'Remove Participant',
    'tournament.user_apply.share_link': 'Share invitation link',
    'tournament.user_apply.team_leader': 'Is the team captain',
    'unit.base.label': 'Base',
    'unit.height.Gigantic': 'Gigantic',
    'unit.height.Large': 'Large',
    'unit.height.Standard': 'Standard',
    'unit.limit.model': 'Models/Army',
    'unit.limit.perArmy': 'par Armée',
    'unit.limit.single': 'single model',
    'unit.limit.unit': 'Units/Army',
    'unit.mount': 'Mount',
    'unit.show.add_model':
      ' + \u003cstrong\u003e{pts}\u003c/strong\u003e pts/extra model',
    'unit.show.change':
      '{name} utils of {number} models count towards {new_name}',
    'unit.show.change_with_limit':
      'Units of {number} or more models without {limit} count towards {new_name} instead of {old_name}.',
    'unit.show.size':
      '\u003cstrong\u003e{min_size}-{max_size}\u003c/strong\u003e models',
    'unit.size.Gigantic': 'Gigantic',
    'unit.size.Large': 'Large',
    'unit.size.Standard': 'Standard',
    'unit.type.label': 'Type',
    'unit_option.per_model': '/mod.',
    'unit_option.use_points.free': 'free',
    'unit_option.use_points.no_limit': 'no limit',
    'unit_option.use_points.up_to': 'up to',
    'unit_options.category.C': 'C',
    'unit_options.category.M': 'M',
    'unit_options.category.S': 'S',
    'unit_options.footonly': 'foot only',
    'version.index.pairing': 'Team Pairing',
    'version.index.search': 'Search by rule',
    'version.index.show': 'Show',
    'version.index.title': 'Versions',
    'version.index.tools': 'Tools',
    'version.show.back': 'Back',
    welcome: 'Welcome',
    with: 'with %',
    without: 'without %',
  },
  el: {
    Common: 'Common',
    'active_admin.menu.admin': 'Administration',
    'active_admin.menu.armies': 'Armies',
    'active_admin.menu.builder': 'Builder',
    'active_admin.menu.dashboard': 'Administration',
    'active_admin.menu.import': 'Import',
    'active_admin.menu.log': 'Log',
    'active_admin.menu.magic': 'magic',
    'active_admin.menu.map': 'Maps',
    'active_admin.menu.ninth_age': 'Ninth Age',
    'active_admin.menu.organisation': 'Organisation',
    'active_admin.menu.paint': 'Paint',
    'active_admin.menu.statistique': 'Statistiques',
    'active_admin.menu.tournament': 'Tournament',
    'active_admin.menu.unit': 'Unit',
    'active_admin.menu.user_annoncement': 'Annoncements',
    'active_admin.menu.users': 'Users',
    'active_admin.menu.versioning': 'Versioning',
    'active_admin.translate.ko': 'Korean',
    'active_admin.translate.pl': 'Polish',
    'active_admin.translate.ru': 'Russian',
    'active_admin.translate.zh': 'Chinese',
    'activerecord.attributes.data_analytics/report.deployments.CounterThrust':
      'Counter Thrust',
    'activerecord.attributes.data_analytics/report.deployments.DawnAssult':
      'Dawn Assult',
    'activerecord.attributes.data_analytics/report.deployments.Encircle':
      'Encircle',
    'activerecord.attributes.data_analytics/report.deployments.FrontlineClash':
      'Frontline Clash',
    'activerecord.attributes.data_analytics/report.deployments.MarchingColumns':
      'Marching Columns',
    'activerecord.attributes.data_analytics/report.deployments.RefusedFlank':
      'Refused Flank',
    'activerecord.attributes.data_analytics/report.maps.A1':
      'A1 - Shrouded Pool',
    'activerecord.attributes.data_analytics/report.maps.A2':
      'A2 - Foothill Outpost',
    'activerecord.attributes.data_analytics/report.maps.A3':
      'A3 - Dilapidated Manor',
    'activerecord.attributes.data_analytics/report.maps.A4':
      'A4 - Volcanic Lake',
    'activerecord.attributes.data_analytics/report.maps.A5':
      'A5 - Misty Marshes',
    'activerecord.attributes.data_analytics/report.maps.A6':
      'A6 - Ancient Walls',
    'activerecord.attributes.data_analytics/report.maps.A7': 'A7 - Beacon Hill',
    'activerecord.attributes.data_analytics/report.maps.A8':
      'A8 - Witch’s Cottage',
    'activerecord.attributes.data_analytics/report.maps.B1':
      'B1 - Mage’s Sanctum',
    'activerecord.attributes.data_analytics/report.maps.B2':
      'B2 - Villa Grounds',
    'activerecord.attributes.data_analytics/report.maps.B3':
      'B3 - Ancient Fortress',
    'activerecord.attributes.data_analytics/report.maps.B4':
      'B4 - Frontier Farm',
    'activerecord.attributes.data_analytics/report.maps.B5':
      'B5 - Ravaged Watchtower',
    'activerecord.attributes.data_analytics/report.maps.B6':
      'B6 - Creeping Forest',
    'activerecord.attributes.data_analytics/report.maps.B7':
      'B7 - Eerie Graveyard',
    'activerecord.attributes.data_analytics/report.maps.B8':
      'B8 - Shattered Bridge',
    'activerecord.attributes.data_analytics/report.objectives.Breakthrough':
      'Breakthrough',
    'activerecord.attributes.data_analytics/report.objectives.CaptureFlags':
      'Capture the Flags',
    'activerecord.attributes.data_analytics/report.objectives.HoldGround':
      'Hold the Ground',
    'activerecord.attributes.data_analytics/report.objectives.KingHill':
      'King of the Hill',
    'activerecord.attributes.data_analytics/report.objectives.SecureTarget':
      'Secure Target',
    'activerecord.attributes.data_analytics/report.objectives.SpoilsWar':
      'Spoils of War',
    'activerecord.attributes.data_analytics/report.opponent_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.opponent_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.opponent_objective':
      'Take the objective',
    'activerecord.attributes.data_analytics/report.your_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.your_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.your_objective':
      'Take the objective',
    'activerecord.attributes.ninth_age/magic_item.only_foot':
      'Prohibited mount',
    'activerecord.attributes.ninth_age/magic_item.only_wizard':
      'Only wizard can use it',
    'activerecord.attributes.ninth_age/magic_item.organisation_ids':
      'Organisations required from the model',
    'activerecord.attributes.ninth_age/magic_item.model_rule_ids':
      'Prohibited  model rules on model',
    'activerecord.attributes.ninth_age/magic_item.unit_ids':
      'For this units only',
    'activerecord.attributes.ninth_age/magic_item.unit_size':
      'Unit with this size can not use this item',
    'activerecord.attributes.ninth_age/magic_standard.organisation':
      'Add organisation to unit',
    'activerecord.attributes.ninth_age/magic_standard.organisation_ids':
      "Only organisation's units",
    'activerecord.attributes.ninth_age/troop.carac_agi': 'Agi',
    'activerecord.attributes.ninth_age/troop.carac_ap': 'Ap',
    'activerecord.attributes.ninth_age/troop.carac_att': 'Att',
    'activerecord.attributes.ninth_age/troop.carac_of': 'Off',
    'activerecord.attributes.ninth_age/troop.carac_str': 'Str',
    'activerecord.attributes.ninth_age/unit.carac_aeg': 'Aeg',
    'activerecord.attributes.ninth_age/unit.carac_arm': 'Arm',
    'activerecord.attributes.ninth_age/unit.carac_def': 'Def',
    'activerecord.attributes.ninth_age/unit.carac_dis': 'Dis',
    'activerecord.attributes.ninth_age/unit.carac_evoked': 'Rea',
    'activerecord.attributes.ninth_age/unit.carac_fly_adv': 'Fly adv',
    'activerecord.attributes.ninth_age/unit.carac_fly_mar': 'Fly mar',
    'activerecord.attributes.ninth_age/unit.carac_ground_adv': 'Adv',
    'activerecord.attributes.ninth_age/unit.carac_ground_mar': 'Mar',
    'activerecord.attributes.ninth_age/unit.carac_hp': 'HP',
    'activerecord.attributes.ninth_age/unit.carac_res': 'Res',
    'activerecord.attributes.ninth_age_army.source.FanMade': 'Fan Made',
    'activerecord.attributes.ninth_age_army.source.Official': 'Official',
    'activerecord.attributes.ninth_age_army.source.Supplement': 'Supplement',
    'activerecord.attributes.ninth_age_unit_option.category.BSB':
      'Battle Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.C': 'Champion',
    'activerecord.attributes.ninth_age_unit_option.category.ModelRule':
      'ModelRule',
    'activerecord.attributes.ninth_age_unit_option.category.ExtraSpells':
      'Spells',
    'activerecord.attributes.ninth_age_unit_option.category.General': 'General',
    'activerecord.attributes.ninth_age_unit_option.category.Generic': 'Generic',
    'activerecord.attributes.ninth_age_unit_option.category.M': 'Musician',
    'activerecord.attributes.ninth_age_unit_option.category.MagicBanner':
      'Banner Enchantment',
    'activerecord.attributes.ninth_age_unit_option.category.MagicEquipment':
      'Magic items',
    'activerecord.attributes.ninth_age_unit_option.category.MagicLvl':
      'Magic LVL',
    'activerecord.attributes.ninth_age_unit_option.category.MagicPath':
      'Magic Path',
    'activerecord.attributes.ninth_age_unit_option.category.MayTake':
      'May take',
    'activerecord.attributes.ninth_age_unit_option.category.Mount': 'Mount',
    'activerecord.attributes.ninth_age_unit_option.category.MustChoice':
      'Must choose',
    'activerecord.attributes.ninth_age_unit_option.category.OneChoice':
      'One choice only',
    'activerecord.attributes.ninth_age_unit_option.category.S':
      'Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.SpecialRule':
      'Special Rule',
    'activerecord.attributes.ninth_age_unit_option.category.WizardAdept':
      'Wizard Adept',
    'activerecord.attributes.ninth_age_unit_option.category.WizardApprentice':
      'Wizard Apprentice',
    'activerecord.attributes.ninth_age_unit_option.category.WizardMaster':
      'Wizard Master',
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ChangeUnitOrganisation':
      "Change unit's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ExcludeAddOrganisation':
      "Not affected with other unit option's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.Unit':
      'All the unit',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Add':
      'Add',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Replace':
      'Replace',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.A':
      'V1-A',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.BS':
      'V1-BS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.E':
      'V1-E',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.I':
      'V1-I',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.LD':
      'V1-Ld',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.M':
      'V1-M',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.S':
      'V1-S',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.T':
      'V1-T',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.W':
      'V1-W',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.WS':
      'V1-WS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_aeg':
      'V2-Aeg',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_agi':
      'V2-Agi',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ap':
      'V2-Ap',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_arm':
      'V2-Arm',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_att':
      'V2-Att',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_def':
      'V2-Def',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_dis':
      'V2-Dis',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_evoked':
      'V2-Evoked',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_adv':
      'V2-Fly-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_mar':
      'V2-Fly-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_adv':
      'V2-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_mar':
      'V2-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_hp':
      'V2-Hp',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_of':
      'V2-Of',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_res':
      'V2-Res',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_str':
      'V2-Str',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByArmy':
      'per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByModel':
      'item per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.MaxRatioByArmy':
      'Max Ratio per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Model':
      'Models per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ModelByUnit':
      'Models per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Units':
      'Units per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Quantity':
      'Quantity from the option',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Selection':
      'Option selected',
    'activerecord.attributes.ninth_age_version.game.EssenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.WarhammerBattle':
      'Warhammer Battle',
    'activerecord.attributes.ninth_age_version.game.essenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.ninthAge': 'Ninth Age',
    'activerecord.attributes.ninth_age_version.game.battle': 'Warhammer Battle',
    'activerecord.attributes.tournament/contest.participation': 'Participation',
    'activerecord.models.ninth_age/magic_standard.one': 'Magic banner',
    'activerecord.models.ninth_age/magic_standard.other': 'Magic banners',
    'activerecord.models.ninth_age/unit.one': 'Unit',
    'activerecord.models.ninth_age/unit.other': 'Units',
    'admin.dashboard': 'Administration',
    'admin.tournament': 'Tournament Org',
    and: ' and ',
    'army.armybook': 'Army book',
    'army.banner': 'Banner enchantement',
    'army.index.show': 'Show',
    'army.index.title': 'All armies',
    'army.show.back': 'Back',
    'army_list.clone.information': 'Are you sure to duplicate list:',
    'army_list.clone.submit': 'Duplicate',
    'army_list.clone.title': 'Duplicate list',
    'army_list.delete.information': 'Are you sure to destroy this list:',
    'army_list.delete.submit': '!!! Delete !!!',
    'army_list.delete.title': 'Delete\u003cbr /\u003elist',
    'army_list.edit.title': 'Update the list',
    'army_list.export.html_full': 'Full HTML',
    'army_list.export.html_lite': 'Lite HTML',
    'army_list.export.include_magics': 'Include magic paths?',
    'army_list.export.information': 'Choose format for list export:',
    'army_list.export.pdf_full': 'Full PDF',
    'army_list.export.pdf_lite': 'Lite PDF',
    'army_list.export.print': 'Print',
    'army_list.export.separator': 'Separator',
    'army_list.export.title': 'Export list',
    'army_list.export.txt.general': 'General',
    'army_list.export.verbosity': 'Verbosity',
    'army_list.form.army.error': 'You must select an army.',
    'army_list.form.army.placeholder': 'Select an army',
    'army_list.form.army.title': 'Army *',
    'army_list.form.folder.placeholder': 'Select a folder',
    'army_list.form.folder.title': 'Folder',
    'army_list.form.max.name': 'You must choose the max of your army',
    'army_list.form.max.placeholder': 'Enter a max',
    'army_list.form.max.title': 'Max *',
    'army_list.form.name.error': 'You must name your list',
    'army_list.form.name.placeholder': 'Enter a name',
    'army_list.form.name.title': 'Name *',
    'army_list.form.notes.placeholder': 'My notes',
    'army_list.form.notes.title': 'Notes',
    'army_list.form.private.title': 'is a private list',
    'army_list.form.rate.title': 'Rate with max',
    'army_list.form.version.error': 'You must select a version.',
    'army_list.form.version.placeholder': 'Select a version',
    'army_list.form.version.title': 'Version *',
    'army_list.format.title': 'Format \u0026 Import an army list',
    'army_list.index.add': 'Create new army list',
    'army_list.index.and': 'and',
    'army_list.index.contest': 'Create a contest',
    'army_list.index.filter': 'Filter by',
    'army_list.index.folder': 'Create new folder',
    'army_list.index.name_or_notes': 'Name or notes',
    'army_list.index.search': 'Submit',
    'army_list.index.title': 'My army lists',
    'army_list.new.title': 'Create new list',
    'army_list.show.add_unit': 'Add unit',
    'army_list.show.delete': 'Delete',
    'army_list.show.duplicate': 'Duplicate',
    'army_list.show.edit': 'Edit',
    'army_list.show.export': 'Export',
    'army_list.show.notes': 'Notes',
    'army_list.show.organisation.excess': 'Excess',
    'army_list.show.organisation.missing': 'Missing',
    'army_list.show.organisation.remaining': 'Remaining',
    'army_list.show.print': 'Print',
    'army_list.show.rearrange_units': 'Rearrange Units',
    'army_list.show.title': 'Army list • {name}',
    'army_list.unit.form.name.placeholder': 'Add a name',
    'army_list.unit.form.name.title': 'Name',
    'army_list.unit.form.title': 'Add an unit',
    'army_list.unit.form.unit.error': 'You must select an unit',
    'army_list.unit.form.unit.placeholder': 'Select an unit',
    'army_list.unit.form.unit.title': 'Unit *',
    'army_list_unit.delete.information': 'Are you sure to destroy this unit:',
    'army_list_unit.delete.submit': '!!! Delete !!!',
    'army_list_unit.delete.title': 'Delete\u003cbr /\u003eunit',
    'army_list_unit.duplicate.new_army_list': 'New {name} list',
    'army_list_unit.duplicate.target': 'To:',
    'army_list_unit.duplicate.title': 'Duplicate',
    'army_list_unit.edit.form.magic': 'Magic',
    'army_list_unit.edit.form.notes': 'Notes',
    'army_list_unit.edit.magic_items': 'Magic items',
    'army_list_unit.edit.magic_standards': 'Magic banners',
    'army_list_unit.edit.options': 'Options',
    'army_list_unit.edit.title': 'Edit',
    'army_list_unit.form.name': 'Name',
    'army_list_unit.form.submit': 'Create Unit',
    'army_list_unit.new.title': 'Add new unit',
    'army_list_unit.show.command_group_unit_options': 'Command Group Options',
    'army_list_unit.show.delete': 'Delete',
    'army_list_unit.show.duplicate': 'Duplicate',
    'army_list_unit.show.edit': 'Edit',
    'army_list_unit.show.model_rules': 'ModelRules',
    'army_list_unit.show.magic': 'Magic',
    'army_list_unit.show.magic_items': 'Magic items',
    'army_list_unit.show.magic_lvl_unit_options':
      'May become (one choice only)',
    'army_list_unit.show.magic_standards': 'Magic banners',
    'army_list_unit.show.magic_unit_options': 'Magic Options',
    'army_list_unit.show.mount_unit_options': 'Mount Options',
    'army_list_unit.show.notes': 'Notes',
    'army_list_unit.show.path_unit_options': 'Must generate spells from',
    'army_list_unit.show.path_unit_options_choose_one':
      'Must generate spells from (choose one)',
    'army_list_unit.show.troops.A': 'A',
    'army_list_unit.show.troops.BS': 'BS',
    'army_list_unit.show.troops.E': 'Evoked',
    'army_list_unit.show.troops.I': 'I',
    'army_list_unit.show.troops.LD': 'Ld',
    'army_list_unit.show.troops.M': 'M',
    'army_list_unit.show.troops.S': 'S',
    'army_list_unit.show.troops.T': 'T',
    'army_list_unit.show.troops.W': 'W',
    'army_list_unit.show.troops.WS': 'WS',
    'army_list_unit.show.troops.name': 'Troops',
    'army_list_unit.show.troops.profile': 'Profile',
    'army_list_unit.show.troops.type': "Troop's type",
    'army_list_unit.show.unit_options': 'Options',
    'army_magic_spell.name': 'Racial Trait Spell',
    'builder.searchs.index.and': 'and',
    'builder.searchs.index.between': 'between',
    'builder.searchs.index.points': 'points',
    'builder.searchs.index.search': 'Search',
    'builder.searchs.index.search_army_select_error':
      'You must select one army',
    'builder.searchs.index.select_army': 'Choise the army',
    'builder.searchs.index.select_points_range': 'Number of point',
    'builder.searchs.index.select_version': 'Choise the version of 9Th Age',
    'builder.searchs.index.title': 'Search an Army list',
    'builder.searchs.show.and': 'and',
    'builder.searchs.show.between': 'between',
    'builder.searchs.show.points': 'points',
    'builder.searchs.show.title': 'Army list found',
    close: 'Close',
    'confirmation.form.email': 'Email',
    'confirmation.form.submit': 'Save',
    'confirmation.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'confirmation.lost.password': 'I have lost my password!',
    'confirmation.title': 'Re-send confirmation instructions',
    'contest.back': 'back',
    'contest.delete.information': 'Are you sure to delete:',
    'contest.delete.submit': '!!! Delete !!!',
    'contest.delete.title': 'Delete contest',
    'contest.edit.title': 'Edit my contest',
    'contest.form.armyListMax.error': 'Your contest need a max points by army',
    'contest.form.armyListMax.placeholder': 'Enter a max points by army',
    'contest.form.armyListMax.title': 'Max points by army',
    'contest.form.endDate.error': 'Your contest need a end date',
    'contest.form.endDate.placeholder': 'Enter a end date',
    'contest.form.endDate.title': 'End date *',
    'contest.form.name.error': 'You must name your list',
    'contest.form.name.placeholder': 'Enter a name',
    'contest.form.name.title': 'Name *',
    'contest.form.participation.error':
      'Your contest need a participation mode',
    'contest.form.participation.placeholder': 'Enter a participation mode',
    'contest.form.participation.title': 'Individual or by Team',
    'contest.form.startDate.error': 'Your contest need a start date',
    'contest.form.startDate.placeholder': 'Enter a start date',
    'contest.form.startDate.title': 'Start date *',
    'contest.form.teamMax.error': 'Your contest need a number of team',
    'contest.form.teamMax.placeholder': 'Enter a number of team',
    'contest.form.teamMax.title': 'Number of team',
    'contest.form.userMax.error':
      'Your contest need a number of participant or team size',
    'contest.form.userMax.placeholder':
      'Enter a number of participant or team size',
    'contest.form.userMax.title': 'Number of participant or team size',
    'contest.form.versionid.error': 'Your contest need a game version',
    'contest.form.versionid.placeholder': 'Enter a game version',
    'contest.form.versionid.title': 'Game version *',
    'contest.name': 'Tournament',
    'contest.new.title': 'Create a contest',
    'contest.show.title': 'Contest: {name}',
    'data_analytics.analytics.title': 'Project: Better data for T9A',
    'data_analytics.report.new.title': 'Report a game',
    'model_rules.index.show': 'Show',
    'model_rules.index.title': 'model rules',
    'export.format': 'Format',
    'export.full': 'Full',
    'export.lite': 'Lite',
    'export.magics': 'Magics',
    'export.nomagics': 'No Magics',
    'export.print': 'print',
    'export.verbosity': 'Verbosity',
    'export.withmagics': 'With magics',
    'folder.add_army_list.form.select': 'Select an army list',
    'folder.add_army_list.title': 'Add a list into this folder',
    'folder.back': 'back',
    'folder.delete.information': 'Are you sure to delete:',
    'folder.delete.submit': '!!! Delete !!!',
    'folder.delete.title': 'Delete folder',
    'folder.edit.title': 'Edit my folder',
    'folder.form.is_share.title': 'Share this folder',
    'folder.form.name.error': 'You must name your list',
    'folder.form.name.placeholder': 'Enter a name',
    'folder.form.name.title': 'Name *',
    'folder.form.parent.placeholder': 'Select the parent',
    'folder.form.parent.title': 'Parent',
    'folder.name': 'Folder',
    'folder.new.title': 'Create a folder',
    'folder.share.title': 'Share folder',
    'folder.show.title': 'Folder: {name}',
    'folder.tournament.information':
      'You can convert this folder into a tournament!',
    'folder.tournament.submit': '!!! Create !!!',
    'folder.tournament.title': 'Create a tournament',
    'footerlink.privacy': 'Privacy Policy',
    'form.add': 'Add',
    'form.cancel': 'Cancel',
    'form.create': 'Create',
    'form.format': 'Format',
    'form.import': 'Import',
    'form.save': 'Save',
    'format.form.date.error': 'You must select a creation date for your list',
    'format.form.date.placeholder': '01/01/2022',
    'format.form.date.title': 'Creation date *',
    'format.form.formated.title': 'Your formated army list',
    'format.form.game.error':
      "You must select the game's name that you want to play",
    'format.form.game.placeholder': 'T9A, EoW, WHB,....',
    'format.form.game.title': 'Your game *',
    'format.form.source.error': 'You must add your list',
    'format.form.source.placeholder': 'Enter an army list',
    'format.form.source.title': 'Your army list *',
    'format.new.title': 'Format and Import an army list',
    help: 'help',
    'home.app.available.google': 'Get it on Google Play',
    'home.app.available.on_platform':
      'Currently under development, available on:',
    'home.app.mobile': 'A mobile app',
    'home.no_account':
      'You can now use all the features of 9ThBuilder without having to create an account first. \nBe careful however, your lists are linked to your local session and therefore will not be available on another browser and may be lost if you delete your cache or your session."\n',
    'home.welcome': '9TH BUILDER',
    'home.whoarewe.compose': 'Compose and archive your favorite armies!',
    'home.whoarewe.description':
      'A passionate of Battle since many years. I took the 9Th Builder since several years, creates a mobile application and helps the 9Th Age administration.\nHelped by Kaos War who greatly contributed to enter army lists and for the new homePage.\n9Th Builder is an effective and easy-to-use tool for creating your army lists and sharing them. It does not generate any income :)\n',
    'home.whoarewe.discord': 'Discord',
    'home.whoarewe.draft': 'Make a team pairing',
    'home.whoarewe.format': 'Format or import your army',
    'home.whoarewe.list': 'Create an Army list',
    'home.whoarewe.newsfb': 'News Facebook',
    'home.whoarewe.paint': 'Create an Paint list',
    'home.whoarewe.readarmy': 'Read Army Books',
    'home.whoarewe.readmagic': 'Read Magic Paths',
    'home.whoarewe.title': 'Who are we?',
    'home.whoarewe.try': 'Do you want to try?',
    'home.whoarewe.whatdo': 'What can you do?',
    'lexicon.index.show': 'Army books \u0026 Tools',
    'magic.casting': 'Casting',
    'magic.duration': 'Duration',
    'magic.effect': 'Effect',
    'magic.index.show': 'Show',
    'magic.index.title': 'Magics',
    'magic.range': 'Range',
    'magic.show.back': 'Back',
    'magic.type': 'Type',
    'magic_item_categories.index.show': 'Show',
    'magic_item_categories.index.title': 'Magic item categories',
    'magic_items.Cbtbmw': 'Cannot be taken by models with',
    'magic_items.Enchantment': 'Enchantment',
    'magic_items.dominant': 'Dominant',
    'magic_items.footonly': 'foot only',
    'magic_items.index.show': 'Show',
    'magic_items.index.title': 'Magic items',
    'magic_items.only': 'only',
    'magic_items.perArmy': 'par Armée',
    'magic_items.type_figurine.All': 'All',
    'magic_items.type_figurine.AnimisteBestial': 'Animiste bestial',
    'magic_items.type_figurine.Character': 'Character',
    'magic_items.type_figurine.FeralOrc': 'Feral Orc',
    'magic_items.type_figurine.Goblins': 'Goblins',
    'magic_items.type_figurine.Infantry': 'Infantry',
    'magic_items.type_figurine.KnightCommanders': 'Knight Commanders',
    'magic_items.type_figurine.MageOnFoot': 'Mage On Foot',
    'magic_items.type_figurine.MarshalsMountedOnHorse':
      'Marshals mounted on Horse',
    'magic_items.type_figurine.ModelsOnChariots': 'models on Chariots',
    'magic_items.type_figurine.ModelsOnFoot': 'Models on foot',
    'magic_items.type_figurine.MonarchsOfTheDead': 'Monarchs of the Dead',
    'magic_items.type_figurine.Monster': 'Monster',
    'magic_items.type_figurine.MountedCharacter': 'Mounted character',
    'magic_items.type_figurine.NoLargeTarget': 'No large target',
    'magic_items.type_figurine.ParentUnit': 'Parent Unit',
    'magic_items.type_figurine.Wizard': 'Wizard',
    'magic_spell.type_lvl.A': 'A',
    'magic_spell.type_lvl.Five': '5',
    'magic_spell.type_lvl.Four': '4',
    'magic_spell.type_lvl.One': '1',
    'magic_spell.type_lvl.Six': '6',
    'magic_spell.type_lvl.Three': '3',
    'magic_spell.type_lvl.Two': '2',
    'magic_spell.type_lvl.Zero': '0',
    'magic_standards.index.show': 'Show',
    'magic_standards.index.title': 'Magic banners',
    'menu.army_lists': 'My army lists',
    'menu.help': 'Help',
    'menu.label': 'Main menu',
    'menu.languages.de': 'Germany',
    'menu.languages.en': 'English',
    'menu.languages.es': 'Spanish - Español',
    'menu.languages.fr': 'French',
    'menu.languages.hu': 'Hungarian',
    'menu.languages.it': 'Italian - Italiano',
    'menu.languages.ko': 'Korean',
    'menu.languages.lang': 'Language',
    'menu.languages.pl': 'Polish',
    'menu.languages.ru': 'Russian',
    'menu.languages.sr': 'Serbian',
    'menu.languages.zh': 'Chinese',
    'menu.preferences': 'Preferences',
    'menu.signin': 'Sign in',
    'menu.signout': 'Sign out',
    'menu.signup': 'Sign up',
    next: 'Next',
    'ninth_age.figurine.mount': 'Mount',
    'ninth_age.figurine.pts': 'pts',
    'ninth_age.magic_item.only_wizard.AllWizard': 'Wizard only',
    'ninth_age.magic_item.only_wizard.NoWizard': 'Cannot be taken by Wizards',
    'ninth_age.magic_item.only_wizard.WizardAdept': 'Wizard adept only',
    'ninth_age.magic_item.only_wizard.WizardApprentice':
      'Wizard apprentice only',
    'ninth_age.magic_item.only_wizard.WizardMaster': 'Wizard master only',
    'ninth_age.troop.offensive': 'Offensive',
    'ninth_age.unit.defensive': 'Defensive',
    'ninth_age.unit.fly': 'fly',
    'ninth_age.unit.global': 'Global',
    'ninth_age.unit.rules': 'Model Rules',
    'paint_list.delete.information': 'Are you sure to destroy this list:',
    'paint_list.delete.submit': '!!! Delete !!!',
    'paint_list.delete.title': 'Delete your list',
    'paint_list.edit.title': 'Edit your paint list',
    'paint_list.form.army.error': 'You must select an army.',
    'paint_list.form.army.placeholder': 'Select an army',
    'paint_list.form.army.title': 'Army *',
    'paint_list.form.name.error': 'You must name your list',
    'paint_list.form.name.placeholder': 'Enter a name',
    'paint_list.form.name.title': 'Name *',
    'paint_list.form.version.error': 'You must select a version.',
    'paint_list.form.version.placeholder': 'Select a version',
    'paint_list.form.version.title': 'Version *',
    'paint_list.index.add': 'Create new paint list',
    'paint_list.index.title': 'My paint lists',
    'paint_list.new.title': 'Create a new list',
    'paint_list.show.assembled': 'Assembled',
    'paint_list.show.buy': 'Buy',
    'paint_list.show.comment': 'Comment',
    'paint_list.show.first_color': 'First color',
    'paint_list.show.paint': 'Paint',
    'paint_list.show.plinth': 'Plinth',
    'paint_list.show.size': 'Size',
    'paint_list.show.state.done': 'Done',
    'paint_list.show.state.waiting': 'Waiting',
    'paint_list.show.state.wip': 'Wip',
    'paint_list.show.title': 'Your Paint list:',
    'paint_list.show.trimmed': 'Trimmed',
    'paint_list.show.unit': 'Unit',
    'paint_list.unit.form.comment.placeholder': 'Add a comment',
    'paint_list.unit.form.comment.title': 'Comment',
    'paint_list.unit.form.size.error': 'You must add a number of model',
    'paint_list.unit.form.size.placeholder': 'Select a size',
    'paint_list.unit.form.size.title': 'Size *',
    'paint_list.unit.form.title': 'Add an unit',
    'paint_list.unit.form.unit.error': 'You must select an unit',
    'paint_list.unit.form.unit.placeholder': 'Select an unit',
    'paint_list.unit.form.unit.title': 'Unit *',
    'password_change.form.confirmation': 'Password confirmation',
    'password_change.form.password': 'Password',
    'password_change.form.submit': 'Save',
    'password_change.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_change.lost.confirmation':
      "I didn't received my confirmation email",
    'password_change.lost.password': 'I have lost my password!',
    'password_change.title': 'Change your password',
    'password_lost.form.email': 'Email',
    'password_lost.form.submit': 'Send me reset password instructions',
    'password_lost.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_lost.lost.confirmation':
      "I didn't received my confirmation email",
    'password_lost.title': 'I have lost my password',
    'picker.datetime.js': 'YYYY.MM.DD HH:mm',
    'picker.datetime.rb': '%Y.%m.%d %H:%M',
    'profile.back': 'Previous page',
    'profile.delete.information':
      'You are not satisfied? \u003ca href="mailto:support@9thbuilder.com"\u003eContact us\u003c/a\u003e or',
    'profile.delete.link': 'immediately destroy your account',
    'profile.delete.title': 'Account deletion',
    'profile.form.confirmation': 'Password confirmation',
    'profile.form.email': 'Email address',
    'profile.form.game': 'Favorite',
    'profile.form.name': 'Name or nickname',
    'profile.form.password': 'Password',
    'profile.form.password_help':
      "Leave it empty if you don't want to change your password",
    'profile.form.submit': 'Save',
    'profile.title': 'My account',
    save: 'Save',
    'search_list.assembled': 'Assembled',
    'search_list.buy': 'Buy',
    'search_list.comment': 'Comment',
    'search_list.first_color': 'First color',
    'search_list.index.search': 'Submit',
    'search_list.index.search_list': 'Search an army list',
    'search_list.paint': 'Paint',
    'search_list.plinth': 'Plinth',
    'search_list.size': 'Size',
    'search_list.trimmed': 'Trimmed',
    'search_list.unit': 'Unit',
    'signin.Confirmation': 'Confirmation',
    'signin.form.email': 'Email',
    'signin.form.lost': 'Forgot ?',
    'signin.form.password': 'Password',
    'signin.form.remember': 'Remember me',
    'signin.form.submit': 'Sign-in',
    'signin.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signin.lost.confirmation': "I didn't received my confirmation email",
    'signin.lost.password': 'I have lost my password!',
    'signin.title': 'Sign in',
    'signup.form.confirmation': 'Password confirmation',
    'signup.form.email': 'Email address',
    'signup.form.game': '--Favorite--',
    'signup.form.name': 'Name or nickname',
    'signup.form.password': 'Password',
    'signup.form.register': 'Join us !',
    'signup.form.submit': 'Sign-up',
    'signup.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signup.lost.confirmation': "I didn't received my confirmation email",
    'signup.lost.password': 'I have lost my password!',
    'signup.title': 'Sign up',
    'site.accept': 'I accept',
    'site.more': 'Learn more',
    'site.use_cookie':
      'This site uses cookies to offer you the best service. By continuing your navigation, you use the use of cookies.',
    'tool.pairing.done': 'Your pairing is complete',
    'tool.pairing.draft.send_link': 'Send this link to your opponent:',
    'tool.pairing.draft.waiting_opponent': 'We are waiting your opponent',
    'tool.pairing.draw.confirm.draw': 'Confirm Draw',
    'tool.pairing.draw.confirm.response': 'Confirm Response',
    'tool.pairing.draw.confirm.select': 'Confirm select',
    'tool.pairing.draw.or': 'or',
    'tool.pairing.draw.vs': 'Vs',
    'tool.pairing.draw_round.select.draw': 'Select one army for the draft',
    'tool.pairing.draw_round.select.response': 'Select your reponses',
    'tool.pairing.draw_round.select.select': 'Select the army',
    'tool.pairing.draw_round.select.waiting': 'Waiting',
    'tool.pairing.image': 'Copy the pairing url image',
    'tool.pairing.inprogress': 'Your pairing is in progress',
    'tool.pairing.matches.tables': 'Tables:',
    'tool.pairing.my_team.my_armies': 'Your armies',
    'tool.pairing.opponent_team.team': 'Team',
    'tool.pairing.select_armies.choise_armies': 'Choise your armies',
    'tool.pairing.select_armies.confirm': 'Confirm',
    'tool.pairing.select_armies.error':
      'Sorry! There was an error loading the items.',
    'tool.pairing.select_armies.your_team': 'Your Team',
    'tool.pairing.select_team_size.how_many': 'How many players in the team?',
    'tool.pairing.table': 'Table',
    'tool.pairing.team_name.confirm': 'Confirm',
    'tool.pairing.team_name.what_name': "What's the name of your team?",
    'tool.pairing.team_name.your_name': 'Your team name',
    'tool.search_rules.index.search': 'Search',
    'tool.search_rules.index.search_army_select_error':
      'You must select one army',
    'tool.search_rules.index.search_rule': 'Choise one rule',
    'tool.search_rules.index.select_army': 'Choise the army',
    'tool.search_rules.index.select_version': 'Choise the version of 9Th Age',
    'tool.search_rules.index.title': 'Search by rules',
    'tournament.contest.back': 'Back to tournaments',
    'tournament.contest.edit': 'Edit',
    'tournament.contest.form.address': 'Address',
    'tournament.contest.form.end_date': 'End',
    'tournament.contest.form.fees': 'Fees',
    'tournament.contest.form.name': 'Name',
    'tournament.contest.form.round_count': 'Rounds',
    'tournament.contest.form.start_date': 'Start',
    'tournament.contest.form.submit': 'Save',
    'tournament.contest.form.team_max': 'Max teams',
    'tournament.contest.form.user_max': 'Max users',
    'tournament.contest.form.user_team_max': 'Max users by team',
    'tournament.contest.form.version': 'Version',
    'tournament.contest.index.title': 'My tournaments',
    'tournament.contest.name': 'Tournament',
    'tournament.contest.new.title': 'Create a tournament',
    'tournament.contest.print_armies': 'Print all armies',
    'tournament.contest.print_repport': 'Rapport',
    'tournament.contest.total': 'Total',
    'tournament.custom_point.name': 'Paint, Wysiwyg, List',
    'tournament.round.add': 'Add round',
    'tournament.round.name': 'Round',
    'tournament.round.pools.validate': 'Create pools',
    'tournament.team.add': 'Add Team',
    'tournament.team.back': 'Back to teams',
    'tournament.team.edit.title': 'Edition team',
    'tournament.team.export.title': 'Team',
    'tournament.team.first': 'Add your first team',
    'tournament.team.form.email': 'Email',
    'tournament.team.form.name': 'Name',
    'tournament.team.form.submit': 'Save',
    'tournament.team.index.title': 'My Tournament teams',
    'tournament.team.name': 'Teams',
    'tournament.team.new.title': 'Add teams',
    'tournament.teams.add': 'Add Team',
    'tournament.teams.back': 'Back to tournaments',
    'tournament.teams.title': 'Teams',
    'tournament.user_apply.add': 'Add Participant',
    'tournament.user_apply.add_into_team': 'Add partipant in this team',
    'tournament.user_apply.army_list.add_now': 'Add it now!',
    'tournament.user_apply.army_list.create': 'Create a new list',
    'tournament.user_apply.army_list.need':
      'You have not added your army list yet.',
    'tournament.user_apply.army_list.or': 'or',
    'tournament.user_apply.army_list.use_existing': 'Use an existing list',
    'tournament.user_apply.army_list.which': 'Which army list ?',
    'tournament.user_apply.army_list_select.form.submit': 'Save',
    'tournament.user_apply.edit.title': 'Edit your participation',
    'tournament.user_apply.first': 'Add your first Participant',
    'tournament.user_apply.form.name': 'Name',
    'tournament.user_apply.form.name_detail':
      'You can add somes users (1 user by line) with email separated by a comma (name, email).',
    'tournament.user_apply.form.or': 'or',
    'tournament.user_apply.form.submit': 'Add',
    'tournament.user_apply.form.user': 'User',
    'tournament.user_apply.manage': 'Manage Team',
    'tournament.user_apply.name': 'User',
    'tournament.user_apply.new.title': 'Add users',
    'tournament.user_apply.remove': 'Remove Participant',
    'tournament.user_apply.share_link': 'Share invitation link',
    'tournament.user_apply.team_leader': 'Is the team captain',
    'unit.base.label': 'Base',
    'unit.height.Gigantic': 'Gigantic',
    'unit.height.Large': 'Large',
    'unit.height.Standard': 'Standard',
    'unit.limit.model': 'Models/Army',
    'unit.limit.perArmy': 'par Armée',
    'unit.limit.single': 'single model',
    'unit.limit.unit': 'Units/Army',
    'unit.mount': 'Mount',
    'unit.show.add_model':
      ' + \u003cstrong\u003e{pts}\u003c/strong\u003e pts/extra model',
    'unit.show.change':
      '{name} utils of {number} models count towards {new_name}',
    'unit.show.change_with_limit':
      'Units of {number} or more models without {limit} count towards {new_name} instead of {old_name}.',
    'unit.show.size':
      '\u003cstrong\u003e{min_size}-{max_size}\u003c/strong\u003e models',
    'unit.size.Gigantic': 'Gigantic',
    'unit.size.Large': 'Large',
    'unit.size.Standard': 'Standard',
    'unit.type.label': 'Type',
    'unit_option.per_model': '/mod.',
    'unit_option.use_points.free': 'free',
    'unit_option.use_points.no_limit': 'no limit',
    'unit_option.use_points.up_to': 'up to',
    'unit_options.category.C': 'C',
    'unit_options.category.M': 'M',
    'unit_options.category.S': 'S',
    'unit_options.footonly': 'foot only',
    'version.index.pairing': 'Team Pairing',
    'version.index.search': 'Search by rule',
    'version.index.show': 'Show',
    'version.index.title': 'Versions',
    'version.index.tools': 'Tools',
    'version.show.back': 'Back',
    welcome: 'Welcome',
    with: 'with %',
    without: 'without %',
  },
  ru: {
    Common: 'Common',
    'active_admin.menu.admin': 'Administration',
    'active_admin.menu.armies': 'Armies',
    'active_admin.menu.builder': 'Builder',
    'active_admin.menu.dashboard': 'Administration',
    'active_admin.menu.import': 'Import',
    'active_admin.menu.log': 'Log',
    'active_admin.menu.magic': 'magic',
    'active_admin.menu.map': 'Maps',
    'active_admin.menu.ninth_age': 'Ninth Age',
    'active_admin.menu.organisation': 'Organisation',
    'active_admin.menu.paint': 'Paint',
    'active_admin.menu.statistique': 'Statistiques',
    'active_admin.menu.tournament': 'Tournament',
    'active_admin.menu.unit': 'Unit',
    'active_admin.menu.user_annoncement': 'Annoncements',
    'active_admin.menu.users': 'Users',
    'active_admin.menu.versioning': 'Versioning',
    'active_admin.translate.ko': 'Korean',
    'active_admin.translate.pl': 'Polish',
    'active_admin.translate.ru': 'Russian',
    'active_admin.translate.zh': 'Chinese',
    'activerecord.attributes.data_analytics/report.deployments.CounterThrust':
      'Counter Thrust',
    'activerecord.attributes.data_analytics/report.deployments.DawnAssult':
      'Dawn Assult',
    'activerecord.attributes.data_analytics/report.deployments.Encircle':
      'Encircle',
    'activerecord.attributes.data_analytics/report.deployments.FrontlineClash':
      'Frontline Clash',
    'activerecord.attributes.data_analytics/report.deployments.MarchingColumns':
      'Marching Columns',
    'activerecord.attributes.data_analytics/report.deployments.RefusedFlank':
      'Refused Flank',
    'activerecord.attributes.data_analytics/report.maps.A1':
      'A1 - Shrouded Pool',
    'activerecord.attributes.data_analytics/report.maps.A2':
      'A2 - Foothill Outpost',
    'activerecord.attributes.data_analytics/report.maps.A3':
      'A3 - Dilapidated Manor',
    'activerecord.attributes.data_analytics/report.maps.A4':
      'A4 - Volcanic Lake',
    'activerecord.attributes.data_analytics/report.maps.A5':
      'A5 - Misty Marshes',
    'activerecord.attributes.data_analytics/report.maps.A6':
      'A6 - Ancient Walls',
    'activerecord.attributes.data_analytics/report.maps.A7': 'A7 - Beacon Hill',
    'activerecord.attributes.data_analytics/report.maps.A8':
      'A8 - Witch’s Cottage',
    'activerecord.attributes.data_analytics/report.maps.B1':
      'B1 - Mage’s Sanctum',
    'activerecord.attributes.data_analytics/report.maps.B2':
      'B2 - Villa Grounds',
    'activerecord.attributes.data_analytics/report.maps.B3':
      'B3 - Ancient Fortress',
    'activerecord.attributes.data_analytics/report.maps.B4':
      'B4 - Frontier Farm',
    'activerecord.attributes.data_analytics/report.maps.B5':
      'B5 - Ravaged Watchtower',
    'activerecord.attributes.data_analytics/report.maps.B6':
      'B6 - Creeping Forest',
    'activerecord.attributes.data_analytics/report.maps.B7':
      'B7 - Eerie Graveyard',
    'activerecord.attributes.data_analytics/report.maps.B8':
      'B8 - Shattered Bridge',
    'activerecord.attributes.data_analytics/report.objectives.Breakthrough':
      'Breakthrough',
    'activerecord.attributes.data_analytics/report.objectives.CaptureFlags':
      'Capture the Flags',
    'activerecord.attributes.data_analytics/report.objectives.HoldGround':
      'Hold the Ground',
    'activerecord.attributes.data_analytics/report.objectives.KingHill':
      'King of the Hill',
    'activerecord.attributes.data_analytics/report.objectives.SecureTarget':
      'Secure Target',
    'activerecord.attributes.data_analytics/report.objectives.SpoilsWar':
      'Spoils of War',
    'activerecord.attributes.data_analytics/report.opponent_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.opponent_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.opponent_objective':
      'Take the objective',
    'activerecord.attributes.data_analytics/report.your_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.your_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.your_objective':
      'Take the objective',
    'activerecord.attributes.ninth_age/magic_item.only_foot':
      'Prohibited mount',
    'activerecord.attributes.ninth_age/magic_item.only_wizard':
      'Only wizard can use it',
    'activerecord.attributes.ninth_age/magic_item.organisation_ids':
      'Organisations required from the model',
    'activerecord.attributes.ninth_age/magic_item.model_rule_ids':
      'Prohibited  model rules on model',
    'activerecord.attributes.ninth_age/magic_item.unit_ids':
      'For this units only',
    'activerecord.attributes.ninth_age/magic_item.unit_size':
      'Unit with this size can not use this item',
    'activerecord.attributes.ninth_age/magic_standard.organisation':
      'Add organisation to unit',
    'activerecord.attributes.ninth_age/magic_standard.organisation_ids':
      "Only organisation's units",
    'activerecord.attributes.ninth_age/troop.carac_agi': 'Agi',
    'activerecord.attributes.ninth_age/troop.carac_ap': 'Ap',
    'activerecord.attributes.ninth_age/troop.carac_att': 'Att',
    'activerecord.attributes.ninth_age/troop.carac_of': 'Off',
    'activerecord.attributes.ninth_age/troop.carac_str': 'Str',
    'activerecord.attributes.ninth_age/unit.carac_aeg': 'Aeg',
    'activerecord.attributes.ninth_age/unit.carac_arm': 'Arm',
    'activerecord.attributes.ninth_age/unit.carac_def': 'Def',
    'activerecord.attributes.ninth_age/unit.carac_dis': 'Dis',
    'activerecord.attributes.ninth_age/unit.carac_evoked': 'Rea',
    'activerecord.attributes.ninth_age/unit.carac_fly_adv': 'Fly adv',
    'activerecord.attributes.ninth_age/unit.carac_fly_mar': 'Fly mar',
    'activerecord.attributes.ninth_age/unit.carac_ground_adv': 'Adv',
    'activerecord.attributes.ninth_age/unit.carac_ground_mar': 'Mar',
    'activerecord.attributes.ninth_age/unit.carac_hp': 'HP',
    'activerecord.attributes.ninth_age/unit.carac_res': 'Res',
    'activerecord.attributes.ninth_age_army.source.FanMade': 'Fan Made',
    'activerecord.attributes.ninth_age_army.source.Official': 'Official',
    'activerecord.attributes.ninth_age_army.source.Supplement': 'Supplement',
    'activerecord.attributes.ninth_age_unit_option.category.BSB':
      'Battle Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.C': 'Champion',
    'activerecord.attributes.ninth_age_unit_option.category.ModelRule':
      'ModelRule',
    'activerecord.attributes.ninth_age_unit_option.category.ExtraSpells':
      'Spells',
    'activerecord.attributes.ninth_age_unit_option.category.General': 'General',
    'activerecord.attributes.ninth_age_unit_option.category.Generic': 'Generic',
    'activerecord.attributes.ninth_age_unit_option.category.M': 'Musician',
    'activerecord.attributes.ninth_age_unit_option.category.MagicBanner':
      'Banner Enchantment',
    'activerecord.attributes.ninth_age_unit_option.category.MagicEquipment':
      'Magic items',
    'activerecord.attributes.ninth_age_unit_option.category.MagicLvl':
      'Magic LVL',
    'activerecord.attributes.ninth_age_unit_option.category.MagicPath':
      'Magic Path',
    'activerecord.attributes.ninth_age_unit_option.category.MayTake':
      'May take',
    'activerecord.attributes.ninth_age_unit_option.category.Mount': 'Mount',
    'activerecord.attributes.ninth_age_unit_option.category.MustChoice':
      'Must choose',
    'activerecord.attributes.ninth_age_unit_option.category.OneChoice':
      'One choice only',
    'activerecord.attributes.ninth_age_unit_option.category.S':
      'Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.SpecialRule':
      'Special Rule',
    'activerecord.attributes.ninth_age_unit_option.category.WizardAdept':
      'Wizard Adept',
    'activerecord.attributes.ninth_age_unit_option.category.WizardApprentice':
      'Wizard Apprentice',
    'activerecord.attributes.ninth_age_unit_option.category.WizardMaster':
      'Wizard Master',
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ChangeUnitOrganisation':
      "Change unit's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ExcludeAddOrganisation':
      "Not affected with other unit option's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.Unit':
      'All the unit',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Add':
      'Add',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Replace':
      'Replace',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.A':
      'V1-A',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.BS':
      'V1-BS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.E':
      'V1-E',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.I':
      'V1-I',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.LD':
      'V1-Ld',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.M':
      'V1-M',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.S':
      'V1-S',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.T':
      'V1-T',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.W':
      'V1-W',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.WS':
      'V1-WS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_aeg':
      'V2-Aeg',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_agi':
      'V2-Agi',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ap':
      'V2-Ap',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_arm':
      'V2-Arm',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_att':
      'V2-Att',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_def':
      'V2-Def',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_dis':
      'V2-Dis',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_evoked':
      'V2-Evoked',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_adv':
      'V2-Fly-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_mar':
      'V2-Fly-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_adv':
      'V2-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_mar':
      'V2-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_hp':
      'V2-Hp',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_of':
      'V2-Of',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_res':
      'V2-Res',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_str':
      'V2-Str',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByArmy':
      'per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByModel':
      'item per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.MaxRatioByArmy':
      'Max Ratio per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Model':
      'Models per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ModelByUnit':
      'Models per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Units':
      'Units per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Quantity':
      'Quantity from the option',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Selection':
      'Option selected',
    'activerecord.attributes.ninth_age_version.game.EssenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.WarhammerBattle':
      'Warhammer Battle',
    'activerecord.attributes.ninth_age_version.game.essenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.ninthAge': 'Ninth Age',
    'activerecord.attributes.ninth_age_version.game.battle': 'Warhammer Battle',
    'activerecord.attributes.tournament/contest.participation': 'Participation',
    'activerecord.models.ninth_age/magic_standard.one': 'Magic banner',
    'activerecord.models.ninth_age/magic_standard.other': 'Magic banners',
    'activerecord.models.ninth_age/unit.one': 'Unit',
    'activerecord.models.ninth_age/unit.other': 'Units',
    'admin.dashboard': 'Administration',
    'admin.tournament': 'Tournament Org',
    and: ' and ',
    'army.armybook': 'Army book',
    'army.banner': 'Banner enchantement',
    'army.index.show': 'Show',
    'army.index.title': 'All armies',
    'army.show.back': 'Back',
    'army_list.clone.information': 'Are you sure to duplicate list:',
    'army_list.clone.submit': 'Duplicate',
    'army_list.clone.title': 'Duplicate list',
    'army_list.delete.information': 'Are you sure to destroy this list:',
    'army_list.delete.submit': '!!! Delete !!!',
    'army_list.delete.title': 'Delete\u003cbr /\u003elist',
    'army_list.edit.title': 'Update the list',
    'army_list.export.html_full': 'Full HTML',
    'army_list.export.html_lite': 'Lite HTML',
    'army_list.export.include_magics': 'Include magic paths?',
    'army_list.export.information': 'Choose format for list export:',
    'army_list.export.pdf_full': 'Full PDF',
    'army_list.export.pdf_lite': 'Lite PDF',
    'army_list.export.print': 'Print',
    'army_list.export.separator': 'Separator',
    'army_list.export.title': 'Export list',
    'army_list.export.txt.general': 'General',
    'army_list.export.verbosity': 'Verbosity',
    'army_list.form.army.error': 'You must select an army.',
    'army_list.form.army.placeholder': 'Select an army',
    'army_list.form.army.title': 'Army *',
    'army_list.form.folder.placeholder': 'Select a folder',
    'army_list.form.folder.title': 'Folder',
    'army_list.form.max.name': 'You must choose the max of your army',
    'army_list.form.max.placeholder': 'Enter a max',
    'army_list.form.max.title': 'Max *',
    'army_list.form.name.error': 'You must name your list',
    'army_list.form.name.placeholder': 'Enter a name',
    'army_list.form.name.title': 'Name *',
    'army_list.form.notes.placeholder': 'My notes',
    'army_list.form.notes.title': 'Notes',
    'army_list.form.private.title': 'is a private list',
    'army_list.form.rate.title': 'Rate with max',
    'army_list.form.version.error': 'You must select a version.',
    'army_list.form.version.placeholder': 'Select a version',
    'army_list.form.version.title': 'Version *',
    'army_list.format.title': 'Format \u0026 Import an army list',
    'army_list.index.add': 'Create new army list',
    'army_list.index.and': 'and',
    'army_list.index.contest': 'Create a contest',
    'army_list.index.filter': 'Filter by',
    'army_list.index.folder': 'Create new folder',
    'army_list.index.name_or_notes': 'Name or notes',
    'army_list.index.search': 'Submit',
    'army_list.index.title': 'My army lists',
    'army_list.new.title': 'Create new list',
    'army_list.show.add_unit': 'Add unit',
    'army_list.show.delete': 'Delete',
    'army_list.show.duplicate': 'Duplicate',
    'army_list.show.edit': 'Edit',
    'army_list.show.export': 'Export',
    'army_list.show.notes': 'Notes',
    'army_list.show.organisation.excess': 'Excess',
    'army_list.show.organisation.missing': 'Missing',
    'army_list.show.organisation.remaining': 'Remaining',
    'army_list.show.print': 'Print',
    'army_list.show.rearrange_units': 'Rearrange Units',
    'army_list.show.title': 'Army list • {name}',
    'army_list.unit.form.name.placeholder': 'Add a name',
    'army_list.unit.form.name.title': 'Name',
    'army_list.unit.form.title': 'Add an unit',
    'army_list.unit.form.unit.error': 'You must select an unit',
    'army_list.unit.form.unit.placeholder': 'Select an unit',
    'army_list.unit.form.unit.title': 'Unit *',
    'army_list_unit.delete.information': 'Are you sure to destroy this unit:',
    'army_list_unit.delete.submit': '!!! Delete !!!',
    'army_list_unit.delete.title': 'Delete\u003cbr /\u003eunit',
    'army_list_unit.duplicate.new_army_list': 'New {name} list',
    'army_list_unit.duplicate.target': 'To:',
    'army_list_unit.duplicate.title': 'Duplicate',
    'army_list_unit.edit.form.magic': 'Magic',
    'army_list_unit.edit.form.notes': 'Notes',
    'army_list_unit.edit.magic_items': 'Magic items',
    'army_list_unit.edit.magic_standards': 'Magic banners',
    'army_list_unit.edit.options': 'Options',
    'army_list_unit.edit.title': 'Edit',
    'army_list_unit.form.name': 'Name',
    'army_list_unit.form.submit': 'Create Unit',
    'army_list_unit.new.title': 'Add new unit',
    'army_list_unit.show.command_group_unit_options': 'Command Group Options',
    'army_list_unit.show.delete': 'Delete',
    'army_list_unit.show.duplicate': 'Duplicate',
    'army_list_unit.show.edit': 'Edit',
    'army_list_unit.show.model_rules': 'ModelRules',
    'army_list_unit.show.magic': 'Magic',
    'army_list_unit.show.magic_items': 'Magic items',
    'army_list_unit.show.magic_lvl_unit_options':
      'May become (one choice only)',
    'army_list_unit.show.magic_standards': 'Magic banners',
    'army_list_unit.show.magic_unit_options': 'Magic Options',
    'army_list_unit.show.mount_unit_options': 'Mount Options',
    'army_list_unit.show.notes': 'Notes',
    'army_list_unit.show.path_unit_options': 'Must generate spells from',
    'army_list_unit.show.path_unit_options_choose_one':
      'Must generate spells from (choose one)',
    'army_list_unit.show.troops.A': 'A',
    'army_list_unit.show.troops.BS': 'BS',
    'army_list_unit.show.troops.E': 'Evoked',
    'army_list_unit.show.troops.I': 'I',
    'army_list_unit.show.troops.LD': 'Ld',
    'army_list_unit.show.troops.M': 'M',
    'army_list_unit.show.troops.S': 'S',
    'army_list_unit.show.troops.T': 'T',
    'army_list_unit.show.troops.W': 'W',
    'army_list_unit.show.troops.WS': 'WS',
    'army_list_unit.show.troops.name': 'Troops',
    'army_list_unit.show.troops.profile': 'Profile',
    'army_list_unit.show.troops.type': "Troop's type",
    'army_list_unit.show.unit_options': 'Options',
    'army_magic_spell.name': 'Racial Trait Spell',
    'builder.searchs.index.and': 'and',
    'builder.searchs.index.between': 'between',
    'builder.searchs.index.points': 'points',
    'builder.searchs.index.search': 'Search',
    'builder.searchs.index.search_army_select_error':
      'You must select one army',
    'builder.searchs.index.select_army': 'Choise the army',
    'builder.searchs.index.select_points_range': 'Number of point',
    'builder.searchs.index.select_version': 'Choise the version of 9Th Age',
    'builder.searchs.index.title': 'Search an Army list',
    'builder.searchs.show.and': 'and',
    'builder.searchs.show.between': 'between',
    'builder.searchs.show.points': 'points',
    'builder.searchs.show.title': 'Army list found',
    close: 'Close',
    'confirmation.form.email': 'Email',
    'confirmation.form.submit': 'Save',
    'confirmation.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'confirmation.lost.password': 'I have lost my password!',
    'confirmation.title': 'Re-send confirmation instructions',
    'contest.back': 'back',
    'contest.delete.information': 'Are you sure to delete:',
    'contest.delete.submit': '!!! Delete !!!',
    'contest.delete.title': 'Delete contest',
    'contest.edit.title': 'Edit my contest',
    'contest.form.armyListMax.error': 'Your contest need a max points by army',
    'contest.form.armyListMax.placeholder': 'Enter a max points by army',
    'contest.form.armyListMax.title': 'Max points by army',
    'contest.form.endDate.error': 'Your contest need a end date',
    'contest.form.endDate.placeholder': 'Enter a end date',
    'contest.form.endDate.title': 'End date *',
    'contest.form.name.error': 'You must name your list',
    'contest.form.name.placeholder': 'Enter a name',
    'contest.form.name.title': 'Name *',
    'contest.form.participation.error':
      'Your contest need a participation mode',
    'contest.form.participation.placeholder': 'Enter a participation mode',
    'contest.form.participation.title': 'Individual or by Team',
    'contest.form.startDate.error': 'Your contest need a start date',
    'contest.form.startDate.placeholder': 'Enter a start date',
    'contest.form.startDate.title': 'Start date *',
    'contest.form.teamMax.error': 'Your contest need a number of team',
    'contest.form.teamMax.placeholder': 'Enter a number of team',
    'contest.form.teamMax.title': 'Number of team',
    'contest.form.userMax.error':
      'Your contest need a number of participant or team size',
    'contest.form.userMax.placeholder':
      'Enter a number of participant or team size',
    'contest.form.userMax.title': 'Number of participant or team size',
    'contest.form.versionid.error': 'Your contest need a game version',
    'contest.form.versionid.placeholder': 'Enter a game version',
    'contest.form.versionid.title': 'Game version *',
    'contest.name': 'Tournament',
    'contest.new.title': 'Create a contest',
    'contest.show.title': 'Contest: {name}',
    'data_analytics.analytics.title': 'Project: Better data for T9A',
    'data_analytics.report.new.title': 'Report a game',
    'model_rules.index.show': 'Show',
    'model_rules.index.title': 'model rules',
    'export.format': 'Format',
    'export.full': 'Full',
    'export.lite': 'Lite',
    'export.magics': 'Magics',
    'export.nomagics': 'No Magics',
    'export.print': 'print',
    'export.verbosity': 'Verbosity',
    'export.withmagics': 'With magics',
    'folder.add_army_list.form.select': 'Select an army list',
    'folder.add_army_list.title': 'Add a list into this folder',
    'folder.back': 'back',
    'folder.delete.information': 'Are you sure to delete:',
    'folder.delete.submit': '!!! Delete !!!',
    'folder.delete.title': 'Delete folder',
    'folder.edit.title': 'Edit my folder',
    'folder.form.is_share.title': 'Share this folder',
    'folder.form.name.error': 'You must name your list',
    'folder.form.name.placeholder': 'Enter a name',
    'folder.form.name.title': 'Name *',
    'folder.form.parent.placeholder': 'Select the parent',
    'folder.form.parent.title': 'Parent',
    'folder.name': 'Folder',
    'folder.new.title': 'Create a folder',
    'folder.share.title': 'Share folder',
    'folder.show.title': 'Folder: {name}',
    'folder.tournament.information':
      'You can convert this folder into a tournament!',
    'folder.tournament.submit': '!!! Create !!!',
    'folder.tournament.title': 'Create a tournament',
    'footerlink.privacy': 'Privacy Policy',
    'form.add': 'Add',
    'form.cancel': 'Cancel',
    'form.create': 'Create',
    'form.format': 'Format',
    'form.import': 'Import',
    'form.save': 'Save',
    'format.form.date.error': 'You must select a creation date for your list',
    'format.form.date.placeholder': '01/01/2022',
    'format.form.date.title': 'Creation date *',
    'format.form.formated.title': 'Your formated army list',
    'format.form.game.error':
      "You must select the game's name that you want to play",
    'format.form.game.placeholder': 'T9A, EoW, WHB,....',
    'format.form.game.title': 'Your game *',
    'format.form.source.error': 'You must add your list',
    'format.form.source.placeholder': 'Enter an army list',
    'format.form.source.title': 'Your army list *',
    'format.new.title': 'Format and Import an army list',
    help: 'help',
    'home.app.available.google': 'Get it on Google Play',
    'home.app.available.on_platform':
      'Currently under development, available on:',
    'home.app.mobile': 'A mobile app',
    'home.no_account':
      'You can now use all the features of 9ThBuilder without having to create an account first. \nBe careful however, your lists are linked to your local session and therefore will not be available on another browser and may be lost if you delete your cache or your session."\n',
    'home.welcome': '9TH BUILDER',
    'home.whoarewe.compose': 'Compose and archive your favorite armies!',
    'home.whoarewe.description':
      'A passionate of Battle since many years. I took the 9Th Builder since several years, creates a mobile application and helps the 9Th Age administration.\nHelped by Kaos War who greatly contributed to enter army lists and for the new homePage.\n9Th Builder is an effective and easy-to-use tool for creating your army lists and sharing them. It does not generate any income :)\n',
    'home.whoarewe.discord': 'Discord',
    'home.whoarewe.draft': 'Make a team pairing',
    'home.whoarewe.format': 'Format or import your army',
    'home.whoarewe.list': 'Create an Army list',
    'home.whoarewe.newsfb': 'News Facebook',
    'home.whoarewe.paint': 'Create an Paint list',
    'home.whoarewe.readarmy': 'Read Army Books',
    'home.whoarewe.readmagic': 'Read Magic Paths',
    'home.whoarewe.title': 'Who are we?',
    'home.whoarewe.try': 'Do you want to try?',
    'home.whoarewe.whatdo': 'What can you do?',
    'lexicon.index.show': 'Army books \u0026 Tools',
    'magic.casting': 'Casting',
    'magic.duration': 'Duration',
    'magic.effect': 'Effect',
    'magic.index.show': 'Show',
    'magic.index.title': 'Magics',
    'magic.range': 'Range',
    'magic.show.back': 'Back',
    'magic.type': 'Type',
    'magic_item_categories.index.show': 'Show',
    'magic_item_categories.index.title': 'Magic item categories',
    'magic_items.Cbtbmw': 'Cannot be taken by models with',
    'magic_items.Enchantment': 'Enchantment',
    'magic_items.dominant': 'Dominant',
    'magic_items.footonly': 'foot only',
    'magic_items.index.show': 'Show',
    'magic_items.index.title': 'Magic items',
    'magic_items.only': 'only',
    'magic_items.perArmy': 'par Armée',
    'magic_items.type_figurine.All': 'All',
    'magic_items.type_figurine.AnimisteBestial': 'Animiste bestial',
    'magic_items.type_figurine.Character': 'Character',
    'magic_items.type_figurine.FeralOrc': 'Feral Orc',
    'magic_items.type_figurine.Goblins': 'Goblins',
    'magic_items.type_figurine.Infantry': 'Infantry',
    'magic_items.type_figurine.KnightCommanders': 'Knight Commanders',
    'magic_items.type_figurine.MageOnFoot': 'Mage On Foot',
    'magic_items.type_figurine.MarshalsMountedOnHorse':
      'Marshals mounted on Horse',
    'magic_items.type_figurine.ModelsOnChariots': 'models on Chariots',
    'magic_items.type_figurine.ModelsOnFoot': 'Models on foot',
    'magic_items.type_figurine.MonarchsOfTheDead': 'Monarchs of the Dead',
    'magic_items.type_figurine.Monster': 'Monster',
    'magic_items.type_figurine.MountedCharacter': 'Mounted character',
    'magic_items.type_figurine.NoLargeTarget': 'No large target',
    'magic_items.type_figurine.ParentUnit': 'Parent Unit',
    'magic_items.type_figurine.Wizard': 'Wizard',
    'magic_spell.type_lvl.A': 'A',
    'magic_spell.type_lvl.Five': '5',
    'magic_spell.type_lvl.Four': '4',
    'magic_spell.type_lvl.One': '1',
    'magic_spell.type_lvl.Six': '6',
    'magic_spell.type_lvl.Three': '3',
    'magic_spell.type_lvl.Two': '2',
    'magic_spell.type_lvl.Zero': '0',
    'magic_standards.index.show': 'Show',
    'magic_standards.index.title': 'Magic banners',
    'menu.army_lists': 'My army lists',
    'menu.help': 'Help',
    'menu.label': 'Main menu',
    'menu.languages.de': 'Germany',
    'menu.languages.en': 'English',
    'menu.languages.es': 'Spanish - Español',
    'menu.languages.fr': 'French',
    'menu.languages.hu': 'Hungarian',
    'menu.languages.it': 'Italian - Italiano',
    'menu.languages.ko': 'Korean',
    'menu.languages.lang': 'Language',
    'menu.languages.pl': 'Polish',
    'menu.languages.ru': 'Russian',
    'menu.languages.sr': 'Serbian',
    'menu.languages.zh': 'Chinese',
    'menu.preferences': 'Preferences',
    'menu.signin': 'Sign in',
    'menu.signout': 'Sign out',
    'menu.signup': 'Sign up',
    next: 'Next',
    'ninth_age.figurine.mount': 'Mount',
    'ninth_age.figurine.pts': 'pts',
    'ninth_age.magic_item.only_wizard.AllWizard': 'Wizard only',
    'ninth_age.magic_item.only_wizard.NoWizard': 'Cannot be taken by Wizards',
    'ninth_age.magic_item.only_wizard.WizardAdept': 'Wizard adept only',
    'ninth_age.magic_item.only_wizard.WizardApprentice':
      'Wizard apprentice only',
    'ninth_age.magic_item.only_wizard.WizardMaster': 'Wizard master only',
    'ninth_age.troop.offensive': 'Offensive',
    'ninth_age.unit.defensive': 'Defensive',
    'ninth_age.unit.fly': 'fly',
    'ninth_age.unit.global': 'Global',
    'ninth_age.unit.rules': 'Model Rules',
    'paint_list.delete.information': 'Are you sure to destroy this list:',
    'paint_list.delete.submit': '!!! Delete !!!',
    'paint_list.delete.title': 'Delete your list',
    'paint_list.edit.title': 'Edit your paint list',
    'paint_list.form.army.error': 'You must select an army.',
    'paint_list.form.army.placeholder': 'Select an army',
    'paint_list.form.army.title': 'Army *',
    'paint_list.form.name.error': 'You must name your list',
    'paint_list.form.name.placeholder': 'Enter a name',
    'paint_list.form.name.title': 'Name *',
    'paint_list.form.version.error': 'You must select a version.',
    'paint_list.form.version.placeholder': 'Select a version',
    'paint_list.form.version.title': 'Version *',
    'paint_list.index.add': 'Create new paint list',
    'paint_list.index.title': 'My paint lists',
    'paint_list.new.title': 'Create a new list',
    'paint_list.show.assembled': 'Assembled',
    'paint_list.show.buy': 'Buy',
    'paint_list.show.comment': 'Comment',
    'paint_list.show.first_color': 'First color',
    'paint_list.show.paint': 'Paint',
    'paint_list.show.plinth': 'Plinth',
    'paint_list.show.size': 'Size',
    'paint_list.show.state.done': 'Done',
    'paint_list.show.state.waiting': 'Waiting',
    'paint_list.show.state.wip': 'Wip',
    'paint_list.show.title': 'Your Paint list:',
    'paint_list.show.trimmed': 'Trimmed',
    'paint_list.show.unit': 'Unit',
    'paint_list.unit.form.comment.placeholder': 'Add a comment',
    'paint_list.unit.form.comment.title': 'Comment',
    'paint_list.unit.form.size.error': 'You must add a number of model',
    'paint_list.unit.form.size.placeholder': 'Select a size',
    'paint_list.unit.form.size.title': 'Size *',
    'paint_list.unit.form.title': 'Add an unit',
    'paint_list.unit.form.unit.error': 'You must select an unit',
    'paint_list.unit.form.unit.placeholder': 'Select an unit',
    'paint_list.unit.form.unit.title': 'Unit *',
    'password_change.form.confirmation': 'Password confirmation',
    'password_change.form.password': 'Password',
    'password_change.form.submit': 'Save',
    'password_change.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_change.lost.confirmation':
      "I didn't received my confirmation email",
    'password_change.lost.password': 'I have lost my password!',
    'password_change.title': 'Change your password',
    'password_lost.form.email': 'Email',
    'password_lost.form.submit': 'Send me reset password instructions',
    'password_lost.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_lost.lost.confirmation':
      "I didn't received my confirmation email",
    'password_lost.title': 'I have lost my password',
    'picker.datetime.js': 'YYYY.MM.DD HH:mm',
    'picker.datetime.rb': '%Y.%m.%d %H:%M',
    'profile.back': 'Previous page',
    'profile.delete.information':
      'You are not satisfied? \u003ca href="mailto:support@9thbuilder.com"\u003eContact us\u003c/a\u003e or',
    'profile.delete.link': 'immediately destroy your account',
    'profile.delete.title': 'Account deletion',
    'profile.form.confirmation': 'Password confirmation',
    'profile.form.email': 'Email address',
    'profile.form.game': 'Favorite',
    'profile.form.name': 'Name or nickname',
    'profile.form.password': 'Password',
    'profile.form.password_help':
      "Leave it empty if you don't want to change your password",
    'profile.form.submit': 'Save',
    'profile.title': 'My account',
    save: 'Save',
    'search_list.assembled': 'Assembled',
    'search_list.buy': 'Buy',
    'search_list.comment': 'Comment',
    'search_list.first_color': 'First color',
    'search_list.index.search': 'Submit',
    'search_list.index.search_list': 'Search an army list',
    'search_list.paint': 'Paint',
    'search_list.plinth': 'Plinth',
    'search_list.size': 'Size',
    'search_list.trimmed': 'Trimmed',
    'search_list.unit': 'Unit',
    'signin.Confirmation': 'Confirmation',
    'signin.form.email': 'Email',
    'signin.form.lost': 'Forgot ?',
    'signin.form.password': 'Password',
    'signin.form.remember': 'Remember me',
    'signin.form.submit': 'Sign-in',
    'signin.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signin.lost.confirmation': "I didn't received my confirmation email",
    'signin.lost.password': 'I have lost my password!',
    'signin.title': 'Sign in',
    'signup.form.confirmation': 'Password confirmation',
    'signup.form.email': 'Email address',
    'signup.form.game': '--Favorite--',
    'signup.form.name': 'Name or nickname',
    'signup.form.password': 'Password',
    'signup.form.register': 'Join us !',
    'signup.form.submit': 'Sign-up',
    'signup.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signup.lost.confirmation': "I didn't received my confirmation email",
    'signup.lost.password': 'I have lost my password!',
    'signup.title': 'Sign up',
    'site.accept': 'I accept',
    'site.more': 'Learn more',
    'site.use_cookie':
      'This site uses cookies to offer you the best service. By continuing your navigation, you use the use of cookies.',
    'tool.pairing.done': 'Your pairing is complete',
    'tool.pairing.draft.send_link': 'Send this link to your opponent:',
    'tool.pairing.draft.waiting_opponent': 'We are waiting your opponent',
    'tool.pairing.draw.confirm.draw': 'Confirm Draw',
    'tool.pairing.draw.confirm.response': 'Confirm Response',
    'tool.pairing.draw.confirm.select': 'Confirm select',
    'tool.pairing.draw.or': 'or',
    'tool.pairing.draw.vs': 'Vs',
    'tool.pairing.draw_round.select.draw': 'Select one army for the draft',
    'tool.pairing.draw_round.select.response': 'Select your reponses',
    'tool.pairing.draw_round.select.select': 'Select the army',
    'tool.pairing.draw_round.select.waiting': 'Waiting',
    'tool.pairing.image': 'Copy the pairing url image',
    'tool.pairing.inprogress': 'Your pairing is in progress',
    'tool.pairing.matches.tables': 'Tables:',
    'tool.pairing.my_team.my_armies': 'Your armies',
    'tool.pairing.opponent_team.team': 'Team',
    'tool.pairing.select_armies.choise_armies': 'Choise your armies',
    'tool.pairing.select_armies.confirm': 'Confirm',
    'tool.pairing.select_armies.error':
      'Sorry! There was an error loading the items.',
    'tool.pairing.select_armies.your_team': 'Your Team',
    'tool.pairing.select_team_size.how_many': 'How many players in the team?',
    'tool.pairing.table': 'Table',
    'tool.pairing.team_name.confirm': 'Confirm',
    'tool.pairing.team_name.what_name': "What's the name of your team?",
    'tool.pairing.team_name.your_name': 'Your team name',
    'tool.search_rules.index.search': 'Search',
    'tool.search_rules.index.search_army_select_error':
      'You must select one army',
    'tool.search_rules.index.search_rule': 'Choise one rule',
    'tool.search_rules.index.select_army': 'Choise the army',
    'tool.search_rules.index.select_version': 'Choise the version of 9Th Age',
    'tool.search_rules.index.title': 'Search by rules',
    'tournament.contest.back': 'Back to tournaments',
    'tournament.contest.edit': 'Edit',
    'tournament.contest.form.address': 'Address',
    'tournament.contest.form.end_date': 'End',
    'tournament.contest.form.fees': 'Fees',
    'tournament.contest.form.name': 'Name',
    'tournament.contest.form.round_count': 'Rounds',
    'tournament.contest.form.start_date': 'Start',
    'tournament.contest.form.submit': 'Save',
    'tournament.contest.form.team_max': 'Max teams',
    'tournament.contest.form.user_max': 'Max users',
    'tournament.contest.form.user_team_max': 'Max users by team',
    'tournament.contest.form.version': 'Version',
    'tournament.contest.index.title': 'My tournaments',
    'tournament.contest.name': 'Tournament',
    'tournament.contest.new.title': 'Create a tournament',
    'tournament.contest.print_armies': 'Print all armies',
    'tournament.contest.print_repport': 'Rapport',
    'tournament.contest.total': 'Total',
    'tournament.custom_point.name': 'Paint, Wysiwyg, List',
    'tournament.round.add': 'Add round',
    'tournament.round.name': 'Round',
    'tournament.round.pools.validate': 'Create pools',
    'tournament.team.add': 'Add Team',
    'tournament.team.back': 'Back to teams',
    'tournament.team.edit.title': 'Edition team',
    'tournament.team.export.title': 'Team',
    'tournament.team.first': 'Add your first team',
    'tournament.team.form.email': 'Email',
    'tournament.team.form.name': 'Name',
    'tournament.team.form.submit': 'Save',
    'tournament.team.index.title': 'My Tournament teams',
    'tournament.team.name': 'Teams',
    'tournament.team.new.title': 'Add teams',
    'tournament.teams.add': 'Add Team',
    'tournament.teams.back': 'Back to tournaments',
    'tournament.teams.title': 'Teams',
    'tournament.user_apply.add': 'Add Participant',
    'tournament.user_apply.add_into_team': 'Add partipant in this team',
    'tournament.user_apply.army_list.add_now': 'Add it now!',
    'tournament.user_apply.army_list.create': 'Create a new list',
    'tournament.user_apply.army_list.need':
      'You have not added your army list yet.',
    'tournament.user_apply.army_list.or': 'or',
    'tournament.user_apply.army_list.use_existing': 'Use an existing list',
    'tournament.user_apply.army_list.which': 'Which army list ?',
    'tournament.user_apply.army_list_select.form.submit': 'Save',
    'tournament.user_apply.edit.title': 'Edit your participation',
    'tournament.user_apply.first': 'Add your first Participant',
    'tournament.user_apply.form.name': 'Name',
    'tournament.user_apply.form.name_detail':
      'You can add somes users (1 user by line) with email separated by a comma (name, email).',
    'tournament.user_apply.form.or': 'or',
    'tournament.user_apply.form.submit': 'Add',
    'tournament.user_apply.form.user': 'User',
    'tournament.user_apply.manage': 'Manage Team',
    'tournament.user_apply.name': 'User',
    'tournament.user_apply.new.title': 'Add users',
    'tournament.user_apply.remove': 'Remove Participant',
    'tournament.user_apply.share_link': 'Share invitation link',
    'tournament.user_apply.team_leader': 'Is the team captain',
    'unit.base.label': 'Base',
    'unit.height.Gigantic': 'Gigantic',
    'unit.height.Large': 'Large',
    'unit.height.Standard': 'Standard',
    'unit.limit.model': 'Models/Army',
    'unit.limit.perArmy': 'par Armée',
    'unit.limit.single': 'single model',
    'unit.limit.unit': 'Units/Army',
    'unit.mount': 'Mount',
    'unit.show.add_model':
      ' + \u003cstrong\u003e{pts}\u003c/strong\u003e pts/extra model',
    'unit.show.change':
      '{name} utils of {number} models count towards {new_name}',
    'unit.show.change_with_limit':
      'Units of {number} or more models without {limit} count towards {new_name} instead of {old_name}.',
    'unit.show.size':
      '\u003cstrong\u003e{min_size}-{max_size}\u003c/strong\u003e models',
    'unit.size.Gigantic': 'Gigantic',
    'unit.size.Large': 'Large',
    'unit.size.Standard': 'Standard',
    'unit.type.label': 'Type',
    'unit_option.per_model': '/mod.',
    'unit_option.use_points.free': 'free',
    'unit_option.use_points.no_limit': 'no limit',
    'unit_option.use_points.up_to': 'up to',
    'unit_options.category.C': 'C',
    'unit_options.category.M': 'M',
    'unit_options.category.S': 'S',
    'unit_options.footonly': 'foot only',
    'version.index.pairing': 'Team Pairing',
    'version.index.search': 'Search by rule',
    'version.index.show': 'Show',
    'version.index.title': 'Versions',
    'version.index.tools': 'Tools',
    'version.show.back': 'Back',
    welcome: 'Welcome',
    with: 'with %',
    without: 'without %',
  },
  se: {
    Common: 'Common',
    'active_admin.menu.admin': 'Administration',
    'active_admin.menu.armies': 'Armies',
    'active_admin.menu.builder': 'Builder',
    'active_admin.menu.dashboard': 'Administration',
    'active_admin.menu.import': 'Import',
    'active_admin.menu.log': 'Log',
    'active_admin.menu.magic': 'magic',
    'active_admin.menu.map': 'Maps',
    'active_admin.menu.ninth_age': 'Ninth Age',
    'active_admin.menu.organisation': 'Organisation',
    'active_admin.menu.paint': 'Paint',
    'active_admin.menu.statistique': 'Statistiques',
    'active_admin.menu.tournament': 'Tournament',
    'active_admin.menu.unit': 'Unit',
    'active_admin.menu.user_annoncement': 'Annoncements',
    'active_admin.menu.users': 'Users',
    'active_admin.menu.versioning': 'Versioning',
    'active_admin.translate.ko': 'Korean',
    'active_admin.translate.pl': 'Polish',
    'active_admin.translate.ru': 'Russian',
    'active_admin.translate.zh': 'Chinese',
    'activerecord.attributes.data_analytics/report.deployments.CounterThrust':
      'Counter Thrust',
    'activerecord.attributes.data_analytics/report.deployments.DawnAssult':
      'Dawn Assult',
    'activerecord.attributes.data_analytics/report.deployments.Encircle':
      'Encircle',
    'activerecord.attributes.data_analytics/report.deployments.FrontlineClash':
      'Frontline Clash',
    'activerecord.attributes.data_analytics/report.deployments.MarchingColumns':
      'Marching Columns',
    'activerecord.attributes.data_analytics/report.deployments.RefusedFlank':
      'Refused Flank',
    'activerecord.attributes.data_analytics/report.maps.A1':
      'A1 - Shrouded Pool',
    'activerecord.attributes.data_analytics/report.maps.A2':
      'A2 - Foothill Outpost',
    'activerecord.attributes.data_analytics/report.maps.A3':
      'A3 - Dilapidated Manor',
    'activerecord.attributes.data_analytics/report.maps.A4':
      'A4 - Volcanic Lake',
    'activerecord.attributes.data_analytics/report.maps.A5':
      'A5 - Misty Marshes',
    'activerecord.attributes.data_analytics/report.maps.A6':
      'A6 - Ancient Walls',
    'activerecord.attributes.data_analytics/report.maps.A7': 'A7 - Beacon Hill',
    'activerecord.attributes.data_analytics/report.maps.A8':
      'A8 - Witch’s Cottage',
    'activerecord.attributes.data_analytics/report.maps.B1':
      'B1 - Mage’s Sanctum',
    'activerecord.attributes.data_analytics/report.maps.B2':
      'B2 - Villa Grounds',
    'activerecord.attributes.data_analytics/report.maps.B3':
      'B3 - Ancient Fortress',
    'activerecord.attributes.data_analytics/report.maps.B4':
      'B4 - Frontier Farm',
    'activerecord.attributes.data_analytics/report.maps.B5':
      'B5 - Ravaged Watchtower',
    'activerecord.attributes.data_analytics/report.maps.B6':
      'B6 - Creeping Forest',
    'activerecord.attributes.data_analytics/report.maps.B7':
      'B7 - Eerie Graveyard',
    'activerecord.attributes.data_analytics/report.maps.B8':
      'B8 - Shattered Bridge',
    'activerecord.attributes.data_analytics/report.objectives.Breakthrough':
      'Breakthrough',
    'activerecord.attributes.data_analytics/report.objectives.CaptureFlags':
      'Capture the Flags',
    'activerecord.attributes.data_analytics/report.objectives.HoldGround':
      'Hold the Ground',
    'activerecord.attributes.data_analytics/report.objectives.KingHill':
      'King of the Hill',
    'activerecord.attributes.data_analytics/report.objectives.SecureTarget':
      'Secure Target',
    'activerecord.attributes.data_analytics/report.objectives.SpoilsWar':
      'Spoils of War',
    'activerecord.attributes.data_analytics/report.opponent_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.opponent_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.opponent_objective':
      'Take the objective',
    'activerecord.attributes.data_analytics/report.your_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.your_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.your_objective':
      'Take the objective',
    'activerecord.attributes.ninth_age/magic_item.only_foot':
      'Prohibited mount',
    'activerecord.attributes.ninth_age/magic_item.only_wizard':
      'Only wizard can use it',
    'activerecord.attributes.ninth_age/magic_item.organisation_ids':
      'Organisations required from the model',
    'activerecord.attributes.ninth_age/magic_item.model_rule_ids':
      'Prohibited  model rules on model',
    'activerecord.attributes.ninth_age/magic_item.unit_ids':
      'For this units only',
    'activerecord.attributes.ninth_age/magic_item.unit_size':
      'Unit with this size can not use this item',
    'activerecord.attributes.ninth_age/magic_standard.organisation':
      'Add organisation to unit',
    'activerecord.attributes.ninth_age/magic_standard.organisation_ids':
      "Only organisation's units",
    'activerecord.attributes.ninth_age/troop.carac_agi': 'Agi',
    'activerecord.attributes.ninth_age/troop.carac_ap': 'Ap',
    'activerecord.attributes.ninth_age/troop.carac_att': 'Att',
    'activerecord.attributes.ninth_age/troop.carac_of': 'Off',
    'activerecord.attributes.ninth_age/troop.carac_str': 'Str',
    'activerecord.attributes.ninth_age/unit.carac_aeg': 'Aeg',
    'activerecord.attributes.ninth_age/unit.carac_arm': 'Arm',
    'activerecord.attributes.ninth_age/unit.carac_def': 'Def',
    'activerecord.attributes.ninth_age/unit.carac_dis': 'Dis',
    'activerecord.attributes.ninth_age/unit.carac_evoked': 'Rea',
    'activerecord.attributes.ninth_age/unit.carac_fly_adv': 'Fly adv',
    'activerecord.attributes.ninth_age/unit.carac_fly_mar': 'Fly mar',
    'activerecord.attributes.ninth_age/unit.carac_ground_adv': 'Adv',
    'activerecord.attributes.ninth_age/unit.carac_ground_mar': 'Mar',
    'activerecord.attributes.ninth_age/unit.carac_hp': 'HP',
    'activerecord.attributes.ninth_age/unit.carac_res': 'Res',
    'activerecord.attributes.ninth_age_army.source.FanMade': 'Fan Made',
    'activerecord.attributes.ninth_age_army.source.Official': 'Official',
    'activerecord.attributes.ninth_age_army.source.Supplement': 'Supplement',
    'activerecord.attributes.ninth_age_unit_option.category.BSB':
      'Battle Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.C': 'Champion',
    'activerecord.attributes.ninth_age_unit_option.category.ModelRule':
      'ModelRule',
    'activerecord.attributes.ninth_age_unit_option.category.ExtraSpells':
      'Spells',
    'activerecord.attributes.ninth_age_unit_option.category.General': 'General',
    'activerecord.attributes.ninth_age_unit_option.category.Generic': 'Generic',
    'activerecord.attributes.ninth_age_unit_option.category.M': 'Musician',
    'activerecord.attributes.ninth_age_unit_option.category.MagicBanner':
      'Banner Enchantment',
    'activerecord.attributes.ninth_age_unit_option.category.MagicEquipment':
      'Magic items',
    'activerecord.attributes.ninth_age_unit_option.category.MagicLvl':
      'Magic LVL',
    'activerecord.attributes.ninth_age_unit_option.category.MagicPath':
      'Magic Path',
    'activerecord.attributes.ninth_age_unit_option.category.MayTake':
      'May take',
    'activerecord.attributes.ninth_age_unit_option.category.Mount': 'Mount',
    'activerecord.attributes.ninth_age_unit_option.category.MustChoice':
      'Must choose',
    'activerecord.attributes.ninth_age_unit_option.category.OneChoice':
      'One choice only',
    'activerecord.attributes.ninth_age_unit_option.category.S':
      'Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.SpecialRule':
      'Special Rule',
    'activerecord.attributes.ninth_age_unit_option.category.WizardAdept':
      'Wizard Adept',
    'activerecord.attributes.ninth_age_unit_option.category.WizardApprentice':
      'Wizard Apprentice',
    'activerecord.attributes.ninth_age_unit_option.category.WizardMaster':
      'Wizard Master',
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ChangeUnitOrganisation':
      "Change unit's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ExcludeAddOrganisation':
      "Not affected with other unit option's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.Unit':
      'All the unit',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Add':
      'Add',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Replace':
      'Replace',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.A':
      'V1-A',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.BS':
      'V1-BS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.E':
      'V1-E',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.I':
      'V1-I',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.LD':
      'V1-Ld',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.M':
      'V1-M',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.S':
      'V1-S',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.T':
      'V1-T',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.W':
      'V1-W',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.WS':
      'V1-WS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_aeg':
      'V2-Aeg',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_agi':
      'V2-Agi',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ap':
      'V2-Ap',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_arm':
      'V2-Arm',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_att':
      'V2-Att',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_def':
      'V2-Def',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_dis':
      'V2-Dis',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_evoked':
      'V2-Evoked',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_adv':
      'V2-Fly-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_mar':
      'V2-Fly-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_adv':
      'V2-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_mar':
      'V2-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_hp':
      'V2-Hp',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_of':
      'V2-Of',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_res':
      'V2-Res',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_str':
      'V2-Str',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByArmy':
      'per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByModel':
      'item per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.MaxRatioByArmy':
      'Max Ratio per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Model':
      'Models per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ModelByUnit':
      'Models per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Units':
      'Units per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Quantity':
      'Quantity from the option',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Selection':
      'Option selected',
    'activerecord.attributes.ninth_age_version.game.EssenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.WarhammerBattle':
      'Warhammer Battle',
    'activerecord.attributes.ninth_age_version.game.essenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.ninthAge': 'Ninth Age',
    'activerecord.attributes.ninth_age_version.game.battle': 'Warhammer Battle',
    'activerecord.attributes.tournament/contest.participation': 'Participation',
    'activerecord.models.ninth_age/magic_standard.one': 'Magic banner',
    'activerecord.models.ninth_age/magic_standard.other': 'Magic banners',
    'activerecord.models.ninth_age/unit.one': 'Unit',
    'activerecord.models.ninth_age/unit.other': 'Units',
    'admin.dashboard': 'Administration',
    'admin.tournament': 'Tournament Org',
    and: ' and ',
    'army.armybook': 'Army book',
    'army.banner': 'Banner enchantement',
    'army.index.show': 'Show',
    'army.index.title': 'All armies',
    'army.show.back': 'Back',
    'army_list.clone.information': 'Are you sure to duplicate list:',
    'army_list.clone.submit': 'Duplicate',
    'army_list.clone.title': 'Duplicate list',
    'army_list.delete.information': 'Are you sure to destroy this list:',
    'army_list.delete.submit': '!!! Delete !!!',
    'army_list.delete.title': 'Delete\u003cbr /\u003elist',
    'army_list.edit.title': 'Update the list',
    'army_list.export.html_full': 'Full HTML',
    'army_list.export.html_lite': 'Lite HTML',
    'army_list.export.include_magics': 'Include magic paths?',
    'army_list.export.information': 'Choose format for list export:',
    'army_list.export.pdf_full': 'Full PDF',
    'army_list.export.pdf_lite': 'Lite PDF',
    'army_list.export.print': 'Print',
    'army_list.export.separator': 'Separator',
    'army_list.export.title': 'Export list',
    'army_list.export.txt.general': 'General',
    'army_list.export.verbosity': 'Verbosity',
    'army_list.form.army.error': 'You must select an army.',
    'army_list.form.army.placeholder': 'Select an army',
    'army_list.form.army.title': 'Army *',
    'army_list.form.folder.placeholder': 'Select a folder',
    'army_list.form.folder.title': 'Folder',
    'army_list.form.max.name': 'You must choose the max of your army',
    'army_list.form.max.placeholder': 'Enter a max',
    'army_list.form.max.title': 'Max *',
    'army_list.form.name.error': 'You must name your list',
    'army_list.form.name.placeholder': 'Enter a name',
    'army_list.form.name.title': 'Name *',
    'army_list.form.notes.placeholder': 'My notes',
    'army_list.form.notes.title': 'Notes',
    'army_list.form.private.title': 'is a private list',
    'army_list.form.rate.title': 'Rate with max',
    'army_list.form.version.error': 'You must select a version.',
    'army_list.form.version.placeholder': 'Select a version',
    'army_list.form.version.title': 'Version *',
    'army_list.format.title': 'Format \u0026 Import an army list',
    'army_list.index.add': 'Create new army list',
    'army_list.index.and': 'and',
    'army_list.index.contest': 'Create a contest',
    'army_list.index.filter': 'Filter by',
    'army_list.index.folder': 'Create new folder',
    'army_list.index.name_or_notes': 'Name or notes',
    'army_list.index.search': 'Submit',
    'army_list.index.title': 'My army lists',
    'army_list.new.title': 'Create new list',
    'army_list.show.add_unit': 'Add unit',
    'army_list.show.delete': 'Delete',
    'army_list.show.duplicate': 'Duplicate',
    'army_list.show.edit': 'Edit',
    'army_list.show.export': 'Export',
    'army_list.show.notes': 'Notes',
    'army_list.show.organisation.excess': 'Excess',
    'army_list.show.organisation.missing': 'Missing',
    'army_list.show.organisation.remaining': 'Remaining',
    'army_list.show.print': 'Print',
    'army_list.show.rearrange_units': 'Rearrange Units',
    'army_list.show.title': 'Army list • {name}',
    'army_list.unit.form.name.placeholder': 'Add a name',
    'army_list.unit.form.name.title': 'Name',
    'army_list.unit.form.title': 'Add an unit',
    'army_list.unit.form.unit.error': 'You must select an unit',
    'army_list.unit.form.unit.placeholder': 'Select an unit',
    'army_list.unit.form.unit.title': 'Unit *',
    'army_list_unit.delete.information': 'Are you sure to destroy this unit:',
    'army_list_unit.delete.submit': '!!! Delete !!!',
    'army_list_unit.delete.title': 'Delete\u003cbr /\u003eunit',
    'army_list_unit.duplicate.new_army_list': 'New {name} list',
    'army_list_unit.duplicate.target': 'To:',
    'army_list_unit.duplicate.title': 'Duplicate',
    'army_list_unit.edit.form.magic': 'Magic',
    'army_list_unit.edit.form.notes': 'Notes',
    'army_list_unit.edit.magic_items': 'Magic items',
    'army_list_unit.edit.magic_standards': 'Magic banners',
    'army_list_unit.edit.options': 'Options',
    'army_list_unit.edit.title': 'Edit',
    'army_list_unit.form.name': 'Name',
    'army_list_unit.form.submit': 'Create Unit',
    'army_list_unit.new.title': 'Add new unit',
    'army_list_unit.show.command_group_unit_options': 'Command Group Options',
    'army_list_unit.show.delete': 'Delete',
    'army_list_unit.show.duplicate': 'Duplicate',
    'army_list_unit.show.edit': 'Edit',
    'army_list_unit.show.model_rules': 'ModelRules',
    'army_list_unit.show.magic': 'Magic',
    'army_list_unit.show.magic_items': 'Magic items',
    'army_list_unit.show.magic_lvl_unit_options':
      'May become (one choice only)',
    'army_list_unit.show.magic_standards': 'Magic banners',
    'army_list_unit.show.magic_unit_options': 'Magic Options',
    'army_list_unit.show.mount_unit_options': 'Mount Options',
    'army_list_unit.show.notes': 'Notes',
    'army_list_unit.show.path_unit_options': 'Must generate spells from',
    'army_list_unit.show.path_unit_options_choose_one':
      'Must generate spells from (choose one)',
    'army_list_unit.show.troops.A': 'A',
    'army_list_unit.show.troops.BS': 'BS',
    'army_list_unit.show.troops.E': 'Evoked',
    'army_list_unit.show.troops.I': 'I',
    'army_list_unit.show.troops.LD': 'Ld',
    'army_list_unit.show.troops.M': 'M',
    'army_list_unit.show.troops.S': 'S',
    'army_list_unit.show.troops.T': 'T',
    'army_list_unit.show.troops.W': 'W',
    'army_list_unit.show.troops.WS': 'WS',
    'army_list_unit.show.troops.name': 'Troops',
    'army_list_unit.show.troops.profile': 'Profile',
    'army_list_unit.show.troops.type': "Troop's type",
    'army_list_unit.show.unit_options': 'Options',
    'army_magic_spell.name': 'Racial Trait Spell',
    'builder.searchs.index.and': 'and',
    'builder.searchs.index.between': 'between',
    'builder.searchs.index.points': 'points',
    'builder.searchs.index.search': 'Search',
    'builder.searchs.index.search_army_select_error':
      'You must select one army',
    'builder.searchs.index.select_army': 'Choise the army',
    'builder.searchs.index.select_points_range': 'Number of point',
    'builder.searchs.index.select_version': 'Choise the version of 9Th Age',
    'builder.searchs.index.title': 'Search an Army list',
    'builder.searchs.show.and': 'and',
    'builder.searchs.show.between': 'between',
    'builder.searchs.show.points': 'points',
    'builder.searchs.show.title': 'Army list found',
    close: 'Close',
    'confirmation.form.email': 'Email',
    'confirmation.form.submit': 'Save',
    'confirmation.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'confirmation.lost.password': 'I have lost my password!',
    'confirmation.title': 'Re-send confirmation instructions',
    'contest.back': 'back',
    'contest.delete.information': 'Are you sure to delete:',
    'contest.delete.submit': '!!! Delete !!!',
    'contest.delete.title': 'Delete contest',
    'contest.edit.title': 'Edit my contest',
    'contest.form.armyListMax.error': 'Your contest need a max points by army',
    'contest.form.armyListMax.placeholder': 'Enter a max points by army',
    'contest.form.armyListMax.title': 'Max points by army',
    'contest.form.endDate.error': 'Your contest need a end date',
    'contest.form.endDate.placeholder': 'Enter a end date',
    'contest.form.endDate.title': 'End date *',
    'contest.form.name.error': 'You must name your list',
    'contest.form.name.placeholder': 'Enter a name',
    'contest.form.name.title': 'Name *',
    'contest.form.participation.error':
      'Your contest need a participation mode',
    'contest.form.participation.placeholder': 'Enter a participation mode',
    'contest.form.participation.title': 'Individual or by Team',
    'contest.form.startDate.error': 'Your contest need a start date',
    'contest.form.startDate.placeholder': 'Enter a start date',
    'contest.form.startDate.title': 'Start date *',
    'contest.form.teamMax.error': 'Your contest need a number of team',
    'contest.form.teamMax.placeholder': 'Enter a number of team',
    'contest.form.teamMax.title': 'Number of team',
    'contest.form.userMax.error':
      'Your contest need a number of participant or team size',
    'contest.form.userMax.placeholder':
      'Enter a number of participant or team size',
    'contest.form.userMax.title': 'Number of participant or team size',
    'contest.form.versionid.error': 'Your contest need a game version',
    'contest.form.versionid.placeholder': 'Enter a game version',
    'contest.form.versionid.title': 'Game version *',
    'contest.name': 'Tournament',
    'contest.new.title': 'Create a contest',
    'contest.show.title': 'Contest: {name}',
    'data_analytics.analytics.title': 'Project: Better data for T9A',
    'data_analytics.report.new.title': 'Report a game',
    'model_rules.index.show': 'Show',
    'model_rules.index.title': 'model rules',
    'export.format': 'Format',
    'export.full': 'Full',
    'export.lite': 'Lite',
    'export.magics': 'Magics',
    'export.nomagics': 'No Magics',
    'export.print': 'print',
    'export.verbosity': 'Verbosity',
    'export.withmagics': 'With magics',
    'folder.add_army_list.form.select': 'Select an army list',
    'folder.add_army_list.title': 'Add a list into this folder',
    'folder.back': 'back',
    'folder.delete.information': 'Are you sure to delete:',
    'folder.delete.submit': '!!! Delete !!!',
    'folder.delete.title': 'Delete folder',
    'folder.edit.title': 'Edit my folder',
    'folder.form.is_share.title': 'Share this folder',
    'folder.form.name.error': 'You must name your list',
    'folder.form.name.placeholder': 'Enter a name',
    'folder.form.name.title': 'Name *',
    'folder.form.parent.placeholder': 'Select the parent',
    'folder.form.parent.title': 'Parent',
    'folder.name': 'Folder',
    'folder.new.title': 'Create a folder',
    'folder.share.title': 'Share folder',
    'folder.show.title': 'Folder: {name}',
    'folder.tournament.information':
      'You can convert this folder into a tournament!',
    'folder.tournament.submit': '!!! Create !!!',
    'folder.tournament.title': 'Create a tournament',
    'footerlink.privacy': 'Privacy Policy',
    'form.add': 'Add',
    'form.cancel': 'Cancel',
    'form.create': 'Create',
    'form.format': 'Format',
    'form.import': 'Import',
    'form.save': 'Save',
    'format.form.date.error': 'You must select a creation date for your list',
    'format.form.date.placeholder': '01/01/2022',
    'format.form.date.title': 'Creation date *',
    'format.form.formated.title': 'Your formated army list',
    'format.form.game.error':
      "You must select the game's name that you want to play",
    'format.form.game.placeholder': 'T9A, EoW, WHB,....',
    'format.form.game.title': 'Your game *',
    'format.form.source.error': 'You must add your list',
    'format.form.source.placeholder': 'Enter an army list',
    'format.form.source.title': 'Your army list *',
    'format.new.title': 'Format and Import an army list',
    help: 'help',
    'home.app.available.google': 'Get it on Google Play',
    'home.app.available.on_platform':
      'Currently under development, available on:',
    'home.app.mobile': 'A mobile app',
    'home.no_account':
      'You can now use all the features of 9ThBuilder without having to create an account first. \nBe careful however, your lists are linked to your local session and therefore will not be available on another browser and may be lost if you delete your cache or your session."\n',
    'home.welcome': '9TH BUILDER',
    'home.whoarewe.compose': 'Compose and archive your favorite armies!',
    'home.whoarewe.description':
      'A passionate of Battle since many years. I took the 9Th Builder since several years, creates a mobile application and helps the 9Th Age administration.\nHelped by Kaos War who greatly contributed to enter army lists and for the new homePage.\n9Th Builder is an effective and easy-to-use tool for creating your army lists and sharing them. It does not generate any income :)\n',
    'home.whoarewe.discord': 'Discord',
    'home.whoarewe.draft': 'Make a team pairing',
    'home.whoarewe.format': 'Format or import your army',
    'home.whoarewe.list': 'Create an Army list',
    'home.whoarewe.newsfb': 'News Facebook',
    'home.whoarewe.paint': 'Create an Paint list',
    'home.whoarewe.readarmy': 'Read Army Books',
    'home.whoarewe.readmagic': 'Read Magic Paths',
    'home.whoarewe.title': 'Who are we?',
    'home.whoarewe.try': 'Do you want to try?',
    'home.whoarewe.whatdo': 'What can you do?',
    'lexicon.index.show': 'Army books \u0026 Tools',
    'magic.casting': 'Casting',
    'magic.duration': 'Duration',
    'magic.effect': 'Effect',
    'magic.index.show': 'Show',
    'magic.index.title': 'Magics',
    'magic.range': 'Range',
    'magic.show.back': 'Back',
    'magic.type': 'Type',
    'magic_item_categories.index.show': 'Show',
    'magic_item_categories.index.title': 'Magic item categories',
    'magic_items.Cbtbmw': 'Cannot be taken by models with',
    'magic_items.Enchantment': 'Enchantment',
    'magic_items.dominant': 'Dominant',
    'magic_items.footonly': 'foot only',
    'magic_items.index.show': 'Show',
    'magic_items.index.title': 'Magic items',
    'magic_items.only': 'only',
    'magic_items.perArmy': 'par Armée',
    'magic_items.type_figurine.All': 'All',
    'magic_items.type_figurine.AnimisteBestial': 'Animiste bestial',
    'magic_items.type_figurine.Character': 'Character',
    'magic_items.type_figurine.FeralOrc': 'Feral Orc',
    'magic_items.type_figurine.Goblins': 'Goblins',
    'magic_items.type_figurine.Infantry': 'Infantry',
    'magic_items.type_figurine.KnightCommanders': 'Knight Commanders',
    'magic_items.type_figurine.MageOnFoot': 'Mage On Foot',
    'magic_items.type_figurine.MarshalsMountedOnHorse':
      'Marshals mounted on Horse',
    'magic_items.type_figurine.ModelsOnChariots': 'models on Chariots',
    'magic_items.type_figurine.ModelsOnFoot': 'Models on foot',
    'magic_items.type_figurine.MonarchsOfTheDead': 'Monarchs of the Dead',
    'magic_items.type_figurine.Monster': 'Monster',
    'magic_items.type_figurine.MountedCharacter': 'Mounted character',
    'magic_items.type_figurine.NoLargeTarget': 'No large target',
    'magic_items.type_figurine.ParentUnit': 'Parent Unit',
    'magic_items.type_figurine.Wizard': 'Wizard',
    'magic_spell.type_lvl.A': 'A',
    'magic_spell.type_lvl.Five': '5',
    'magic_spell.type_lvl.Four': '4',
    'magic_spell.type_lvl.One': '1',
    'magic_spell.type_lvl.Six': '6',
    'magic_spell.type_lvl.Three': '3',
    'magic_spell.type_lvl.Two': '2',
    'magic_spell.type_lvl.Zero': '0',
    'magic_standards.index.show': 'Show',
    'magic_standards.index.title': 'Magic banners',
    'menu.army_lists': 'My army lists',
    'menu.help': 'Help',
    'menu.label': 'Main menu',
    'menu.languages.de': 'Germany',
    'menu.languages.en': 'English',
    'menu.languages.es': 'Spanish - Español',
    'menu.languages.fr': 'French',
    'menu.languages.hu': 'Hungarian',
    'menu.languages.it': 'Italian - Italiano',
    'menu.languages.ko': 'Korean',
    'menu.languages.lang': 'Language',
    'menu.languages.pl': 'Polish',
    'menu.languages.ru': 'Russian',
    'menu.languages.sr': 'Serbian',
    'menu.languages.zh': 'Chinese',
    'menu.preferences': 'Preferences',
    'menu.signin': 'Sign in',
    'menu.signout': 'Sign out',
    'menu.signup': 'Sign up',
    next: 'Next',
    'ninth_age.figurine.mount': 'Mount',
    'ninth_age.figurine.pts': 'pts',
    'ninth_age.magic_item.only_wizard.AllWizard': 'Wizard only',
    'ninth_age.magic_item.only_wizard.NoWizard': 'Cannot be taken by Wizards',
    'ninth_age.magic_item.only_wizard.WizardAdept': 'Wizard adept only',
    'ninth_age.magic_item.only_wizard.WizardApprentice':
      'Wizard apprentice only',
    'ninth_age.magic_item.only_wizard.WizardMaster': 'Wizard master only',
    'ninth_age.troop.offensive': 'Offensive',
    'ninth_age.unit.defensive': 'Defensive',
    'ninth_age.unit.fly': 'fly',
    'ninth_age.unit.global': 'Global',
    'ninth_age.unit.rules': 'Model Rules',
    'paint_list.delete.information': 'Are you sure to destroy this list:',
    'paint_list.delete.submit': '!!! Delete !!!',
    'paint_list.delete.title': 'Delete your list',
    'paint_list.edit.title': 'Edit your paint list',
    'paint_list.form.army.error': 'You must select an army.',
    'paint_list.form.army.placeholder': 'Select an army',
    'paint_list.form.army.title': 'Army *',
    'paint_list.form.name.error': 'You must name your list',
    'paint_list.form.name.placeholder': 'Enter a name',
    'paint_list.form.name.title': 'Name *',
    'paint_list.form.version.error': 'You must select a version.',
    'paint_list.form.version.placeholder': 'Select a version',
    'paint_list.form.version.title': 'Version *',
    'paint_list.index.add': 'Create new paint list',
    'paint_list.index.title': 'My paint lists',
    'paint_list.new.title': 'Create a new list',
    'paint_list.show.assembled': 'Assembled',
    'paint_list.show.buy': 'Buy',
    'paint_list.show.comment': 'Comment',
    'paint_list.show.first_color': 'First color',
    'paint_list.show.paint': 'Paint',
    'paint_list.show.plinth': 'Plinth',
    'paint_list.show.size': 'Size',
    'paint_list.show.state.done': 'Done',
    'paint_list.show.state.waiting': 'Waiting',
    'paint_list.show.state.wip': 'Wip',
    'paint_list.show.title': 'Your Paint list:',
    'paint_list.show.trimmed': 'Trimmed',
    'paint_list.show.unit': 'Unit',
    'paint_list.unit.form.comment.placeholder': 'Add a comment',
    'paint_list.unit.form.comment.title': 'Comment',
    'paint_list.unit.form.size.error': 'You must add a number of model',
    'paint_list.unit.form.size.placeholder': 'Select a size',
    'paint_list.unit.form.size.title': 'Size *',
    'paint_list.unit.form.title': 'Add an unit',
    'paint_list.unit.form.unit.error': 'You must select an unit',
    'paint_list.unit.form.unit.placeholder': 'Select an unit',
    'paint_list.unit.form.unit.title': 'Unit *',
    'password_change.form.confirmation': 'Password confirmation',
    'password_change.form.password': 'Password',
    'password_change.form.submit': 'Save',
    'password_change.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_change.lost.confirmation':
      "I didn't received my confirmation email",
    'password_change.lost.password': 'I have lost my password!',
    'password_change.title': 'Change your password',
    'password_lost.form.email': 'Email',
    'password_lost.form.submit': 'Send me reset password instructions',
    'password_lost.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_lost.lost.confirmation':
      "I didn't received my confirmation email",
    'password_lost.title': 'I have lost my password',
    'picker.datetime.js': 'YYYY.MM.DD HH:mm',
    'picker.datetime.rb': '%Y.%m.%d %H:%M',
    'profile.back': 'Previous page',
    'profile.delete.information':
      'You are not satisfied? \u003ca href="mailto:support@9thbuilder.com"\u003eContact us\u003c/a\u003e or',
    'profile.delete.link': 'immediately destroy your account',
    'profile.delete.title': 'Account deletion',
    'profile.form.confirmation': 'Password confirmation',
    'profile.form.email': 'Email address',
    'profile.form.game': 'Favorite',
    'profile.form.name': 'Name or nickname',
    'profile.form.password': 'Password',
    'profile.form.password_help':
      "Leave it empty if you don't want to change your password",
    'profile.form.submit': 'Save',
    'profile.title': 'My account',
    save: 'Save',
    'search_list.assembled': 'Assembled',
    'search_list.buy': 'Buy',
    'search_list.comment': 'Comment',
    'search_list.first_color': 'First color',
    'search_list.index.search': 'Submit',
    'search_list.index.search_list': 'Search an army list',
    'search_list.paint': 'Paint',
    'search_list.plinth': 'Plinth',
    'search_list.size': 'Size',
    'search_list.trimmed': 'Trimmed',
    'search_list.unit': 'Unit',
    'signin.Confirmation': 'Confirmation',
    'signin.form.email': 'Email',
    'signin.form.lost': 'Forgot ?',
    'signin.form.password': 'Password',
    'signin.form.remember': 'Remember me',
    'signin.form.submit': 'Sign-in',
    'signin.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signin.lost.confirmation': "I didn't received my confirmation email",
    'signin.lost.password': 'I have lost my password!',
    'signin.title': 'Sign in',
    'signup.form.confirmation': 'Password confirmation',
    'signup.form.email': 'Email address',
    'signup.form.game': '--Favorite--',
    'signup.form.name': 'Name or nickname',
    'signup.form.password': 'Password',
    'signup.form.register': 'Join us !',
    'signup.form.submit': 'Sign-up',
    'signup.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signup.lost.confirmation': "I didn't received my confirmation email",
    'signup.lost.password': 'I have lost my password!',
    'signup.title': 'Sign up',
    'site.accept': 'I accept',
    'site.more': 'Learn more',
    'site.use_cookie':
      'This site uses cookies to offer you the best service. By continuing your navigation, you use the use of cookies.',
    'tool.pairing.done': 'Your pairing is complete',
    'tool.pairing.draft.send_link': 'Send this link to your opponent:',
    'tool.pairing.draft.waiting_opponent': 'We are waiting your opponent',
    'tool.pairing.draw.confirm.draw': 'Confirm Draw',
    'tool.pairing.draw.confirm.response': 'Confirm Response',
    'tool.pairing.draw.confirm.select': 'Confirm select',
    'tool.pairing.draw.or': 'or',
    'tool.pairing.draw.vs': 'Vs',
    'tool.pairing.draw_round.select.draw': 'Select one army for the draft',
    'tool.pairing.draw_round.select.response': 'Select your reponses',
    'tool.pairing.draw_round.select.select': 'Select the army',
    'tool.pairing.draw_round.select.waiting': 'Waiting',
    'tool.pairing.image': 'Copy the pairing url image',
    'tool.pairing.inprogress': 'Your pairing is in progress',
    'tool.pairing.matches.tables': 'Tables:',
    'tool.pairing.my_team.my_armies': 'Your armies',
    'tool.pairing.opponent_team.team': 'Team',
    'tool.pairing.select_armies.choise_armies': 'Choise your armies',
    'tool.pairing.select_armies.confirm': 'Confirm',
    'tool.pairing.select_armies.error':
      'Sorry! There was an error loading the items.',
    'tool.pairing.select_armies.your_team': 'Your Team',
    'tool.pairing.select_team_size.how_many': 'How many players in the team?',
    'tool.pairing.table': 'Table',
    'tool.pairing.team_name.confirm': 'Confirm',
    'tool.pairing.team_name.what_name': "What's the name of your team?",
    'tool.pairing.team_name.your_name': 'Your team name',
    'tool.search_rules.index.search': 'Search',
    'tool.search_rules.index.search_army_select_error':
      'You must select one army',
    'tool.search_rules.index.search_rule': 'Choise one rule',
    'tool.search_rules.index.select_army': 'Choise the army',
    'tool.search_rules.index.select_version': 'Choise the version of 9Th Age',
    'tool.search_rules.index.title': 'Search by rules',
    'tournament.contest.back': 'Back to tournaments',
    'tournament.contest.edit': 'Edit',
    'tournament.contest.form.address': 'Address',
    'tournament.contest.form.end_date': 'End',
    'tournament.contest.form.fees': 'Fees',
    'tournament.contest.form.name': 'Name',
    'tournament.contest.form.round_count': 'Rounds',
    'tournament.contest.form.start_date': 'Start',
    'tournament.contest.form.submit': 'Save',
    'tournament.contest.form.team_max': 'Max teams',
    'tournament.contest.form.user_max': 'Max users',
    'tournament.contest.form.user_team_max': 'Max users by team',
    'tournament.contest.form.version': 'Version',
    'tournament.contest.index.title': 'My tournaments',
    'tournament.contest.name': 'Tournament',
    'tournament.contest.new.title': 'Create a tournament',
    'tournament.contest.print_armies': 'Print all armies',
    'tournament.contest.print_repport': 'Rapport',
    'tournament.contest.total': 'Total',
    'tournament.custom_point.name': 'Paint, Wysiwyg, List',
    'tournament.round.add': 'Add round',
    'tournament.round.name': 'Round',
    'tournament.round.pools.validate': 'Create pools',
    'tournament.team.add': 'Add Team',
    'tournament.team.back': 'Back to teams',
    'tournament.team.edit.title': 'Edition team',
    'tournament.team.export.title': 'Team',
    'tournament.team.first': 'Add your first team',
    'tournament.team.form.email': 'Email',
    'tournament.team.form.name': 'Name',
    'tournament.team.form.submit': 'Save',
    'tournament.team.index.title': 'My Tournament teams',
    'tournament.team.name': 'Teams',
    'tournament.team.new.title': 'Add teams',
    'tournament.teams.add': 'Add Team',
    'tournament.teams.back': 'Back to tournaments',
    'tournament.teams.title': 'Teams',
    'tournament.user_apply.add': 'Add Participant',
    'tournament.user_apply.add_into_team': 'Add partipant in this team',
    'tournament.user_apply.army_list.add_now': 'Add it now!',
    'tournament.user_apply.army_list.create': 'Create a new list',
    'tournament.user_apply.army_list.need':
      'You have not added your army list yet.',
    'tournament.user_apply.army_list.or': 'or',
    'tournament.user_apply.army_list.use_existing': 'Use an existing list',
    'tournament.user_apply.army_list.which': 'Which army list ?',
    'tournament.user_apply.army_list_select.form.submit': 'Save',
    'tournament.user_apply.edit.title': 'Edit your participation',
    'tournament.user_apply.first': 'Add your first Participant',
    'tournament.user_apply.form.name': 'Name',
    'tournament.user_apply.form.name_detail':
      'You can add somes users (1 user by line) with email separated by a comma (name, email).',
    'tournament.user_apply.form.or': 'or',
    'tournament.user_apply.form.submit': 'Add',
    'tournament.user_apply.form.user': 'User',
    'tournament.user_apply.manage': 'Manage Team',
    'tournament.user_apply.name': 'User',
    'tournament.user_apply.new.title': 'Add users',
    'tournament.user_apply.remove': 'Remove Participant',
    'tournament.user_apply.share_link': 'Share invitation link',
    'tournament.user_apply.team_leader': 'Is the team captain',
    'unit.base.label': 'Base',
    'unit.height.Gigantic': 'Gigantic',
    'unit.height.Large': 'Large',
    'unit.height.Standard': 'Standard',
    'unit.limit.perArmy': 'par Armée',
    'unit.limit.single': 'single model',
    'unit.limit.unit': 'Units/Army',
    'unit.limit.model': 'Models/Army',
    'unit.mount': 'Mount',
    'unit.show.add_model':
      ' + \u003cstrong\u003e{pts}\u003c/strong\u003e pts/extra model',
    'unit.show.change':
      '{name} utils of {number} models count towards {new_name}',
    'unit.show.change_with_limit':
      'Units of {number} or more models without {limit} count towards {new_name} instead of {old_name}.',
    'unit.show.size':
      '\u003cstrong\u003e{min_size}-{max_size}\u003c/strong\u003e models',
    'unit.size.Gigantic': 'Gigantic',
    'unit.size.Large': 'Large',
    'unit.size.Standard': 'Standard',
    'unit.type.label': 'Type',
    'unit_option.per_model': '/mod.',
    'unit_option.use_points.free': 'free',
    'unit_option.use_points.no_limit': 'no limit',
    'unit_option.use_points.up_to': 'up to',
    'unit_options.category.C': 'C',
    'unit_options.category.M': 'M',
    'unit_options.category.S': 'S',
    'unit_options.footonly': 'foot only',
    'version.index.pairing': 'Team Pairing',
    'version.index.search': 'Search by rule',
    'version.index.show': 'Show',
    'version.index.title': 'Versions',
    'version.index.tools': 'Tools',
    'version.show.back': 'Back',
    welcome: 'Welcome',
    with: 'with %',
    without: 'without %',
  },
  ua: {
    Common: 'Common',
    'active_admin.menu.admin': 'Administration',
    'active_admin.menu.armies': 'Armies',
    'active_admin.menu.builder': 'Builder',
    'active_admin.menu.dashboard': 'Administration',
    'active_admin.menu.import': 'Import',
    'active_admin.menu.log': 'Log',
    'active_admin.menu.magic': 'magic',
    'active_admin.menu.map': 'Maps',
    'active_admin.menu.ninth_age': 'Ninth Age',
    'active_admin.menu.organisation': 'Organisation',
    'active_admin.menu.paint': 'Paint',
    'active_admin.menu.statistique': 'Statistiques',
    'active_admin.menu.tournament': 'Tournament',
    'active_admin.menu.unit': 'Unit',
    'active_admin.menu.user_annoncement': 'Annoncements',
    'active_admin.menu.users': 'Users',
    'active_admin.menu.versioning': 'Versioning',
    'active_admin.translate.ko': 'Korean',
    'active_admin.translate.pl': 'Polish',
    'active_admin.translate.ru': 'Russian',
    'active_admin.translate.zh': 'Chinese',
    'activerecord.attributes.data_analytics/report.deployments.CounterThrust':
      'Counter Thrust',
    'activerecord.attributes.data_analytics/report.deployments.DawnAssult':
      'Dawn Assult',
    'activerecord.attributes.data_analytics/report.deployments.Encircle':
      'Encircle',
    'activerecord.attributes.data_analytics/report.deployments.FrontlineClash':
      'Frontline Clash',
    'activerecord.attributes.data_analytics/report.deployments.MarchingColumns':
      'Marching Columns',
    'activerecord.attributes.data_analytics/report.deployments.RefusedFlank':
      'Refused Flank',
    'activerecord.attributes.data_analytics/report.maps.A1':
      'A1 - Shrouded Pool',
    'activerecord.attributes.data_analytics/report.maps.A2':
      'A2 - Foothill Outpost',
    'activerecord.attributes.data_analytics/report.maps.A3':
      'A3 - Dilapidated Manor',
    'activerecord.attributes.data_analytics/report.maps.A4':
      'A4 - Volcanic Lake',
    'activerecord.attributes.data_analytics/report.maps.A5':
      'A5 - Misty Marshes',
    'activerecord.attributes.data_analytics/report.maps.A6':
      'A6 - Ancient Walls',
    'activerecord.attributes.data_analytics/report.maps.A7': 'A7 - Beacon Hill',
    'activerecord.attributes.data_analytics/report.maps.A8':
      'A8 - Witch’s Cottage',
    'activerecord.attributes.data_analytics/report.maps.B1':
      'B1 - Mage’s Sanctum',
    'activerecord.attributes.data_analytics/report.maps.B2':
      'B2 - Villa Grounds',
    'activerecord.attributes.data_analytics/report.maps.B3':
      'B3 - Ancient Fortress',
    'activerecord.attributes.data_analytics/report.maps.B4':
      'B4 - Frontier Farm',
    'activerecord.attributes.data_analytics/report.maps.B5':
      'B5 - Ravaged Watchtower',
    'activerecord.attributes.data_analytics/report.maps.B6':
      'B6 - Creeping Forest',
    'activerecord.attributes.data_analytics/report.maps.B7':
      'B7 - Eerie Graveyard',
    'activerecord.attributes.data_analytics/report.maps.B8':
      'B8 - Shattered Bridge',
    'activerecord.attributes.data_analytics/report.objectives.Breakthrough':
      'Breakthrough',
    'activerecord.attributes.data_analytics/report.objectives.CaptureFlags':
      'Capture the Flags',
    'activerecord.attributes.data_analytics/report.objectives.HoldGround':
      'Hold the Ground',
    'activerecord.attributes.data_analytics/report.objectives.KingHill':
      'King of the Hill',
    'activerecord.attributes.data_analytics/report.objectives.SecureTarget':
      'Secure Target',
    'activerecord.attributes.data_analytics/report.objectives.SpoilsWar':
      'Spoils of War',
    'activerecord.attributes.data_analytics/report.opponent_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.opponent_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.opponent_objective':
      'Take the objective',
    'activerecord.attributes.data_analytics/report.your_deployment':
      'First to deploy',
    'activerecord.attributes.data_analytics/report.your_first_turn':
      'First turn',
    'activerecord.attributes.data_analytics/report.your_objective':
      'Take the objective',
    'activerecord.attributes.ninth_age/magic_item.only_foot':
      'Prohibited mount',
    'activerecord.attributes.ninth_age/magic_item.only_wizard':
      'Only wizard can use it',
    'activerecord.attributes.ninth_age/magic_item.organisation_ids':
      'Organisations required from the model',
    'activerecord.attributes.ninth_age/magic_item.model_rule_ids':
      'Prohibited  model rules on model',
    'activerecord.attributes.ninth_age/magic_item.unit_ids':
      'For this units only',
    'activerecord.attributes.ninth_age/magic_item.unit_size':
      'Unit with this size can not use this item',
    'activerecord.attributes.ninth_age/magic_standard.organisation':
      'Add organisation to unit',
    'activerecord.attributes.ninth_age/magic_standard.organisation_ids':
      "Only organisation's units",
    'activerecord.attributes.ninth_age/troop.carac_agi': 'Agi',
    'activerecord.attributes.ninth_age/troop.carac_ap': 'Ap',
    'activerecord.attributes.ninth_age/troop.carac_att': 'Att',
    'activerecord.attributes.ninth_age/troop.carac_of': 'Off',
    'activerecord.attributes.ninth_age/troop.carac_str': 'Str',
    'activerecord.attributes.ninth_age/unit.carac_aeg': 'Aeg',
    'activerecord.attributes.ninth_age/unit.carac_arm': 'Arm',
    'activerecord.attributes.ninth_age/unit.carac_def': 'Def',
    'activerecord.attributes.ninth_age/unit.carac_dis': 'Dis',
    'activerecord.attributes.ninth_age/unit.carac_evoked': 'Rea',
    'activerecord.attributes.ninth_age/unit.carac_fly_adv': 'Fly adv',
    'activerecord.attributes.ninth_age/unit.carac_fly_mar': 'Fly mar',
    'activerecord.attributes.ninth_age/unit.carac_ground_adv': 'Adv',
    'activerecord.attributes.ninth_age/unit.carac_ground_mar': 'Mar',
    'activerecord.attributes.ninth_age/unit.carac_hp': 'HP',
    'activerecord.attributes.ninth_age/unit.carac_res': 'Res',
    'activerecord.attributes.ninth_age_army.source.FanMade': 'Fan Made',
    'activerecord.attributes.ninth_age_army.source.Official': 'Official',
    'activerecord.attributes.ninth_age_army.source.Supplement': 'Supplement',
    'activerecord.attributes.ninth_age_unit_option.category.BSB':
      'Battle Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.C': 'Champion',
    'activerecord.attributes.ninth_age_unit_option.category.ModelRule':
      'ModelRule',
    'activerecord.attributes.ninth_age_unit_option.category.ExtraSpells':
      'Spells',
    'activerecord.attributes.ninth_age_unit_option.category.General': 'General',
    'activerecord.attributes.ninth_age_unit_option.category.Generic': 'Generic',
    'activerecord.attributes.ninth_age_unit_option.category.M': 'Musician',
    'activerecord.attributes.ninth_age_unit_option.category.MagicBanner':
      'Banner Enchantment',
    'activerecord.attributes.ninth_age_unit_option.category.MagicEquipment':
      'Magic items',
    'activerecord.attributes.ninth_age_unit_option.category.MagicLvl':
      'Magic LVL',
    'activerecord.attributes.ninth_age_unit_option.category.MagicPath':
      'Magic Path',
    'activerecord.attributes.ninth_age_unit_option.category.MayTake':
      'May take',
    'activerecord.attributes.ninth_age_unit_option.category.Mount': 'Mount',
    'activerecord.attributes.ninth_age_unit_option.category.MustChoice':
      'Must choose',
    'activerecord.attributes.ninth_age_unit_option.category.OneChoice':
      'One choice only',
    'activerecord.attributes.ninth_age_unit_option.category.S':
      'Standard Bearer',
    'activerecord.attributes.ninth_age_unit_option.category.SpecialRule':
      'Special Rule',
    'activerecord.attributes.ninth_age_unit_option.category.WizardAdept':
      'Wizard Adept',
    'activerecord.attributes.ninth_age_unit_option.category.WizardApprentice':
      'Wizard Apprentice',
    'activerecord.attributes.ninth_age_unit_option.category.WizardMaster':
      'Wizard Master',
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ChangeUnitOrganisation':
      "Change unit's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.ExcludeAddOrganisation':
      "Not affected with other unit option's organisation",
    'activerecord.attributes.ninth_age_unit_option.organisation_mode.Unit':
      'All the unit',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_availability.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Disable':
      'Disable',
    'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Enable':
      'Enable',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Add':
      'Add',
    'activerecord.attributes.ninth_age_unit_option_change_profil.action.Replace':
      'Replace',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.A':
      'V1-A',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.BS':
      'V1-BS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.E':
      'V1-E',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.I':
      'V1-I',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.LD':
      'V1-Ld',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.M':
      'V1-M',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.S':
      'V1-S',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.T':
      'V1-T',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.W':
      'V1-W',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.WS':
      'V1-WS',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_aeg':
      'V2-Aeg',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_agi':
      'V2-Agi',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ap':
      'V2-Ap',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_arm':
      'V2-Arm',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_att':
      'V2-Att',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_def':
      'V2-Def',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_dis':
      'V2-Dis',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_evoked':
      'V2-Evoked',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_adv':
      'V2-Fly-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_mar':
      'V2-Fly-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_adv':
      'V2-Adv',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_mar':
      'V2-Mar',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_hp':
      'V2-Hp',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_of':
      'V2-Of',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_res':
      'V2-Res',
    'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_str':
      'V2-Str',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByArmy':
      'per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByModel':
      'item per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.MaxRatioByArmy':
      'Max Ratio per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Model':
      'Models per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.ModelByUnit':
      'Models per Unit',
    'activerecord.attributes.ninth_age_unit_option_limit.limit.Units':
      'Units per Army',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Quantity':
      'Quantity from the option',
    'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Selection':
      'Option selected',
    'activerecord.attributes.ninth_age_version.game.EssenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.WarhammerBattle':
      'Warhammer Battle',
    'activerecord.attributes.ninth_age_version.game.TheOldWorld':
      'The Old World',
    'activerecord.attributes.ninth_age_version.game.essenceOfWar':
      'Essence of War',
    'activerecord.attributes.ninth_age_version.game.ninthAge': 'Ninth Age',
    'activerecord.attributes.ninth_age_version.game.battle': 'Warhammer Battle',
    'activerecord.attributes.ninth_age_version.game.theOldWorld':
      'The Old World',
    'activerecord.attributes.tournament/contest.participation': 'Participation',
    'activerecord.models.ninth_age/magic_standard.one': 'Magic banner',
    'activerecord.models.ninth_age/magic_standard.other': 'Magic banners',
    'activerecord.models.ninth_age/unit.one': 'Unit',
    'activerecord.models.ninth_age/unit.other': 'Units',
    'admin.dashboard': 'Administration',
    'admin.tournament': 'Tournament Org',
    and: ' and ',
    'army.armybook': 'Army book',
    'army.banner': 'Banner enchantement',
    'army.index.show': 'Show',
    'army.index.title': 'All armies',
    'army.show.back': 'Back',
    'army_list.clone.information': 'Are you sure to duplicate list:',
    'army_list.clone.submit': 'Duplicate',
    'army_list.clone.title': 'Duplicate list',
    'army_list.delete.information': 'Are you sure to destroy this list:',
    'army_list.delete.submit': '!!! Delete !!!',
    'army_list.delete.title': 'Delete\u003cbr /\u003elist',
    'army_list.edit.title': 'Update the list',
    'army_list.export.html_full': 'Full HTML',
    'army_list.export.html_lite': 'Lite HTML',
    'army_list.export.include_magics': 'Include magic paths?',
    'army_list.export.information': 'Choose format for list export:',
    'army_list.export.pdf_full': 'Full PDF',
    'army_list.export.pdf_lite': 'Lite PDF',
    'army_list.export.print': 'Print',
    'army_list.export.separator': 'Separator',
    'army_list.export.title': 'Export list',
    'army_list.export.txt.general': 'General',
    'army_list.export.verbosity': 'Verbosity',
    'army_list.form.army.error': 'You must select an army.',
    'army_list.form.army.placeholder': 'Select an army',
    'army_list.form.army.title': 'Army *',
    'army_list.form.folder.placeholder': 'Select a folder',
    'army_list.form.folder.title': 'Folder',
    'army_list.form.max.name': 'You must choose the max of your army',
    'army_list.form.max.placeholder': 'Enter a max',
    'army_list.form.max.title': 'Max *',
    'army_list.form.name.error': 'You must name your list',
    'army_list.form.name.placeholder': 'Enter a name',
    'army_list.form.name.title': 'Name *',
    'army_list.form.notes.placeholder': 'My notes',
    'army_list.form.notes.title': 'Notes',
    'army_list.form.private.title': 'is a private list',
    'army_list.form.rate.title': 'Rate with max',
    'army_list.form.version.error': 'You must select a version.',
    'army_list.form.version.placeholder': 'Select a version',
    'army_list.form.version.title': 'Version *',
    'army_list.format.title': 'Format \u0026 Import an army list',
    'army_list.index.add': 'Create new army list',
    'army_list.index.and': 'and',
    'army_list.index.contest': 'Create a contest',
    'army_list.index.filter': 'Filter by',
    'army_list.index.folder': 'Create new folder',
    'army_list.index.name_or_notes': 'Name or notes',
    'army_list.index.search': 'Submit',
    'army_list.index.title': 'My army lists',
    'army_list.new.title': 'Create new list',
    'army_list.show.add_unit': 'Add unit',
    'army_list.show.delete': 'Delete',
    'army_list.show.duplicate': 'Duplicate',
    'army_list.show.edit': 'Edit',
    'army_list.show.export': 'Export',
    'army_list.show.notes': 'Notes',
    'army_list.show.organisation.excess': 'Excess',
    'army_list.show.organisation.missing': 'Missing',
    'army_list.show.organisation.remaining': 'Remaining',
    'army_list.show.print': 'Print',
    'army_list.show.rearrange_units': 'Rearrange Units',
    'army_list.show.title': 'Army list • {name}',
    'army_list.unit.form.name.placeholder': 'Add a name',
    'army_list.unit.form.name.title': 'Name',
    'army_list.unit.form.title': 'Add an unit',
    'army_list.unit.form.unit.error': 'You must select an unit',
    'army_list.unit.form.unit.placeholder': 'Select an unit',
    'army_list.unit.form.unit.title': 'Unit *',
    'army_list_unit.delete.information': 'Are you sure to destroy this unit:',
    'army_list_unit.delete.submit': '!!! Delete !!!',
    'army_list_unit.delete.title': 'Delete\u003cbr /\u003eunit',
    'army_list_unit.duplicate.new_army_list': 'New {name} list',
    'army_list_unit.duplicate.target': 'To:',
    'army_list_unit.duplicate.title': 'Duplicate',
    'army_list_unit.edit.form.magic': 'Magic',
    'army_list_unit.edit.form.notes': 'Notes',
    'army_list_unit.edit.magic_items': 'Magic items',
    'army_list_unit.edit.magic_standards': 'Magic banners',
    'army_list_unit.edit.options': 'Options',
    'army_list_unit.edit.title': 'Edit',
    'army_list_unit.form.name': 'Name',
    'army_list_unit.form.submit': 'Create Unit',
    'army_list_unit.new.title': 'Add new unit',
    'army_list_unit.show.command_group_unit_options': 'Command Group Options',
    'army_list_unit.show.delete': 'Delete',
    'army_list_unit.show.duplicate': 'Duplicate',
    'army_list_unit.show.edit': 'Edit',
    'army_list_unit.show.model_rules': 'ModelRules',
    'army_list_unit.show.magic': 'Magic',
    'army_list_unit.show.magic_items': 'Magic items',
    'army_list_unit.show.magic_lvl_unit_options':
      'May become (one choice only)',
    'army_list_unit.show.magic_standards': 'Magic banners',
    'army_list_unit.show.magic_unit_options': 'Magic Options',
    'army_list_unit.show.mount_unit_options': 'Mount Options',
    'army_list_unit.show.notes': 'Notes',
    'army_list_unit.show.path_unit_options': 'Must generate spells from',
    'army_list_unit.show.path_unit_options_choose_one':
      'Must generate spells from (choose one)',
    'army_list_unit.show.troops.A': 'A',
    'army_list_unit.show.troops.BS': 'BS',
    'army_list_unit.show.troops.E': 'Evoked',
    'army_list_unit.show.troops.I': 'I',
    'army_list_unit.show.troops.LD': 'Ld',
    'army_list_unit.show.troops.M': 'M',
    'army_list_unit.show.troops.S': 'S',
    'army_list_unit.show.troops.T': 'T',
    'army_list_unit.show.troops.W': 'W',
    'army_list_unit.show.troops.WS': 'WS',
    'army_list_unit.show.troops.name': 'Troops',
    'army_list_unit.show.troops.profile': 'Profile',
    'army_list_unit.show.troops.type': "Troop's type",
    'army_list_unit.show.unit_options': 'Options',
    'army_magic_spell.name': 'Racial Trait Spell',
    'builder.searchs.index.and': 'and',
    'builder.searchs.index.between': 'between',
    'builder.searchs.index.points': 'points',
    'builder.searchs.index.search': 'Search',
    'builder.searchs.index.search_army_select_error':
      'You must select one army',
    'builder.searchs.index.select_army': 'Choise the army',
    'builder.searchs.index.select_points_range': 'Number of point',
    'builder.searchs.index.select_version': 'Choise the version of 9Th Age',
    'builder.searchs.index.title': 'Search an Army list',
    'builder.searchs.show.and': 'and',
    'builder.searchs.show.between': 'between',
    'builder.searchs.show.points': 'points',
    'builder.searchs.show.title': 'Army list found',
    close: 'Close',
    'confirmation.form.email': 'Email',
    'confirmation.form.submit': 'Save',
    'confirmation.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'confirmation.lost.password': 'I have lost my password!',
    'confirmation.title': 'Re-send confirmation instructions',
    'contest.back': 'back',
    'contest.delete.information': 'Are you sure to delete:',
    'contest.delete.submit': '!!! Delete !!!',
    'contest.delete.title': 'Delete contest',
    'contest.edit.title': 'Edit my contest',
    'contest.form.armyListMax.error': 'Your contest need a max points by army',
    'contest.form.armyListMax.placeholder': 'Enter a max points by army',
    'contest.form.armyListMax.title': 'Max points by army',
    'contest.form.endDate.error': 'Your contest need a end date',
    'contest.form.endDate.placeholder': 'Enter a end date',
    'contest.form.endDate.title': 'End date *',
    'contest.form.name.error': 'You must name your list',
    'contest.form.name.placeholder': 'Enter a name',
    'contest.form.name.title': 'Name *',
    'contest.form.participation.error':
      'Your contest need a participation mode',
    'contest.form.participation.placeholder': 'Enter a participation mode',
    'contest.form.participation.title': 'Individual or by Team',
    'contest.form.startDate.error': 'Your contest need a start date',
    'contest.form.startDate.placeholder': 'Enter a start date',
    'contest.form.startDate.title': 'Start date *',
    'contest.form.teamMax.error': 'Your contest need a number of team',
    'contest.form.teamMax.placeholder': 'Enter a number of team',
    'contest.form.teamMax.title': 'Number of team',
    'contest.form.userMax.error':
      'Your contest need a number of participant or team size',
    'contest.form.userMax.placeholder':
      'Enter a number of participant or team size',
    'contest.form.userMax.title': 'Number of participant or team size',
    'contest.form.versionid.error': 'Your contest need a game version',
    'contest.form.versionid.placeholder': 'Enter a game version',
    'contest.form.versionid.title': 'Game version *',
    'contest.name': 'Tournament',
    'contest.new.title': 'Create a contest',
    'contest.show.title': 'Contest: {name}',
    'data_analytics.analytics.title': 'Project: Better data for T9A',
    'data_analytics.report.new.title': 'Report a game',
    'model_rules.index.show': 'Show',
    'model_rules.index.title': 'model rules',
    'export.format': 'Format',
    'export.full': 'Full',
    'export.lite': 'Lite',
    'export.magics': 'Magics',
    'export.nomagics': 'No Magics',
    'export.print': 'print',
    'export.verbosity': 'Verbosity',
    'export.withmagics': 'With magics',
    'folder.add_army_list.form.select': 'Select an army list',
    'folder.add_army_list.title': 'Add a list into this folder',
    'folder.back': 'back',
    'folder.delete.information': 'Are you sure to delete:',
    'folder.delete.submit': '!!! Delete !!!',
    'folder.delete.title': 'Delete folder',
    'folder.edit.title': 'Edit my folder',
    'folder.form.is_share.title': 'Share this folder',
    'folder.form.name.error': 'You must name your list',
    'folder.form.name.placeholder': 'Enter a name',
    'folder.form.name.title': 'Name *',
    'folder.form.parent.placeholder': 'Select the parent',
    'folder.form.parent.title': 'Parent',
    'folder.name': 'Folder',
    'folder.new.title': 'Create a folder',
    'folder.share.title': 'Share folder',
    'folder.show.title': 'Folder: {name}',
    'folder.tournament.information':
      'You can convert this folder into a tournament!',
    'folder.tournament.submit': '!!! Create !!!',
    'folder.tournament.title': 'Create a tournament',
    'footerlink.privacy': 'Privacy Policy',
    'form.add': 'Add',
    'form.cancel': 'Cancel',
    'form.create': 'Create',
    'form.format': 'Format',
    'form.import': 'Import',
    'form.save': 'Save',
    'format.form.date.error': 'You must select a creation date for your list',
    'format.form.date.placeholder': '01/01/2022',
    'format.form.date.title': 'Creation date *',
    'format.form.formated.title': 'Your formated army list',
    'format.form.game.error':
      "You must select the game's name that you want to play",
    'format.form.game.placeholder': 'T9A, EoW, WHB,....',
    'format.form.game.title': 'Your game *',
    'format.form.source.error': 'You must add your list',
    'format.form.source.placeholder': 'Enter an army list',
    'format.form.source.title': 'Your army list *',
    'format.new.title': 'Format and Import an army list',
    help: 'help',
    'home.app.available.google': 'Get it on Google Play',
    'home.app.available.on_platform':
      'Currently under development, available on:',
    'home.app.mobile': 'A mobile app',
    'home.no_account':
      'You can now use all the features of 9ThBuilder without having to create an account first. \nBe careful however, your lists are linked to your local session and therefore will not be available on another browser and may be lost if you delete your cache or your session."\n',
    'home.welcome': '9TH BUILDER',
    'home.whoarewe.compose': 'Compose and archive your favorite armies!',
    'home.whoarewe.description':
      'A passionate of Battle since many years. I took the 9Th Builder since several years, creates a mobile application and helps the 9Th Age administration.\nHelped by Kaos War who greatly contributed to enter army lists and for the new homePage.\n9Th Builder is an effective and easy-to-use tool for creating your army lists and sharing them. It does not generate any income :)\n',
    'home.whoarewe.discord': 'Discord',
    'home.whoarewe.draft': 'Make a team pairing',
    'home.whoarewe.format': 'Format or import your army',
    'home.whoarewe.list': 'Create an Army list',
    'home.whoarewe.newsfb': 'News Facebook',
    'home.whoarewe.paint': 'Create an Paint list',
    'home.whoarewe.readarmy': 'Read Army Books',
    'home.whoarewe.readmagic': 'Read Magic Paths',
    'home.whoarewe.title': 'Who are we?',
    'home.whoarewe.try': 'Do you want to try?',
    'home.whoarewe.whatdo': 'What can you do?',
    'lexicon.index.show': 'Army books \u0026 Tools',
    'magic.casting': 'Casting',
    'magic.duration': 'Duration',
    'magic.effect': 'Effect',
    'magic.index.show': 'Show',
    'magic.index.title': 'Magics',
    'magic.range': 'Range',
    'magic.show.back': 'Back',
    'magic.type': 'Type',
    'magic_item_categories.index.show': 'Show',
    'magic_item_categories.index.title': 'Magic item categories',
    'magic_items.Cbtbmw': 'Cannot be taken by models with',
    'magic_items.Enchantment': 'Enchantment',
    'magic_items.dominant': 'Dominant',
    'magic_items.footonly': 'foot only',
    'magic_items.index.show': 'Show',
    'magic_items.index.title': 'Magic items',
    'magic_items.only': 'only',
    'magic_items.perArmy': 'par Armée',
    'magic_items.type_figurine.All': 'All',
    'magic_items.type_figurine.AnimisteBestial': 'Animiste bestial',
    'magic_items.type_figurine.Character': 'Character',
    'magic_items.type_figurine.FeralOrc': 'Feral Orc',
    'magic_items.type_figurine.Goblins': 'Goblins',
    'magic_items.type_figurine.Infantry': 'Infantry',
    'magic_items.type_figurine.KnightCommanders': 'Knight Commanders',
    'magic_items.type_figurine.MageOnFoot': 'Mage On Foot',
    'magic_items.type_figurine.MarshalsMountedOnHorse':
      'Marshals mounted on Horse',
    'magic_items.type_figurine.ModelsOnChariots': 'models on Chariots',
    'magic_items.type_figurine.ModelsOnFoot': 'Models on foot',
    'magic_items.type_figurine.MonarchsOfTheDead': 'Monarchs of the Dead',
    'magic_items.type_figurine.Monster': 'Monster',
    'magic_items.type_figurine.MountedCharacter': 'Mounted character',
    'magic_items.type_figurine.NoLargeTarget': 'No large target',
    'magic_items.type_figurine.ParentUnit': 'Parent Unit',
    'magic_items.type_figurine.Wizard': 'Wizard',
    'magic_spell.type_lvl.A': 'A',
    'magic_spell.type_lvl.Five': '5',
    'magic_spell.type_lvl.Four': '4',
    'magic_spell.type_lvl.One': '1',
    'magic_spell.type_lvl.Six': '6',
    'magic_spell.type_lvl.Three': '3',
    'magic_spell.type_lvl.Two': '2',
    'magic_spell.type_lvl.Zero': '0',
    'magic_standards.index.show': 'Show',
    'magic_standards.index.title': 'Magic banners',
    'menu.army_lists': 'My army lists',
    'menu.help': 'Help',
    'menu.label': 'Main menu',
    'menu.languages.de': 'Germany',
    'menu.languages.en': 'English',
    'menu.languages.es': 'Spanish - Español',
    'menu.languages.fr': 'French',
    'menu.languages.hu': 'Hungarian',
    'menu.languages.it': 'Italian - Italiano',
    'menu.languages.ko': 'Korean',
    'menu.languages.lang': 'Language',
    'menu.languages.pl': 'Polish',
    'menu.languages.ru': 'Russian',
    'menu.languages.sr': 'Serbian',
    'menu.languages.zh': 'Chinese',
    'menu.preferences': 'Preferences',
    'menu.signin': 'Sign in',
    'menu.signout': 'Sign out',
    'menu.signup': 'Sign up',
    next: 'Next',
    'ninth_age.figurine.mount': 'Mount',
    'ninth_age.figurine.pts': 'pts',
    'ninth_age.magic_item.only_wizard.AllWizard': 'Wizard only',
    'ninth_age.magic_item.only_wizard.NoWizard': 'Cannot be taken by Wizards',
    'ninth_age.magic_item.only_wizard.WizardAdept': 'Wizard adept only',
    'ninth_age.magic_item.only_wizard.WizardApprentice':
      'Wizard apprentice only',
    'ninth_age.magic_item.only_wizard.WizardMaster': 'Wizard master only',
    'ninth_age.troop.offensive': 'Offensive',
    'ninth_age.unit.defensive': 'Defensive',
    'ninth_age.unit.fly': 'fly',
    'ninth_age.unit.global': 'Global',
    'ninth_age.unit.rules': 'Model Rules',
    'paint_list.delete.information': 'Are you sure to destroy this list:',
    'paint_list.delete.submit': '!!! Delete !!!',
    'paint_list.delete.title': 'Delete your list',
    'paint_list.edit.title': 'Edit your paint list',
    'paint_list.form.army.error': 'You must select an army.',
    'paint_list.form.army.placeholder': 'Select an army',
    'paint_list.form.army.title': 'Army *',
    'paint_list.form.name.error': 'You must name your list',
    'paint_list.form.name.placeholder': 'Enter a name',
    'paint_list.form.name.title': 'Name *',
    'paint_list.form.version.error': 'You must select a version.',
    'paint_list.form.version.placeholder': 'Select a version',
    'paint_list.form.version.title': 'Version *',
    'paint_list.index.add': 'Create new paint list',
    'paint_list.index.title': 'My paint lists',
    'paint_list.new.title': 'Create a new list',
    'paint_list.show.assembled': 'Assembled',
    'paint_list.show.buy': 'Buy',
    'paint_list.show.comment': 'Comment',
    'paint_list.show.first_color': 'First color',
    'paint_list.show.paint': 'Paint',
    'paint_list.show.plinth': 'Plinth',
    'paint_list.show.size': 'Size',
    'paint_list.show.state.done': 'Done',
    'paint_list.show.state.waiting': 'Waiting',
    'paint_list.show.state.wip': 'Wip',
    'paint_list.show.title': 'Your Paint list:',
    'paint_list.show.trimmed': 'Trimmed',
    'paint_list.show.unit': 'Unit',
    'paint_list.unit.form.comment.placeholder': 'Add a comment',
    'paint_list.unit.form.comment.title': 'Comment',
    'paint_list.unit.form.size.error': 'You must add a number of model',
    'paint_list.unit.form.size.placeholder': 'Select a size',
    'paint_list.unit.form.size.title': 'Size *',
    'paint_list.unit.form.title': 'Add an unit',
    'paint_list.unit.form.unit.error': 'You must select an unit',
    'paint_list.unit.form.unit.placeholder': 'Select an unit',
    'paint_list.unit.form.unit.title': 'Unit *',
    'password_change.form.confirmation': 'Password confirmation',
    'password_change.form.password': 'Password',
    'password_change.form.submit': 'Save',
    'password_change.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_change.lost.confirmation':
      "I didn't received my confirmation email",
    'password_change.lost.password': 'I have lost my password!',
    'password_change.title': 'Change your password',
    'password_lost.form.email': 'Email',
    'password_lost.form.submit': 'Send me reset password instructions',
    'password_lost.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'password_lost.lost.confirmation':
      "I didn't received my confirmation email",
    'password_lost.title': 'I have lost my password',
    'picker.datetime.js': 'YYYY.MM.DD HH:mm',
    'picker.datetime.rb': '%Y.%m.%d %H:%M',
    'profile.back': 'Previous page',
    'profile.delete.information':
      'You are not satisfied? \u003ca href="mailto:support@9thbuilder.com"\u003eContact us\u003c/a\u003e or',
    'profile.delete.link': 'immediately destroy your account',
    'profile.delete.title': 'Account deletion',
    'profile.form.confirmation': 'Password confirmation',
    'profile.form.email': 'Email address',
    'profile.form.game': 'Favorite',
    'profile.form.name': 'Name or nickname',
    'profile.form.password': 'Password',
    'profile.form.password_help':
      "Leave it empty if you don't want to change your password",
    'profile.form.submit': 'Save',
    'profile.title': 'My account',
    save: 'Save',
    'search_list.assembled': 'Assembled',
    'search_list.buy': 'Buy',
    'search_list.comment': 'Comment',
    'search_list.first_color': 'First color',
    'search_list.index.search': 'Submit',
    'search_list.index.search_list': 'Search an army list',
    'search_list.paint': 'Paint',
    'search_list.plinth': 'Plinth',
    'search_list.size': 'Size',
    'search_list.trimmed': 'Trimmed',
    'search_list.unit': 'Unit',
    'signin.Confirmation': 'Confirmation',
    'signin.form.email': 'Email',
    'signin.form.lost': 'Forgot ?',
    'signin.form.password': 'Password',
    'signin.form.remember': 'Remember me',
    'signin.form.submit': 'Sign-in',
    'signin.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signin.lost.confirmation': "I didn't received my confirmation email",
    'signin.lost.password': 'I have lost my password!',
    'signin.title': 'Sign in',
    'signup.form.confirmation': 'Password confirmation',
    'signup.form.email': 'Email address',
    'signup.form.game': '--Favorite--',
    'signup.form.name': 'Name or nickname',
    'signup.form.password': 'Password',
    'signup.form.register': 'Join us !',
    'signup.form.submit': 'Sign-up',
    'signup.information':
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
    'signup.lost.confirmation': "I didn't received my confirmation email",
    'signup.lost.password': 'I have lost my password!',
    'signup.title': 'Sign up',
    'site.accept': 'I accept',
    'site.more': 'Learn more',
    'site.use_cookie':
      'This site uses cookies to offer you the best service. By continuing your navigation, you use the use of cookies.',
    'tool.pairing.done': 'Your pairing is complete',
    'tool.pairing.draft.send_link': 'Send this link to your opponent:',
    'tool.pairing.draft.waiting_opponent': 'We are waiting your opponent',
    'tool.pairing.draw.confirm.draw': 'Confirm Draw',
    'tool.pairing.draw.confirm.response': 'Confirm Response',
    'tool.pairing.draw.confirm.select': 'Confirm select',
    'tool.pairing.draw.or': 'or',
    'tool.pairing.draw.vs': 'Vs',
    'tool.pairing.draw_round.select.draw': 'Select one army for the draft',
    'tool.pairing.draw_round.select.response': 'Select your reponses',
    'tool.pairing.draw_round.select.select': 'Select the army',
    'tool.pairing.draw_round.select.waiting': 'Waiting',
    'tool.pairing.image': 'Copy the pairing url image',
    'tool.pairing.inprogress': 'Your pairing is in progress',
    'tool.pairing.matches.tables': 'Tables:',
    'tool.pairing.my_team.my_armies': 'Your armies',
    'tool.pairing.opponent_team.team': 'Team',
    'tool.pairing.select_armies.choise_armies': 'Choise your armies',
    'tool.pairing.select_armies.confirm': 'Confirm',
    'tool.pairing.select_armies.error':
      'Sorry! There was an error loading the items.',
    'tool.pairing.select_armies.your_team': 'Your Team',
    'tool.pairing.select_team_size.how_many': 'How many players in the team?',
    'tool.pairing.table': 'Table',
    'tool.pairing.team_name.confirm': 'Confirm',
    'tool.pairing.team_name.what_name': "What's the name of your team?",
    'tool.pairing.team_name.your_name': 'Your team name',
    'tool.search_rules.index.search': 'Search',
    'tool.search_rules.index.search_army_select_error':
      'You must select one army',
    'tool.search_rules.index.search_rule': 'Choise one rule',
    'tool.search_rules.index.select_army': 'Choise the army',
    'tool.search_rules.index.select_version': 'Choise the version of 9Th Age',
    'tool.search_rules.index.title': 'Search by rules',
    'tournament.contest.back': 'Back to tournaments',
    'tournament.contest.edit': 'Edit',
    'tournament.contest.form.address': 'Address',
    'tournament.contest.form.end_date': 'End',
    'tournament.contest.form.fees': 'Fees',
    'tournament.contest.form.name': 'Name',
    'tournament.contest.form.round_count': 'Rounds',
    'tournament.contest.form.start_date': 'Start',
    'tournament.contest.form.submit': 'Save',
    'tournament.contest.form.team_max': 'Max teams',
    'tournament.contest.form.user_max': 'Max users',
    'tournament.contest.form.user_team_max': 'Max users by team',
    'tournament.contest.form.version': 'Version',
    'tournament.contest.index.title': 'My tournaments',
    'tournament.contest.name': 'Tournament',
    'tournament.contest.new.title': 'Create a tournament',
    'tournament.contest.print_armies': 'Print all armies',
    'tournament.contest.print_repport': 'Rapport',
    'tournament.contest.total': 'Total',
    'tournament.custom_point.name': 'Paint, Wysiwyg, List',
    'tournament.round.add': 'Add round',
    'tournament.round.name': 'Round',
    'tournament.round.pools.validate': 'Create pools',
    'tournament.team.add': 'Add Team',
    'tournament.team.back': 'Back to teams',
    'tournament.team.edit.title': 'Edition team',
    'tournament.team.export.title': 'Team',
    'tournament.team.first': 'Add your first team',
    'tournament.team.form.email': 'Email',
    'tournament.team.form.name': 'Name',
    'tournament.team.form.submit': 'Save',
    'tournament.team.index.title': 'My Tournament teams',
    'tournament.team.name': 'Teams',
    'tournament.team.new.title': 'Add teams',
    'tournament.teams.add': 'Add Team',
    'tournament.teams.back': 'Back to tournaments',
    'tournament.teams.title': 'Teams',
    'tournament.user_apply.add': 'Add Participant',
    'tournament.user_apply.add_into_team': 'Add partipant in this team',
    'tournament.user_apply.army_list.add_now': 'Add it now!',
    'tournament.user_apply.army_list.create': 'Create a new list',
    'tournament.user_apply.army_list.need':
      'You have not added your army list yet.',
    'tournament.user_apply.army_list.or': 'or',
    'tournament.user_apply.army_list.use_existing': 'Use an existing list',
    'tournament.user_apply.army_list.which': 'Which army list ?',
    'tournament.user_apply.army_list_select.form.submit': 'Save',
    'tournament.user_apply.edit.title': 'Edit your participation',
    'tournament.user_apply.first': 'Add your first Participant',
    'tournament.user_apply.form.name': 'Name',
    'tournament.user_apply.form.name_detail':
      'You can add somes users (1 user by line) with email separated by a comma (name, email).',
    'tournament.user_apply.form.or': 'or',
    'tournament.user_apply.form.submit': 'Add',
    'tournament.user_apply.form.user': 'User',
    'tournament.user_apply.manage': 'Manage Team',
    'tournament.user_apply.name': 'User',
    'tournament.user_apply.new.title': 'Add users',
    'tournament.user_apply.remove': 'Remove Participant',
    'tournament.user_apply.share_link': 'Share invitation link',
    'tournament.user_apply.team_leader': 'Is the team captain',
    'unit.base.label': 'Base',
    'unit.height.Gigantic': 'Gigantic',
    'unit.height.Large': 'Large',
    'unit.height.Standard': 'Standard',
    'unit.limit.model': 'Models/Army',
    'unit.limit.perArmy': 'par Armée',
    'unit.limit.single': 'single model',
    'unit.limit.unit': 'Units/Army',
    'unit.mount': 'Mount',
    'unit.show.add_model':
      ' + \u003cstrong\u003e{pts}\u003c/strong\u003e pts/extra model',
    'unit.show.change':
      '{name} utils of {number} models count towards {new_name}',
    'unit.show.change_with_limit':
      'Units of {number} or more models without {limit} count towards {new_name} instead of {old_name}.',
    'unit.show.size':
      '\u003cstrong\u003e{min_size}-{max_size}\u003c/strong\u003e models',
    'unit.size.Gigantic': 'Gigantic',
    'unit.size.Large': 'Large',
    'unit.size.Standard': 'Standard',
    'unit.type.label': 'Type',
    'unit_option.per_model': '/mod.',
    'unit_option.use_points.free': 'free',
    'unit_option.use_points.no_limit': 'no limit',
    'unit_option.use_points.up_to': 'up to',
    'unit_options.category.C': 'C',
    'unit_options.category.M': 'M',
    'unit_options.category.S': 'S',
    'unit_options.footonly': 'foot only',
    'version.index.pairing': 'Team Pairing',
    'version.index.search': 'Search by rule',
    'version.index.show': 'Show',
    'version.index.title': 'Versions',
    'version.index.tools': 'Tools',
    'version.show.back': 'Back',
    welcome: 'Welcome',
    with: 'with %',
    without: 'without %',
  },
};
